if (
    ((function (global, factory) {
        "use strict";
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = global.document
                  ? factory(global, !0)
                  : function (w) {
                        if (!w.document) throw new Error("jQuery requires a window with a document");
                        return factory(w);
                    })
            : factory(global);
    })("undefined" != typeof window ? window : this, function (window, noGlobal) {
        "use strict";
        var arr = [],
            document = window.document,
            getProto = Object.getPrototypeOf,
            slice = arr.slice,
            concat = arr.concat,
            push = arr.push,
            indexOf = arr.indexOf,
            class2type = {},
            toString = class2type.toString,
            hasOwn = class2type.hasOwnProperty,
            fnToString = hasOwn.toString,
            ObjectFunctionString = fnToString.call(Object),
            support = {},
            isFunction = function (obj) {
                return "function" == typeof obj && "number" != typeof obj.nodeType;
            },
            isWindow = function (obj) {
                return null != obj && obj === obj.window;
            },
            preservedScriptAttributes = { type: !0, src: !0, noModule: !0 };
        function DOMEval(code, doc, node) {
            var i,
                script = (doc = doc || document).createElement("script");
            if (((script.text = code), node)) for (i in preservedScriptAttributes) node[i] && (script[i] = node[i]);
            doc.head.appendChild(script).parentNode.removeChild(script);
        }
        function toType(obj) {
            return null == obj ? obj + "" : "object" == typeof obj || "function" == typeof obj ? class2type[toString.call(obj)] || "object" : typeof obj;
        }
        var jQuery = function (selector, context) {
                return new jQuery.fn.init(selector, context);
            },
            rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        function isArrayLike(obj) {
            var length = !!obj && "length" in obj && obj.length,
                type = toType(obj);
            return !isFunction(obj) && !isWindow(obj) && ("array" === type || 0 === length || ("number" == typeof length && 0 < length && length - 1 in obj));
        }
        (jQuery.fn = jQuery.prototype = {
            jquery: "3.3.1",
            constructor: jQuery,
            length: 0,
            toArray: function () {
                return slice.call(this);
            },
            get: function (num) {
                return null == num ? slice.call(this) : num < 0 ? this[num + this.length] : this[num];
            },
            pushStack: function (elems) {
                var ret = jQuery.merge(this.constructor(), elems);
                return (ret.prevObject = this), ret;
            },
            each: function (callback) {
                return jQuery.each(this, callback);
            },
            map: function (callback) {
                return this.pushStack(
                    jQuery.map(this, function (elem, i) {
                        return callback.call(elem, i, elem);
                    })
                );
            },
            slice: function () {
                return this.pushStack(slice.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            eq: function (i) {
                var len = this.length,
                    j = +i + (i < 0 ? len : 0);
                return this.pushStack(0 <= j && j < len ? [this[j]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            push: push,
            sort: arr.sort,
            splice: arr.splice,
        }),
            (jQuery.extend = jQuery.fn.extend = function () {
                var options,
                    name,
                    src,
                    copy,
                    copyIsArray,
                    clone,
                    target = arguments[0] || {},
                    i = 1,
                    length = arguments.length,
                    deep = !1;
                for ("boolean" == typeof target && ((deep = target), (target = arguments[i] || {}), i++), "object" == typeof target || isFunction(target) || (target = {}), i === length && ((target = this), i--); i < length; i++)
                    if (null != (options = arguments[i]))
                        for (name in options)
                            (src = target[name]),
                                target !== (copy = options[name]) &&
                                    (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))
                                        ? ((clone = copyIsArray ? ((copyIsArray = !1), src && Array.isArray(src) ? src : []) : src && jQuery.isPlainObject(src) ? src : {}), (target[name] = jQuery.extend(deep, clone, copy)))
                                        : void 0 !== copy && (target[name] = copy));
                return target;
            }),
            jQuery.extend({
                expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (msg) {
                    throw new Error(msg);
                },
                noop: function () {},
                isPlainObject: function (obj) {
                    var proto, Ctor;
                    return (
                        !(!obj || "[object Object]" !== toString.call(obj)) &&
                        (!(proto = getProto(obj)) || ("function" == typeof (Ctor = hasOwn.call(proto, "constructor") && proto.constructor) && fnToString.call(Ctor) === ObjectFunctionString))
                    );
                },
                isEmptyObject: function (obj) {
                    var name;
                    for (name in obj) return !1;
                    return !0;
                },
                globalEval: function (code) {
                    DOMEval(code);
                },
                each: function (obj, callback) {
                    var length,
                        i = 0;
                    if (isArrayLike(obj)) for (length = obj.length; i < length && !1 !== callback.call(obj[i], i, obj[i]); i++);
                    else for (i in obj) if (!1 === callback.call(obj[i], i, obj[i])) break;
                    return obj;
                },
                trim: function (text) {
                    return null == text ? "" : (text + "").replace(rtrim, "");
                },
                makeArray: function (arr, results) {
                    var ret = results || [];
                    return null != arr && (isArrayLike(Object(arr)) ? jQuery.merge(ret, "string" == typeof arr ? [arr] : arr) : push.call(ret, arr)), ret;
                },
                inArray: function (elem, arr, i) {
                    return null == arr ? -1 : indexOf.call(arr, elem, i);
                },
                merge: function (first, second) {
                    for (var len = +second.length, j = 0, i = first.length; j < len; j++) first[i++] = second[j];
                    return (first.length = i), first;
                },
                grep: function (elems, callback, invert) {
                    for (var matches = [], i = 0, length = elems.length, callbackExpect = !invert; i < length; i++) !callback(elems[i], i) != callbackExpect && matches.push(elems[i]);
                    return matches;
                },
                map: function (elems, callback, arg) {
                    var length,
                        value,
                        i = 0,
                        ret = [];
                    if (isArrayLike(elems)) for (length = elems.length; i < length; i++) null != (value = callback(elems[i], i, arg)) && ret.push(value);
                    else for (i in elems) null != (value = callback(elems[i], i, arg)) && ret.push(value);
                    return concat.apply([], ret);
                },
                guid: 1,
                support: support,
            }),
            "function" == typeof Symbol && (jQuery.fn[Symbol.iterator] = arr[Symbol.iterator]),
            jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (i, name) {
                class2type["[object " + name + "]"] = name.toLowerCase();
            });
        var Sizzle = (function (window) {
            function funescape(_, escaped, escapedWhitespace) {
                var high = "0x" + escaped - 65536;
                return high != high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(65536 + high) : String.fromCharCode((high >> 10) | 55296, (1023 & high) | 56320);
            }
            function unloadHandler() {
                setDocument();
            }
            var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                sortOrder = function (a, b) {
                    return a === b && (hasDuplicate = !0), 0;
                },
                hasOwn = {}.hasOwnProperty,
                arr = [],
                pop = arr.pop,
                push_native = arr.push,
                push = arr.push,
                slice = arr.slice,
                indexOf = function (list, elem) {
                    for (var i = 0, len = list.length; i < len; i++) if (list[i] === elem) return i;
                    return -1;
                },
                booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                whitespace = "[\\x20\\t\\r\\n\\f]",
                identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + "*([*^$|!~]?=)" + whitespace + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
                pseudos = ":(" + identifier + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|.*)\\)|)",
                rwhitespace = new RegExp(whitespace + "+", "g"),
                rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
                rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
                rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
                rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
                rpseudo = new RegExp(pseudos),
                ridentifier = new RegExp("^" + identifier + "$"),
                matchExpr = {
                    ID: new RegExp("^#(" + identifier + ")"),
                    CLASS: new RegExp("^\\.(" + identifier + ")"),
                    TAG: new RegExp("^(" + identifier + "|[*])"),
                    ATTR: new RegExp("^" + attributes),
                    PSEUDO: new RegExp("^" + pseudos),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + booleans + ")$", "i"),
                    needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i"),
                },
                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,
                rnative = /^[^{]+\{\s*\[native \w/,
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                rsibling = /[+~]/,
                runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
                rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function (ch, asCodePoint) {
                    return asCodePoint ? ("\0" === ch ? "�" : ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ") : "\\" + ch;
                },
                disabledAncestor = addCombinator(
                    function (elem) {
                        return !0 === elem.disabled && ("form" in elem || "label" in elem);
                    },
                    { dir: "parentNode", next: "legend" }
                );
            try {
                push.apply((arr = slice.call(preferredDoc.childNodes)), preferredDoc.childNodes), arr[preferredDoc.childNodes.length].nodeType;
            } catch (e) {
                push = {
                    apply: arr.length
                        ? function (target, els) {
                              push_native.apply(target, slice.call(els));
                          }
                        : function (target, els) {
                              for (var j = target.length, i = 0; (target[j++] = els[i++]); );
                              target.length = j - 1;
                          },
                };
            }
            function Sizzle(selector, context, results, seed) {
                var m,
                    i,
                    elem,
                    nid,
                    match,
                    groups,
                    newSelector,
                    newContext = context && context.ownerDocument,
                    nodeType = context ? context.nodeType : 9;
                if (((results = results || []), "string" != typeof selector || !selector || (1 !== nodeType && 9 !== nodeType && 11 !== nodeType))) return results;
                if (!seed && ((context ? context.ownerDocument || context : preferredDoc) !== document && setDocument(context), (context = context || document), documentIsHTML)) {
                    if (11 !== nodeType && (match = rquickExpr.exec(selector)))
                        if ((m = match[1])) {
                            if (9 === nodeType) {
                                if (!(elem = context.getElementById(m))) return results;
                                if (elem.id === m) return results.push(elem), results;
                            } else if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) return results.push(elem), results;
                        } else {
                            if (match[2]) return push.apply(results, context.getElementsByTagName(selector)), results;
                            if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) return push.apply(results, context.getElementsByClassName(m)), results;
                        }
                    if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        if (1 !== nodeType) (newContext = context), (newSelector = selector);
                        else if ("object" !== context.nodeName.toLowerCase()) {
                            for ((nid = context.getAttribute("id")) ? (nid = nid.replace(rcssescape, fcssescape)) : context.setAttribute("id", (nid = expando)), i = (groups = tokenize(selector)).length; i--; )
                                groups[i] = "#" + nid + " " + toSelector(groups[i]);
                            (newSelector = groups.join(",")), (newContext = (rsibling.test(selector) && testContext(context.parentNode)) || context);
                        }
                        if (newSelector)
                            try {
                                return push.apply(results, newContext.querySelectorAll(newSelector)), results;
                            } catch (qsaError) {
                            } finally {
                                nid === expando && context.removeAttribute("id");
                            }
                    }
                }
                return select(selector.replace(rtrim, "$1"), context, results, seed);
            }
            function createCache() {
                var keys = [];
                return function cache(key, value) {
                    return keys.push(key + " ") > Expr.cacheLength && delete cache[keys.shift()], (cache[key + " "] = value);
                };
            }
            function markFunction(fn) {
                return (fn[expando] = !0), fn;
            }
            function assert(fn) {
                var el = document.createElement("fieldset");
                try {
                    return !!fn(el);
                } catch (e) {
                    return !1;
                } finally {
                    el.parentNode && el.parentNode.removeChild(el), (el = null);
                }
            }
            function addHandle(attrs, handler) {
                for (var arr = attrs.split("|"), i = arr.length; i--; ) Expr.attrHandle[arr[i]] = handler;
            }
            function siblingCheck(a, b) {
                var cur = b && a,
                    diff = cur && 1 === a.nodeType && 1 === b.nodeType && a.sourceIndex - b.sourceIndex;
                if (diff) return diff;
                if (cur) for (; (cur = cur.nextSibling); ) if (cur === b) return -1;
                return a ? 1 : -1;
            }
            function createInputPseudo(type) {
                return function (elem) {
                    return "input" === elem.nodeName.toLowerCase() && elem.type === type;
                };
            }
            function createButtonPseudo(type) {
                return function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return ("input" === name || "button" === name) && elem.type === type;
                };
            }
            function createDisabledPseudo(disabled) {
                return function (elem) {
                    return "form" in elem
                        ? elem.parentNode && !1 === elem.disabled
                            ? "label" in elem
                                ? "label" in elem.parentNode
                                    ? elem.parentNode.disabled === disabled
                                    : elem.disabled === disabled
                                : elem.isDisabled === disabled || (elem.isDisabled !== !disabled && disabledAncestor(elem) === disabled)
                            : elem.disabled === disabled
                        : "label" in elem && elem.disabled === disabled;
                };
            }
            function createPositionalPseudo(fn) {
                return markFunction(function (argument) {
                    return (
                        (argument = +argument),
                        markFunction(function (seed, matches) {
                            for (var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length; i--; ) seed[(j = matchIndexes[i])] && (seed[j] = !(matches[j] = seed[j]));
                        })
                    );
                });
            }
            function testContext(context) {
                return context && void 0 !== context.getElementsByTagName && context;
            }
            for (i in ((support = Sizzle.support = {}),
            (isXML = Sizzle.isXML = function (elem) {
                var documentElement = elem && (elem.ownerDocument || elem).documentElement;
                return !!documentElement && "HTML" !== documentElement.nodeName;
            }),
            (setDocument = Sizzle.setDocument = function (node) {
                var hasCompare,
                    subWindow,
                    doc = node ? node.ownerDocument || node : preferredDoc;
                return (
                    doc !== document &&
                        9 === doc.nodeType &&
                        doc.documentElement &&
                        ((docElem = (document = doc).documentElement),
                        (documentIsHTML = !isXML(document)),
                        preferredDoc !== document &&
                            (subWindow = document.defaultView) &&
                            subWindow.top !== subWindow &&
                            (subWindow.addEventListener ? subWindow.addEventListener("unload", unloadHandler, !1) : subWindow.attachEvent && subWindow.attachEvent("onunload", unloadHandler)),
                        (support.attributes = assert(function (el) {
                            return (el.className = "i"), !el.getAttribute("className");
                        })),
                        (support.getElementsByTagName = assert(function (el) {
                            return el.appendChild(document.createComment("")), !el.getElementsByTagName("*").length;
                        })),
                        (support.getElementsByClassName = rnative.test(document.getElementsByClassName)),
                        (support.getById = assert(function (el) {
                            return (docElem.appendChild(el).id = expando), !document.getElementsByName || !document.getElementsByName(expando).length;
                        })),
                        support.getById
                            ? ((Expr.filter.ID = function (id) {
                                  var attrId = id.replace(runescape, funescape);
                                  return function (elem) {
                                      return elem.getAttribute("id") === attrId;
                                  };
                              }),
                              (Expr.find.ID = function (id, context) {
                                  if (void 0 !== context.getElementById && documentIsHTML) {
                                      var elem = context.getElementById(id);
                                      return elem ? [elem] : [];
                                  }
                              }))
                            : ((Expr.filter.ID = function (id) {
                                  var attrId = id.replace(runescape, funescape);
                                  return function (elem) {
                                      var node = void 0 !== elem.getAttributeNode && elem.getAttributeNode("id");
                                      return node && node.value === attrId;
                                  };
                              }),
                              (Expr.find.ID = function (id, context) {
                                  if (void 0 !== context.getElementById && documentIsHTML) {
                                      var node,
                                          i,
                                          elems,
                                          elem = context.getElementById(id);
                                      if (elem) {
                                          if ((node = elem.getAttributeNode("id")) && node.value === id) return [elem];
                                          for (elems = context.getElementsByName(id), i = 0; (elem = elems[i++]); ) if ((node = elem.getAttributeNode("id")) && node.value === id) return [elem];
                                      }
                                      return [];
                                  }
                              })),
                        (Expr.find.TAG = support.getElementsByTagName
                            ? function (tag, context) {
                                  return void 0 !== context.getElementsByTagName ? context.getElementsByTagName(tag) : support.qsa ? context.querySelectorAll(tag) : void 0;
                              }
                            : function (tag, context) {
                                  var elem,
                                      tmp = [],
                                      i = 0,
                                      results = context.getElementsByTagName(tag);
                                  if ("*" !== tag) return results;
                                  for (; (elem = results[i++]); ) 1 === elem.nodeType && tmp.push(elem);
                                  return tmp;
                              }),
                        (Expr.find.CLASS =
                            support.getElementsByClassName &&
                            function (className, context) {
                                if (void 0 !== context.getElementsByClassName && documentIsHTML) return context.getElementsByClassName(className);
                            }),
                        (rbuggyMatches = []),
                        (rbuggyQSA = []),
                        (support.qsa = rnative.test(document.querySelectorAll)) &&
                            (assert(function (el) {
                                (docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a><select id='" + expando + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                    el.querySelectorAll("[msallowcapture^='']").length && rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")"),
                                    el.querySelectorAll("[selected]").length || rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")"),
                                    el.querySelectorAll("[id~=" + expando + "-]").length || rbuggyQSA.push("~="),
                                    el.querySelectorAll(":checked").length || rbuggyQSA.push(":checked"),
                                    el.querySelectorAll("a#" + expando + "+*").length || rbuggyQSA.push(".#.+[+~]");
                            }),
                            assert(function (el) {
                                el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                var input = document.createElement("input");
                                input.setAttribute("type", "hidden"),
                                    el.appendChild(input).setAttribute("name", "D"),
                                    el.querySelectorAll("[name=d]").length && rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?="),
                                    2 !== el.querySelectorAll(":enabled").length && rbuggyQSA.push(":enabled", ":disabled"),
                                    (docElem.appendChild(el).disabled = !0),
                                    2 !== el.querySelectorAll(":disabled").length && rbuggyQSA.push(":enabled", ":disabled"),
                                    el.querySelectorAll("*,:x"),
                                    rbuggyQSA.push(",.*:");
                            })),
                        (support.matchesSelector = rnative.test((matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector))) &&
                            assert(function (el) {
                                (support.disconnectedMatch = matches.call(el, "*")), matches.call(el, "[s!='']:x"), rbuggyMatches.push("!=", pseudos);
                            }),
                        (rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"))),
                        (rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"))),
                        (hasCompare = rnative.test(docElem.compareDocumentPosition)),
                        (contains =
                            hasCompare || rnative.test(docElem.contains)
                                ? function (a, b) {
                                      var adown = 9 === a.nodeType ? a.documentElement : a,
                                          bup = b && b.parentNode;
                                      return a === bup || !(!bup || 1 !== bup.nodeType || !(adown.contains ? adown.contains(bup) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(bup)));
                                  }
                                : function (a, b) {
                                      if (b) for (; (b = b.parentNode); ) if (b === a) return !0;
                                      return !1;
                                  }),
                        (sortOrder = hasCompare
                            ? function (a, b) {
                                  if (a === b) return (hasDuplicate = !0), 0;
                                  var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                                  return (
                                      compare ||
                                      (1 & (compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1) || (!support.sortDetached && b.compareDocumentPosition(a) === compare)
                                          ? a === document || (a.ownerDocument === preferredDoc && contains(preferredDoc, a))
                                              ? -1
                                              : b === document || (b.ownerDocument === preferredDoc && contains(preferredDoc, b))
                                              ? 1
                                              : sortInput
                                              ? indexOf(sortInput, a) - indexOf(sortInput, b)
                                              : 0
                                          : 4 & compare
                                          ? -1
                                          : 1)
                                  );
                              }
                            : function (a, b) {
                                  if (a === b) return (hasDuplicate = !0), 0;
                                  var cur,
                                      i = 0,
                                      aup = a.parentNode,
                                      bup = b.parentNode,
                                      ap = [a],
                                      bp = [b];
                                  if (!aup || !bup) return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                                  if (aup === bup) return siblingCheck(a, b);
                                  for (cur = a; (cur = cur.parentNode); ) ap.unshift(cur);
                                  for (cur = b; (cur = cur.parentNode); ) bp.unshift(cur);
                                  for (; ap[i] === bp[i]; ) i++;
                                  return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
                              })),
                    document
                );
            }),
            (Sizzle.matches = function (expr, elements) {
                return Sizzle(expr, null, null, elements);
            }),
            (Sizzle.matchesSelector = function (elem, expr) {
                if (
                    ((elem.ownerDocument || elem) !== document && setDocument(elem),
                    (expr = expr.replace(rattributeQuotes, "='$1']")),
                    support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr)))
                )
                    try {
                        var ret = matches.call(elem, expr);
                        if (ret || support.disconnectedMatch || (elem.document && 11 !== elem.document.nodeType)) return ret;
                    } catch (e) {}
                return 0 < Sizzle(expr, document, null, [elem]).length;
            }),
            (Sizzle.contains = function (context, elem) {
                return (context.ownerDocument || context) !== document && setDocument(context), contains(context, elem);
            }),
            (Sizzle.attr = function (elem, name) {
                (elem.ownerDocument || elem) !== document && setDocument(elem);
                var fn = Expr.attrHandle[name.toLowerCase()],
                    val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : void 0;
                return void 0 !== val ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
            }),
            (Sizzle.escape = function (sel) {
                return (sel + "").replace(rcssescape, fcssescape);
            }),
            (Sizzle.error = function (msg) {
                throw new Error("Syntax error, unrecognized expression: " + msg);
            }),
            (Sizzle.uniqueSort = function (results) {
                var elem,
                    duplicates = [],
                    j = 0,
                    i = 0;
                if (((hasDuplicate = !support.detectDuplicates), (sortInput = !support.sortStable && results.slice(0)), results.sort(sortOrder), hasDuplicate)) {
                    for (; (elem = results[i++]); ) elem === results[i] && (j = duplicates.push(i));
                    for (; j--; ) results.splice(duplicates[j], 1);
                }
                return (sortInput = null), results;
            }),
            (getText = Sizzle.getText = function (elem) {
                var node,
                    ret = "",
                    i = 0,
                    nodeType = elem.nodeType;
                if (nodeType) {
                    if (1 === nodeType || 9 === nodeType || 11 === nodeType) {
                        if ("string" == typeof elem.textContent) return elem.textContent;
                        for (elem = elem.firstChild; elem; elem = elem.nextSibling) ret += getText(elem);
                    } else if (3 === nodeType || 4 === nodeType) return elem.nodeValue;
                } else for (; (node = elem[i++]); ) ret += getText(node);
                return ret;
            }),
            ((Expr = Sizzle.selectors = {
                cacheLength: 50,
                createPseudo: markFunction,
                match: matchExpr,
                attrHandle: {},
                find: {},
                relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                preFilter: {
                    ATTR: function (match) {
                        return (
                            (match[1] = match[1].replace(runescape, funescape)), (match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape)), "~=" === match[2] && (match[3] = " " + match[3] + " "), match.slice(0, 4)
                        );
                    },
                    CHILD: function (match) {
                        return (
                            (match[1] = match[1].toLowerCase()),
                            "nth" === match[1].slice(0, 3)
                                ? (match[3] || Sizzle.error(match[0]), (match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * ("even" === match[3] || "odd" === match[3]))), (match[5] = +(match[7] + match[8] || "odd" === match[3])))
                                : match[3] && Sizzle.error(match[0]),
                            match
                        );
                    },
                    PSEUDO: function (match) {
                        var excess,
                            unquoted = !match[6] && match[2];
                        return matchExpr.CHILD.test(match[0])
                            ? null
                            : (match[3]
                                  ? (match[2] = match[4] || match[5] || "")
                                  : unquoted &&
                                    rpseudo.test(unquoted) &&
                                    (excess = tokenize(unquoted, !0)) &&
                                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length) &&
                                    ((match[0] = match[0].slice(0, excess)), (match[2] = unquoted.slice(0, excess))),
                              match.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (nodeNameSelector) {
                        var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                        return "*" === nodeNameSelector
                            ? function () {
                                  return !0;
                              }
                            : function (elem) {
                                  return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                              };
                    },
                    CLASS: function (className) {
                        var pattern = classCache[className + " "];
                        return (
                            pattern ||
                            ((pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) &&
                                classCache(className, function (elem) {
                                    return pattern.test(("string" == typeof elem.className && elem.className) || (void 0 !== elem.getAttribute && elem.getAttribute("class")) || "");
                                }))
                        );
                    },
                    ATTR: function (name, operator, check) {
                        return function (elem) {
                            var result = Sizzle.attr(elem, name);
                            return null == result
                                ? "!=" === operator
                                : !operator ||
                                      ((result += ""),
                                      "=" === operator
                                          ? result === check
                                          : "!=" === operator
                                          ? result !== check
                                          : "^=" === operator
                                          ? check && 0 === result.indexOf(check)
                                          : "*=" === operator
                                          ? check && -1 < result.indexOf(check)
                                          : "$=" === operator
                                          ? check && result.slice(-check.length) === check
                                          : "~=" === operator
                                          ? -1 < (" " + result.replace(rwhitespace, " ") + " ").indexOf(check)
                                          : "|=" === operator && (result === check || result.slice(0, check.length + 1) === check + "-"));
                        };
                    },
                    CHILD: function (type, what, argument, first, last) {
                        var simple = "nth" !== type.slice(0, 3),
                            forward = "last" !== type.slice(-4),
                            ofType = "of-type" === what;
                        return 1 === first && 0 === last
                            ? function (elem) {
                                  return !!elem.parentNode;
                              }
                            : function (elem, context, xml) {
                                  var cache,
                                      uniqueCache,
                                      outerCache,
                                      node,
                                      nodeIndex,
                                      start,
                                      dir = simple != forward ? "nextSibling" : "previousSibling",
                                      parent = elem.parentNode,
                                      name = ofType && elem.nodeName.toLowerCase(),
                                      useCache = !xml && !ofType,
                                      diff = !1;
                                  if (parent) {
                                      if (simple) {
                                          for (; dir; ) {
                                              for (node = elem; (node = node[dir]); ) if (ofType ? node.nodeName.toLowerCase() === name : 1 === node.nodeType) return !1;
                                              start = dir = "only" === type && !start && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((start = [forward ? parent.firstChild : parent.lastChild]), forward && useCache)) {
                                          for (
                                              diff =
                                                  (nodeIndex =
                                                      (cache = (uniqueCache = (outerCache = (node = parent)[expando] || (node[expando] = {}))[node.uniqueID] || (outerCache[node.uniqueID] = {}))[type] || [])[0] === dirruns && cache[1]) &&
                                                  cache[2],
                                                  node = nodeIndex && parent.childNodes[nodeIndex];
                                              (node = (++nodeIndex && node && node[dir]) || (diff = nodeIndex = 0) || start.pop());

                                          )
                                              if (1 === node.nodeType && ++diff && node === elem) {
                                                  uniqueCache[type] = [dirruns, nodeIndex, diff];
                                                  break;
                                              }
                                      } else if (
                                          (useCache &&
                                              (diff = nodeIndex =
                                                  (cache = (uniqueCache = (outerCache = (node = elem)[expando] || (node[expando] = {}))[node.uniqueID] || (outerCache[node.uniqueID] = {}))[type] || [])[0] === dirruns && cache[1]),
                                          !1 === diff)
                                      )
                                          for (
                                              ;
                                              (node = (++nodeIndex && node && node[dir]) || (diff = nodeIndex = 0) || start.pop()) &&
                                              ((ofType ? node.nodeName.toLowerCase() !== name : 1 !== node.nodeType) ||
                                                  !++diff ||
                                                  (useCache && ((uniqueCache = (outerCache = node[expando] || (node[expando] = {}))[node.uniqueID] || (outerCache[node.uniqueID] = {}))[type] = [dirruns, diff]), node !== elem));

                                          );
                                      return (diff -= last) === first || (diff % first == 0 && 0 <= diff / first);
                                  }
                              };
                    },
                    PSEUDO: function (pseudo, argument) {
                        var args,
                            fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                        return fn[expando]
                            ? fn(argument)
                            : 1 < fn.length
                            ? ((args = [pseudo, pseudo, "", argument]),
                              Expr.setFilters.hasOwnProperty(pseudo.toLowerCase())
                                  ? markFunction(function (seed, matches) {
                                        for (var idx, matched = fn(seed, argument), i = matched.length; i--; ) seed[(idx = indexOf(seed, matched[i]))] = !(matches[idx] = matched[i]);
                                    })
                                  : function (elem) {
                                        return fn(elem, 0, args);
                                    })
                            : fn;
                    },
                },
                pseudos: {
                    not: markFunction(function (selector) {
                        var input = [],
                            results = [],
                            matcher = compile(selector.replace(rtrim, "$1"));
                        return matcher[expando]
                            ? markFunction(function (seed, matches, context, xml) {
                                  for (var elem, unmatched = matcher(seed, null, xml, []), i = seed.length; i--; ) (elem = unmatched[i]) && (seed[i] = !(matches[i] = elem));
                              })
                            : function (elem, context, xml) {
                                  return (input[0] = elem), matcher(input, null, xml, results), (input[0] = null), !results.pop();
                              };
                    }),
                    has: markFunction(function (selector) {
                        return function (elem) {
                            return 0 < Sizzle(selector, elem).length;
                        };
                    }),
                    contains: markFunction(function (text) {
                        return (
                            (text = text.replace(runescape, funescape)),
                            function (elem) {
                                return -1 < (elem.textContent || elem.innerText || getText(elem)).indexOf(text);
                            }
                        );
                    }),
                    lang: markFunction(function (lang) {
                        return (
                            ridentifier.test(lang || "") || Sizzle.error("unsupported lang: " + lang),
                            (lang = lang.replace(runescape, funescape).toLowerCase()),
                            function (elem) {
                                var elemLang;
                                do {
                                    if ((elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) return (elemLang = elemLang.toLowerCase()) === lang || 0 === elemLang.indexOf(lang + "-");
                                } while ((elem = elem.parentNode) && 1 === elem.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (elem) {
                        var hash = window.location && window.location.hash;
                        return hash && hash.slice(1) === elem.id;
                    },
                    root: function (elem) {
                        return elem === docElem;
                    },
                    focus: function (elem) {
                        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                    },
                    enabled: createDisabledPseudo(!1),
                    disabled: createDisabledPseudo(!0),
                    checked: function (elem) {
                        var nodeName = elem.nodeName.toLowerCase();
                        return ("input" === nodeName && !!elem.checked) || ("option" === nodeName && !!elem.selected);
                    },
                    selected: function (elem) {
                        return elem.parentNode && elem.parentNode.selectedIndex, !0 === elem.selected;
                    },
                    empty: function (elem) {
                        for (elem = elem.firstChild; elem; elem = elem.nextSibling) if (elem.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (elem) {
                        return !Expr.pseudos.empty(elem);
                    },
                    header: function (elem) {
                        return rheader.test(elem.nodeName);
                    },
                    input: function (elem) {
                        return rinputs.test(elem.nodeName);
                    },
                    button: function (elem) {
                        var name = elem.nodeName.toLowerCase();
                        return ("input" === name && "button" === elem.type) || "button" === name;
                    },
                    text: function (elem) {
                        var attr;
                        return "input" === elem.nodeName.toLowerCase() && "text" === elem.type && (null == (attr = elem.getAttribute("type")) || "text" === attr.toLowerCase());
                    },
                    first: createPositionalPseudo(function () {
                        return [0];
                    }),
                    last: createPositionalPseudo(function (matchIndexes, length) {
                        return [length - 1];
                    }),
                    eq: createPositionalPseudo(function (matchIndexes, length, argument) {
                        return [argument < 0 ? argument + length : argument];
                    }),
                    even: createPositionalPseudo(function (matchIndexes, length) {
                        for (var i = 0; i < length; i += 2) matchIndexes.push(i);
                        return matchIndexes;
                    }),
                    odd: createPositionalPseudo(function (matchIndexes, length) {
                        for (var i = 1; i < length; i += 2) matchIndexes.push(i);
                        return matchIndexes;
                    }),
                    lt: createPositionalPseudo(function (matchIndexes, length, argument) {
                        for (var i = argument < 0 ? argument + length : argument; 0 <= --i; ) matchIndexes.push(i);
                        return matchIndexes;
                    }),
                    gt: createPositionalPseudo(function (matchIndexes, length, argument) {
                        for (var i = argument < 0 ? argument + length : argument; ++i < length; ) matchIndexes.push(i);
                        return matchIndexes;
                    }),
                },
            }).pseudos.nth = Expr.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                Expr.pseudos[i] = createInputPseudo(i);
            for (i in { submit: !0, reset: !0 }) Expr.pseudos[i] = createButtonPseudo(i);
            function setFilters() {}
            function toSelector(tokens) {
                for (var i = 0, len = tokens.length, selector = ""; i < len; i++) selector += tokens[i].value;
                return selector;
            }
            function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir,
                    skip = combinator.next,
                    key = skip || dir,
                    checkNonElements = base && "parentNode" === key,
                    doneName = done++;
                return combinator.first
                    ? function (elem, context, xml) {
                          for (; (elem = elem[dir]); ) if (1 === elem.nodeType || checkNonElements) return matcher(elem, context, xml);
                          return !1;
                      }
                    : function (elem, context, xml) {
                          var oldCache,
                              uniqueCache,
                              outerCache,
                              newCache = [dirruns, doneName];
                          if (xml) {
                              for (; (elem = elem[dir]); ) if ((1 === elem.nodeType || checkNonElements) && matcher(elem, context, xml)) return !0;
                          } else
                              for (; (elem = elem[dir]); )
                                  if (1 === elem.nodeType || checkNonElements)
                                      if (((uniqueCache = (outerCache = elem[expando] || (elem[expando] = {}))[elem.uniqueID] || (outerCache[elem.uniqueID] = {})), skip && skip === elem.nodeName.toLowerCase())) elem = elem[dir] || elem;
                                      else {
                                          if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) return (newCache[2] = oldCache[2]);
                                          if (((uniqueCache[key] = newCache)[2] = matcher(elem, context, xml))) return !0;
                                      }
                          return !1;
                      };
            }
            function elementMatcher(matchers) {
                return 1 < matchers.length
                    ? function (elem, context, xml) {
                          for (var i = matchers.length; i--; ) if (!matchers[i](elem, context, xml)) return !1;
                          return !0;
                      }
                    : matchers[0];
            }
            function condense(unmatched, map, filter, context, xml) {
                for (var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = null != map; i < len; i++) (elem = unmatched[i]) && ((filter && !filter(elem, context, xml)) || (newUnmatched.push(elem), mapped && map.push(i)));
                return newUnmatched;
            }
            function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
                return (
                    postFilter && !postFilter[expando] && (postFilter = setMatcher(postFilter)),
                    postFinder && !postFinder[expando] && (postFinder = setMatcher(postFinder, postSelector)),
                    markFunction(function (seed, results, context, xml) {
                        var temp,
                            i,
                            elem,
                            preMap = [],
                            postMap = [],
                            preexisting = results.length,
                            elems =
                                seed ||
                                (function (selector, contexts, results) {
                                    for (var i = 0, len = contexts.length; i < len; i++) Sizzle(selector, contexts[i], results);
                                    return results;
                                })(selector || "*", context.nodeType ? [context] : context, []),
                            matcherIn = !preFilter || (!seed && selector) ? elems : condense(elems, preMap, preFilter, context, xml),
                            matcherOut = matcher ? (postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results) : matcherIn;
                        if ((matcher && matcher(matcherIn, matcherOut, context, xml), postFilter))
                            for (temp = condense(matcherOut, postMap), postFilter(temp, [], context, xml), i = temp.length; i--; ) (elem = temp[i]) && (matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem));
                        if (seed) {
                            if (postFinder || preFilter) {
                                if (postFinder) {
                                    for (temp = [], i = matcherOut.length; i--; ) (elem = matcherOut[i]) && temp.push((matcherIn[i] = elem));
                                    postFinder(null, (matcherOut = []), temp, xml);
                                }
                                for (i = matcherOut.length; i--; ) (elem = matcherOut[i]) && -1 < (temp = postFinder ? indexOf(seed, elem) : preMap[i]) && (seed[temp] = !(results[temp] = elem));
                            }
                        } else (matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut)), postFinder ? postFinder(null, results, matcherOut, xml) : push.apply(results, matcherOut);
                    })
                );
            }
            function matcherFromTokens(tokens) {
                for (
                    var checkContext,
                        matcher,
                        j,
                        len = tokens.length,
                        leadingRelative = Expr.relative[tokens[0].type],
                        implicitRelative = leadingRelative || Expr.relative[" "],
                        i = leadingRelative ? 1 : 0,
                        matchContext = addCombinator(
                            function (elem) {
                                return elem === checkContext;
                            },
                            implicitRelative,
                            !0
                        ),
                        matchAnyContext = addCombinator(
                            function (elem) {
                                return -1 < indexOf(checkContext, elem);
                            },
                            implicitRelative,
                            !0
                        ),
                        matchers = [
                            function (elem, context, xml) {
                                var ret = (!leadingRelative && (xml || context !== outermostContext)) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                                return (checkContext = null), ret;
                            },
                        ];
                    i < len;
                    i++
                )
                    if ((matcher = Expr.relative[tokens[i].type])) matchers = [addCombinator(elementMatcher(matchers), matcher)];
                    else {
                        if ((matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches))[expando]) {
                            for (j = ++i; j < len && !Expr.relative[tokens[j].type]; j++);
                            return setMatcher(
                                1 < i && elementMatcher(matchers),
                                1 < i && toSelector(tokens.slice(0, i - 1).concat({ value: " " === tokens[i - 2].type ? "*" : "" })).replace(rtrim, "$1"),
                                matcher,
                                i < j && matcherFromTokens(tokens.slice(i, j)),
                                j < len && matcherFromTokens((tokens = tokens.slice(j))),
                                j < len && toSelector(tokens)
                            );
                        }
                        matchers.push(matcher);
                    }
                return elementMatcher(matchers);
            }
            return (
                (setFilters.prototype = Expr.filters = Expr.pseudos),
                (Expr.setFilters = new setFilters()),
                (tokenize = Sizzle.tokenize = function (selector, parseOnly) {
                    var matched,
                        match,
                        tokens,
                        type,
                        soFar,
                        groups,
                        preFilters,
                        cached = tokenCache[selector + " "];
                    if (cached) return parseOnly ? 0 : cached.slice(0);
                    for (soFar = selector, groups = [], preFilters = Expr.preFilter; soFar; ) {
                        for (type in ((matched && !(match = rcomma.exec(soFar))) || (match && (soFar = soFar.slice(match[0].length) || soFar), groups.push((tokens = []))),
                        (matched = !1),
                        (match = rcombinators.exec(soFar)) && ((matched = match.shift()), tokens.push({ value: matched, type: match[0].replace(rtrim, " ") }), (soFar = soFar.slice(matched.length))),
                        Expr.filter))
                            !(match = matchExpr[type].exec(soFar)) ||
                                (preFilters[type] && !(match = preFilters[type](match))) ||
                                ((matched = match.shift()), tokens.push({ value: matched, type: type, matches: match }), (soFar = soFar.slice(matched.length)));
                        if (!matched) break;
                    }
                    return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
                }),
                (compile = Sizzle.compile = function (selector, match) {
                    var i,
                        setMatchers = [],
                        elementMatchers = [],
                        cached = compilerCache[selector + " "];
                    if (!cached) {
                        for (i = (match = match || tokenize(selector)).length; i--; ) (cached = matcherFromTokens(match[i]))[expando] ? setMatchers.push(cached) : elementMatchers.push(cached);
                        (cached = compilerCache(
                            selector,
                            (function (elementMatchers, setMatchers) {
                                function superMatcher(seed, context, xml, results, outermost) {
                                    var elem,
                                        j,
                                        matcher,
                                        matchedCount = 0,
                                        i = "0",
                                        unmatched = seed && [],
                                        setMatched = [],
                                        contextBackup = outermostContext,
                                        elems = seed || (byElement && Expr.find.TAG("*", outermost)),
                                        dirrunsUnique = (dirruns += null == contextBackup ? 1 : Math.random() || 0.1),
                                        len = elems.length;
                                    for (outermost && (outermostContext = context === document || context || outermost); i !== len && null != (elem = elems[i]); i++) {
                                        if (byElement && elem) {
                                            for (j = 0, context || elem.ownerDocument === document || (setDocument(elem), (xml = !documentIsHTML)); (matcher = elementMatchers[j++]); )
                                                if (matcher(elem, context || document, xml)) {
                                                    results.push(elem);
                                                    break;
                                                }
                                            outermost && (dirruns = dirrunsUnique);
                                        }
                                        bySet && ((elem = !matcher && elem) && matchedCount--, seed && unmatched.push(elem));
                                    }
                                    if (((matchedCount += i), bySet && i !== matchedCount)) {
                                        for (j = 0; (matcher = setMatchers[j++]); ) matcher(unmatched, setMatched, context, xml);
                                        if (seed) {
                                            if (0 < matchedCount) for (; i--; ) unmatched[i] || setMatched[i] || (setMatched[i] = pop.call(results));
                                            setMatched = condense(setMatched);
                                        }
                                        push.apply(results, setMatched), outermost && !seed && 0 < setMatched.length && 1 < matchedCount + setMatchers.length && Sizzle.uniqueSort(results);
                                    }
                                    return outermost && ((dirruns = dirrunsUnique), (outermostContext = contextBackup)), unmatched;
                                }
                                var bySet = 0 < setMatchers.length,
                                    byElement = 0 < elementMatchers.length;
                                return bySet ? markFunction(superMatcher) : superMatcher;
                            })(elementMatchers, setMatchers)
                        )).selector = selector;
                    }
                    return cached;
                }),
                (select = Sizzle.select = function (selector, context, results, seed) {
                    var i,
                        tokens,
                        token,
                        type,
                        find,
                        compiled = "function" == typeof selector && selector,
                        match = !seed && tokenize((selector = compiled.selector || selector));
                    if (((results = results || []), 1 === match.length)) {
                        if (2 < (tokens = match[0] = match[0].slice(0)).length && "ID" === (token = tokens[0]).type && 9 === context.nodeType && documentIsHTML && Expr.relative[tokens[1].type]) {
                            if (!(context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0])) return results;
                            compiled && (context = context.parentNode), (selector = selector.slice(tokens.shift().value.length));
                        }
                        for (i = matchExpr.needsContext.test(selector) ? 0 : tokens.length; i-- && ((token = tokens[i]), !Expr.relative[(type = token.type)]); )
                            if ((find = Expr.find[type]) && (seed = find(token.matches[0].replace(runescape, funescape), (rsibling.test(tokens[0].type) && testContext(context.parentNode)) || context))) {
                                if ((tokens.splice(i, 1), !(selector = seed.length && toSelector(tokens)))) return push.apply(results, seed), results;
                                break;
                            }
                    }
                    return (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || (rsibling.test(selector) && testContext(context.parentNode)) || context), results;
                }),
                (support.sortStable = expando.split("").sort(sortOrder).join("") === expando),
                (support.detectDuplicates = !!hasDuplicate),
                setDocument(),
                (support.sortDetached = assert(function (el) {
                    return 1 & el.compareDocumentPosition(document.createElement("fieldset"));
                })),
                assert(function (el) {
                    return (el.innerHTML = "<a href='#'></a>"), "#" === el.firstChild.getAttribute("href");
                }) ||
                    addHandle("type|href|height|width", function (elem, name, isXML) {
                        if (!isXML) return elem.getAttribute(name, "type" === name.toLowerCase() ? 1 : 2);
                    }),
                (support.attributes &&
                    assert(function (el) {
                        return (el.innerHTML = "<input/>"), el.firstChild.setAttribute("value", ""), "" === el.firstChild.getAttribute("value");
                    })) ||
                    addHandle("value", function (elem, name, isXML) {
                        if (!isXML && "input" === elem.nodeName.toLowerCase()) return elem.defaultValue;
                    }),
                assert(function (el) {
                    return null == el.getAttribute("disabled");
                }) ||
                    addHandle(booleans, function (elem, name, isXML) {
                        var val;
                        if (!isXML) return !0 === elem[name] ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
                    }),
                Sizzle
            );
        })(window);
        (jQuery.find = Sizzle),
            (jQuery.expr = Sizzle.selectors),
            (jQuery.expr[":"] = jQuery.expr.pseudos),
            (jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort),
            (jQuery.text = Sizzle.getText),
            (jQuery.isXMLDoc = Sizzle.isXML),
            (jQuery.contains = Sizzle.contains),
            (jQuery.escapeSelector = Sizzle.escape);
        function siblings(n, elem) {
            for (var matched = []; n; n = n.nextSibling) 1 === n.nodeType && n !== elem && matched.push(n);
            return matched;
        }
        var dir = function (elem, dir, until) {
                for (var matched = [], truncate = void 0 !== until; (elem = elem[dir]) && 9 !== elem.nodeType; )
                    if (1 === elem.nodeType) {
                        if (truncate && jQuery(elem).is(until)) break;
                        matched.push(elem);
                    }
                return matched;
            },
            rneedsContext = jQuery.expr.match.needsContext;
        function nodeName(elem, name) {
            return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
        }
        var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        function winnow(elements, qualifier, not) {
            return isFunction(qualifier)
                ? jQuery.grep(elements, function (elem, i) {
                      return !!qualifier.call(elem, i, elem) !== not;
                  })
                : qualifier.nodeType
                ? jQuery.grep(elements, function (elem) {
                      return (elem === qualifier) !== not;
                  })
                : "string" != typeof qualifier
                ? jQuery.grep(elements, function (elem) {
                      return -1 < indexOf.call(qualifier, elem) !== not;
                  })
                : jQuery.filter(qualifier, elements, not);
        }
        (jQuery.filter = function (expr, elems, not) {
            var elem = elems[0];
            return (
                not && (expr = ":not(" + expr + ")"),
                1 === elems.length && 1 === elem.nodeType
                    ? jQuery.find.matchesSelector(elem, expr)
                        ? [elem]
                        : []
                    : jQuery.find.matches(
                          expr,
                          jQuery.grep(elems, function (elem) {
                              return 1 === elem.nodeType;
                          })
                      )
            );
        }),
            jQuery.fn.extend({
                find: function (selector) {
                    var i,
                        ret,
                        len = this.length,
                        self = this;
                    if ("string" != typeof selector)
                        return this.pushStack(
                            jQuery(selector).filter(function () {
                                for (i = 0; i < len; i++) if (jQuery.contains(self[i], this)) return !0;
                            })
                        );
                    for (ret = this.pushStack([]), i = 0; i < len; i++) jQuery.find(selector, self[i], ret);
                    return 1 < len ? jQuery.uniqueSort(ret) : ret;
                },
                filter: function (selector) {
                    return this.pushStack(winnow(this, selector || [], !1));
                },
                not: function (selector) {
                    return this.pushStack(winnow(this, selector || [], !0));
                },
                is: function (selector) {
                    return !!winnow(this, "string" == typeof selector && rneedsContext.test(selector) ? jQuery(selector) : selector || [], !1).length;
                },
            });
        var rootjQuery,
            rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        ((jQuery.fn.init = function (selector, context, root) {
            var match, elem;
            if (!selector) return this;
            if (((root = root || rootjQuery), "string" != typeof selector))
                return selector.nodeType ? ((this[0] = selector), (this.length = 1), this) : isFunction(selector) ? (void 0 !== root.ready ? root.ready(selector) : selector(jQuery)) : jQuery.makeArray(selector, this);
            if (!(match = "<" === selector[0] && ">" === selector[selector.length - 1] && 3 <= selector.length ? [null, selector, null] : rquickExpr.exec(selector)) || (!match[1] && context))
                return !context || context.jquery ? (context || root).find(selector) : this.constructor(context).find(selector);
            if (match[1]) {
                if (
                    ((context = context instanceof jQuery ? context[0] : context),
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, !0)),
                    rsingleTag.test(match[1]) && jQuery.isPlainObject(context))
                )
                    for (match in context) isFunction(this[match]) ? this[match](context[match]) : this.attr(match, context[match]);
                return this;
            }
            return (elem = document.getElementById(match[2])) && ((this[0] = elem), (this.length = 1)), this;
        }).prototype = jQuery.fn),
            (rootjQuery = jQuery(document));
        var rparentsprev = /^(?:parents|prev(?:Until|All))/,
            guaranteedUnique = { children: !0, contents: !0, next: !0, prev: !0 };
        function sibling(cur, dir) {
            for (; (cur = cur[dir]) && 1 !== cur.nodeType; );
            return cur;
        }
        jQuery.fn.extend({
            has: function (target) {
                var targets = jQuery(target, this),
                    l = targets.length;
                return this.filter(function () {
                    for (var i = 0; i < l; i++) if (jQuery.contains(this, targets[i])) return !0;
                });
            },
            closest: function (selectors, context) {
                var cur,
                    i = 0,
                    l = this.length,
                    matched = [],
                    targets = "string" != typeof selectors && jQuery(selectors);
                if (!rneedsContext.test(selectors))
                    for (; i < l; i++)
                        for (cur = this[i]; cur && cur !== context; cur = cur.parentNode)
                            if (cur.nodeType < 11 && (targets ? -1 < targets.index(cur) : 1 === cur.nodeType && jQuery.find.matchesSelector(cur, selectors))) {
                                matched.push(cur);
                                break;
                            }
                return this.pushStack(1 < matched.length ? jQuery.uniqueSort(matched) : matched);
            },
            index: function (elem) {
                return elem ? ("string" == typeof elem ? indexOf.call(jQuery(elem), this[0]) : indexOf.call(this, elem.jquery ? elem[0] : elem)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (selector, context) {
                return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
            },
            addBack: function (selector) {
                return this.add(null == selector ? this.prevObject : this.prevObject.filter(selector));
            },
        }),
            jQuery.each(
                {
                    parent: function (elem) {
                        var parent = elem.parentNode;
                        return parent && 11 !== parent.nodeType ? parent : null;
                    },
                    parents: function (elem) {
                        return dir(elem, "parentNode");
                    },
                    parentsUntil: function (elem, i, until) {
                        return dir(elem, "parentNode", until);
                    },
                    next: function (elem) {
                        return sibling(elem, "nextSibling");
                    },
                    prev: function (elem) {
                        return sibling(elem, "previousSibling");
                    },
                    nextAll: function (elem) {
                        return dir(elem, "nextSibling");
                    },
                    prevAll: function (elem) {
                        return dir(elem, "previousSibling");
                    },
                    nextUntil: function (elem, i, until) {
                        return dir(elem, "nextSibling", until);
                    },
                    prevUntil: function (elem, i, until) {
                        return dir(elem, "previousSibling", until);
                    },
                    siblings: function (elem) {
                        return siblings((elem.parentNode || {}).firstChild, elem);
                    },
                    children: function (elem) {
                        return siblings(elem.firstChild);
                    },
                    contents: function (elem) {
                        return nodeName(elem, "iframe") ? elem.contentDocument : (nodeName(elem, "template") && (elem = elem.content || elem), jQuery.merge([], elem.childNodes));
                    },
                },
                function (name, fn) {
                    jQuery.fn[name] = function (until, selector) {
                        var matched = jQuery.map(this, fn, until);
                        return (
                            "Until" !== name.slice(-5) && (selector = until),
                            selector && "string" == typeof selector && (matched = jQuery.filter(selector, matched)),
                            1 < this.length && (guaranteedUnique[name] || jQuery.uniqueSort(matched), rparentsprev.test(name) && matched.reverse()),
                            this.pushStack(matched)
                        );
                    };
                }
            );
        var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
        function Identity(v) {
            return v;
        }
        function Thrower(ex) {
            throw ex;
        }
        function adoptValue(value, resolve, reject, noValue) {
            var method;
            try {
                value && isFunction((method = value.promise))
                    ? method.call(value).done(resolve).fail(reject)
                    : value && isFunction((method = value.then))
                    ? method.call(value, resolve, reject)
                    : resolve.apply(void 0, [value].slice(noValue));
            } catch (value) {
                reject.apply(void 0, [value]);
            }
        }
        (jQuery.Callbacks = function (options) {
            options =
                "string" == typeof options
                    ? (function (options) {
                          var object = {};
                          return (
                              jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
                                  object[flag] = !0;
                              }),
                              object
                          );
                      })(options)
                    : jQuery.extend({}, options);
            function fire() {
                for (locked = locked || options.once, fired = firing = !0; queue.length; firingIndex = -1)
                    for (memory = queue.shift(); ++firingIndex < list.length; ) !1 === list[firingIndex].apply(memory[0], memory[1]) && options.stopOnFalse && ((firingIndex = list.length), (memory = !1));
                options.memory || (memory = !1), (firing = !1), locked && (list = memory ? [] : "");
            }
            var firing,
                memory,
                fired,
                locked,
                list = [],
                queue = [],
                firingIndex = -1,
                self = {
                    add: function () {
                        return (
                            list &&
                                (memory && !firing && ((firingIndex = list.length - 1), queue.push(memory)),
                                (function add(args) {
                                    jQuery.each(args, function (_, arg) {
                                        isFunction(arg) ? (options.unique && self.has(arg)) || list.push(arg) : arg && arg.length && "string" !== toType(arg) && add(arg);
                                    });
                                })(arguments),
                                memory && !firing && fire()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            jQuery.each(arguments, function (_, arg) {
                                for (var index; -1 < (index = jQuery.inArray(arg, list, index)); ) list.splice(index, 1), index <= firingIndex && firingIndex--;
                            }),
                            this
                        );
                    },
                    has: function (fn) {
                        return fn ? -1 < jQuery.inArray(fn, list) : 0 < list.length;
                    },
                    empty: function () {
                        return (list = list && []), this;
                    },
                    disable: function () {
                        return (locked = queue = []), (list = memory = ""), this;
                    },
                    disabled: function () {
                        return !list;
                    },
                    lock: function () {
                        return (locked = queue = []), memory || firing || (list = memory = ""), this;
                    },
                    locked: function () {
                        return !!locked;
                    },
                    fireWith: function (context, args) {
                        return locked || ((args = [context, (args = args || []).slice ? args.slice() : args]), queue.push(args), firing || fire()), this;
                    },
                    fire: function () {
                        return self.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!fired;
                    },
                };
            return self;
        }),
            jQuery.extend({
                Deferred: function (func) {
                    var tuples = [
                            ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2],
                            ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"],
                        ],
                        state = "pending",
                        promise = {
                            state: function () {
                                return state;
                            },
                            always: function () {
                                return deferred.done(arguments).fail(arguments), this;
                            },
                            catch: function (fn) {
                                return promise.then(null, fn);
                            },
                            pipe: function () {
                                var fns = arguments;
                                return jQuery
                                    .Deferred(function (newDefer) {
                                        jQuery.each(tuples, function (i, tuple) {
                                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                                            deferred[tuple[1]](function () {
                                                var returned = fn && fn.apply(this, arguments);
                                                returned && isFunction(returned.promise)
                                                    ? returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject)
                                                    : newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
                                            });
                                        }),
                                            (fns = null);
                                    })
                                    .promise();
                            },
                            then: function (onFulfilled, onRejected, onProgress) {
                                var maxDepth = 0;
                                function resolve(depth, deferred, handler, special) {
                                    return function () {
                                        function mightThrow() {
                                            var returned, then;
                                            if (!(depth < maxDepth)) {
                                                if ((returned = handler.apply(that, args)) === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                                (then = returned && ("object" == typeof returned || "function" == typeof returned) && returned.then),
                                                    isFunction(then)
                                                        ? special
                                                            ? then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special))
                                                            : (maxDepth++,
                                                              then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith)))
                                                        : (handler !== Identity && ((that = void 0), (args = [returned])), (special || deferred.resolveWith)(that, args));
                                            }
                                        }
                                        var that = this,
                                            args = arguments,
                                            process = special
                                                ? mightThrow
                                                : function () {
                                                      try {
                                                          mightThrow();
                                                      } catch (e) {
                                                          jQuery.Deferred.exceptionHook && jQuery.Deferred.exceptionHook(e, process.stackTrace),
                                                              maxDepth <= depth + 1 && (handler !== Thrower && ((that = void 0), (args = [e])), deferred.rejectWith(that, args));
                                                      }
                                                  };
                                        depth ? process() : (jQuery.Deferred.getStackHook && (process.stackTrace = jQuery.Deferred.getStackHook()), window.setTimeout(process));
                                    };
                                }
                                return jQuery
                                    .Deferred(function (newDefer) {
                                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith)),
                                            tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity)),
                                            tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                                    })
                                    .promise();
                            },
                            promise: function (obj) {
                                return null != obj ? jQuery.extend(obj, promise) : promise;
                            },
                        },
                        deferred = {};
                    return (
                        jQuery.each(tuples, function (i, tuple) {
                            var list = tuple[2],
                                stateString = tuple[5];
                            (promise[tuple[1]] = list.add),
                                stateString &&
                                    list.add(
                                        function () {
                                            state = stateString;
                                        },
                                        tuples[3 - i][2].disable,
                                        tuples[3 - i][3].disable,
                                        tuples[0][2].lock,
                                        tuples[0][3].lock
                                    ),
                                list.add(tuple[3].fire),
                                (deferred[tuple[0]] = function () {
                                    return deferred[tuple[0] + "With"](this === deferred ? void 0 : this, arguments), this;
                                }),
                                (deferred[tuple[0] + "With"] = list.fireWith);
                        }),
                        promise.promise(deferred),
                        func && func.call(deferred, deferred),
                        deferred
                    );
                },
                when: function (singleValue) {
                    function updateFunc(i) {
                        return function (value) {
                            (resolveContexts[i] = this), (resolveValues[i] = 1 < arguments.length ? slice.call(arguments) : value), --remaining || master.resolveWith(resolveContexts, resolveValues);
                        };
                    }
                    var remaining = arguments.length,
                        i = remaining,
                        resolveContexts = Array(i),
                        resolveValues = slice.call(arguments),
                        master = jQuery.Deferred();
                    if (remaining <= 1 && (adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining), "pending" === master.state() || isFunction(resolveValues[i] && resolveValues[i].then))) return master.then();
                    for (; i--; ) adoptValue(resolveValues[i], updateFunc(i), master.reject);
                    return master.promise();
                },
            });
        var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        (jQuery.Deferred.exceptionHook = function (error, stack) {
            window.console && window.console.warn && error && rerrorNames.test(error.name) && window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
        }),
            (jQuery.readyException = function (error) {
                window.setTimeout(function () {
                    throw error;
                });
            });
        var readyList = jQuery.Deferred();
        function completed() {
            document.removeEventListener("DOMContentLoaded", completed), window.removeEventListener("load", completed), jQuery.ready();
        }
        (jQuery.fn.ready = function (fn) {
            return (
                readyList.then(fn).catch(function (error) {
                    jQuery.readyException(error);
                }),
                this
            );
        }),
            jQuery.extend({
                isReady: !1,
                readyWait: 1,
                ready: function (wait) {
                    (!0 === wait ? --jQuery.readyWait : jQuery.isReady) || ((jQuery.isReady = !0) !== wait && 0 < --jQuery.readyWait) || readyList.resolveWith(document, [jQuery]);
                },
            }),
            (jQuery.ready.then = readyList.then),
            "complete" === document.readyState || ("loading" !== document.readyState && !document.documentElement.doScroll)
                ? window.setTimeout(jQuery.ready)
                : (document.addEventListener("DOMContentLoaded", completed), window.addEventListener("load", completed));
        var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
                var i = 0,
                    len = elems.length,
                    bulk = null == key;
                if ("object" === toType(key)) for (i in ((chainable = !0), key)) access(elems, fn, i, key[i], !0, emptyGet, raw);
                else if (
                    void 0 !== value &&
                    ((chainable = !0),
                    isFunction(value) || (raw = !0),
                    bulk &&
                        (fn = raw
                            ? (fn.call(elems, value), null)
                            : ((bulk = fn),
                              function (elem, key, value) {
                                  return bulk.call(jQuery(elem), value);
                              })),
                    fn)
                )
                    for (; i < len; i++) fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
                return chainable ? elems : bulk ? fn.call(elems) : len ? fn(elems[0], key) : emptyGet;
            },
            rmsPrefix = /^-ms-/,
            rdashAlpha = /-([a-z])/g;
        function fcamelCase(all, letter) {
            return letter.toUpperCase();
        }
        function camelCase(string) {
            return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
        }
        function acceptData(owner) {
            return 1 === owner.nodeType || 9 === owner.nodeType || !+owner.nodeType;
        }
        function Data() {
            this.expando = jQuery.expando + Data.uid++;
        }
        (Data.uid = 1),
            (Data.prototype = {
                cache: function (owner) {
                    var value = owner[this.expando];
                    return value || ((value = {}), acceptData(owner) && (owner.nodeType ? (owner[this.expando] = value) : Object.defineProperty(owner, this.expando, { value: value, configurable: !0 }))), value;
                },
                set: function (owner, data, value) {
                    var prop,
                        cache = this.cache(owner);
                    if ("string" == typeof data) cache[camelCase(data)] = value;
                    else for (prop in data) cache[camelCase(prop)] = data[prop];
                    return cache;
                },
                get: function (owner, key) {
                    return void 0 === key ? this.cache(owner) : owner[this.expando] && owner[this.expando][camelCase(key)];
                },
                access: function (owner, key, value) {
                    return void 0 === key || (key && "string" == typeof key && void 0 === value) ? this.get(owner, key) : (this.set(owner, key, value), void 0 !== value ? value : key);
                },
                remove: function (owner, key) {
                    var i,
                        cache = owner[this.expando];
                    if (void 0 !== cache) {
                        if (void 0 !== key) {
                            i = (key = Array.isArray(key) ? key.map(camelCase) : (key = camelCase(key)) in cache ? [key] : key.match(rnothtmlwhite) || []).length;
                            for (; i--; ) delete cache[key[i]];
                        }
                        (void 0 !== key && !jQuery.isEmptyObject(cache)) || (owner.nodeType ? (owner[this.expando] = void 0) : delete owner[this.expando]);
                    }
                },
                hasData: function (owner) {
                    var cache = owner[this.expando];
                    return void 0 !== cache && !jQuery.isEmptyObject(cache);
                },
            });
        var dataPriv = new Data(),
            dataUser = new Data(),
            rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            rmultiDash = /[A-Z]/g;
        function dataAttr(elem, key, data) {
            var name;
            if (void 0 === data && 1 === elem.nodeType)
                if (((name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase()), "string" == typeof (data = elem.getAttribute(name)))) {
                    try {
                        data = (function (data) {
                            return "true" === data || ("false" !== data && ("null" === data ? null : data === +data + "" ? +data : rbrace.test(data) ? JSON.parse(data) : data));
                        })(data);
                    } catch (e) {}
                    dataUser.set(elem, key, data);
                } else data = void 0;
            return data;
        }
        jQuery.extend({
            hasData: function (elem) {
                return dataUser.hasData(elem) || dataPriv.hasData(elem);
            },
            data: function (elem, name, data) {
                return dataUser.access(elem, name, data);
            },
            removeData: function (elem, name) {
                dataUser.remove(elem, name);
            },
            _data: function (elem, name, data) {
                return dataPriv.access(elem, name, data);
            },
            _removeData: function (elem, name) {
                dataPriv.remove(elem, name);
            },
        }),
            jQuery.fn.extend({
                data: function (key, value) {
                    var i,
                        name,
                        data,
                        elem = this[0],
                        attrs = elem && elem.attributes;
                    if (void 0 !== key)
                        return "object" == typeof key
                            ? this.each(function () {
                                  dataUser.set(this, key);
                              })
                            : access(
                                  this,
                                  function (value) {
                                      var data;
                                      if (elem && void 0 === value) return void 0 !== (data = dataUser.get(elem, key)) ? data : void 0 !== (data = dataAttr(elem, key)) ? data : void 0;
                                      this.each(function () {
                                          dataUser.set(this, key, value);
                                      });
                                  },
                                  null,
                                  value,
                                  1 < arguments.length,
                                  null,
                                  !0
                              );
                    if (this.length && ((data = dataUser.get(elem)), 1 === elem.nodeType && !dataPriv.get(elem, "hasDataAttrs"))) {
                        for (i = attrs.length; i--; ) attrs[i] && 0 === (name = attrs[i].name).indexOf("data-") && ((name = camelCase(name.slice(5))), dataAttr(elem, name, data[name]));
                        dataPriv.set(elem, "hasDataAttrs", !0);
                    }
                    return data;
                },
                removeData: function (key) {
                    return this.each(function () {
                        dataUser.remove(this, key);
                    });
                },
            }),
            jQuery.extend({
                queue: function (elem, type, data) {
                    var queue;
                    if (elem)
                        return (type = (type || "fx") + "queue"), (queue = dataPriv.get(elem, type)), data && (!queue || Array.isArray(data) ? (queue = dataPriv.access(elem, type, jQuery.makeArray(data))) : queue.push(data)), queue || [];
                },
                dequeue: function (elem, type) {
                    type = type || "fx";
                    var queue = jQuery.queue(elem, type),
                        startLength = queue.length,
                        fn = queue.shift(),
                        hooks = jQuery._queueHooks(elem, type);
                    "inprogress" === fn && ((fn = queue.shift()), startLength--),
                        fn &&
                            ("fx" === type && queue.unshift("inprogress"),
                            delete hooks.stop,
                            fn.call(
                                elem,
                                function () {
                                    jQuery.dequeue(elem, type);
                                },
                                hooks
                            )),
                        !startLength && hooks && hooks.empty.fire();
                },
                _queueHooks: function (elem, type) {
                    var key = type + "queueHooks";
                    return (
                        dataPriv.get(elem, key) ||
                        dataPriv.access(elem, key, {
                            empty: jQuery.Callbacks("once memory").add(function () {
                                dataPriv.remove(elem, [type + "queue", key]);
                            }),
                        })
                    );
                },
            }),
            jQuery.fn.extend({
                queue: function (type, data) {
                    var setter = 2;
                    return (
                        "string" != typeof type && ((data = type), (type = "fx"), setter--),
                        arguments.length < setter
                            ? jQuery.queue(this[0], type)
                            : void 0 === data
                            ? this
                            : this.each(function () {
                                  var queue = jQuery.queue(this, type, data);
                                  jQuery._queueHooks(this, type), "fx" === type && "inprogress" !== queue[0] && jQuery.dequeue(this, type);
                              })
                    );
                },
                dequeue: function (type) {
                    return this.each(function () {
                        jQuery.dequeue(this, type);
                    });
                },
                clearQueue: function (type) {
                    return this.queue(type || "fx", []);
                },
                promise: function (type, obj) {
                    function resolve() {
                        --count || defer.resolveWith(elements, [elements]);
                    }
                    var tmp,
                        count = 1,
                        defer = jQuery.Deferred(),
                        elements = this,
                        i = this.length;
                    for ("string" != typeof type && ((obj = type), (type = void 0)), type = type || "fx"; i--; ) (tmp = dataPriv.get(elements[i], type + "queueHooks")) && tmp.empty && (count++, tmp.empty.add(resolve));
                    return resolve(), defer.promise(obj);
                },
            });
        function swap(elem, options, callback, args) {
            var ret,
                name,
                old = {};
            for (name in options) (old[name] = elem.style[name]), (elem.style[name] = options[name]);
            for (name in ((ret = callback.apply(elem, args || [])), options)) elem.style[name] = old[name];
            return ret;
        }
        var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i"),
            cssExpand = ["Top", "Right", "Bottom", "Left"],
            isHiddenWithinTree = function (elem, el) {
                return "none" === (elem = el || elem).style.display || ("" === elem.style.display && jQuery.contains(elem.ownerDocument, elem) && "none" === jQuery.css(elem, "display"));
            };
        function adjustCSS(elem, prop, valueParts, tween) {
            var adjusted,
                scale,
                maxIterations = 20,
                currentValue = tween
                    ? function () {
                          return tween.cur();
                      }
                    : function () {
                          return jQuery.css(elem, prop, "");
                      },
                initial = currentValue(),
                unit = (valueParts && valueParts[3]) || (jQuery.cssNumber[prop] ? "" : "px"),
                initialInUnit = (jQuery.cssNumber[prop] || ("px" !== unit && +initial)) && rcssNum.exec(jQuery.css(elem, prop));
            if (initialInUnit && initialInUnit[3] !== unit) {
                for (initial /= 2, unit = unit || initialInUnit[3], initialInUnit = +initial || 1; maxIterations--; )
                    jQuery.style(elem, prop, initialInUnit + unit), (1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0 && (maxIterations = 0), (initialInUnit /= scale);
                (initialInUnit *= 2), jQuery.style(elem, prop, initialInUnit + unit), (valueParts = valueParts || []);
            }
            return (
                valueParts &&
                    ((initialInUnit = +initialInUnit || +initial || 0),
                    (adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2]),
                    tween && ((tween.unit = unit), (tween.start = initialInUnit), (tween.end = adjusted))),
                adjusted
            );
        }
        var defaultDisplayMap = {};
        function getDefaultDisplay(elem) {
            var temp,
                doc = elem.ownerDocument,
                nodeName = elem.nodeName,
                display = defaultDisplayMap[nodeName];
            return (
                display ||
                ((temp = doc.body.appendChild(doc.createElement(nodeName))), (display = jQuery.css(temp, "display")), temp.parentNode.removeChild(temp), "none" === display && (display = "block"), (defaultDisplayMap[nodeName] = display))
            );
        }
        function showHide(elements, show) {
            for (var display, elem, values = [], index = 0, length = elements.length; index < length; index++)
                (elem = elements[index]).style &&
                    ((display = elem.style.display),
                    show
                        ? ("none" === display && ((values[index] = dataPriv.get(elem, "display") || null), values[index] || (elem.style.display = "")),
                          "" === elem.style.display && isHiddenWithinTree(elem) && (values[index] = getDefaultDisplay(elem)))
                        : "none" !== display && ((values[index] = "none"), dataPriv.set(elem, "display", display)));
            for (index = 0; index < length; index++) null != values[index] && (elements[index].style.display = values[index]);
            return elements;
        }
        jQuery.fn.extend({
            show: function () {
                return showHide(this, !0);
            },
            hide: function () {
                return showHide(this);
            },
            toggle: function (state) {
                return "boolean" == typeof state
                    ? state
                        ? this.show()
                        : this.hide()
                    : this.each(function () {
                          isHiddenWithinTree(this) ? jQuery(this).show() : jQuery(this).hide();
                      });
            },
        });
        var rcheckableType = /^(?:checkbox|radio)$/i,
            rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
            rscriptType = /^$|^module$|\/(?:java|ecma)script/i,
            wrapMap = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""],
            };
        function getAll(context, tag) {
            var ret;
            return (
                (ret = void 0 !== context.getElementsByTagName ? context.getElementsByTagName(tag || "*") : void 0 !== context.querySelectorAll ? context.querySelectorAll(tag || "*") : []),
                void 0 === tag || (tag && nodeName(context, tag)) ? jQuery.merge([context], ret) : ret
            );
        }
        function setGlobalEval(elems, refElements) {
            for (var i = 0, l = elems.length; i < l; i++) dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
        }
        (wrapMap.optgroup = wrapMap.option), (wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead), (wrapMap.th = wrapMap.td);
        var div,
            input,
            rhtml = /<|&#?\w+;/;
        function buildFragment(elems, context, scripts, selection, ignored) {
            for (var elem, tmp, tag, wrap, contains, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length; i < l; i++)
                if ((elem = elems[i]) || 0 === elem)
                    if ("object" === toType(elem)) jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
                    else if (rhtml.test(elem)) {
                        for (
                            tmp = tmp || fragment.appendChild(context.createElement("div")),
                                tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase(),
                                wrap = wrapMap[tag] || wrapMap._default,
                                tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2],
                                j = wrap[0];
                            j--;

                        )
                            tmp = tmp.lastChild;
                        jQuery.merge(nodes, tmp.childNodes), ((tmp = fragment.firstChild).textContent = "");
                    } else nodes.push(context.createTextNode(elem));
            for (fragment.textContent = "", i = 0; (elem = nodes[i++]); )
                if (selection && -1 < jQuery.inArray(elem, selection)) ignored && ignored.push(elem);
                else if (((contains = jQuery.contains(elem.ownerDocument, elem)), (tmp = getAll(fragment.appendChild(elem), "script")), contains && setGlobalEval(tmp), scripts))
                    for (j = 0; (elem = tmp[j++]); ) rscriptType.test(elem.type || "") && scripts.push(elem);
            return fragment;
        }
        (div = document.createDocumentFragment().appendChild(document.createElement("div"))),
            (input = document.createElement("input")).setAttribute("type", "radio"),
            input.setAttribute("checked", "checked"),
            input.setAttribute("name", "t"),
            div.appendChild(input),
            (support.checkClone = div.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (div.innerHTML = "<textarea>x</textarea>"),
            (support.noCloneChecked = !!div.cloneNode(!0).lastChild.defaultValue);
        var documentElement = document.documentElement,
            rkeyEvent = /^key/,
            rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
        function returnTrue() {
            return !0;
        }
        function returnFalse() {
            return !1;
        }
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        function on(elem, types, selector, data, fn, one) {
            var origFn, type;
            if ("object" == typeof types) {
                for (type in ("string" != typeof selector && ((data = data || selector), (selector = void 0)), types)) on(elem, type, selector, data, types[type], one);
                return elem;
            }
            if ((null == data && null == fn ? ((fn = selector), (data = selector = void 0)) : null == fn && ("string" == typeof selector ? ((fn = data), (data = void 0)) : ((fn = data), (data = selector), (selector = void 0))), !1 === fn))
                fn = returnFalse;
            else if (!fn) return elem;
            return (
                1 === one &&
                    ((origFn = fn),
                    ((fn = function (event) {
                        return jQuery().off(event), origFn.apply(this, arguments);
                    }).guid = origFn.guid || (origFn.guid = jQuery.guid++))),
                elem.each(function () {
                    jQuery.event.add(this, types, fn, data, selector);
                })
            );
        }
        (jQuery.event = {
            global: {},
            add: function (elem, types, handler, data, selector) {
                var handleObjIn,
                    eventHandle,
                    tmp,
                    events,
                    t,
                    handleObj,
                    special,
                    handlers,
                    type,
                    namespaces,
                    origType,
                    elemData = dataPriv.get(elem);
                if (elemData)
                    for (
                        handler.handler && ((handler = (handleObjIn = handler).handler), (selector = handleObjIn.selector)),
                            selector && jQuery.find.matchesSelector(documentElement, selector),
                            handler.guid || (handler.guid = jQuery.guid++),
                            (events = elemData.events) || (events = elemData.events = {}),
                            (eventHandle = elemData.handle) ||
                                (eventHandle = elemData.handle = function (e) {
                                    return void 0 !== jQuery && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : void 0;
                                }),
                            t = (types = (types || "").match(rnothtmlwhite) || [""]).length;
                        t--;

                    )
                        (type = origType = (tmp = rtypenamespace.exec(types[t]) || [])[1]),
                            (namespaces = (tmp[2] || "").split(".").sort()),
                            type &&
                                ((special = jQuery.event.special[type] || {}),
                                (type = (selector ? special.delegateType : special.bindType) || type),
                                (special = jQuery.event.special[type] || {}),
                                (handleObj = jQuery.extend(
                                    {
                                        type: type,
                                        origType: origType,
                                        data: data,
                                        handler: handler,
                                        guid: handler.guid,
                                        selector: selector,
                                        needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                                        namespace: namespaces.join("."),
                                    },
                                    handleObjIn
                                )),
                                (handlers = events[type]) ||
                                    (((handlers = events[type] = []).delegateCount = 0),
                                    (special.setup && !1 !== special.setup.call(elem, data, namespaces, eventHandle)) || (elem.addEventListener && elem.addEventListener(type, eventHandle))),
                                special.add && (special.add.call(elem, handleObj), handleObj.handler.guid || (handleObj.handler.guid = handler.guid)),
                                selector ? handlers.splice(handlers.delegateCount++, 0, handleObj) : handlers.push(handleObj),
                                (jQuery.event.global[type] = !0));
            },
            remove: function (elem, types, handler, selector, mappedTypes) {
                var j,
                    origCount,
                    tmp,
                    events,
                    t,
                    handleObj,
                    special,
                    handlers,
                    type,
                    namespaces,
                    origType,
                    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
                if (elemData && (events = elemData.events)) {
                    for (t = (types = (types || "").match(rnothtmlwhite) || [""]).length; t--; )
                        if (((type = origType = (tmp = rtypenamespace.exec(types[t]) || [])[1]), (namespaces = (tmp[2] || "").split(".").sort()), type)) {
                            for (
                                special = jQuery.event.special[type] || {},
                                    handlers = events[(type = (selector ? special.delegateType : special.bindType) || type)] || [],
                                    tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                                    origCount = j = handlers.length;
                                j--;

                            )
                                (handleObj = handlers[j]),
                                    (!mappedTypes && origType !== handleObj.origType) ||
                                        (handler && handler.guid !== handleObj.guid) ||
                                        (tmp && !tmp.test(handleObj.namespace)) ||
                                        (selector && selector !== handleObj.selector && ("**" !== selector || !handleObj.selector)) ||
                                        (handlers.splice(j, 1), handleObj.selector && handlers.delegateCount--, special.remove && special.remove.call(elem, handleObj));
                            origCount && !handlers.length && ((special.teardown && !1 !== special.teardown.call(elem, namespaces, elemData.handle)) || jQuery.removeEvent(elem, type, elemData.handle), delete events[type]);
                        } else for (type in events) jQuery.event.remove(elem, type + types[t], handler, selector, !0);
                    jQuery.isEmptyObject(events) && dataPriv.remove(elem, "handle events");
                }
            },
            dispatch: function (nativeEvent) {
                var i,
                    j,
                    ret,
                    matched,
                    handleObj,
                    handlerQueue,
                    event = jQuery.event.fix(nativeEvent),
                    args = new Array(arguments.length),
                    handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
                    special = jQuery.event.special[event.type] || {};
                for (args[0] = event, i = 1; i < arguments.length; i++) args[i] = arguments[i];
                if (((event.delegateTarget = this), !special.preDispatch || !1 !== special.preDispatch.call(this, event))) {
                    for (handlerQueue = jQuery.event.handlers.call(this, event, handlers), i = 0; (matched = handlerQueue[i++]) && !event.isPropagationStopped(); )
                        for (event.currentTarget = matched.elem, j = 0; (handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped(); )
                            (event.rnamespace && !event.rnamespace.test(handleObj.namespace)) ||
                                ((event.handleObj = handleObj),
                                (event.data = handleObj.data),
                                void 0 !== (ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args)) &&
                                    !1 === (event.result = ret) &&
                                    (event.preventDefault(), event.stopPropagation()));
                    return special.postDispatch && special.postDispatch.call(this, event), event.result;
                }
            },
            handlers: function (event, handlers) {
                var i,
                    handleObj,
                    sel,
                    matchedHandlers,
                    matchedSelectors,
                    handlerQueue = [],
                    delegateCount = handlers.delegateCount,
                    cur = event.target;
                if (delegateCount && cur.nodeType && !("click" === event.type && 1 <= event.button))
                    for (; cur !== this; cur = cur.parentNode || this)
                        if (1 === cur.nodeType && ("click" !== event.type || !0 !== cur.disabled)) {
                            for (matchedHandlers = [], matchedSelectors = {}, i = 0; i < delegateCount; i++)
                                void 0 === matchedSelectors[(sel = (handleObj = handlers[i]).selector + " ")] &&
                                    (matchedSelectors[sel] = handleObj.needsContext ? -1 < jQuery(sel, this).index(cur) : jQuery.find(sel, this, null, [cur]).length),
                                    matchedSelectors[sel] && matchedHandlers.push(handleObj);
                            matchedHandlers.length && handlerQueue.push({ elem: cur, handlers: matchedHandlers });
                        }
                return (cur = this), delegateCount < handlers.length && handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) }), handlerQueue;
            },
            addProp: function (name, hook) {
                Object.defineProperty(jQuery.Event.prototype, name, {
                    enumerable: !0,
                    configurable: !0,
                    get: isFunction(hook)
                        ? function () {
                              if (this.originalEvent) return hook(this.originalEvent);
                          }
                        : function () {
                              if (this.originalEvent) return this.originalEvent[name];
                          },
                    set: function (value) {
                        Object.defineProperty(this, name, { enumerable: !0, configurable: !0, writable: !0, value: value });
                    },
                });
            },
            fix: function (originalEvent) {
                return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
            },
            special: {
                load: { noBubble: !0 },
                focus: {
                    trigger: function () {
                        if (this !== safeActiveElement() && this.focus) return this.focus(), !1;
                    },
                    delegateType: "focusin",
                },
                blur: {
                    trigger: function () {
                        if (this === safeActiveElement() && this.blur) return this.blur(), !1;
                    },
                    delegateType: "focusout",
                },
                click: {
                    trigger: function () {
                        if ("checkbox" === this.type && this.click && nodeName(this, "input")) return this.click(), !1;
                    },
                    _default: function (event) {
                        return nodeName(event.target, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (event) {
                        void 0 !== event.result && event.originalEvent && (event.originalEvent.returnValue = event.result);
                    },
                },
            },
        }),
            (jQuery.removeEvent = function (elem, type, handle) {
                elem.removeEventListener && elem.removeEventListener(type, handle);
            }),
            (jQuery.Event = function (src, props) {
                if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
                src && src.type
                    ? ((this.originalEvent = src),
                      (this.type = src.type),
                      (this.isDefaultPrevented = src.defaultPrevented || (void 0 === src.defaultPrevented && !1 === src.returnValue) ? returnTrue : returnFalse),
                      (this.target = src.target && 3 === src.target.nodeType ? src.target.parentNode : src.target),
                      (this.currentTarget = src.currentTarget),
                      (this.relatedTarget = src.relatedTarget))
                    : (this.type = src),
                    props && jQuery.extend(this, props),
                    (this.timeStamp = (src && src.timeStamp) || Date.now()),
                    (this[jQuery.expando] = !0);
            }),
            (jQuery.Event.prototype = {
                constructor: jQuery.Event,
                isDefaultPrevented: returnFalse,
                isPropagationStopped: returnFalse,
                isImmediatePropagationStopped: returnFalse,
                isSimulated: !1,
                preventDefault: function () {
                    var e = this.originalEvent;
                    (this.isDefaultPrevented = returnTrue), e && !this.isSimulated && e.preventDefault();
                },
                stopPropagation: function () {
                    var e = this.originalEvent;
                    (this.isPropagationStopped = returnTrue), e && !this.isSimulated && e.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var e = this.originalEvent;
                    (this.isImmediatePropagationStopped = returnTrue), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            jQuery.each(
                {
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: function (event) {
                        var button = event.button;
                        return null == event.which && rkeyEvent.test(event.type)
                            ? null != event.charCode
                                ? event.charCode
                                : event.keyCode
                            : !event.which && void 0 !== button && rmouseEvent.test(event.type)
                            ? 1 & button
                                ? 1
                                : 2 & button
                                ? 3
                                : 4 & button
                                ? 2
                                : 0
                            : event.which;
                    },
                },
                jQuery.event.addProp
            ),
            jQuery.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (orig, fix) {
                jQuery.event.special[orig] = {
                    delegateType: fix,
                    bindType: fix,
                    handle: function (event) {
                        var ret,
                            related = event.relatedTarget,
                            handleObj = event.handleObj;
                        return (related && (related === this || jQuery.contains(this, related))) || ((event.type = handleObj.origType), (ret = handleObj.handler.apply(this, arguments)), (event.type = fix)), ret;
                    },
                };
            }),
            jQuery.fn.extend({
                on: function (types, selector, data, fn) {
                    return on(this, types, selector, data, fn);
                },
                one: function (types, selector, data, fn) {
                    return on(this, types, selector, data, fn, 1);
                },
                off: function (types, selector, fn) {
                    var handleObj, type;
                    if (types && types.preventDefault && types.handleObj)
                        return (handleObj = types.handleObj), jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler), this;
                    if ("object" != typeof types)
                        return (
                            (!1 !== selector && "function" != typeof selector) || ((fn = selector), (selector = void 0)),
                            !1 === fn && (fn = returnFalse),
                            this.each(function () {
                                jQuery.event.remove(this, types, fn, selector);
                            })
                        );
                    for (type in types) this.off(type, selector, types[type]);
                    return this;
                },
            });
        var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
            rnoInnerhtml = /<script|<style|<link/i,
            rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
            rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        function manipulationTarget(elem, content) {
            return (nodeName(elem, "table") && nodeName(11 !== content.nodeType ? content : content.firstChild, "tr") && jQuery(elem).children("tbody")[0]) || elem;
        }
        function disableScript(elem) {
            return (elem.type = (null !== elem.getAttribute("type")) + "/" + elem.type), elem;
        }
        function restoreScript(elem) {
            return "true/" === (elem.type || "").slice(0, 5) ? (elem.type = elem.type.slice(5)) : elem.removeAttribute("type"), elem;
        }
        function cloneCopyEvent(src, dest) {
            var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
            if (1 === dest.nodeType) {
                if (dataPriv.hasData(src) && ((pdataOld = dataPriv.access(src)), (pdataCur = dataPriv.set(dest, pdataOld)), (events = pdataOld.events)))
                    for (type in (delete pdataCur.handle, (pdataCur.events = {}), events)) for (i = 0, l = events[type].length; i < l; i++) jQuery.event.add(dest, type, events[type][i]);
                dataUser.hasData(src) && ((udataOld = dataUser.access(src)), (udataCur = jQuery.extend({}, udataOld)), dataUser.set(dest, udataCur));
            }
        }
        function domManip(collection, args, callback, ignored) {
            args = concat.apply([], args);
            var fragment,
                first,
                scripts,
                hasScripts,
                node,
                doc,
                i = 0,
                l = collection.length,
                iNoClone = l - 1,
                value = args[0],
                valueIsFunction = isFunction(value);
            if (valueIsFunction || (1 < l && "string" == typeof value && !support.checkClone && rchecked.test(value)))
                return collection.each(function (index) {
                    var self = collection.eq(index);
                    valueIsFunction && (args[0] = value.call(this, index, self.html())), domManip(self, args, callback, ignored);
                });
            if (l && ((first = (fragment = buildFragment(args, collection[0].ownerDocument, !1, collection, ignored)).firstChild), 1 === fragment.childNodes.length && (fragment = first), first || ignored)) {
                for (hasScripts = (scripts = jQuery.map(getAll(fragment, "script"), disableScript)).length; i < l; i++)
                    (node = fragment), i !== iNoClone && ((node = jQuery.clone(node, !0, !0)), hasScripts && jQuery.merge(scripts, getAll(node, "script"))), callback.call(collection[i], node, i);
                if (hasScripts)
                    for (doc = scripts[scripts.length - 1].ownerDocument, jQuery.map(scripts, restoreScript), i = 0; i < hasScripts; i++)
                        (node = scripts[i]),
                            rscriptType.test(node.type || "") &&
                                !dataPriv.access(node, "globalEval") &&
                                jQuery.contains(doc, node) &&
                                (node.src && "module" !== (node.type || "").toLowerCase() ? jQuery._evalUrl && jQuery._evalUrl(node.src) : DOMEval(node.textContent.replace(rcleanScript, ""), doc, node));
            }
            return collection;
        }
        function remove(elem, selector, keepData) {
            for (var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0; null != (node = nodes[i]); i++)
                keepData || 1 !== node.nodeType || jQuery.cleanData(getAll(node)), node.parentNode && (keepData && jQuery.contains(node.ownerDocument, node) && setGlobalEval(getAll(node, "script")), node.parentNode.removeChild(node));
            return elem;
        }
        jQuery.extend({
            htmlPrefilter: function (html) {
                return html.replace(rxhtmlTag, "<$1></$2>");
            },
            clone: function (elem, dataAndEvents, deepDataAndEvents) {
                var i,
                    l,
                    srcElements,
                    destElements,
                    src,
                    dest,
                    nodeName,
                    clone = elem.cloneNode(!0),
                    inPage = jQuery.contains(elem.ownerDocument, elem);
                if (!(support.noCloneChecked || (1 !== elem.nodeType && 11 !== elem.nodeType) || jQuery.isXMLDoc(elem)))
                    for (destElements = getAll(clone), i = 0, l = (srcElements = getAll(elem)).length; i < l; i++)
                        (src = srcElements[i]),
                            (dest = destElements[i]),
                            void 0,
                            "input" === (nodeName = dest.nodeName.toLowerCase()) && rcheckableType.test(src.type) ? (dest.checked = src.checked) : ("input" !== nodeName && "textarea" !== nodeName) || (dest.defaultValue = src.defaultValue);
                if (dataAndEvents)
                    if (deepDataAndEvents) for (srcElements = srcElements || getAll(elem), destElements = destElements || getAll(clone), i = 0, l = srcElements.length; i < l; i++) cloneCopyEvent(srcElements[i], destElements[i]);
                    else cloneCopyEvent(elem, clone);
                return 0 < (destElements = getAll(clone, "script")).length && setGlobalEval(destElements, !inPage && getAll(elem, "script")), clone;
            },
            cleanData: function (elems) {
                for (var data, elem, type, special = jQuery.event.special, i = 0; void 0 !== (elem = elems[i]); i++)
                    if (acceptData(elem)) {
                        if ((data = elem[dataPriv.expando])) {
                            if (data.events) for (type in data.events) special[type] ? jQuery.event.remove(elem, type) : jQuery.removeEvent(elem, type, data.handle);
                            elem[dataPriv.expando] = void 0;
                        }
                        elem[dataUser.expando] && (elem[dataUser.expando] = void 0);
                    }
            },
        }),
            jQuery.fn.extend({
                detach: function (selector) {
                    return remove(this, selector, !0);
                },
                remove: function (selector) {
                    return remove(this, selector);
                },
                text: function (value) {
                    return access(
                        this,
                        function (value) {
                            return void 0 === value
                                ? jQuery.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = value);
                                  });
                        },
                        null,
                        value,
                        arguments.length
                    );
                },
                append: function () {
                    return domManip(this, arguments, function (elem) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || manipulationTarget(this, elem).appendChild(elem);
                    });
                },
                prepend: function () {
                    return domManip(this, arguments, function (elem) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var target = manipulationTarget(this, elem);
                            target.insertBefore(elem, target.firstChild);
                        }
                    });
                },
                before: function () {
                    return domManip(this, arguments, function (elem) {
                        this.parentNode && this.parentNode.insertBefore(elem, this);
                    });
                },
                after: function () {
                    return domManip(this, arguments, function (elem) {
                        this.parentNode && this.parentNode.insertBefore(elem, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var elem, i = 0; null != (elem = this[i]); i++) 1 === elem.nodeType && (jQuery.cleanData(getAll(elem, !1)), (elem.textContent = ""));
                    return this;
                },
                clone: function (dataAndEvents, deepDataAndEvents) {
                    return (
                        (dataAndEvents = null != dataAndEvents && dataAndEvents),
                        (deepDataAndEvents = null == deepDataAndEvents ? dataAndEvents : deepDataAndEvents),
                        this.map(function () {
                            return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
                        })
                    );
                },
                html: function (value) {
                    return access(
                        this,
                        function (value) {
                            var elem = this[0] || {},
                                i = 0,
                                l = this.length;
                            if (void 0 === value && 1 === elem.nodeType) return elem.innerHTML;
                            if ("string" == typeof value && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
                                value = jQuery.htmlPrefilter(value);
                                try {
                                    for (; i < l; i++) 1 === (elem = this[i] || {}).nodeType && (jQuery.cleanData(getAll(elem, !1)), (elem.innerHTML = value));
                                    elem = 0;
                                } catch (e) {}
                            }
                            elem && this.empty().append(value);
                        },
                        null,
                        value,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var ignored = [];
                    return domManip(
                        this,
                        arguments,
                        function (elem) {
                            var parent = this.parentNode;
                            jQuery.inArray(this, ignored) < 0 && (jQuery.cleanData(getAll(this)), parent && parent.replaceChild(elem, this));
                        },
                        ignored
                    );
                },
            }),
            jQuery.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (name, original) {
                jQuery.fn[name] = function (selector) {
                    for (var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0; i <= last; i++) (elems = i === last ? this : this.clone(!0)), jQuery(insert[i])[original](elems), push.apply(ret, elems.get());
                    return this.pushStack(ret);
                };
            });
        var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i"),
            getStyles = function (elem) {
                var view = elem.ownerDocument.defaultView;
                return (view && view.opener) || (view = window), view.getComputedStyle(elem);
            },
            rboxStyle = new RegExp(cssExpand.join("|"), "i");
        function curCSS(elem, name, computed) {
            var width,
                minWidth,
                maxWidth,
                ret,
                style = elem.style;
            return (
                (computed = computed || getStyles(elem)) &&
                    ("" !== (ret = computed.getPropertyValue(name) || computed[name]) || jQuery.contains(elem.ownerDocument, elem) || (ret = jQuery.style(elem, name)),
                    !support.pixelBoxStyles() &&
                        rnumnonpx.test(ret) &&
                        rboxStyle.test(name) &&
                        ((width = style.width),
                        (minWidth = style.minWidth),
                        (maxWidth = style.maxWidth),
                        (style.minWidth = style.maxWidth = style.width = ret),
                        (ret = computed.width),
                        (style.width = width),
                        (style.minWidth = minWidth),
                        (style.maxWidth = maxWidth))),
                void 0 !== ret ? ret + "" : ret
            );
        }
        function addGetHookIf(conditionFn, hookFn) {
            return {
                get: function () {
                    if (!conditionFn()) return (this.get = hookFn).apply(this, arguments);
                    delete this.get;
                },
            };
        }
        !(function () {
            function computeStyleTests() {
                if (div) {
                    (container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                        (div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                        documentElement.appendChild(container).appendChild(div);
                    var divStyle = window.getComputedStyle(div);
                    (pixelPositionVal = "1%" !== divStyle.top),
                        (reliableMarginLeftVal = 12 === roundPixelMeasures(divStyle.marginLeft)),
                        (div.style.right = "60%"),
                        (pixelBoxStylesVal = 36 === roundPixelMeasures(divStyle.right)),
                        (boxSizingReliableVal = 36 === roundPixelMeasures(divStyle.width)),
                        (div.style.position = "absolute"),
                        (scrollboxSizeVal = 36 === div.offsetWidth || "absolute"),
                        documentElement.removeChild(container),
                        (div = null);
                }
            }
            function roundPixelMeasures(measure) {
                return Math.round(parseFloat(measure));
            }
            var pixelPositionVal,
                boxSizingReliableVal,
                scrollboxSizeVal,
                pixelBoxStylesVal,
                reliableMarginLeftVal,
                container = document.createElement("div"),
                div = document.createElement("div");
            div.style &&
                ((div.style.backgroundClip = "content-box"),
                (div.cloneNode(!0).style.backgroundClip = ""),
                (support.clearCloneStyle = "content-box" === div.style.backgroundClip),
                jQuery.extend(support, {
                    boxSizingReliable: function () {
                        return computeStyleTests(), boxSizingReliableVal;
                    },
                    pixelBoxStyles: function () {
                        return computeStyleTests(), pixelBoxStylesVal;
                    },
                    pixelPosition: function () {
                        return computeStyleTests(), pixelPositionVal;
                    },
                    reliableMarginLeft: function () {
                        return computeStyleTests(), reliableMarginLeftVal;
                    },
                    scrollboxSize: function () {
                        return computeStyleTests(), scrollboxSizeVal;
                    },
                }));
        })();
        var rdisplayswap = /^(none|table(?!-c[ea]).+)/,
            rcustomProp = /^--/,
            cssShow = { position: "absolute", visibility: "hidden", display: "block" },
            cssNormalTransform = { letterSpacing: "0", fontWeight: "400" },
            cssPrefixes = ["Webkit", "Moz", "ms"],
            emptyStyle = document.createElement("div").style;
        function finalPropName(name) {
            var ret = jQuery.cssProps[name];
            return (ret =
                ret ||
                (jQuery.cssProps[name] =
                    (function (name) {
                        if (name in emptyStyle) return name;
                        for (var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length; i--; ) if ((name = cssPrefixes[i] + capName) in emptyStyle) return name;
                    })(name) || name));
        }
        function setPositiveNumber(elem, value, subtract) {
            var matches = rcssNum.exec(value);
            return matches ? Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
        }
        function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
            var i = "width" === dimension ? 1 : 0,
                extra = 0,
                delta = 0;
            if (box === (isBorderBox ? "border" : "content")) return 0;
            for (; i < 4; i += 2)
                "margin" === box && (delta += jQuery.css(elem, box + cssExpand[i], !0, styles)),
                    isBorderBox
                        ? ("content" === box && (delta -= jQuery.css(elem, "padding" + cssExpand[i], !0, styles)), "margin" !== box && (delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", !0, styles)))
                        : ((delta += jQuery.css(elem, "padding" + cssExpand[i], !0, styles)),
                          "padding" !== box ? (delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", !0, styles)) : (extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", !0, styles)));
            return !isBorderBox && 0 <= computedVal && (delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5))), delta;
        }
        function getWidthOrHeight(elem, dimension, extra) {
            var styles = getStyles(elem),
                val = curCSS(elem, dimension, styles),
                isBorderBox = "border-box" === jQuery.css(elem, "boxSizing", !1, styles),
                valueIsBorderBox = isBorderBox;
            if (rnumnonpx.test(val)) {
                if (!extra) return val;
                val = "auto";
            }
            return (
                (valueIsBorderBox = valueIsBorderBox && (support.boxSizingReliable() || val === elem.style[dimension])),
                ("auto" !== val && (parseFloat(val) || "inline" !== jQuery.css(elem, "display", !1, styles))) || ((val = elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)]), (valueIsBorderBox = !0)),
                (val = parseFloat(val) || 0) + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, val) + "px"
            );
        }
        function Tween(elem, options, prop, end, easing) {
            return new Tween.prototype.init(elem, options, prop, end, easing);
        }
        jQuery.extend({
            cssHooks: {
                opacity: {
                    get: function (elem, computed) {
                        if (computed) {
                            var ret = curCSS(elem, "opacity");
                            return "" === ret ? "1" : ret;
                        }
                    },
                },
            },
            cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
            cssProps: {},
            style: function (elem, name, value, extra) {
                if (elem && 3 !== elem.nodeType && 8 !== elem.nodeType && elem.style) {
                    var ret,
                        type,
                        hooks,
                        origName = camelCase(name),
                        isCustomProp = rcustomProp.test(name),
                        style = elem.style;
                    if ((isCustomProp || (name = finalPropName(origName)), (hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]), void 0 === value))
                        return hooks && "get" in hooks && void 0 !== (ret = hooks.get(elem, !1, extra)) ? ret : style[name];
                    "string" === (type = typeof value) && (ret = rcssNum.exec(value)) && ret[1] && ((value = adjustCSS(elem, name, ret)), (type = "number")),
                        null != value &&
                            value == value &&
                            ("number" === type && (value += (ret && ret[3]) || (jQuery.cssNumber[origName] ? "" : "px")),
                            support.clearCloneStyle || "" !== value || 0 !== name.indexOf("background") || (style[name] = "inherit"),
                            (hooks && "set" in hooks && void 0 === (value = hooks.set(elem, value, extra))) || (isCustomProp ? style.setProperty(name, value) : (style[name] = value)));
                }
            },
            css: function (elem, name, extra, styles) {
                var val,
                    num,
                    hooks,
                    origName = camelCase(name);
                return (
                    rcustomProp.test(name) || (name = finalPropName(origName)),
                    (hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]) && "get" in hooks && (val = hooks.get(elem, !0, extra)),
                    void 0 === val && (val = curCSS(elem, name, styles)),
                    "normal" === val && name in cssNormalTransform && (val = cssNormalTransform[name]),
                    "" === extra || extra ? ((num = parseFloat(val)), !0 === extra || isFinite(num) ? num || 0 : val) : val
                );
            },
        }),
            jQuery.each(["height", "width"], function (i, dimension) {
                jQuery.cssHooks[dimension] = {
                    get: function (elem, computed, extra) {
                        if (computed)
                            return !rdisplayswap.test(jQuery.css(elem, "display")) || (elem.getClientRects().length && elem.getBoundingClientRect().width)
                                ? getWidthOrHeight(elem, dimension, extra)
                                : swap(elem, cssShow, function () {
                                      return getWidthOrHeight(elem, dimension, extra);
                                  });
                    },
                    set: function (elem, value, extra) {
                        var matches,
                            styles = getStyles(elem),
                            isBorderBox = "border-box" === jQuery.css(elem, "boxSizing", !1, styles),
                            subtract = extra && boxModelAdjustment(elem, dimension, extra, isBorderBox, styles);
                        return (
                            isBorderBox &&
                                support.scrollboxSize() === styles.position &&
                                (subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", !1, styles) - 0.5)),
                            subtract && (matches = rcssNum.exec(value)) && "px" !== (matches[3] || "px") && ((elem.style[dimension] = value), (value = jQuery.css(elem, dimension))),
                            setPositiveNumber(0, value, subtract)
                        );
                    },
                };
            }),
            (jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
                if (computed)
                    return (
                        (parseFloat(curCSS(elem, "marginLeft")) ||
                            elem.getBoundingClientRect().left -
                                swap(elem, { marginLeft: 0 }, function () {
                                    return elem.getBoundingClientRect().left;
                                })) + "px"
                    );
            })),
            jQuery.each({ margin: "", padding: "", border: "Width" }, function (prefix, suffix) {
                (jQuery.cssHooks[prefix + suffix] = {
                    expand: function (value) {
                        for (var i = 0, expanded = {}, parts = "string" == typeof value ? value.split(" ") : [value]; i < 4; i++) expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                        return expanded;
                    },
                }),
                    "margin" !== prefix && (jQuery.cssHooks[prefix + suffix].set = setPositiveNumber);
            }),
            jQuery.fn.extend({
                css: function (name, value) {
                    return access(
                        this,
                        function (elem, name, value) {
                            var styles,
                                len,
                                map = {},
                                i = 0;
                            if (Array.isArray(name)) {
                                for (styles = getStyles(elem), len = name.length; i < len; i++) map[name[i]] = jQuery.css(elem, name[i], !1, styles);
                                return map;
                            }
                            return void 0 !== value ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
                        },
                        name,
                        value,
                        1 < arguments.length
                    );
                },
            }),
            (((jQuery.Tween = Tween).prototype = {
                constructor: Tween,
                init: function (elem, options, prop, end, easing, unit) {
                    (this.elem = elem),
                        (this.prop = prop),
                        (this.easing = easing || jQuery.easing._default),
                        (this.options = options),
                        (this.start = this.now = this.cur()),
                        (this.end = end),
                        (this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px"));
                },
                cur: function () {
                    var hooks = Tween.propHooks[this.prop];
                    return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
                },
                run: function (percent) {
                    var eased,
                        hooks = Tween.propHooks[this.prop];
                    return (
                        this.options.duration ? (this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration)) : (this.pos = eased = percent),
                        (this.now = (this.end - this.start) * eased + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        hooks && hooks.set ? hooks.set(this) : Tween.propHooks._default.set(this),
                        this
                    );
                },
            }).init.prototype = Tween.prototype),
            ((Tween.propHooks = {
                _default: {
                    get: function (tween) {
                        var result;
                        return 1 !== tween.elem.nodeType || (null != tween.elem[tween.prop] && null == tween.elem.style[tween.prop])
                            ? tween.elem[tween.prop]
                            : (result = jQuery.css(tween.elem, tween.prop, "")) && "auto" !== result
                            ? result
                            : 0;
                    },
                    set: function (tween) {
                        jQuery.fx.step[tween.prop]
                            ? jQuery.fx.step[tween.prop](tween)
                            : 1 !== tween.elem.nodeType || (null == tween.elem.style[jQuery.cssProps[tween.prop]] && !jQuery.cssHooks[tween.prop])
                            ? (tween.elem[tween.prop] = tween.now)
                            : jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                    },
                },
            }).scrollTop = Tween.propHooks.scrollLeft = {
                set: function (tween) {
                    tween.elem.nodeType && tween.elem.parentNode && (tween.elem[tween.prop] = tween.now);
                },
            }),
            (jQuery.easing = {
                linear: function (p) {
                    return p;
                },
                swing: function (p) {
                    return 0.5 - Math.cos(p * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (jQuery.fx = Tween.prototype.init),
            (jQuery.fx.step = {});
        var fxNow,
            inProgress,
            rfxtypes = /^(?:toggle|show|hide)$/,
            rrun = /queueHooks$/;
        function schedule() {
            inProgress && (!1 === document.hidden && window.requestAnimationFrame ? window.requestAnimationFrame(schedule) : window.setTimeout(schedule, jQuery.fx.interval), jQuery.fx.tick());
        }
        function createFxNow() {
            return (
                window.setTimeout(function () {
                    fxNow = void 0;
                }),
                (fxNow = Date.now())
            );
        }
        function genFx(type, includeWidth) {
            var which,
                i = 0,
                attrs = { height: type };
            for (includeWidth = includeWidth ? 1 : 0; i < 4; i += 2 - includeWidth) attrs["margin" + (which = cssExpand[i])] = attrs["padding" + which] = type;
            return includeWidth && (attrs.opacity = attrs.width = type), attrs;
        }
        function createTween(value, prop, animation) {
            for (var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length; index < length; index++)
                if ((tween = collection[index].call(animation, prop, value))) return tween;
        }
        function Animation(elem, properties, options) {
            var result,
                stopped,
                index = 0,
                length = Animation.prefilters.length,
                deferred = jQuery.Deferred().always(function () {
                    delete tick.elem;
                }),
                tick = function () {
                    if (stopped) return !1;
                    for (
                        var currentTime = fxNow || createFxNow(),
                            remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
                            percent = 1 - (remaining / animation.duration || 0),
                            index = 0,
                            length = animation.tweens.length;
                        index < length;
                        index++
                    )
                        animation.tweens[index].run(percent);
                    return deferred.notifyWith(elem, [animation, percent, remaining]), percent < 1 && length ? remaining : (length || deferred.notifyWith(elem, [animation, 1, 0]), deferred.resolveWith(elem, [animation]), !1);
                },
                animation = deferred.promise({
                    elem: elem,
                    props: jQuery.extend({}, properties),
                    opts: jQuery.extend(!0, { specialEasing: {}, easing: jQuery.easing._default }, options),
                    originalProperties: properties,
                    originalOptions: options,
                    startTime: fxNow || createFxNow(),
                    duration: options.duration,
                    tweens: [],
                    createTween: function (prop, end) {
                        var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                        return animation.tweens.push(tween), tween;
                    },
                    stop: function (gotoEnd) {
                        var index = 0,
                            length = gotoEnd ? animation.tweens.length : 0;
                        if (stopped) return this;
                        for (stopped = !0; index < length; index++) animation.tweens[index].run(1);
                        return gotoEnd ? (deferred.notifyWith(elem, [animation, 1, 0]), deferred.resolveWith(elem, [animation, gotoEnd])) : deferred.rejectWith(elem, [animation, gotoEnd]), this;
                    },
                }),
                props = animation.props;
            for (
                !(function (props, specialEasing) {
                    var index, name, easing, value, hooks;
                    for (index in props)
                        if (
                            ((easing = specialEasing[(name = camelCase(index))]),
                            (value = props[index]),
                            Array.isArray(value) && ((easing = value[1]), (value = props[index] = value[0])),
                            index !== name && ((props[name] = value), delete props[index]),
                            (hooks = jQuery.cssHooks[name]) && ("expand" in hooks))
                        )
                            for (index in ((value = hooks.expand(value)), delete props[name], value)) (index in props) || ((props[index] = value[index]), (specialEasing[index] = easing));
                        else specialEasing[name] = easing;
                })(props, animation.opts.specialEasing);
                index < length;
                index++
            )
                if ((result = Animation.prefilters[index].call(animation, elem, props, animation.opts))) return isFunction(result.stop) && (jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result)), result;
            return (
                jQuery.map(props, createTween, animation),
                isFunction(animation.opts.start) && animation.opts.start.call(elem, animation),
                animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always),
                jQuery.fx.timer(jQuery.extend(tick, { elem: elem, anim: animation, queue: animation.opts.queue })),
                animation
            );
        }
        (jQuery.Animation = jQuery.extend(Animation, {
            tweeners: {
                "*": [
                    function (prop, value) {
                        var tween = this.createTween(prop, value);
                        return adjustCSS(tween.elem, prop, rcssNum.exec(value), tween), tween;
                    },
                ],
            },
            tweener: function (props, callback) {
                for (var prop, index = 0, length = (props = isFunction(props) ? ((callback = props), ["*"]) : props.match(rnothtmlwhite)).length; index < length; index++)
                    (prop = props[index]), (Animation.tweeners[prop] = Animation.tweeners[prop] || []), Animation.tweeners[prop].unshift(callback);
            },
            prefilters: [
                function (elem, props, opts) {
                    var prop,
                        value,
                        toggle,
                        hooks,
                        oldfire,
                        propTween,
                        restoreDisplay,
                        display,
                        isBox = "width" in props || "height" in props,
                        anim = this,
                        orig = {},
                        style = elem.style,
                        hidden = elem.nodeType && isHiddenWithinTree(elem),
                        dataShow = dataPriv.get(elem, "fxshow");
                    for (prop in (opts.queue ||
                        (null == (hooks = jQuery._queueHooks(elem, "fx")).unqueued &&
                            ((hooks.unqueued = 0),
                            (oldfire = hooks.empty.fire),
                            (hooks.empty.fire = function () {
                                hooks.unqueued || oldfire();
                            })),
                        hooks.unqueued++,
                        anim.always(function () {
                            anim.always(function () {
                                hooks.unqueued--, jQuery.queue(elem, "fx").length || hooks.empty.fire();
                            });
                        })),
                    props))
                        if (((value = props[prop]), rfxtypes.test(value))) {
                            if ((delete props[prop], (toggle = toggle || "toggle" === value), value === (hidden ? "hide" : "show"))) {
                                if ("show" !== value || !dataShow || void 0 === dataShow[prop]) continue;
                                hidden = !0;
                            }
                            orig[prop] = (dataShow && dataShow[prop]) || jQuery.style(elem, prop);
                        }
                    if ((propTween = !jQuery.isEmptyObject(props)) || !jQuery.isEmptyObject(orig))
                        for (prop in (isBox &&
                            1 === elem.nodeType &&
                            ((opts.overflow = [style.overflow, style.overflowX, style.overflowY]),
                            null == (restoreDisplay = dataShow && dataShow.display) && (restoreDisplay = dataPriv.get(elem, "display")),
                            "none" === (display = jQuery.css(elem, "display")) &&
                                (restoreDisplay ? (display = restoreDisplay) : (showHide([elem], !0), (restoreDisplay = elem.style.display || restoreDisplay), (display = jQuery.css(elem, "display")), showHide([elem]))),
                            ("inline" === display || ("inline-block" === display && null != restoreDisplay)) &&
                                "none" === jQuery.css(elem, "float") &&
                                (propTween ||
                                    (anim.done(function () {
                                        style.display = restoreDisplay;
                                    }),
                                    null == restoreDisplay && ((display = style.display), (restoreDisplay = "none" === display ? "" : display))),
                                (style.display = "inline-block"))),
                        opts.overflow &&
                            ((style.overflow = "hidden"),
                            anim.always(function () {
                                (style.overflow = opts.overflow[0]), (style.overflowX = opts.overflow[1]), (style.overflowY = opts.overflow[2]);
                            })),
                        (propTween = !1),
                        orig))
                            propTween ||
                                (dataShow ? "hidden" in dataShow && (hidden = dataShow.hidden) : (dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay })),
                                toggle && (dataShow.hidden = !hidden),
                                hidden && showHide([elem], !0),
                                anim.done(function () {
                                    for (prop in (hidden || showHide([elem]), dataPriv.remove(elem, "fxshow"), orig)) jQuery.style(elem, prop, orig[prop]);
                                })),
                                (propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim)),
                                prop in dataShow || ((dataShow[prop] = propTween.start), hidden && ((propTween.end = propTween.start), (propTween.start = 0)));
                },
            ],
            prefilter: function (callback, prepend) {
                prepend ? Animation.prefilters.unshift(callback) : Animation.prefilters.push(callback);
            },
        })),
            (jQuery.speed = function (speed, easing, fn) {
                var opt =
                    speed && "object" == typeof speed ? jQuery.extend({}, speed) : { complete: fn || (!fn && easing) || (isFunction(speed) && speed), duration: speed, easing: (fn && easing) || (easing && !isFunction(easing) && easing) };
                return (
                    jQuery.fx.off ? (opt.duration = 0) : "number" != typeof opt.duration && (opt.duration in jQuery.fx.speeds ? (opt.duration = jQuery.fx.speeds[opt.duration]) : (opt.duration = jQuery.fx.speeds._default)),
                    (null != opt.queue && !0 !== opt.queue) || (opt.queue = "fx"),
                    (opt.old = opt.complete),
                    (opt.complete = function () {
                        isFunction(opt.old) && opt.old.call(this), opt.queue && jQuery.dequeue(this, opt.queue);
                    }),
                    opt
                );
            }),
            jQuery.fn.extend({
                fadeTo: function (speed, to, easing, callback) {
                    return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
                },
                animate: function (prop, speed, easing, callback) {
                    function doAnimation() {
                        var anim = Animation(this, jQuery.extend({}, prop), optall);
                        (empty || dataPriv.get(this, "finish")) && anim.stop(!0);
                    }
                    var empty = jQuery.isEmptyObject(prop),
                        optall = jQuery.speed(speed, easing, callback);
                    return (doAnimation.finish = doAnimation), empty || !1 === optall.queue ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
                },
                stop: function (type, clearQueue, gotoEnd) {
                    function stopQueue(hooks) {
                        var stop = hooks.stop;
                        delete hooks.stop, stop(gotoEnd);
                    }
                    return (
                        "string" != typeof type && ((gotoEnd = clearQueue), (clearQueue = type), (type = void 0)),
                        clearQueue && !1 !== type && this.queue(type || "fx", []),
                        this.each(function () {
                            var dequeue = !0,
                                index = null != type && type + "queueHooks",
                                timers = jQuery.timers,
                                data = dataPriv.get(this);
                            if (index) data[index] && data[index].stop && stopQueue(data[index]);
                            else for (index in data) data[index] && data[index].stop && rrun.test(index) && stopQueue(data[index]);
                            for (index = timers.length; index--; ) timers[index].elem !== this || (null != type && timers[index].queue !== type) || (timers[index].anim.stop(gotoEnd), (dequeue = !1), timers.splice(index, 1));
                            (!dequeue && gotoEnd) || jQuery.dequeue(this, type);
                        })
                    );
                },
                finish: function (type) {
                    return (
                        !1 !== type && (type = type || "fx"),
                        this.each(function () {
                            var index,
                                data = dataPriv.get(this),
                                queue = data[type + "queue"],
                                hooks = data[type + "queueHooks"],
                                timers = jQuery.timers,
                                length = queue ? queue.length : 0;
                            for (data.finish = !0, jQuery.queue(this, type, []), hooks && hooks.stop && hooks.stop.call(this, !0), index = timers.length; index--; )
                                timers[index].elem === this && timers[index].queue === type && (timers[index].anim.stop(!0), timers.splice(index, 1));
                            for (index = 0; index < length; index++) queue[index] && queue[index].finish && queue[index].finish.call(this);
                            delete data.finish;
                        })
                    );
                },
            }),
            jQuery.each(["toggle", "show", "hide"], function (i, name) {
                var cssFn = jQuery.fn[name];
                jQuery.fn[name] = function (speed, easing, callback) {
                    return null == speed || "boolean" == typeof speed ? cssFn.apply(this, arguments) : this.animate(genFx(name, !0), speed, easing, callback);
                };
            }),
            jQuery.each({ slideDown: genFx("show"), slideUp: genFx("hide"), slideToggle: genFx("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (name, props) {
                jQuery.fn[name] = function (speed, easing, callback) {
                    return this.animate(props, speed, easing, callback);
                };
            }),
            (jQuery.timers = []),
            (jQuery.fx.tick = function () {
                var timer,
                    i = 0,
                    timers = jQuery.timers;
                for (fxNow = Date.now(); i < timers.length; i++) (timer = timers[i])() || timers[i] !== timer || timers.splice(i--, 1);
                timers.length || jQuery.fx.stop(), (fxNow = void 0);
            }),
            (jQuery.fx.timer = function (timer) {
                jQuery.timers.push(timer), jQuery.fx.start();
            }),
            (jQuery.fx.interval = 13),
            (jQuery.fx.start = function () {
                inProgress || ((inProgress = !0), schedule());
            }),
            (jQuery.fx.stop = function () {
                inProgress = null;
            }),
            (jQuery.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (jQuery.fn.delay = function (time, type) {
                return (
                    (time = (jQuery.fx && jQuery.fx.speeds[time]) || time),
                    (type = type || "fx"),
                    this.queue(type, function (next, hooks) {
                        var timeout = window.setTimeout(next, time);
                        hooks.stop = function () {
                            window.clearTimeout(timeout);
                        };
                    })
                );
            }),
            (function () {
                var input = document.createElement("input"),
                    opt = document.createElement("select").appendChild(document.createElement("option"));
                (input.type = "checkbox"),
                    (support.checkOn = "" !== input.value),
                    (support.optSelected = opt.selected),
                    ((input = document.createElement("input")).value = "t"),
                    (input.type = "radio"),
                    (support.radioValue = "t" === input.value);
            })();
        var boolHook,
            attrHandle = jQuery.expr.attrHandle;
        jQuery.fn.extend({
            attr: function (name, value) {
                return access(this, jQuery.attr, name, value, 1 < arguments.length);
            },
            removeAttr: function (name) {
                return this.each(function () {
                    jQuery.removeAttr(this, name);
                });
            },
        }),
            jQuery.extend({
                attr: function (elem, name, value) {
                    var ret,
                        hooks,
                        nType = elem.nodeType;
                    if (3 !== nType && 8 !== nType && 2 !== nType)
                        return void 0 === elem.getAttribute
                            ? jQuery.prop(elem, name, value)
                            : ((1 === nType && jQuery.isXMLDoc(elem)) || (hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : void 0)),
                              void 0 !== value
                                  ? null === value
                                      ? void jQuery.removeAttr(elem, name)
                                      : hooks && "set" in hooks && void 0 !== (ret = hooks.set(elem, value, name))
                                      ? ret
                                      : (elem.setAttribute(name, value + ""), value)
                                  : hooks && "get" in hooks && null !== (ret = hooks.get(elem, name))
                                  ? ret
                                  : null == (ret = jQuery.find.attr(elem, name))
                                  ? void 0
                                  : ret);
                },
                attrHooks: {
                    type: {
                        set: function (elem, value) {
                            if (!support.radioValue && "radio" === value && nodeName(elem, "input")) {
                                var val = elem.value;
                                return elem.setAttribute("type", value), val && (elem.value = val), value;
                            }
                        },
                    },
                },
                removeAttr: function (elem, value) {
                    var name,
                        i = 0,
                        attrNames = value && value.match(rnothtmlwhite);
                    if (attrNames && 1 === elem.nodeType) for (; (name = attrNames[i++]); ) elem.removeAttribute(name);
                },
            }),
            (boolHook = {
                set: function (elem, value, name) {
                    return !1 === value ? jQuery.removeAttr(elem, name) : elem.setAttribute(name, name), name;
                },
            }),
            jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
                var getter = attrHandle[name] || jQuery.find.attr;
                attrHandle[name] = function (elem, name, isXML) {
                    var ret,
                        handle,
                        lowercaseName = name.toLowerCase();
                    return isXML || ((handle = attrHandle[lowercaseName]), (attrHandle[lowercaseName] = ret), (ret = null != getter(elem, name, isXML) ? lowercaseName : null), (attrHandle[lowercaseName] = handle)), ret;
                };
            });
        var rfocusable = /^(?:input|select|textarea|button)$/i,
            rclickable = /^(?:a|area)$/i;
        function stripAndCollapse(value) {
            return (value.match(rnothtmlwhite) || []).join(" ");
        }
        function getClass(elem) {
            return (elem.getAttribute && elem.getAttribute("class")) || "";
        }
        function classesToArray(value) {
            return Array.isArray(value) ? value : ("string" == typeof value && value.match(rnothtmlwhite)) || [];
        }
        jQuery.fn.extend({
            prop: function (name, value) {
                return access(this, jQuery.prop, name, value, 1 < arguments.length);
            },
            removeProp: function (name) {
                return this.each(function () {
                    delete this[jQuery.propFix[name] || name];
                });
            },
        }),
            jQuery.extend({
                prop: function (elem, name, value) {
                    var ret,
                        hooks,
                        nType = elem.nodeType;
                    if (3 !== nType && 8 !== nType && 2 !== nType)
                        return (
                            (1 === nType && jQuery.isXMLDoc(elem)) || ((name = jQuery.propFix[name] || name), (hooks = jQuery.propHooks[name])),
                            void 0 !== value ? (hooks && "set" in hooks && void 0 !== (ret = hooks.set(elem, value, name)) ? ret : (elem[name] = value)) : hooks && "get" in hooks && null !== (ret = hooks.get(elem, name)) ? ret : elem[name]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (elem) {
                            var tabindex = jQuery.find.attr(elem, "tabindex");
                            return tabindex ? parseInt(tabindex, 10) : rfocusable.test(elem.nodeName) || (rclickable.test(elem.nodeName) && elem.href) ? 0 : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            support.optSelected ||
                (jQuery.propHooks.selected = {
                    get: function (elem) {
                        var parent = elem.parentNode;
                        return parent && parent.parentNode && parent.parentNode.selectedIndex, null;
                    },
                    set: function (elem) {
                        var parent = elem.parentNode;
                        parent && (parent.selectedIndex, parent.parentNode && parent.parentNode.selectedIndex);
                    },
                }),
            jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                jQuery.propFix[this.toLowerCase()] = this;
            }),
            jQuery.fn.extend({
                addClass: function (value) {
                    var classes,
                        elem,
                        cur,
                        curValue,
                        clazz,
                        j,
                        finalValue,
                        i = 0;
                    if (isFunction(value))
                        return this.each(function (j) {
                            jQuery(this).addClass(value.call(this, j, getClass(this)));
                        });
                    if ((classes = classesToArray(value)).length)
                        for (; (elem = this[i++]); )
                            if (((curValue = getClass(elem)), (cur = 1 === elem.nodeType && " " + stripAndCollapse(curValue) + " "))) {
                                for (j = 0; (clazz = classes[j++]); ) cur.indexOf(" " + clazz + " ") < 0 && (cur += clazz + " ");
                                curValue !== (finalValue = stripAndCollapse(cur)) && elem.setAttribute("class", finalValue);
                            }
                    return this;
                },
                removeClass: function (value) {
                    var classes,
                        elem,
                        cur,
                        curValue,
                        clazz,
                        j,
                        finalValue,
                        i = 0;
                    if (isFunction(value))
                        return this.each(function (j) {
                            jQuery(this).removeClass(value.call(this, j, getClass(this)));
                        });
                    if (!arguments.length) return this.attr("class", "");
                    if ((classes = classesToArray(value)).length)
                        for (; (elem = this[i++]); )
                            if (((curValue = getClass(elem)), (cur = 1 === elem.nodeType && " " + stripAndCollapse(curValue) + " "))) {
                                for (j = 0; (clazz = classes[j++]); ) for (; -1 < cur.indexOf(" " + clazz + " "); ) cur = cur.replace(" " + clazz + " ", " ");
                                curValue !== (finalValue = stripAndCollapse(cur)) && elem.setAttribute("class", finalValue);
                            }
                    return this;
                },
                toggleClass: function (value, stateVal) {
                    var type = typeof value,
                        isValidValue = "string" == type || Array.isArray(value);
                    return "boolean" == typeof stateVal && isValidValue
                        ? stateVal
                            ? this.addClass(value)
                            : this.removeClass(value)
                        : isFunction(value)
                        ? this.each(function (i) {
                              jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
                          })
                        : this.each(function () {
                              var className, i, self, classNames;
                              if (isValidValue) for (i = 0, self = jQuery(this), classNames = classesToArray(value); (className = classNames[i++]); ) self.hasClass(className) ? self.removeClass(className) : self.addClass(className);
                              else
                                  (void 0 !== value && "boolean" != type) ||
                                      ((className = getClass(this)) && dataPriv.set(this, "__className__", className),
                                      this.setAttribute && this.setAttribute("class", className || !1 === value ? "" : dataPriv.get(this, "__className__") || ""));
                          });
                },
                hasClass: function (selector) {
                    var className,
                        elem,
                        i = 0;
                    for (className = " " + selector + " "; (elem = this[i++]); ) if (1 === elem.nodeType && -1 < (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className)) return !0;
                    return !1;
                },
            });
        var rreturn = /\r/g;
        jQuery.fn.extend({
            val: function (value) {
                var hooks,
                    ret,
                    valueIsFunction,
                    elem = this[0];
                return arguments.length
                    ? ((valueIsFunction = isFunction(value)),
                      this.each(function (i) {
                          var val;
                          1 === this.nodeType &&
                              (null == (val = valueIsFunction ? value.call(this, i, jQuery(this).val()) : value)
                                  ? (val = "")
                                  : "number" == typeof val
                                  ? (val += "")
                                  : Array.isArray(val) &&
                                    (val = jQuery.map(val, function (value) {
                                        return null == value ? "" : value + "";
                                    })),
                              ((hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()]) && "set" in hooks && void 0 !== hooks.set(this, val, "value")) || (this.value = val));
                      }))
                    : elem
                    ? (hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()]) && "get" in hooks && void 0 !== (ret = hooks.get(elem, "value"))
                        ? ret
                        : "string" == typeof (ret = elem.value)
                        ? ret.replace(rreturn, "")
                        : null == ret
                        ? ""
                        : ret
                    : void 0;
            },
        }),
            jQuery.extend({
                valHooks: {
                    option: {
                        get: function (elem) {
                            var val = jQuery.find.attr(elem, "value");
                            return null != val ? val : stripAndCollapse(jQuery.text(elem));
                        },
                    },
                    select: {
                        get: function (elem) {
                            var value,
                                option,
                                i,
                                options = elem.options,
                                index = elem.selectedIndex,
                                one = "select-one" === elem.type,
                                values = one ? null : [],
                                max = one ? index + 1 : options.length;
                            for (i = index < 0 ? max : one ? index : 0; i < max; i++)
                                if (((option = options[i]).selected || i === index) && !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                                    if (((value = jQuery(option).val()), one)) return value;
                                    values.push(value);
                                }
                            return values;
                        },
                        set: function (elem, value) {
                            for (var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length; i--; )
                                ((option = options[i]).selected = -1 < jQuery.inArray(jQuery.valHooks.option.get(option), values)) && (optionSet = !0);
                            return optionSet || (elem.selectedIndex = -1), values;
                        },
                    },
                },
            }),
            jQuery.each(["radio", "checkbox"], function () {
                (jQuery.valHooks[this] = {
                    set: function (elem, value) {
                        if (Array.isArray(value)) return (elem.checked = -1 < jQuery.inArray(jQuery(elem).val(), value));
                    },
                }),
                    support.checkOn ||
                        (jQuery.valHooks[this].get = function (elem) {
                            return null === elem.getAttribute("value") ? "on" : elem.value;
                        });
            }),
            (support.focusin = "onfocusin" in window);
        function stopPropagationCallback(e) {
            e.stopPropagation();
        }
        var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
        jQuery.extend(jQuery.event, {
            trigger: function (event, data, elem, onlyHandlers) {
                var i,
                    cur,
                    tmp,
                    bubbleType,
                    ontype,
                    handle,
                    special,
                    lastElement,
                    eventPath = [elem || document],
                    type = hasOwn.call(event, "type") ? event.type : event,
                    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
                if (
                    ((cur = lastElement = tmp = elem = elem || document),
                    3 !== elem.nodeType &&
                        8 !== elem.nodeType &&
                        !rfocusMorph.test(type + jQuery.event.triggered) &&
                        (-1 < type.indexOf(".") && ((type = (namespaces = type.split(".")).shift()), namespaces.sort()),
                        (ontype = type.indexOf(":") < 0 && "on" + type),
                        ((event = event[jQuery.expando] ? event : new jQuery.Event(type, "object" == typeof event && event)).isTrigger = onlyHandlers ? 2 : 3),
                        (event.namespace = namespaces.join(".")),
                        (event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                        (event.result = void 0),
                        event.target || (event.target = elem),
                        (data = null == data ? [event] : jQuery.makeArray(data, [event])),
                        (special = jQuery.event.special[type] || {}),
                        onlyHandlers || !special.trigger || !1 !== special.trigger.apply(elem, data)))
                ) {
                    if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                        for (bubbleType = special.delegateType || type, rfocusMorph.test(bubbleType + type) || (cur = cur.parentNode); cur; cur = cur.parentNode) eventPath.push(cur), (tmp = cur);
                        tmp === (elem.ownerDocument || document) && eventPath.push(tmp.defaultView || tmp.parentWindow || window);
                    }
                    for (i = 0; (cur = eventPath[i++]) && !event.isPropagationStopped(); )
                        (lastElement = cur),
                            (event.type = 1 < i ? bubbleType : special.bindType || type),
                            (handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle")) && handle.apply(cur, data),
                            (handle = ontype && cur[ontype]) && handle.apply && acceptData(cur) && ((event.result = handle.apply(cur, data)), !1 === event.result && event.preventDefault());
                    return (
                        (event.type = type),
                        onlyHandlers ||
                            event.isDefaultPrevented() ||
                            (special._default && !1 !== special._default.apply(eventPath.pop(), data)) ||
                            !acceptData(elem) ||
                            (ontype &&
                                isFunction(elem[type]) &&
                                !isWindow(elem) &&
                                ((tmp = elem[ontype]) && (elem[ontype] = null),
                                (jQuery.event.triggered = type),
                                event.isPropagationStopped() && lastElement.addEventListener(type, stopPropagationCallback),
                                elem[type](),
                                event.isPropagationStopped() && lastElement.removeEventListener(type, stopPropagationCallback),
                                (jQuery.event.triggered = void 0),
                                tmp && (elem[ontype] = tmp))),
                        event.result
                    );
                }
            },
            simulate: function (type, elem, event) {
                var e = jQuery.extend(new jQuery.Event(), event, { type: type, isSimulated: !0 });
                jQuery.event.trigger(e, null, elem);
            },
        }),
            jQuery.fn.extend({
                trigger: function (type, data) {
                    return this.each(function () {
                        jQuery.event.trigger(type, data, this);
                    });
                },
                triggerHandler: function (type, data) {
                    var elem = this[0];
                    if (elem) return jQuery.event.trigger(type, data, elem, !0);
                },
            }),
            support.focusin ||
                jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {
                    function handler(event) {
                        jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
                    }
                    jQuery.event.special[fix] = {
                        setup: function () {
                            var doc = this.ownerDocument || this,
                                attaches = dataPriv.access(doc, fix);
                            attaches || doc.addEventListener(orig, handler, !0), dataPriv.access(doc, fix, (attaches || 0) + 1);
                        },
                        teardown: function () {
                            var doc = this.ownerDocument || this,
                                attaches = dataPriv.access(doc, fix) - 1;
                            attaches ? dataPriv.access(doc, fix, attaches) : (doc.removeEventListener(orig, handler, !0), dataPriv.remove(doc, fix));
                        },
                    };
                });
        var location = window.location,
            nonce = Date.now(),
            rquery = /\?/;
        jQuery.parseXML = function (data) {
            var xml;
            if (!data || "string" != typeof data) return null;
            try {
                xml = new window.DOMParser().parseFromString(data, "text/xml");
            } catch (e) {
                xml = void 0;
            }
            return (xml && !xml.getElementsByTagName("parsererror").length) || jQuery.error("Invalid XML: " + data), xml;
        };
        var rbracket = /\[\]$/,
            rCRLF = /\r?\n/g,
            rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
            rsubmittable = /^(?:input|select|textarea|keygen)/i;
        function buildParams(prefix, obj, traditional, add) {
            var name;
            if (Array.isArray(obj))
                jQuery.each(obj, function (i, v) {
                    traditional || rbracket.test(prefix) ? add(prefix, v) : buildParams(prefix + "[" + ("object" == typeof v && null != v ? i : "") + "]", v, traditional, add);
                });
            else if (traditional || "object" !== toType(obj)) add(prefix, obj);
            else for (name in obj) buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        }
        (jQuery.param = function (a, traditional) {
            function add(key, valueOrFunction) {
                var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
                s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(null == value ? "" : value);
            }
            var prefix,
                s = [];
            if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a)))
                jQuery.each(a, function () {
                    add(this.name, this.value);
                });
            else for (prefix in a) buildParams(prefix, a[prefix], traditional, add);
            return s.join("&");
        }),
            jQuery.fn.extend({
                serialize: function () {
                    return jQuery.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var elements = jQuery.prop(this, "elements");
                        return elements ? jQuery.makeArray(elements) : this;
                    })
                        .filter(function () {
                            var type = this.type;
                            return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
                        })
                        .map(function (i, elem) {
                            var val = jQuery(this).val();
                            return null == val
                                ? null
                                : Array.isArray(val)
                                ? jQuery.map(val, function (val) {
                                      return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                                  })
                                : { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                        })
                        .get();
                },
            });
        var r20 = /%20/g,
            rhash = /#.*$/,
            rantiCache = /([?&])_=[^&]*/,
            rheaders = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            rnoContent = /^(?:GET|HEAD)$/,
            rprotocol = /^\/\//,
            prefilters = {},
            transports = {},
            allTypes = "*/".concat("*"),
            originAnchor = document.createElement("a");
        function addToPrefiltersOrTransports(structure) {
            return function (dataTypeExpression, func) {
                "string" != typeof dataTypeExpression && ((func = dataTypeExpression), (dataTypeExpression = "*"));
                var dataType,
                    i = 0,
                    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
                if (isFunction(func))
                    for (; (dataType = dataTypes[i++]); )
                        "+" === dataType[0] ? ((dataType = dataType.slice(1) || "*"), (structure[dataType] = structure[dataType] || []).unshift(func)) : (structure[dataType] = structure[dataType] || []).push(func);
            };
        }
        function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
            var inspected = {},
                seekingTransport = structure === transports;
            function inspect(dataType) {
                var selected;
                return (
                    (inspected[dataType] = !0),
                    jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
                        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                        return "string" != typeof dataTypeOrTransport || seekingTransport || inspected[dataTypeOrTransport]
                            ? seekingTransport
                                ? !(selected = dataTypeOrTransport)
                                : void 0
                            : (options.dataTypes.unshift(dataTypeOrTransport), inspect(dataTypeOrTransport), !1);
                    }),
                    selected
                );
            }
            return inspect(options.dataTypes[0]) || (!inspected["*"] && inspect("*"));
        }
        function ajaxExtend(target, src) {
            var key,
                deep,
                flatOptions = jQuery.ajaxSettings.flatOptions || {};
            for (key in src) void 0 !== src[key] && ((flatOptions[key] ? target : (deep = deep || {}))[key] = src[key]);
            return deep && jQuery.extend(!0, target, deep), target;
        }
        (originAnchor.href = location.href),
            jQuery.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: location.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(location.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": allTypes, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": jQuery.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (target, settings) {
                    return settings ? ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : ajaxExtend(jQuery.ajaxSettings, target);
                },
                ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
                ajaxTransport: addToPrefiltersOrTransports(transports),
                ajax: function (url, options) {
                    "object" == typeof url && ((options = url), (url = void 0)), (options = options || {});
                    var transport,
                        cacheURL,
                        responseHeadersString,
                        responseHeaders,
                        timeoutTimer,
                        urlAnchor,
                        completed,
                        fireGlobals,
                        i,
                        uncached,
                        s = jQuery.ajaxSetup({}, options),
                        callbackContext = s.context || s,
                        globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
                        deferred = jQuery.Deferred(),
                        completeDeferred = jQuery.Callbacks("once memory"),
                        statusCode = s.statusCode || {},
                        requestHeaders = {},
                        requestHeadersNames = {},
                        strAbort = "canceled",
                        jqXHR = {
                            readyState: 0,
                            getResponseHeader: function (key) {
                                var match;
                                if (completed) {
                                    if (!responseHeaders) for (responseHeaders = {}; (match = rheaders.exec(responseHeadersString)); ) responseHeaders[match[1].toLowerCase()] = match[2];
                                    match = responseHeaders[key.toLowerCase()];
                                }
                                return null == match ? null : match;
                            },
                            getAllResponseHeaders: function () {
                                return completed ? responseHeadersString : null;
                            },
                            setRequestHeader: function (name, value) {
                                return null == completed && ((name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name), (requestHeaders[name] = value)), this;
                            },
                            overrideMimeType: function (type) {
                                return null == completed && (s.mimeType = type), this;
                            },
                            statusCode: function (map) {
                                var code;
                                if (map)
                                    if (completed) jqXHR.always(map[jqXHR.status]);
                                    else for (code in map) statusCode[code] = [statusCode[code], map[code]];
                                return this;
                            },
                            abort: function (statusText) {
                                var finalText = statusText || strAbort;
                                return transport && transport.abort(finalText), done(0, finalText), this;
                            },
                        };
                    if (
                        (deferred.promise(jqXHR),
                        (s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//")),
                        (s.type = options.method || options.type || s.method || s.type),
                        (s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""]),
                        null == s.crossDomain)
                    ) {
                        urlAnchor = document.createElement("a");
                        try {
                            (urlAnchor.href = s.url), (urlAnchor.href = urlAnchor.href), (s.crossDomain = originAnchor.protocol + "//" + originAnchor.host != urlAnchor.protocol + "//" + urlAnchor.host);
                        } catch (e) {
                            s.crossDomain = !0;
                        }
                    }
                    if ((s.data && s.processData && "string" != typeof s.data && (s.data = jQuery.param(s.data, s.traditional)), inspectPrefiltersOrTransports(prefilters, s, options, jqXHR), completed)) return jqXHR;
                    for (i in ((fireGlobals = jQuery.event && s.global) && 0 == jQuery.active++ && jQuery.event.trigger("ajaxStart"),
                    (s.type = s.type.toUpperCase()),
                    (s.hasContent = !rnoContent.test(s.type)),
                    (cacheURL = s.url.replace(rhash, "")),
                    s.hasContent
                        ? s.data && s.processData && 0 === (s.contentType || "").indexOf("application/x-www-form-urlencoded") && (s.data = s.data.replace(r20, "+"))
                        : ((uncached = s.url.slice(cacheURL.length)),
                          s.data && (s.processData || "string" == typeof s.data) && ((cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data), delete s.data),
                          !1 === s.cache && ((cacheURL = cacheURL.replace(rantiCache, "$1")), (uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++ + uncached)),
                          (s.url = cacheURL + uncached)),
                    s.ifModified && (jQuery.lastModified[cacheURL] && jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]), jQuery.etag[cacheURL] && jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL])),
                    ((s.data && s.hasContent && !1 !== s.contentType) || options.contentType) && jqXHR.setRequestHeader("Content-Type", s.contentType),
                    jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + ("*" !== s.dataTypes[0] ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]),
                    s.headers))
                        jqXHR.setRequestHeader(i, s.headers[i]);
                    if (s.beforeSend && (!1 === s.beforeSend.call(callbackContext, jqXHR, s) || completed)) return jqXHR.abort();
                    if (((strAbort = "abort"), completeDeferred.add(s.complete), jqXHR.done(s.success), jqXHR.fail(s.error), (transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR)))) {
                        if (((jqXHR.readyState = 1), fireGlobals && globalEventContext.trigger("ajaxSend", [jqXHR, s]), completed)) return jqXHR;
                        s.async &&
                            0 < s.timeout &&
                            (timeoutTimer = window.setTimeout(function () {
                                jqXHR.abort("timeout");
                            }, s.timeout));
                        try {
                            (completed = !1), transport.send(requestHeaders, done);
                        } catch (e) {
                            if (completed) throw e;
                            done(-1, e);
                        }
                    } else done(-1, "No Transport");
                    function done(status, nativeStatusText, responses, headers) {
                        var isSuccess,
                            success,
                            error,
                            response,
                            modified,
                            statusText = nativeStatusText;
                        completed ||
                            ((completed = !0),
                            timeoutTimer && window.clearTimeout(timeoutTimer),
                            (transport = void 0),
                            (responseHeadersString = headers || ""),
                            (jqXHR.readyState = 0 < status ? 4 : 0),
                            (isSuccess = (200 <= status && status < 300) || 304 === status),
                            responses &&
                                (response = (function (s, jqXHR, responses) {
                                    for (var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes; "*" === dataTypes[0]; )
                                        dataTypes.shift(), void 0 === ct && (ct = s.mimeType || jqXHR.getResponseHeader("Content-Type"));
                                    if (ct)
                                        for (type in contents)
                                            if (contents[type] && contents[type].test(ct)) {
                                                dataTypes.unshift(type);
                                                break;
                                            }
                                    if (dataTypes[0] in responses) finalDataType = dataTypes[0];
                                    else {
                                        for (type in responses) {
                                            if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                                                finalDataType = type;
                                                break;
                                            }
                                            firstDataType = firstDataType || type;
                                        }
                                        finalDataType = finalDataType || firstDataType;
                                    }
                                    if (finalDataType) return finalDataType !== dataTypes[0] && dataTypes.unshift(finalDataType), responses[finalDataType];
                                })(s, jqXHR, responses)),
                            (response = (function (s, response, jqXHR, isSuccess) {
                                var conv2,
                                    current,
                                    conv,
                                    tmp,
                                    prev,
                                    converters = {},
                                    dataTypes = s.dataTypes.slice();
                                if (dataTypes[1]) for (conv in s.converters) converters[conv.toLowerCase()] = s.converters[conv];
                                for (current = dataTypes.shift(); current; )
                                    if (
                                        (s.responseFields[current] && (jqXHR[s.responseFields[current]] = response),
                                        !prev && isSuccess && s.dataFilter && (response = s.dataFilter(response, s.dataType)),
                                        (prev = current),
                                        (current = dataTypes.shift()))
                                    )
                                        if ("*" === current) current = prev;
                                        else if ("*" !== prev && prev !== current) {
                                            if (!(conv = converters[prev + " " + current] || converters["* " + current]))
                                                for (conv2 in converters)
                                                    if ((tmp = conv2.split(" "))[1] === current && (conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]])) {
                                                        !0 === conv ? (conv = converters[conv2]) : !0 !== converters[conv2] && ((current = tmp[0]), dataTypes.unshift(tmp[1]));
                                                        break;
                                                    }
                                            if (!0 !== conv)
                                                if (conv && s.throws) response = conv(response);
                                                else
                                                    try {
                                                        response = conv(response);
                                                    } catch (e) {
                                                        return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
                                                    }
                                        }
                                return { state: "success", data: response };
                            })(s, response, jqXHR, isSuccess)),
                            isSuccess
                                ? (s.ifModified && ((modified = jqXHR.getResponseHeader("Last-Modified")) && (jQuery.lastModified[cacheURL] = modified), (modified = jqXHR.getResponseHeader("etag")) && (jQuery.etag[cacheURL] = modified)),
                                  204 === status || "HEAD" === s.type
                                      ? (statusText = "nocontent")
                                      : 304 === status
                                      ? (statusText = "notmodified")
                                      : ((statusText = response.state), (success = response.data), (isSuccess = !(error = response.error))))
                                : ((error = statusText), (!status && statusText) || ((statusText = "error"), status < 0 && (status = 0))),
                            (jqXHR.status = status),
                            (jqXHR.statusText = (nativeStatusText || statusText) + ""),
                            isSuccess ? deferred.resolveWith(callbackContext, [success, statusText, jqXHR]) : deferred.rejectWith(callbackContext, [jqXHR, statusText, error]),
                            jqXHR.statusCode(statusCode),
                            (statusCode = void 0),
                            fireGlobals && globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]),
                            completeDeferred.fireWith(callbackContext, [jqXHR, statusText]),
                            fireGlobals && (globalEventContext.trigger("ajaxComplete", [jqXHR, s]), --jQuery.active || jQuery.event.trigger("ajaxStop")));
                    }
                    return jqXHR;
                },
                getJSON: function (url, data, callback) {
                    return jQuery.get(url, data, callback, "json");
                },
                getScript: function (url, callback) {
                    return jQuery.get(url, void 0, callback, "script");
                },
            }),
            jQuery.each(["get", "post"], function (i, method) {
                jQuery[method] = function (url, data, callback, type) {
                    return (
                        isFunction(data) && ((type = type || callback), (callback = data), (data = void 0)),
                        jQuery.ajax(jQuery.extend({ url: url, type: method, dataType: type, data: data, success: callback }, jQuery.isPlainObject(url) && url))
                    );
                };
            }),
            (jQuery._evalUrl = function (url) {
                return jQuery.ajax({ url: url, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, throws: !0 });
            }),
            jQuery.fn.extend({
                wrapAll: function (html) {
                    var wrap;
                    return (
                        this[0] &&
                            (isFunction(html) && (html = html.call(this[0])),
                            (wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(!0)),
                            this[0].parentNode && wrap.insertBefore(this[0]),
                            wrap
                                .map(function () {
                                    for (var elem = this; elem.firstElementChild; ) elem = elem.firstElementChild;
                                    return elem;
                                })
                                .append(this)),
                        this
                    );
                },
                wrapInner: function (html) {
                    return isFunction(html)
                        ? this.each(function (i) {
                              jQuery(this).wrapInner(html.call(this, i));
                          })
                        : this.each(function () {
                              var self = jQuery(this),
                                  contents = self.contents();
                              contents.length ? contents.wrapAll(html) : self.append(html);
                          });
                },
                wrap: function (html) {
                    var htmlIsFunction = isFunction(html);
                    return this.each(function (i) {
                        jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
                    });
                },
                unwrap: function (selector) {
                    return (
                        this.parent(selector)
                            .not("body")
                            .each(function () {
                                jQuery(this).replaceWith(this.childNodes);
                            }),
                        this
                    );
                },
            }),
            (jQuery.expr.pseudos.hidden = function (elem) {
                return !jQuery.expr.pseudos.visible(elem);
            }),
            (jQuery.expr.pseudos.visible = function (elem) {
                return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
            }),
            (jQuery.ajaxSettings.xhr = function () {
                try {
                    return new window.XMLHttpRequest();
                } catch (e) {}
            });
        var xhrSuccessStatus = { 0: 200, 1223: 204 },
            xhrSupported = jQuery.ajaxSettings.xhr();
        (support.cors = !!xhrSupported && "withCredentials" in xhrSupported),
            (support.ajax = xhrSupported = !!xhrSupported),
            jQuery.ajaxTransport(function (options) {
                var callback, errorCallback;
                if (support.cors || (xhrSupported && !options.crossDomain))
                    return {
                        send: function (headers, complete) {
                            var i,
                                xhr = options.xhr();
                            if ((xhr.open(options.type, options.url, options.async, options.username, options.password), options.xhrFields)) for (i in options.xhrFields) xhr[i] = options.xhrFields[i];
                            for (i in (options.mimeType && xhr.overrideMimeType && xhr.overrideMimeType(options.mimeType), options.crossDomain || headers["X-Requested-With"] || (headers["X-Requested-With"] = "XMLHttpRequest"), headers))
                                xhr.setRequestHeader(i, headers[i]);
                            (callback = function (type) {
                                return function () {
                                    callback &&
                                        ((callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null),
                                        "abort" === type
                                            ? xhr.abort()
                                            : "error" === type
                                            ? "number" != typeof xhr.status
                                                ? complete(0, "error")
                                                : complete(xhr.status, xhr.statusText)
                                            : complete(
                                                  xhrSuccessStatus[xhr.status] || xhr.status,
                                                  xhr.statusText,
                                                  "text" !== (xhr.responseType || "text") || "string" != typeof xhr.responseText ? { binary: xhr.response } : { text: xhr.responseText },
                                                  xhr.getAllResponseHeaders()
                                              ));
                                };
                            }),
                                (xhr.onload = callback()),
                                (errorCallback = xhr.onerror = xhr.ontimeout = callback("error")),
                                void 0 !== xhr.onabort
                                    ? (xhr.onabort = errorCallback)
                                    : (xhr.onreadystatechange = function () {
                                          4 === xhr.readyState &&
                                              window.setTimeout(function () {
                                                  callback && errorCallback();
                                              });
                                      }),
                                (callback = callback("abort"));
                            try {
                                xhr.send((options.hasContent && options.data) || null);
                            } catch (e) {
                                if (callback) throw e;
                            }
                        },
                        abort: function () {
                            callback && callback();
                        },
                    };
            }),
            jQuery.ajaxPrefilter(function (s) {
                s.crossDomain && (s.contents.script = !1);
            }),
            jQuery.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (text) {
                        return jQuery.globalEval(text), text;
                    },
                },
            }),
            jQuery.ajaxPrefilter("script", function (s) {
                void 0 === s.cache && (s.cache = !1), s.crossDomain && (s.type = "GET");
            }),
            jQuery.ajaxTransport("script", function (s) {
                var script, callback;
                if (s.crossDomain)
                    return {
                        send: function (_, complete) {
                            (script = jQuery("<script>")
                                .prop({ charset: s.scriptCharset, src: s.url })
                                .on(
                                    "load error",
                                    (callback = function (evt) {
                                        script.remove(), (callback = null), evt && complete("error" === evt.type ? 404 : 200, evt.type);
                                    })
                                )),
                                document.head.appendChild(script[0]);
                        },
                        abort: function () {
                            callback && callback();
                        },
                    };
            });
        var body,
            oldCallbacks = [],
            rjsonp = /(=)\?(?=&|$)|\?\?/;
        jQuery.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
                return (this[callback] = !0), callback;
            },
        }),
            jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
                var callbackName,
                    overwritten,
                    responseContainer,
                    jsonProp = !1 !== s.jsonp && (rjsonp.test(s.url) ? "url" : "string" == typeof s.data && 0 === (s.contentType || "").indexOf("application/x-www-form-urlencoded") && rjsonp.test(s.data) && "data");
                if (jsonProp || "jsonp" === s.dataTypes[0])
                    return (
                        (callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback),
                        jsonProp ? (s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName)) : !1 !== s.jsonp && (s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName),
                        (s.converters["script json"] = function () {
                            return responseContainer || jQuery.error(callbackName + " was not called"), responseContainer[0];
                        }),
                        (s.dataTypes[0] = "json"),
                        (overwritten = window[callbackName]),
                        (window[callbackName] = function () {
                            responseContainer = arguments;
                        }),
                        jqXHR.always(function () {
                            void 0 === overwritten ? jQuery(window).removeProp(callbackName) : (window[callbackName] = overwritten),
                                s[callbackName] && ((s.jsonpCallback = originalSettings.jsonpCallback), oldCallbacks.push(callbackName)),
                                responseContainer && isFunction(overwritten) && overwritten(responseContainer[0]),
                                (responseContainer = overwritten = void 0);
                        }),
                        "script"
                    );
            }),
            (support.createHTMLDocument = (((body = document.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === body.childNodes.length)),
            (jQuery.parseHTML = function (data, context, keepScripts) {
                return "string" != typeof data
                    ? []
                    : ("boolean" == typeof context && ((keepScripts = context), (context = !1)),
                      context ||
                          (support.createHTMLDocument ? (((base = (context = document.implementation.createHTMLDocument("")).createElement("base")).href = document.location.href), context.head.appendChild(base)) : (context = document)),
                      (scripts = !keepScripts && []),
                      (parsed = rsingleTag.exec(data)) ? [context.createElement(parsed[1])] : ((parsed = buildFragment([data], context, scripts)), scripts && scripts.length && jQuery(scripts).remove(), jQuery.merge([], parsed.childNodes)));
                var base, parsed, scripts;
            }),
            (jQuery.fn.load = function (url, params, callback) {
                var selector,
                    type,
                    response,
                    self = this,
                    off = url.indexOf(" ");
                return (
                    -1 < off && ((selector = stripAndCollapse(url.slice(off))), (url = url.slice(0, off))),
                    isFunction(params) ? ((callback = params), (params = void 0)) : params && "object" == typeof params && (type = "POST"),
                    0 < self.length &&
                        jQuery
                            .ajax({ url: url, type: type || "GET", dataType: "html", data: params })
                            .done(function (responseText) {
                                (response = arguments), self.html(selector ? jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : responseText);
                            })
                            .always(
                                callback &&
                                    function (jqXHR, status) {
                                        self.each(function () {
                                            callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
                                        });
                                    }
                            ),
                    this
                );
            }),
            jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (i, type) {
                jQuery.fn[type] = function (fn) {
                    return this.on(type, fn);
                };
            }),
            (jQuery.expr.pseudos.animated = function (elem) {
                return jQuery.grep(jQuery.timers, function (fn) {
                    return elem === fn.elem;
                }).length;
            }),
            (jQuery.offset = {
                setOffset: function (elem, options, i) {
                    var curPosition,
                        curLeft,
                        curCSSTop,
                        curTop,
                        curOffset,
                        curCSSLeft,
                        position = jQuery.css(elem, "position"),
                        curElem = jQuery(elem),
                        props = {};
                    "static" === position && (elem.style.position = "relative"),
                        (curOffset = curElem.offset()),
                        (curCSSTop = jQuery.css(elem, "top")),
                        (curCSSLeft = jQuery.css(elem, "left")),
                        (curLeft =
                            ("absolute" === position || "fixed" === position) && -1 < (curCSSTop + curCSSLeft).indexOf("auto")
                                ? ((curTop = (curPosition = curElem.position()).top), curPosition.left)
                                : ((curTop = parseFloat(curCSSTop) || 0), parseFloat(curCSSLeft) || 0)),
                        isFunction(options) && (options = options.call(elem, i, jQuery.extend({}, curOffset))),
                        null != options.top && (props.top = options.top - curOffset.top + curTop),
                        null != options.left && (props.left = options.left - curOffset.left + curLeft),
                        "using" in options ? options.using.call(elem, props) : curElem.css(props);
                },
            }),
            jQuery.fn.extend({
                offset: function (options) {
                    if (arguments.length)
                        return void 0 === options
                            ? this
                            : this.each(function (i) {
                                  jQuery.offset.setOffset(this, options, i);
                              });
                    var rect,
                        win,
                        elem = this[0];
                    return elem
                        ? elem.getClientRects().length
                            ? ((rect = elem.getBoundingClientRect()), (win = elem.ownerDocument.defaultView), { top: rect.top + win.pageYOffset, left: rect.left + win.pageXOffset })
                            : { top: 0, left: 0 }
                        : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var offsetParent,
                            offset,
                            doc,
                            elem = this[0],
                            parentOffset = { top: 0, left: 0 };
                        if ("fixed" === jQuery.css(elem, "position")) offset = elem.getBoundingClientRect();
                        else {
                            for (
                                offset = this.offset(), doc = elem.ownerDocument, offsetParent = elem.offsetParent || doc.documentElement;
                                offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && "static" === jQuery.css(offsetParent, "position");

                            )
                                offsetParent = offsetParent.parentNode;
                            offsetParent &&
                                offsetParent !== elem &&
                                1 === offsetParent.nodeType &&
                                (((parentOffset = jQuery(offsetParent).offset()).top += jQuery.css(offsetParent, "borderTopWidth", !0)), (parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", !0)));
                        }
                        return { top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", !0), left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", !0) };
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var offsetParent = this.offsetParent; offsetParent && "static" === jQuery.css(offsetParent, "position"); ) offsetParent = offsetParent.offsetParent;
                        return offsetParent || documentElement;
                    });
                },
            }),
            jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
                var top = "pageYOffset" === prop;
                jQuery.fn[method] = function (val) {
                    return access(
                        this,
                        function (elem, method, val) {
                            var win;
                            if ((isWindow(elem) ? (win = elem) : 9 === elem.nodeType && (win = elem.defaultView), void 0 === val)) return win ? win[prop] : elem[method];
                            win ? win.scrollTo(top ? win.pageXOffset : val, top ? val : win.pageYOffset) : (elem[method] = val);
                        },
                        method,
                        val,
                        arguments.length
                    );
                };
            }),
            jQuery.each(["top", "left"], function (i, prop) {
                jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
                    if (computed) return (computed = curCSS(elem, prop)), rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
                });
            }),
            jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
                jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {
                    jQuery.fn[funcName] = function (margin, value) {
                        var chainable = arguments.length && (defaultExtra || "boolean" != typeof margin),
                            extra = defaultExtra || (!0 === margin || !0 === value ? "margin" : "border");
                        return access(
                            this,
                            function (elem, type, value) {
                                var doc;
                                return isWindow(elem)
                                    ? 0 === funcName.indexOf("outer")
                                        ? elem["inner" + name]
                                        : elem.document.documentElement["client" + name]
                                    : 9 === elem.nodeType
                                    ? ((doc = elem.documentElement), Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]))
                                    : void 0 === value
                                    ? jQuery.css(elem, type, extra)
                                    : jQuery.style(elem, type, value, extra);
                            },
                            type,
                            chainable ? margin : void 0,
                            chainable
                        );
                    };
                });
            }),
            jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (i, name) {
                jQuery.fn[name] = function (data, fn) {
                    return 0 < arguments.length ? this.on(name, null, data, fn) : this.trigger(name);
                };
            }),
            jQuery.fn.extend({
                hover: function (fnOver, fnOut) {
                    return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
                },
            }),
            jQuery.fn.extend({
                bind: function (types, data, fn) {
                    return this.on(types, null, data, fn);
                },
                unbind: function (types, fn) {
                    return this.off(types, null, fn);
                },
                delegate: function (selector, types, data, fn) {
                    return this.on(types, selector, data, fn);
                },
                undelegate: function (selector, types, fn) {
                    return 1 === arguments.length ? this.off(selector, "**") : this.off(types, selector || "**", fn);
                },
            }),
            (jQuery.proxy = function (fn, context) {
                var tmp, args, proxy;
                if (("string" == typeof context && ((tmp = fn[context]), (context = fn), (fn = tmp)), isFunction(fn)))
                    return (
                        (args = slice.call(arguments, 2)),
                        ((proxy = function () {
                            return fn.apply(context || this, args.concat(slice.call(arguments)));
                        }).guid = fn.guid = fn.guid || jQuery.guid++),
                        proxy
                    );
            }),
            (jQuery.holdReady = function (hold) {
                hold ? jQuery.readyWait++ : jQuery.ready(!0);
            }),
            (jQuery.isArray = Array.isArray),
            (jQuery.parseJSON = JSON.parse),
            (jQuery.nodeName = nodeName),
            (jQuery.isFunction = isFunction),
            (jQuery.isWindow = isWindow),
            (jQuery.camelCase = camelCase),
            (jQuery.type = toType),
            (jQuery.now = Date.now),
            (jQuery.isNumeric = function (obj) {
                var type = jQuery.type(obj);
                return ("number" === type || "string" === type) && !isNaN(obj - parseFloat(obj));
            }),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return jQuery;
                });
        var _jQuery = window.jQuery,
            _$ = window.$;
        return (
            (jQuery.noConflict = function (deep) {
                return window.$ === jQuery && (window.$ = _$), deep && window.jQuery === jQuery && (window.jQuery = _jQuery), jQuery;
            }),
            noGlobal || (window.jQuery = window.$ = jQuery),
            jQuery
        );
    }),
    "undefined" == typeof jQuery)
)
    throw new Error("Bootstrap's JavaScript requires jQuery");
!(function () {
    "use strict";
    var version = jQuery.fn.jquery.split(" ")[0].split(".");
    if ((version[0] < 2 && version[1] < 9) || (1 == version[0] && 9 == version[1] && version[2] < 1) || 3 < version[0]) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
})(),
    (function ($) {
        "use strict";
        ($.fn.emulateTransitionEnd = function (duration) {
            var called = !1,
                $el = this;
            $(this).one("bsTransitionEnd", function () {
                called = !0;
            });
            return (
                setTimeout(function () {
                    called || $($el).trigger($.support.transition.end);
                }, duration),
                this
            );
        }),
            $(function () {
                ($.support.transition = (function () {
                    var el = document.createElement("bootstrap"),
                        transEndEventNames = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };
                    for (var name in transEndEventNames) if (void 0 !== el.style[name]) return { end: transEndEventNames[name] };
                    return !1;
                })()),
                    $.support.transition &&
                        ($.event.special.bsTransitionEnd = {
                            bindType: $.support.transition.end,
                            delegateType: $.support.transition.end,
                            handle: function (e) {
                                if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
                            },
                        });
            });
    })(jQuery),
    (function ($) {
        "use strict";
        function Alert(el) {
            $(el).on("click", dismiss, this.close);
        }
        var dismiss = '[data-dismiss="alert"]';
        (Alert.VERSION = "3.3.7"),
            (Alert.TRANSITION_DURATION = 150),
            (Alert.prototype.close = function (e) {
                var $this = $(this),
                    selector = $this.attr("data-target");
                selector = selector || ((selector = $this.attr("href")) && selector.replace(/.*(?=#[^\s]*$)/, ""));
                var $parent = $("#" === selector ? [] : selector);
                function removeElement() {
                    $parent.detach().trigger("closed.bs.alert").remove();
                }
                e && e.preventDefault(),
                    $parent.length || ($parent = $this.closest(".alert")),
                    $parent.trigger((e = $.Event("close.bs.alert"))),
                    e.isDefaultPrevented() || ($parent.removeClass("in"), $.support.transition && $parent.hasClass("fade") ? $parent.one("bsTransitionEnd", removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement());
            });
        var old = $.fn.alert;
        ($.fn.alert = function (option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.alert");
                data || $this.data("bs.alert", (data = new Alert(this))), "string" == typeof option && data[option].call($this);
            });
        }),
            ($.fn.alert.Constructor = Alert),
            ($.fn.alert.noConflict = function () {
                return ($.fn.alert = old), this;
            }),
            $(document).on("click.bs.alert.data-api", dismiss, Alert.prototype.close);
    })(jQuery),
    (function ($) {
        "use strict";
        var Button = function (element, options) {
            (this.$element = $(element)), (this.options = $.extend({}, Button.DEFAULTS, options)), (this.isLoading = !1);
        };
        function Plugin(option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.button"),
                    options = "object" == typeof option && option;
                data || $this.data("bs.button", (data = new Button(this, options))), "toggle" == option ? data.toggle() : option && data.setState(option);
            });
        }
        (Button.VERSION = "3.3.7"),
            (Button.DEFAULTS = { loadingText: "loading..." }),
            (Button.prototype.setState = function (state) {
                var d = "disabled",
                    $el = this.$element,
                    val = $el.is("input") ? "val" : "html",
                    data = $el.data();
                (state += "Text"),
                    null == data.resetText && $el.data("resetText", $el[val]()),
                    setTimeout(
                        $.proxy(function () {
                            $el[val](null == data[state] ? this.options[state] : data[state]),
                                "loadingText" == state ? ((this.isLoading = !0), $el.addClass(d).attr(d, d).prop(d, !0)) : this.isLoading && ((this.isLoading = !1), $el.removeClass(d).removeAttr(d).prop(d, !1));
                        }, this),
                        0
                    );
            }),
            (Button.prototype.toggle = function () {
                var changed = !0,
                    $parent = this.$element.closest('[data-toggle="buttons"]');
                if ($parent.length) {
                    var $input = this.$element.find("input");
                    "radio" == $input.prop("type")
                        ? ($input.prop("checked") && (changed = !1), $parent.find(".active").removeClass("active"), this.$element.addClass("active"))
                        : "checkbox" == $input.prop("type") && ($input.prop("checked") !== this.$element.hasClass("active") && (changed = !1), this.$element.toggleClass("active")),
                        $input.prop("checked", this.$element.hasClass("active")),
                        changed && $input.trigger("change");
                } else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active");
            });
        var old = $.fn.button;
        ($.fn.button = Plugin),
            ($.fn.button.Constructor = Button),
            ($.fn.button.noConflict = function () {
                return ($.fn.button = old), this;
            }),
            $(document)
                .on("click.bs.button.data-api", '[data-toggle^="button"]', function (e) {
                    var $btn = $(e.target).closest(".btn");
                    Plugin.call($btn, "toggle"),
                        $(e.target).is('input[type="radio"], input[type="checkbox"]') || (e.preventDefault(), $btn.is("input,button") ? $btn.trigger("focus") : $btn.find("input:visible,button:visible").first().trigger("focus"));
                })
                .on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function (e) {
                    $(e.target)
                        .closest(".btn")
                        .toggleClass("focus", /^focus(in)?$/.test(e.type));
                });
    })(jQuery),
    (function ($) {
        "use strict";
        function Carousel(element, options) {
            (this.$element = $(element)),
                (this.$indicators = this.$element.find(".carousel-indicators")),
                (this.options = options),
                (this.paused = null),
                (this.sliding = null),
                (this.interval = null),
                (this.$active = null),
                (this.$items = null),
                this.options.keyboard && this.$element.on("keydown.bs.carousel", $.proxy(this.keydown, this)),
                "hover" != this.options.pause || "ontouchstart" in document.documentElement || this.$element.on("mouseenter.bs.carousel", $.proxy(this.pause, this)).on("mouseleave.bs.carousel", $.proxy(this.cycle, this));
        }
        function Plugin(option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.carousel"),
                    options = $.extend({}, Carousel.DEFAULTS, $this.data(), "object" == typeof option && option),
                    action = "string" == typeof option ? option : options.slide;
                data || $this.data("bs.carousel", (data = new Carousel(this, options))), "number" == typeof option ? data.to(option) : action ? data[action]() : options.interval && data.pause().cycle();
            });
        }
        (Carousel.VERSION = "3.3.7"),
            (Carousel.TRANSITION_DURATION = 600),
            (Carousel.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }),
            (Carousel.prototype.keydown = function (e) {
                if (!/input|textarea/i.test(e.target.tagName)) {
                    switch (e.which) {
                        case 37:
                            this.prev();
                            break;
                        case 39:
                            this.next();
                            break;
                        default:
                            return;
                    }
                    e.preventDefault();
                }
            }),
            (Carousel.prototype.cycle = function (e) {
                return e || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval)), this;
            }),
            (Carousel.prototype.getItemIndex = function (item) {
                return (this.$items = item.parent().children(".item")), this.$items.index(item || this.$active);
            }),
            (Carousel.prototype.getItemForDirection = function (direction, active) {
                var activeIndex = this.getItemIndex(active);
                if ((("prev" == direction && 0 === activeIndex) || ("next" == direction && activeIndex == this.$items.length - 1)) && !this.options.wrap) return active;
                var itemIndex = (activeIndex + ("prev" == direction ? -1 : 1)) % this.$items.length;
                return this.$items.eq(itemIndex);
            }),
            (Carousel.prototype.to = function (pos) {
                var that = this,
                    activeIndex = this.getItemIndex((this.$active = this.$element.find(".item.active")));
                if (!(pos > this.$items.length - 1 || pos < 0))
                    return this.sliding
                        ? this.$element.one("slid.bs.carousel", function () {
                              that.to(pos);
                          })
                        : activeIndex == pos
                        ? this.pause().cycle()
                        : this.slide(activeIndex < pos ? "next" : "prev", this.$items.eq(pos));
            }),
            (Carousel.prototype.pause = function (e) {
                return e || (this.paused = !0), this.$element.find(".next, .prev").length && $.support.transition && (this.$element.trigger($.support.transition.end), this.cycle(!0)), (this.interval = clearInterval(this.interval)), this;
            }),
            (Carousel.prototype.next = function () {
                if (!this.sliding) return this.slide("next");
            }),
            (Carousel.prototype.prev = function () {
                if (!this.sliding) return this.slide("prev");
            }),
            (Carousel.prototype.slide = function (type, next) {
                var $active = this.$element.find(".item.active"),
                    $next = next || this.getItemForDirection(type, $active),
                    isCycling = this.interval,
                    direction = "next" == type ? "left" : "right",
                    that = this;
                if ($next.hasClass("active")) return (this.sliding = !1);
                var relatedTarget = $next[0],
                    slideEvent = $.Event("slide.bs.carousel", { relatedTarget: relatedTarget, direction: direction });
                if ((this.$element.trigger(slideEvent), !slideEvent.isDefaultPrevented())) {
                    if (((this.sliding = !0), isCycling && this.pause(), this.$indicators.length)) {
                        this.$indicators.find(".active").removeClass("active");
                        var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
                        $nextIndicator && $nextIndicator.addClass("active");
                    }
                    var slidEvent = $.Event("slid.bs.carousel", { relatedTarget: relatedTarget, direction: direction });
                    return (
                        $.support.transition && this.$element.hasClass("slide")
                            ? ($next.addClass(type),
                              $next[0].offsetWidth,
                              $active.addClass(direction),
                              $next.addClass(direction),
                              $active
                                  .one("bsTransitionEnd", function () {
                                      $next.removeClass([type, direction].join(" ")).addClass("active"),
                                          $active.removeClass(["active", direction].join(" ")),
                                          (that.sliding = !1),
                                          setTimeout(function () {
                                              that.$element.trigger(slidEvent);
                                          }, 0);
                                  })
                                  .emulateTransitionEnd(Carousel.TRANSITION_DURATION))
                            : ($active.removeClass("active"), $next.addClass("active"), (this.sliding = !1), this.$element.trigger(slidEvent)),
                        isCycling && this.cycle(),
                        this
                    );
                }
            });
        var old = $.fn.carousel;
        ($.fn.carousel = Plugin),
            ($.fn.carousel.Constructor = Carousel),
            ($.fn.carousel.noConflict = function () {
                return ($.fn.carousel = old), this;
            });
        function clickHandler(e) {
            var href,
                $this = $(this),
                $target = $($this.attr("data-target") || ((href = $this.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, "")));
            if ($target.hasClass("carousel")) {
                var options = $.extend({}, $target.data(), $this.data()),
                    slideIndex = $this.attr("data-slide-to");
                slideIndex && (options.interval = !1), Plugin.call($target, options), slideIndex && $target.data("bs.carousel").to(slideIndex), e.preventDefault();
            }
        }
        $(document).on("click.bs.carousel.data-api", "[data-slide]", clickHandler).on("click.bs.carousel.data-api", "[data-slide-to]", clickHandler),
            $(window).on("load", function () {
                $('[data-ride="carousel"]').each(function () {
                    var $carousel = $(this);
                    Plugin.call($carousel, $carousel.data());
                });
            });
    })(jQuery),
    (function ($) {
        "use strict";
        var Collapse = function (element, options) {
            (this.$element = $(element)),
                (this.options = $.extend({}, Collapse.DEFAULTS, options)),
                (this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],[data-toggle="collapse"][data-target="#' + element.id + '"]')),
                (this.transitioning = null),
                this.options.parent ? (this.$parent = this.getParent()) : this.addAriaAndCollapsedClass(this.$element, this.$trigger),
                this.options.toggle && this.toggle();
        };
        function getTargetFromTrigger($trigger) {
            var href,
                target = $trigger.attr("data-target") || ((href = $trigger.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, ""));
            return $(target);
        }
        function Plugin(option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.collapse"),
                    options = $.extend({}, Collapse.DEFAULTS, $this.data(), "object" == typeof option && option);
                !data && options.toggle && /show|hide/.test(option) && (options.toggle = !1), data || $this.data("bs.collapse", (data = new Collapse(this, options))), "string" == typeof option && data[option]();
            });
        }
        (Collapse.VERSION = "3.3.7"),
            (Collapse.TRANSITION_DURATION = 350),
            (Collapse.DEFAULTS = { toggle: !0 }),
            (Collapse.prototype.dimension = function () {
                return this.$element.hasClass("width") ? "width" : "height";
            }),
            (Collapse.prototype.show = function () {
                if (!this.transitioning && !this.$element.hasClass("in")) {
                    var activesData,
                        actives = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
                    if (!(actives && actives.length && (activesData = actives.data("bs.collapse")) && activesData.transitioning)) {
                        var startEvent = $.Event("show.bs.collapse");
                        if ((this.$element.trigger(startEvent), !startEvent.isDefaultPrevented())) {
                            actives && actives.length && (Plugin.call(actives, "hide"), activesData || actives.data("bs.collapse", null));
                            var dimension = this.dimension();
                            this.$element.removeClass("collapse").addClass("collapsing")[dimension](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), (this.transitioning = 1);
                            var complete = function () {
                                this.$element.removeClass("collapsing").addClass("collapse in")[dimension](""), (this.transitioning = 0), this.$element.trigger("shown.bs.collapse");
                            };
                            if (!$.support.transition) return complete.call(this);
                            var scrollSize = $.camelCase(["scroll", dimension].join("-"));
                            this.$element.one("bsTransitionEnd", $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
                        }
                    }
                }
            }),
            (Collapse.prototype.hide = function () {
                if (!this.transitioning && this.$element.hasClass("in")) {
                    var startEvent = $.Event("hide.bs.collapse");
                    if ((this.$element.trigger(startEvent), !startEvent.isDefaultPrevented())) {
                        var dimension = this.dimension();
                        this.$element[dimension](this.$element[dimension]())[0].offsetHeight,
                            this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1),
                            this.$trigger.addClass("collapsed").attr("aria-expanded", !1),
                            (this.transitioning = 1);
                        var complete = function () {
                            (this.transitioning = 0), this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
                        };
                        if (!$.support.transition) return complete.call(this);
                        this.$element[dimension](0).one("bsTransitionEnd", $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
                    }
                }
            }),
            (Collapse.prototype.toggle = function () {
                this[this.$element.hasClass("in") ? "hide" : "show"]();
            }),
            (Collapse.prototype.getParent = function () {
                return $(this.options.parent)
                    .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
                    .each(
                        $.proxy(function (i, element) {
                            var $element = $(element);
                            this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
                        }, this)
                    )
                    .end();
            }),
            (Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
                var isOpen = $element.hasClass("in");
                $element.attr("aria-expanded", isOpen), $trigger.toggleClass("collapsed", !isOpen).attr("aria-expanded", isOpen);
            });
        var old = $.fn.collapse;
        ($.fn.collapse = Plugin),
            ($.fn.collapse.Constructor = Collapse),
            ($.fn.collapse.noConflict = function () {
                return ($.fn.collapse = old), this;
            }),
            $(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (e) {
                var $this = $(this);
                $this.attr("data-target") || e.preventDefault();
                var $target = getTargetFromTrigger($this),
                    option = $target.data("bs.collapse") ? "toggle" : $this.data();
                Plugin.call($target, option);
            });
    })(jQuery),
    (function ($) {
        "use strict";
        function Dropdown(element) {
            $(element).on("click.bs.dropdown", this.toggle);
        }
        var toggle = '[data-toggle="dropdown"]';
        function getParent($this) {
            var selector = $this.attr("data-target"),
                $parent = (selector = selector || ((selector = $this.attr("href")) && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ""))) && $(selector);
            return $parent && $parent.length ? $parent : $this.parent();
        }
        function clearMenus(e) {
            (e && 3 === e.which) ||
                ($(".dropdown-backdrop").remove(),
                $(toggle).each(function () {
                    var $this = $(this),
                        $parent = getParent($this),
                        relatedTarget = { relatedTarget: this };
                    $parent.hasClass("open") &&
                        ((e && "click" == e.type && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) ||
                            ($parent.trigger((e = $.Event("hide.bs.dropdown", relatedTarget))),
                            e.isDefaultPrevented() || ($this.attr("aria-expanded", "false"), $parent.removeClass("open").trigger($.Event("hidden.bs.dropdown", relatedTarget)))));
                }));
        }
        (Dropdown.VERSION = "3.3.7"),
            (Dropdown.prototype.toggle = function (e) {
                var $this = $(this);
                if (!$this.is(".disabled, :disabled")) {
                    var $parent = getParent($this),
                        isActive = $parent.hasClass("open");
                    if ((clearMenus(), !isActive)) {
                        "ontouchstart" in document.documentElement && !$parent.closest(".navbar-nav").length && $(document.createElement("div")).addClass("dropdown-backdrop").insertAfter($(this)).on("click", clearMenus);
                        var relatedTarget = { relatedTarget: this };
                        if (($parent.trigger((e = $.Event("show.bs.dropdown", relatedTarget))), e.isDefaultPrevented())) return;
                        $this.trigger("focus").attr("aria-expanded", "true"), $parent.toggleClass("open").trigger($.Event("shown.bs.dropdown", relatedTarget));
                    }
                    return !1;
                }
            }),
            (Dropdown.prototype.keydown = function (e) {
                if (/(38|40|27|32)/.test(e.which) && !/input|textarea/i.test(e.target.tagName)) {
                    var $this = $(this);
                    if ((e.preventDefault(), e.stopPropagation(), !$this.is(".disabled, :disabled"))) {
                        var $parent = getParent($this),
                            isActive = $parent.hasClass("open");
                        if ((!isActive && 27 != e.which) || (isActive && 27 == e.which)) return 27 == e.which && $parent.find(toggle).trigger("focus"), $this.trigger("click");
                        var $items = $parent.find(".dropdown-menu li:not(.disabled):visible a");
                        if ($items.length) {
                            var index = $items.index(e.target);
                            38 == e.which && 0 < index && index--, 40 == e.which && index < $items.length - 1 && index++, ~index || (index = 0), $items.eq(index).trigger("focus");
                        }
                    }
                }
            });
        var old = $.fn.dropdown;
        ($.fn.dropdown = function (option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.dropdown");
                data || $this.data("bs.dropdown", (data = new Dropdown(this))), "string" == typeof option && data[option].call($this);
            });
        }),
            ($.fn.dropdown.Constructor = Dropdown),
            ($.fn.dropdown.noConflict = function () {
                return ($.fn.dropdown = old), this;
            }),
            $(document)
                .on("click.bs.dropdown.data-api", clearMenus)
                .on("click.bs.dropdown.data-api", ".dropdown form", function (e) {
                    e.stopPropagation();
                })
                .on("click.bs.dropdown.data-api", toggle, Dropdown.prototype.toggle)
                .on("keydown.bs.dropdown.data-api", toggle, Dropdown.prototype.keydown)
                .on("keydown.bs.dropdown.data-api", ".dropdown-menu", Dropdown.prototype.keydown);
    })(jQuery),
    (function ($) {
        "use strict";
        function Modal(element, options) {
            (this.options = options),
                (this.$body = $(document.body)),
                (this.$element = $(element)),
                (this.$dialog = this.$element.find(".modal-dialog")),
                (this.$backdrop = null),
                (this.isShown = null),
                (this.originalBodyPad = null),
                (this.scrollbarWidth = 0),
                (this.ignoreBackdropClick = !1),
                this.options.remote &&
                    this.$element.find(".modal-content").load(
                        this.options.remote,
                        $.proxy(function () {
                            this.$element.trigger("loaded.bs.modal");
                        }, this)
                    );
        }
        function Plugin(option, _relatedTarget) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.modal"),
                    options = $.extend({}, Modal.DEFAULTS, $this.data(), "object" == typeof option && option);
                data || $this.data("bs.modal", (data = new Modal(this, options))), "string" == typeof option ? data[option](_relatedTarget) : options.show && data.show(_relatedTarget);
            });
        }
        (Modal.VERSION = "3.3.7"),
            (Modal.TRANSITION_DURATION = 300),
            (Modal.BACKDROP_TRANSITION_DURATION = 150),
            (Modal.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
            (Modal.prototype.toggle = function (_relatedTarget) {
                return this.isShown ? this.hide() : this.show(_relatedTarget);
            }),
            (Modal.prototype.show = function (_relatedTarget) {
                var that = this,
                    e = $.Event("show.bs.modal", { relatedTarget: _relatedTarget });
                this.$element.trigger(e),
                    this.isShown ||
                        e.isDefaultPrevented() ||
                        ((this.isShown = !0),
                        this.checkScrollbar(),
                        this.setScrollbar(),
                        this.$body.addClass("modal-open"),
                        this.escape(),
                        this.resize(),
                        this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', $.proxy(this.hide, this)),
                        this.$dialog.on("mousedown.dismiss.bs.modal", function () {
                            that.$element.one("mouseup.dismiss.bs.modal", function (e) {
                                $(e.target).is(that.$element) && (that.ignoreBackdropClick = !0);
                            });
                        }),
                        this.backdrop(function () {
                            var transition = $.support.transition && that.$element.hasClass("fade");
                            that.$element.parent().length || that.$element.appendTo(that.$body),
                                that.$element.show().scrollTop(0),
                                that.adjustDialog(),
                                transition && that.$element[0].offsetWidth,
                                that.$element.addClass("in"),
                                that.enforceFocus();
                            var e = $.Event("shown.bs.modal", { relatedTarget: _relatedTarget });
                            transition
                                ? that.$dialog
                                      .one("bsTransitionEnd", function () {
                                          that.$element.trigger("focus").trigger(e);
                                      })
                                      .emulateTransitionEnd(Modal.TRANSITION_DURATION)
                                : that.$element.trigger("focus").trigger(e);
                        }));
            }),
            (Modal.prototype.hide = function (e) {
                e && e.preventDefault(),
                    (e = $.Event("hide.bs.modal")),
                    this.$element.trigger(e),
                    this.isShown &&
                        !e.isDefaultPrevented() &&
                        ((this.isShown = !1),
                        this.escape(),
                        this.resize(),
                        $(document).off("focusin.bs.modal"),
                        this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),
                        this.$dialog.off("mousedown.dismiss.bs.modal"),
                        $.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal());
            }),
            (Modal.prototype.enforceFocus = function () {
                $(document)
                    .off("focusin.bs.modal")
                    .on(
                        "focusin.bs.modal",
                        $.proxy(function (e) {
                            document === e.target || this.$element[0] === e.target || this.$element.has(e.target).length || this.$element.trigger("focus");
                        }, this)
                    );
            }),
            (Modal.prototype.escape = function () {
                this.isShown && this.options.keyboard
                    ? this.$element.on(
                          "keydown.dismiss.bs.modal",
                          $.proxy(function (e) {
                              27 == e.which && this.hide();
                          }, this)
                      )
                    : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
            }),
            (Modal.prototype.resize = function () {
                this.isShown ? $(window).on("resize.bs.modal", $.proxy(this.handleUpdate, this)) : $(window).off("resize.bs.modal");
            }),
            (Modal.prototype.hideModal = function () {
                var that = this;
                this.$element.hide(),
                    this.backdrop(function () {
                        that.$body.removeClass("modal-open"), that.resetAdjustments(), that.resetScrollbar(), that.$element.trigger("hidden.bs.modal");
                    });
            }),
            (Modal.prototype.removeBackdrop = function () {
                this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
            }),
            (Modal.prototype.backdrop = function (callback) {
                var that = this,
                    animate = this.$element.hasClass("fade") ? "fade" : "";
                if (this.isShown && this.options.backdrop) {
                    var doAnimate = $.support.transition && animate;
                    if (
                        ((this.$backdrop = $(document.createElement("div"))
                            .addClass("modal-backdrop " + animate)
                            .appendTo(this.$body)),
                        this.$element.on(
                            "click.dismiss.bs.modal",
                            $.proxy(function (e) {
                                this.ignoreBackdropClick ? (this.ignoreBackdropClick = !1) : e.target === e.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide());
                            }, this)
                        ),
                        doAnimate && this.$backdrop[0].offsetWidth,
                        this.$backdrop.addClass("in"),
                        !callback)
                    )
                        return;
                    doAnimate ? this.$backdrop.one("bsTransitionEnd", callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
                } else if (!this.isShown && this.$backdrop) {
                    this.$backdrop.removeClass("in");
                    var callbackRemove = function () {
                        that.removeBackdrop(), callback && callback();
                    };
                    $.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
                } else callback && callback();
            }),
            (Modal.prototype.handleUpdate = function () {
                this.adjustDialog();
            }),
            (Modal.prototype.adjustDialog = function () {
                var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
                this.$element.css({ paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : "" });
            }),
            (Modal.prototype.resetAdjustments = function () {
                this.$element.css({ paddingLeft: "", paddingRight: "" });
            }),
            (Modal.prototype.checkScrollbar = function () {
                var fullWindowWidth = window.innerWidth;
                if (!fullWindowWidth) {
                    var documentElementRect = document.documentElement.getBoundingClientRect();
                    fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
                }
                (this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth), (this.scrollbarWidth = this.measureScrollbar());
            }),
            (Modal.prototype.setScrollbar = function () {
                var bodyPad = parseInt(this.$body.css("padding-right") || 0, 10);
                (this.originalBodyPad = document.body.style.paddingRight || ""), this.bodyIsOverflowing && this.$body.css("padding-right", bodyPad + this.scrollbarWidth);
            }),
            (Modal.prototype.resetScrollbar = function () {
                this.$body.css("padding-right", this.originalBodyPad);
            }),
            (Modal.prototype.measureScrollbar = function () {
                var scrollDiv = document.createElement("div");
                (scrollDiv.className = "modal-scrollbar-measure"), this.$body.append(scrollDiv);
                var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                return this.$body[0].removeChild(scrollDiv), scrollbarWidth;
            });
        var old = $.fn.modal;
        ($.fn.modal = Plugin),
            ($.fn.modal.Constructor = Modal),
            ($.fn.modal.noConflict = function () {
                return ($.fn.modal = old), this;
            }),
            $(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (e) {
                var $this = $(this),
                    href = $this.attr("href"),
                    $target = $($this.attr("data-target") || (href && href.replace(/.*(?=#[^\s]+$)/, ""))),
                    option = $target.data("bs.modal") ? "toggle" : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());
                $this.is("a") && e.preventDefault(),
                    $target.one("show.bs.modal", function (showEvent) {
                        showEvent.isDefaultPrevented() ||
                            $target.one("hidden.bs.modal", function () {
                                $this.is(":visible") && $this.trigger("focus");
                            });
                    }),
                    Plugin.call($target, option, this);
            });
    })(jQuery),
    (function ($) {
        "use strict";
        function Tooltip(element, options) {
            (this.type = null), (this.options = null), (this.enabled = null), (this.timeout = null), (this.hoverState = null), (this.$element = null), (this.inState = null), this.init("tooltip", element, options);
        }
        (Tooltip.VERSION = "3.3.7"),
            (Tooltip.TRANSITION_DURATION = 150),
            (Tooltip.DEFAULTS = {
                animation: !0,
                placement: "top",
                selector: !1,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                trigger: "hover focus",
                title: "",
                delay: 0,
                html: !1,
                container: !1,
                viewport: { selector: "body", padding: 0 },
            }),
            (Tooltip.prototype.init = function (type, element, options) {
                if (
                    ((this.enabled = !0),
                    (this.type = type),
                    (this.$element = $(element)),
                    (this.options = this.getOptions(options)),
                    (this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport)),
                    (this.inState = { click: !1, hover: !1, focus: !1 }),
                    this.$element[0] instanceof document.constructor && !this.options.selector)
                )
                    throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
                for (var triggers = this.options.trigger.split(" "), i = triggers.length; i--; ) {
                    var trigger = triggers[i];
                    if ("click" == trigger) this.$element.on("click." + this.type, this.options.selector, $.proxy(this.toggle, this));
                    else if ("manual" != trigger) {
                        var eventIn = "hover" == trigger ? "mouseenter" : "focusin",
                            eventOut = "hover" == trigger ? "mouseleave" : "focusout";
                        this.$element.on(eventIn + "." + this.type, this.options.selector, $.proxy(this.enter, this)), this.$element.on(eventOut + "." + this.type, this.options.selector, $.proxy(this.leave, this));
                    }
                }
                this.options.selector ? (this._options = $.extend({}, this.options, { trigger: "manual", selector: "" })) : this.fixTitle();
            }),
            (Tooltip.prototype.getDefaults = function () {
                return Tooltip.DEFAULTS;
            }),
            (Tooltip.prototype.getOptions = function (options) {
                return (options = $.extend({}, this.getDefaults(), this.$element.data(), options)).delay && "number" == typeof options.delay && (options.delay = { show: options.delay, hide: options.delay }), options;
            }),
            (Tooltip.prototype.getDelegateOptions = function () {
                var options = {},
                    defaults = this.getDefaults();
                return (
                    this._options &&
                        $.each(this._options, function (key, value) {
                            defaults[key] != value && (options[key] = value);
                        }),
                    options
                );
            }),
            (Tooltip.prototype.enter = function (obj) {
                var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data("bs." + this.type);
                if (
                    (self || ((self = new this.constructor(obj.currentTarget, this.getDelegateOptions())), $(obj.currentTarget).data("bs." + this.type, self)),
                    obj instanceof $.Event && (self.inState["focusin" == obj.type ? "focus" : "hover"] = !0),
                    self.tip().hasClass("in") || "in" == self.hoverState)
                )
                    self.hoverState = "in";
                else {
                    if ((clearTimeout(self.timeout), (self.hoverState = "in"), !self.options.delay || !self.options.delay.show)) return self.show();
                    self.timeout = setTimeout(function () {
                        "in" == self.hoverState && self.show();
                    }, self.options.delay.show);
                }
            }),
            (Tooltip.prototype.isInStateTrue = function () {
                for (var key in this.inState) if (this.inState[key]) return !0;
                return !1;
            }),
            (Tooltip.prototype.leave = function (obj) {
                var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data("bs." + this.type);
                if (
                    (self || ((self = new this.constructor(obj.currentTarget, this.getDelegateOptions())), $(obj.currentTarget).data("bs." + this.type, self)),
                    obj instanceof $.Event && (self.inState["focusout" == obj.type ? "focus" : "hover"] = !1),
                    !self.isInStateTrue())
                ) {
                    if ((clearTimeout(self.timeout), (self.hoverState = "out"), !self.options.delay || !self.options.delay.hide)) return self.hide();
                    self.timeout = setTimeout(function () {
                        "out" == self.hoverState && self.hide();
                    }, self.options.delay.hide);
                }
            }),
            (Tooltip.prototype.show = function () {
                var e = $.Event("show.bs." + this.type);
                if (this.hasContent() && this.enabled) {
                    this.$element.trigger(e);
                    var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
                    if (e.isDefaultPrevented() || !inDom) return;
                    var that = this,
                        $tip = this.tip(),
                        tipId = this.getUID(this.type);
                    this.setContent(), $tip.attr("id", tipId), this.$element.attr("aria-describedby", tipId), this.options.animation && $tip.addClass("fade");
                    var placement = "function" == typeof this.options.placement ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement,
                        autoToken = /\s?auto?\s?/i,
                        autoPlace = autoToken.test(placement);
                    autoPlace && (placement = placement.replace(autoToken, "") || "top"),
                        $tip
                            .detach()
                            .css({ top: 0, left: 0, display: "block" })
                            .addClass(placement)
                            .data("bs." + this.type, this),
                        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element),
                        this.$element.trigger("inserted.bs." + this.type);
                    var pos = this.getPosition(),
                        actualWidth = $tip[0].offsetWidth,
                        actualHeight = $tip[0].offsetHeight;
                    if (autoPlace) {
                        var orgPlacement = placement,
                            viewportDim = this.getPosition(this.$viewport);
                        (placement =
                            "bottom" == placement && pos.bottom + actualHeight > viewportDim.bottom
                                ? "top"
                                : "top" == placement && pos.top - actualHeight < viewportDim.top
                                ? "bottom"
                                : "right" == placement && pos.right + actualWidth > viewportDim.width
                                ? "left"
                                : "left" == placement && pos.left - actualWidth < viewportDim.left
                                ? "right"
                                : placement),
                            $tip.removeClass(orgPlacement).addClass(placement);
                    }
                    var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
                    this.applyPlacement(calculatedOffset, placement);
                    var complete = function () {
                        var prevHoverState = that.hoverState;
                        that.$element.trigger("shown.bs." + that.type), (that.hoverState = null), "out" == prevHoverState && that.leave(that);
                    };
                    $.support.transition && this.$tip.hasClass("fade") ? $tip.one("bsTransitionEnd", complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
                }
            }),
            (Tooltip.prototype.applyPlacement = function (offset, placement) {
                var $tip = this.tip(),
                    width = $tip[0].offsetWidth,
                    height = $tip[0].offsetHeight,
                    marginTop = parseInt($tip.css("margin-top"), 10),
                    marginLeft = parseInt($tip.css("margin-left"), 10);
                isNaN(marginTop) && (marginTop = 0),
                    isNaN(marginLeft) && (marginLeft = 0),
                    (offset.top += marginTop),
                    (offset.left += marginLeft),
                    $.offset.setOffset(
                        $tip[0],
                        $.extend(
                            {
                                using: function (props) {
                                    $tip.css({ top: Math.round(props.top), left: Math.round(props.left) });
                                },
                            },
                            offset
                        ),
                        0
                    ),
                    $tip.addClass("in");
                var actualWidth = $tip[0].offsetWidth,
                    actualHeight = $tip[0].offsetHeight;
                "top" == placement && actualHeight != height && (offset.top = offset.top + height - actualHeight);
                var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
                delta.left ? (offset.left += delta.left) : (offset.top += delta.top);
                var isVertical = /top|bottom/.test(placement),
                    arrowDelta = isVertical ? 2 * delta.left - width + actualWidth : 2 * delta.top - height + actualHeight,
                    arrowOffsetPosition = isVertical ? "offsetWidth" : "offsetHeight";
                $tip.offset(offset), this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
            }),
            (Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
                this.arrow()
                    .css(isVertical ? "left" : "top", 50 * (1 - delta / dimension) + "%")
                    .css(isVertical ? "top" : "left", "");
            }),
            (Tooltip.prototype.setContent = function () {
                var $tip = this.tip(),
                    title = this.getTitle();
                $tip.find(".tooltip-inner")[this.options.html ? "html" : "text"](title), $tip.removeClass("fade in top bottom left right");
            }),
            (Tooltip.prototype.hide = function (callback) {
                var that = this,
                    $tip = $(this.$tip),
                    e = $.Event("hide.bs." + this.type);
                function complete() {
                    "in" != that.hoverState && $tip.detach(), that.$element && that.$element.removeAttr("aria-describedby").trigger("hidden.bs." + that.type), callback && callback();
                }
                if ((this.$element.trigger(e), !e.isDefaultPrevented()))
                    return $tip.removeClass("in"), $.support.transition && $tip.hasClass("fade") ? $tip.one("bsTransitionEnd", complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete(), (this.hoverState = null), this;
            }),
            (Tooltip.prototype.fixTitle = function () {
                var $e = this.$element;
                (!$e.attr("title") && "string" == typeof $e.attr("data-original-title")) || $e.attr("data-original-title", $e.attr("title") || "").attr("title", "");
            }),
            (Tooltip.prototype.hasContent = function () {
                return this.getTitle();
            }),
            (Tooltip.prototype.getPosition = function ($element) {
                var el = ($element = $element || this.$element)[0],
                    isBody = "BODY" == el.tagName,
                    elRect = el.getBoundingClientRect();
                null == elRect.width && (elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top }));
                var isSvg = window.SVGElement && el instanceof window.SVGElement,
                    elOffset = isBody ? { top: 0, left: 0 } : isSvg ? null : $element.offset(),
                    scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() },
                    outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;
                return $.extend({}, elRect, scroll, outerDims, elOffset);
            }),
            (Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
                return "bottom" == placement
                    ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 }
                    : "top" == placement
                    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 }
                    : "left" == placement
                    ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth }
                    : { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
            }),
            (Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
                var delta = { top: 0, left: 0 };
                if (!this.$viewport) return delta;
                var viewportPadding = (this.options.viewport && this.options.viewport.padding) || 0,
                    viewportDimensions = this.getPosition(this.$viewport);
                if (/right|left/.test(placement)) {
                    var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll,
                        bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
                    topEdgeOffset < viewportDimensions.top
                        ? (delta.top = viewportDimensions.top - topEdgeOffset)
                        : bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height && (delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset);
                } else {
                    var leftEdgeOffset = pos.left - viewportPadding,
                        rightEdgeOffset = pos.left + viewportPadding + actualWidth;
                    leftEdgeOffset < viewportDimensions.left
                        ? (delta.left = viewportDimensions.left - leftEdgeOffset)
                        : rightEdgeOffset > viewportDimensions.right && (delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset);
                }
                return delta;
            }),
            (Tooltip.prototype.getTitle = function () {
                var $e = this.$element,
                    o = this.options;
                return $e.attr("data-original-title") || ("function" == typeof o.title ? o.title.call($e[0]) : o.title);
            }),
            (Tooltip.prototype.getUID = function (prefix) {
                for (; (prefix += ~~(1e6 * Math.random())), document.getElementById(prefix); );
                return prefix;
            }),
            (Tooltip.prototype.tip = function () {
                if (!this.$tip && ((this.$tip = $(this.options.template)), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
                return this.$tip;
            }),
            (Tooltip.prototype.arrow = function () {
                return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
            }),
            (Tooltip.prototype.enable = function () {
                this.enabled = !0;
            }),
            (Tooltip.prototype.disable = function () {
                this.enabled = !1;
            }),
            (Tooltip.prototype.toggleEnabled = function () {
                this.enabled = !this.enabled;
            }),
            (Tooltip.prototype.toggle = function (e) {
                var self = this;
                e && ((self = $(e.currentTarget).data("bs." + this.type)) || ((self = new this.constructor(e.currentTarget, this.getDelegateOptions())), $(e.currentTarget).data("bs." + this.type, self))),
                    e ? ((self.inState.click = !self.inState.click), self.isInStateTrue() ? self.enter(self) : self.leave(self)) : self.tip().hasClass("in") ? self.leave(self) : self.enter(self);
            }),
            (Tooltip.prototype.destroy = function () {
                var that = this;
                clearTimeout(this.timeout),
                    this.hide(function () {
                        that.$element.off("." + that.type).removeData("bs." + that.type), that.$tip && that.$tip.detach(), (that.$tip = null), (that.$arrow = null), (that.$viewport = null), (that.$element = null);
                    });
            });
        var old = $.fn.tooltip;
        ($.fn.tooltip = function (option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.tooltip"),
                    options = "object" == typeof option && option;
                (!data && /destroy|hide/.test(option)) || (data || $this.data("bs.tooltip", (data = new Tooltip(this, options))), "string" == typeof option && data[option]());
            });
        }),
            ($.fn.tooltip.Constructor = Tooltip),
            ($.fn.tooltip.noConflict = function () {
                return ($.fn.tooltip = old), this;
            });
    })(jQuery),
    (function ($) {
        "use strict";
        function Popover(element, options) {
            this.init("popover", element, options);
        }
        if (!$.fn.tooltip) throw new Error("Popover requires tooltip.js");
        (Popover.VERSION = "3.3.7"),
            (Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
                placement: "right",
                trigger: "click",
                content: "",
                template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
            })),
            (((Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)).constructor = Popover).prototype.getDefaults = function () {
                return Popover.DEFAULTS;
            }),
            (Popover.prototype.setContent = function () {
                var $tip = this.tip(),
                    title = this.getTitle(),
                    content = this.getContent();
                $tip.find(".popover-title")[this.options.html ? "html" : "text"](title),
                    $tip.find(".popover-content").children().detach().end()[this.options.html ? ("string" == typeof content ? "html" : "append") : "text"](content),
                    $tip.removeClass("fade top bottom left right in"),
                    $tip.find(".popover-title").html() || $tip.find(".popover-title").hide();
            }),
            (Popover.prototype.hasContent = function () {
                return this.getTitle() || this.getContent();
            }),
            (Popover.prototype.getContent = function () {
                var $e = this.$element,
                    o = this.options;
                return $e.attr("data-content") || ("function" == typeof o.content ? o.content.call($e[0]) : o.content);
            }),
            (Popover.prototype.arrow = function () {
                return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
            });
        var old = $.fn.popover;
        ($.fn.popover = function (option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.popover"),
                    options = "object" == typeof option && option;
                (!data && /destroy|hide/.test(option)) || (data || $this.data("bs.popover", (data = new Popover(this, options))), "string" == typeof option && data[option]());
            });
        }),
            ($.fn.popover.Constructor = Popover),
            ($.fn.popover.noConflict = function () {
                return ($.fn.popover = old), this;
            });
    })(jQuery),
    (function ($) {
        "use strict";
        function ScrollSpy(element, options) {
            (this.$body = $(document.body)),
                (this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)),
                (this.options = $.extend({}, ScrollSpy.DEFAULTS, options)),
                (this.selector = (this.options.target || "") + " .nav li > a"),
                (this.offsets = []),
                (this.targets = []),
                (this.activeTarget = null),
                (this.scrollHeight = 0),
                this.$scrollElement.on("scroll.bs.scrollspy", $.proxy(this.process, this)),
                this.refresh(),
                this.process();
        }
        function Plugin(option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.scrollspy"),
                    options = "object" == typeof option && option;
                data || $this.data("bs.scrollspy", (data = new ScrollSpy(this, options))), "string" == typeof option && data[option]();
            });
        }
        (ScrollSpy.VERSION = "3.3.7"),
            (ScrollSpy.DEFAULTS = { offset: 10 }),
            (ScrollSpy.prototype.getScrollHeight = function () {
                return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
            }),
            (ScrollSpy.prototype.refresh = function () {
                var that = this,
                    offsetMethod = "offset",
                    offsetBase = 0;
                (this.offsets = []),
                    (this.targets = []),
                    (this.scrollHeight = this.getScrollHeight()),
                    $.isWindow(this.$scrollElement[0]) || ((offsetMethod = "position"), (offsetBase = this.$scrollElement.scrollTop())),
                    this.$body
                        .find(this.selector)
                        .map(function () {
                            var $el = $(this),
                                href = $el.data("target") || $el.attr("href"),
                                $href = /^#./.test(href) && $(href);
                            return ($href && $href.length && $href.is(":visible") && [[$href[offsetMethod]().top + offsetBase, href]]) || null;
                        })
                        .sort(function (a, b) {
                            return a[0] - b[0];
                        })
                        .each(function () {
                            that.offsets.push(this[0]), that.targets.push(this[1]);
                        });
            }),
            (ScrollSpy.prototype.process = function () {
                var i,
                    scrollTop = this.$scrollElement.scrollTop() + this.options.offset,
                    scrollHeight = this.getScrollHeight(),
                    maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height(),
                    offsets = this.offsets,
                    targets = this.targets,
                    activeTarget = this.activeTarget;
                if ((this.scrollHeight != scrollHeight && this.refresh(), maxScroll <= scrollTop)) return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
                if (activeTarget && scrollTop < offsets[0]) return (this.activeTarget = null), this.clear();
                for (i = offsets.length; i--; ) activeTarget != targets[i] && scrollTop >= offsets[i] && (void 0 === offsets[i + 1] || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
            }),
            (ScrollSpy.prototype.activate = function (target) {
                (this.activeTarget = target), this.clear();
                var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]',
                    active = $(selector).parents("li").addClass("active");
                active.parent(".dropdown-menu").length && (active = active.closest("li.dropdown").addClass("active")), active.trigger("activate.bs.scrollspy");
            }),
            (ScrollSpy.prototype.clear = function () {
                $(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
            });
        var old = $.fn.scrollspy;
        ($.fn.scrollspy = Plugin),
            ($.fn.scrollspy.Constructor = ScrollSpy),
            ($.fn.scrollspy.noConflict = function () {
                return ($.fn.scrollspy = old), this;
            }),
            $(window).on("load.bs.scrollspy.data-api", function () {
                $('[data-spy="scroll"]').each(function () {
                    var $spy = $(this);
                    Plugin.call($spy, $spy.data());
                });
            });
    })(jQuery),
    (function ($) {
        "use strict";
        function Tab(element) {
            this.element = $(element);
        }
        function Plugin(option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.tab");
                data || $this.data("bs.tab", (data = new Tab(this))), "string" == typeof option && data[option]();
            });
        }
        (Tab.VERSION = "3.3.7"),
            (Tab.TRANSITION_DURATION = 150),
            (Tab.prototype.show = function () {
                var $this = this.element,
                    $ul = $this.closest("ul:not(.dropdown-menu)"),
                    selector = $this.data("target");
                if (((selector = selector || ((selector = $this.attr("href")) && selector.replace(/.*(?=#[^\s]*$)/, ""))), !$this.parent("li").hasClass("active"))) {
                    var $previous = $ul.find(".active:last a"),
                        hideEvent = $.Event("hide.bs.tab", { relatedTarget: $this[0] }),
                        showEvent = $.Event("show.bs.tab", { relatedTarget: $previous[0] });
                    if (($previous.trigger(hideEvent), $this.trigger(showEvent), !showEvent.isDefaultPrevented() && !hideEvent.isDefaultPrevented())) {
                        var $target = $(selector);
                        this.activate($this.closest("li"), $ul),
                            this.activate($target, $target.parent(), function () {
                                $previous.trigger({ type: "hidden.bs.tab", relatedTarget: $this[0] }), $this.trigger({ type: "shown.bs.tab", relatedTarget: $previous[0] });
                            });
                    }
                }
            }),
            (Tab.prototype.activate = function (element, container, callback) {
                var $active = container.find("> .active"),
                    transition = callback && $.support.transition && (($active.length && $active.hasClass("fade")) || !!container.find("> .fade").length);
                function next() {
                    $active.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1),
                        element.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0),
                        transition ? (element[0].offsetWidth, element.addClass("in")) : element.removeClass("fade"),
                        element.parent(".dropdown-menu").length && element.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0),
                        callback && callback();
                }
                $active.length && transition ? $active.one("bsTransitionEnd", next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next(), $active.removeClass("in");
            });
        var old = $.fn.tab;
        ($.fn.tab = Plugin),
            ($.fn.tab.Constructor = Tab),
            ($.fn.tab.noConflict = function () {
                return ($.fn.tab = old), this;
            });
        function clickHandler(e) {
            e.preventDefault(), Plugin.call($(this), "show");
        }
        $(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', clickHandler).on("click.bs.tab.data-api", '[data-toggle="pill"]', clickHandler);
    })(jQuery),
    (function ($) {
        "use strict";
        var Affix = function (element, options) {
            (this.options = $.extend({}, Affix.DEFAULTS, options)),
                (this.$target = $(this.options.target).on("scroll.bs.affix.data-api", $.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", $.proxy(this.checkPositionWithEventLoop, this))),
                (this.$element = $(element)),
                (this.affixed = null),
                (this.unpin = null),
                (this.pinnedOffset = null),
                this.checkPosition();
        };
        function Plugin(option) {
            return this.each(function () {
                var $this = $(this),
                    data = $this.data("bs.affix"),
                    options = "object" == typeof option && option;
                data || $this.data("bs.affix", (data = new Affix(this, options))), "string" == typeof option && data[option]();
            });
        }
        (Affix.VERSION = "3.3.7"),
            (Affix.RESET = "affix affix-top affix-bottom"),
            (Affix.DEFAULTS = { offset: 0, target: window }),
            (Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
                var scrollTop = this.$target.scrollTop(),
                    position = this.$element.offset(),
                    targetHeight = this.$target.height();
                if (null != offsetTop && "top" == this.affixed) return scrollTop < offsetTop && "top";
                if ("bottom" == this.affixed) return null != offsetTop ? !(scrollTop + this.unpin <= position.top) && "bottom" : !(scrollTop + targetHeight <= scrollHeight - offsetBottom) && "bottom";
                var initializing = null == this.affixed,
                    colliderTop = initializing ? scrollTop : position.top;
                return null != offsetTop && scrollTop <= offsetTop ? "top" : null != offsetBottom && scrollHeight - offsetBottom <= colliderTop + (initializing ? targetHeight : height) && "bottom";
            }),
            (Affix.prototype.getPinnedOffset = function () {
                if (this.pinnedOffset) return this.pinnedOffset;
                this.$element.removeClass(Affix.RESET).addClass("affix");
                var scrollTop = this.$target.scrollTop(),
                    position = this.$element.offset();
                return (this.pinnedOffset = position.top - scrollTop);
            }),
            (Affix.prototype.checkPositionWithEventLoop = function () {
                setTimeout($.proxy(this.checkPosition, this), 1);
            }),
            (Affix.prototype.checkPosition = function () {
                if (this.$element.is(":visible")) {
                    var height = this.$element.height(),
                        offset = this.options.offset,
                        offsetTop = offset.top,
                        offsetBottom = offset.bottom,
                        scrollHeight = Math.max($(document).height(), $(document.body).height());
                    "object" != typeof offset && (offsetBottom = offsetTop = offset),
                        "function" == typeof offsetTop && (offsetTop = offset.top(this.$element)),
                        "function" == typeof offsetBottom && (offsetBottom = offset.bottom(this.$element));
                    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
                    if (this.affixed != affix) {
                        null != this.unpin && this.$element.css("top", "");
                        var affixType = "affix" + (affix ? "-" + affix : ""),
                            e = $.Event(affixType + ".bs.affix");
                        if ((this.$element.trigger(e), e.isDefaultPrevented())) return;
                        (this.affixed = affix),
                            (this.unpin = "bottom" == affix ? this.getPinnedOffset() : null),
                            this.$element
                                .removeClass(Affix.RESET)
                                .addClass(affixType)
                                .trigger(affixType.replace("affix", "affixed") + ".bs.affix");
                    }
                    "bottom" == affix && this.$element.offset({ top: scrollHeight - height - offsetBottom });
                }
            });
        var old = $.fn.affix;
        ($.fn.affix = Plugin),
            ($.fn.affix.Constructor = Affix),
            ($.fn.affix.noConflict = function () {
                return ($.fn.affix = old), this;
            }),
            $(window).on("load", function () {
                $('[data-spy="affix"]').each(function () {
                    var $spy = $(this),
                        data = $spy.data();
                    (data.offset = data.offset || {}), null != data.offsetBottom && (data.offset.bottom = data.offsetBottom), null != data.offsetTop && (data.offset.top = data.offsetTop), Plugin.call($spy, data);
                });
            });
    })(jQuery),
    (function ($) {
        $.fn.tableHeadFixer = function (param) {
            return this.each(function () {
                (function () {
                    function setBackground(elements) {
                        elements.each(function (k, element) {
                            element = $(element);
                            var parent = $(element).parent();
                            if (settings.cellBackground) background = settings.cellBackground;
                            else {
                                var elementBackground = element.css("background-color");
                                elementBackground = "transparent" == elementBackground || "rgba(0, 0, 0, 0)" == elementBackground ? null : elementBackground;
                                var parentBackground = parent.css("background-color"),
                                    background = (parentBackground = "transparent" == parentBackground || "rgba(0, 0, 0, 0)" == parentBackground ? null : parentBackground) || "white";
                                background = elementBackground || background;
                            }
                            element.css("background-color", background);
                        });
                    }
                    function solverLeftColspan(row, action) {
                        for (var fixColumn = settings.left, inc = 1, i = 1; i <= fixColumn; i += inc) {
                            var nth = 1 < inc ? i - 1 : i,
                                cell = $(row).find("> *:nth-child(" + nth + ")"),
                                colspan = cell.prop("colspan");
                            void 0 !== cell.cellPos() && cell.cellPos().left < fixColumn && action(cell), (inc = colspan);
                        }
                    }
                    var settings = $.extend({}, { head: !0, foot: !1, left: 0, right: 0, "z-index": 0 }, param);
                    (settings.table = this),
                        (settings.parent = $(settings.table).parent()),
                        (function () {
                            var parent = $(settings.parent),
                                table = $(settings.table);
                            parent.append(table),
                                parent.css({ "overflow-x": "auto", "overflow-y": "auto" }),
                                parent.scroll(
                                    function () {
                                        var scrollWidth = parent[0].scrollWidth,
                                            clientWidth = parent[0].clientWidth,
                                            scrollHeight = parent[0].scrollHeight,
                                            clientHeight = parent[0].clientHeight,
                                            top = parent.scrollTop(),
                                            left = parent.scrollLeft();
                                        settings.head && this.find("> thead > tr > *").css("top", top),
                                            settings.foot && this.find("> tfoot > tr > *").css("bottom", scrollHeight - clientHeight - top),
                                            0 < settings.left && settings.leftColumns.css("left", left),
                                            0 < settings.right && settings.rightColumns.css("right", scrollWidth - clientWidth - left);
                                    }.bind(table)
                                );
                        })(),
                        1 == settings.head &&
                            (function () {
                                var thead = $(settings.table).find("> thead"),
                                    cells = (thead.find("> tr"), thead.find("> tr > *"));
                                setBackground(cells), cells.css({ position: "relative" });
                            })();
                    1 == settings.foot &&
                        (function () {
                            var tfoot = $(settings.table).find("> tfoot"),
                                cells = (tfoot.find("> tr"), tfoot.find("> tr > *"));
                            setBackground(cells), cells.css({ position: "relative" });
                        })();
                    0 < settings.left &&
                        (function () {
                            var table = $(settings.table);
                            (settings.leftColumns = $()),
                                table.find("> thead > tr, > tbody > tr, > tfoot > tr").each(function (k, row) {
                                    solverLeftColspan(row, function (cell) {
                                        settings.leftColumns = settings.leftColumns.add(cell);
                                    });
                                }),
                                settings.leftColumns.each(function (k, cell) {
                                    setBackground((cell = $(cell))), cell.css({ position: "relative" });
                                });
                        })();
                    0 < settings.right &&
                        (function () {
                            var table = $(settings.table);
                            settings.right, (settings.rightColumns = $());
                            var tr_head = table.find("> thead").find("> tr"),
                                tr_body = table.find("> tbody").find("> tr"),
                                fcell = null;
                            tr_head.each(function (k, row) {
                                !(function (row, action) {
                                    for (var fixColumn = settings.right, inc = 1, i = 1; i <= fixColumn; i += inc) {
                                        var nth = 1 < inc ? i - 1 : i,
                                            cell = $(row).find("> *:nth-last-child(" + nth + ")"),
                                            colspan = cell.prop("colspan");
                                        action(cell), (inc = colspan);
                                    }
                                })(row, function (cell) {
                                    0 === k && (fcell = cell), (settings.rightColumns = settings.rightColumns.add(fcell));
                                });
                            }),
                                tr_body.each(function (k, row) {
                                    !(function (row, action) {
                                        for (var fixColumn = settings.right, inc = 1, i = 1; i <= fixColumn; i += inc) {
                                            var nth = 1 < inc ? i - 1 : i,
                                                cell = $(row).find("> *:nth-last-child(" + nth + ")"),
                                                colspan = cell.prop("colspan");
                                            action(cell), (inc = colspan);
                                        }
                                    })(row, function (cell) {
                                        settings.rightColumns = settings.rightColumns.add(cell);
                                    });
                                }),
                                settings.rightColumns.each(function (k, cell) {
                                    setBackground((cell = $(cell))), cell.css({ position: "relative", "z-index": "9999" });
                                });
                        })();
                    (function () {
                        var table = $(settings.table);
                        if (settings.head) {
                            if (0 < settings.left)
                                table.find("> thead > tr").each(function (k, row) {
                                    solverLeftColspan(row, function (cell) {
                                        $(cell).css("z-index", settings["z-index"] + 1);
                                    });
                                });
                            if (0 < settings.right)
                                table.find("> thead > tr").each(function (k, row) {
                                    solveRightColspan(row, function (cell) {
                                        $(cell).css("z-index", settings["z-index"] + 1);
                                    });
                                });
                        }
                        if (settings.foot) {
                            if (0 < settings.left)
                                table.find("> tfoot > tr").each(function (k, row) {
                                    solverLeftColspan(row, function (cell) {
                                        $(cell).css("z-index", settings["z-index"]);
                                    });
                                });
                            if (0 < settings.right)
                                table.find("> tfoot > tr").each(function (k, row) {
                                    solveRightColspan(row, function (cell) {
                                        $(cell).css("z-index", settings["z-index"]);
                                    });
                                });
                        }
                    })(),
                        $(settings.parent).trigger("scroll"),
                        $(window).resize(function () {
                            $(settings.parent).trigger("scroll");
                        });
                }.call(this));
            });
        };
    })(jQuery),
    (function ($) {
        $.fn.cellPos = function (rescan) {
            var $cell = this.first(),
                pos = $cell.data("cellPos");
            (pos && !rescan) ||
                (function ($table) {
                    var m = [];
                    $table.children("tr").each(function (y, row) {
                        $(row)
                            .children("td, th")
                            .each(function (x, cell) {
                                var tx,
                                    ty,
                                    $cell = $(cell),
                                    cspan = 0 | $cell.attr("colspan"),
                                    rspan = 0 | $cell.attr("rowspan");
                                for (cspan = cspan || 1, rspan = rspan || 1; m[y] && m[y][x]; ++x);
                                for (tx = x; tx < x + cspan; ++tx) for (ty = y; ty < y + rspan; ++ty) m[ty] || (m[ty] = []), (m[ty][tx] = !0);
                                var pos = { top: y, left: x };
                                $cell.data("cellPos", pos);
                            });
                    });
                })($cell.closest("table, thead, tbody, tfoot"));
            return (pos = $cell.data("cellPos"));
        };
    })(jQuery),
    (function (factory) {
        "function" == typeof define && define.amd ? define(["jquery"], factory) : "object" == typeof exports ? factory(require("jquery")) : factory(window.jQuery || window.Zepto);
    })(function ($) {
        function MagnificPopup() {}
        function _mfpOn(name, f) {
            mfp.ev.on("mfp" + name + ".mfp", f);
        }
        function _getEl(className, appendTo, html, raw) {
            var el = document.createElement("div");
            return (el.className = "mfp-" + className), html && (el.innerHTML = html), raw ? appendTo && appendTo.appendChild(el) : ((el = $(el)), appendTo && el.appendTo(appendTo)), el;
        }
        function _mfpTrigger(e, data) {
            mfp.ev.triggerHandler("mfp" + e, data), mfp.st.callbacks && ((e = e.charAt(0).toLowerCase() + e.slice(1)), mfp.st.callbacks[e] && mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [data]));
        }
        function _getCloseBtn(type) {
            return (type === _currPopupType && mfp.currTemplate.closeBtn) || ((mfp.currTemplate.closeBtn = $(mfp.st.closeMarkup.replace("%title%", mfp.st.tClose))), (_currPopupType = type)), mfp.currTemplate.closeBtn;
        }
        function _checkInstance() {
            $.magnificPopup.instance || ((mfp = new MagnificPopup()).init(), ($.magnificPopup.instance = mfp));
        }
        var mfp,
            _prevStatus,
            _document,
            _prevContentType,
            _wrapClasses,
            _currPopupType,
            _isJQ = !!window.jQuery,
            _window = $(window);
        (MagnificPopup.prototype = {
            constructor: MagnificPopup,
            init: function () {
                var appVersion = navigator.appVersion;
                (mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener),
                    (mfp.isAndroid = /android/gi.test(appVersion)),
                    (mfp.isIOS = /iphone|ipad|ipod/gi.test(appVersion)),
                    (mfp.supportsTransition = (function () {
                        var s = document.createElement("p").style,
                            v = ["ms", "O", "Moz", "Webkit"];
                        if (void 0 !== s.transition) return !0;
                        for (; v.length; ) if (v.pop() + "Transition" in s) return !0;
                        return !1;
                    })()),
                    (mfp.probablyMobile = mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent)),
                    (_document = $(document)),
                    (mfp.popupsCache = {});
            },
            open: function (data) {
                var i;
                if (!1 === data.isObj) {
                    (mfp.items = data.items.toArray()), (mfp.index = 0);
                    var item,
                        items = data.items;
                    for (i = 0; i < items.length; i++)
                        if (((item = items[i]).parsed && (item = item.el[0]), item === data.el[0])) {
                            mfp.index = i;
                            break;
                        }
                } else (mfp.items = $.isArray(data.items) ? data.items : [data.items]), (mfp.index = data.index || 0);
                if (!mfp.isOpen) {
                    (mfp.types = []),
                        (_wrapClasses = ""),
                        data.mainEl && data.mainEl.length ? (mfp.ev = data.mainEl.eq(0)) : (mfp.ev = _document),
                        data.key ? (mfp.popupsCache[data.key] || (mfp.popupsCache[data.key] = {}), (mfp.currTemplate = mfp.popupsCache[data.key])) : (mfp.currTemplate = {}),
                        (mfp.st = $.extend(!0, {}, $.magnificPopup.defaults, data)),
                        (mfp.fixedContentPos = "auto" === mfp.st.fixedContentPos ? !mfp.probablyMobile : mfp.st.fixedContentPos),
                        mfp.st.modal && ((mfp.st.closeOnContentClick = !1), (mfp.st.closeOnBgClick = !1), (mfp.st.showCloseBtn = !1), (mfp.st.enableEscapeKey = !1)),
                        mfp.bgOverlay ||
                            ((mfp.bgOverlay = _getEl("bg").on("click.mfp", function () {
                                mfp.close();
                            })),
                            (mfp.wrap = _getEl("wrap")
                                .attr("tabindex", -1)
                                .on("click.mfp", function (e) {
                                    mfp._checkIfClose(e.target) && mfp.close();
                                })),
                            (mfp.container = _getEl("container", mfp.wrap))),
                        (mfp.contentContainer = _getEl("content")),
                        mfp.st.preloader && (mfp.preloader = _getEl("preloader", mfp.container, mfp.st.tLoading));
                    var modules = $.magnificPopup.modules;
                    for (i = 0; i < modules.length; i++) {
                        var n = modules[i];
                        (n = n.charAt(0).toUpperCase() + n.slice(1)), mfp["init" + n].call(mfp);
                    }
                    _mfpTrigger("BeforeOpen"),
                        mfp.st.showCloseBtn &&
                            (mfp.st.closeBtnInside
                                ? (_mfpOn("MarkupParse", function (e, template, values, item) {
                                      values.close_replaceWith = _getCloseBtn(item.type);
                                  }),
                                  (_wrapClasses += " mfp-close-btn-in"))
                                : mfp.wrap.append(_getCloseBtn())),
                        mfp.st.alignTop && (_wrapClasses += " mfp-align-top"),
                        mfp.fixedContentPos ? mfp.wrap.css({ overflow: mfp.st.overflowY, overflowX: "hidden", overflowY: mfp.st.overflowY }) : mfp.wrap.css({ top: _window.scrollTop(), position: "absolute" }),
                        (!1 !== mfp.st.fixedBgPos && ("auto" !== mfp.st.fixedBgPos || mfp.fixedContentPos)) || mfp.bgOverlay.css({ height: _document.height(), position: "absolute" }),
                        mfp.st.enableEscapeKey &&
                            _document.on("keyup.mfp", function (e) {
                                27 === e.keyCode && mfp.close();
                            }),
                        _window.on("resize.mfp", function () {
                            mfp.updateSize();
                        }),
                        mfp.st.closeOnContentClick || (_wrapClasses += " mfp-auto-cursor"),
                        _wrapClasses && mfp.wrap.addClass(_wrapClasses);
                    var windowHeight = (mfp.wH = _window.height()),
                        windowStyles = {};
                    if (mfp.fixedContentPos && mfp._hasScrollBar(windowHeight)) {
                        var s = mfp._getScrollbarSize();
                        s && (windowStyles.marginRight = s);
                    }
                    mfp.fixedContentPos && (mfp.isIE7 ? $("body, html").css("overflow", "hidden") : (windowStyles.overflow = "hidden"));
                    var classesToadd = mfp.st.mainClass;
                    return (
                        mfp.isIE7 && (classesToadd += " mfp-ie7"),
                        classesToadd && mfp._addClassToMFP(classesToadd),
                        mfp.updateItemHTML(),
                        _mfpTrigger("BuildControls"),
                        $("html").css(windowStyles),
                        mfp.bgOverlay.add(mfp.wrap).prependTo(mfp.st.prependTo || $(document.body)),
                        (mfp._lastFocusedEl = document.activeElement),
                        setTimeout(function () {
                            mfp.content ? (mfp._addClassToMFP("mfp-ready"), mfp._setFocus()) : mfp.bgOverlay.addClass("mfp-ready"), _document.on("focusin.mfp", mfp._onFocusIn);
                        }, 16),
                        (mfp.isOpen = !0),
                        mfp.updateSize(windowHeight),
                        _mfpTrigger("Open"),
                        data
                    );
                }
                mfp.updateItemHTML();
            },
            close: function () {
                mfp.isOpen &&
                    (_mfpTrigger("BeforeClose"),
                    (mfp.isOpen = !1),
                    mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition
                        ? (mfp._addClassToMFP("mfp-removing"),
                          setTimeout(function () {
                              mfp._close();
                          }, mfp.st.removalDelay))
                        : mfp._close());
            },
            _close: function () {
                _mfpTrigger("Close");
                var classesToRemove = "mfp-removing mfp-ready ";
                if ((mfp.bgOverlay.detach(), mfp.wrap.detach(), mfp.container.empty(), mfp.st.mainClass && (classesToRemove += mfp.st.mainClass + " "), mfp._removeClassFromMFP(classesToRemove), mfp.fixedContentPos)) {
                    var windowStyles = { marginRight: "" };
                    mfp.isIE7 ? $("body, html").css("overflow", "") : (windowStyles.overflow = ""), $("html").css(windowStyles);
                }
                _document.off("keyup.mfp focusin.mfp"),
                    mfp.ev.off(".mfp"),
                    mfp.wrap.attr("class", "mfp-wrap").removeAttr("style"),
                    mfp.bgOverlay.attr("class", "mfp-bg"),
                    mfp.container.attr("class", "mfp-container"),
                    !mfp.st.showCloseBtn || (mfp.st.closeBtnInside && !0 !== mfp.currTemplate[mfp.currItem.type]) || (mfp.currTemplate.closeBtn && mfp.currTemplate.closeBtn.detach()),
                    mfp.st.autoFocusLast && mfp._lastFocusedEl && $(mfp._lastFocusedEl).focus(),
                    (mfp.currItem = null),
                    (mfp.content = null),
                    (mfp.currTemplate = null),
                    (mfp.prevHeight = 0),
                    _mfpTrigger("AfterClose");
            },
            updateSize: function (winHeight) {
                if (mfp.isIOS) {
                    var zoomLevel = document.documentElement.clientWidth / window.innerWidth,
                        height = window.innerHeight * zoomLevel;
                    mfp.wrap.css("height", height), (mfp.wH = height);
                } else mfp.wH = winHeight || _window.height();
                mfp.fixedContentPos || mfp.wrap.css("height", mfp.wH), _mfpTrigger("Resize");
            },
            updateItemHTML: function () {
                var item = mfp.items[mfp.index];
                mfp.contentContainer.detach(), mfp.content && mfp.content.detach(), item.parsed || (item = mfp.parseEl(mfp.index));
                var type = item.type;
                if ((_mfpTrigger("BeforeChange", [mfp.currItem ? mfp.currItem.type : "", type]), (mfp.currItem = item), !mfp.currTemplate[type])) {
                    var markup = !!mfp.st[type] && mfp.st[type].markup;
                    _mfpTrigger("FirstMarkupParse", markup), (mfp.currTemplate[type] = !markup || $(markup));
                }
                _prevContentType && _prevContentType !== item.type && mfp.container.removeClass("mfp-" + _prevContentType + "-holder");
                var newContent = mfp["get" + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
                mfp.appendContent(newContent, type), (item.preloaded = !0), _mfpTrigger("Change", item), (_prevContentType = item.type), mfp.container.prepend(mfp.contentContainer), _mfpTrigger("AfterChange");
            },
            appendContent: function (newContent, type) {
                (mfp.content = newContent)
                    ? mfp.st.showCloseBtn && mfp.st.closeBtnInside && !0 === mfp.currTemplate[type]
                        ? mfp.content.find(".mfp-close").length || mfp.content.append(_getCloseBtn())
                        : (mfp.content = newContent)
                    : (mfp.content = ""),
                    _mfpTrigger("BeforeAppend"),
                    mfp.container.addClass("mfp-" + type + "-holder"),
                    mfp.contentContainer.append(mfp.content);
            },
            parseEl: function (index) {
                var type,
                    item = mfp.items[index];
                if ((item = item.tagName ? { el: $(item) } : ((type = item.type), { data: item, src: item.src })).el) {
                    for (var types = mfp.types, i = 0; i < types.length; i++)
                        if (item.el.hasClass("mfp-" + types[i])) {
                            type = types[i];
                            break;
                        }
                    (item.src = item.el.attr("data-mfp-src")), item.src || (item.src = item.el.attr("href"));
                }
                return (item.type = type || mfp.st.type || "inline"), (item.index = index), (item.parsed = !0), (mfp.items[index] = item), _mfpTrigger("ElementParse", item), mfp.items[index];
            },
            addGroup: function (el, options) {
                function eHandler(e) {
                    (e.mfpEl = this), mfp._openClick(e, el, options);
                }
                var eName = "click.magnificPopup";
                ((options = options || {}).mainEl = el),
                    options.items
                        ? ((options.isObj = !0), el.off(eName).on(eName, eHandler))
                        : ((options.isObj = !1), options.delegate ? el.off(eName).on(eName, options.delegate, eHandler) : (options.items = el).off(eName).on(eName, eHandler));
            },
            _openClick: function (e, el, options) {
                if ((void 0 !== options.midClick ? options.midClick : $.magnificPopup.defaults.midClick) || !(2 === e.which || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey)) {
                    var disableOn = void 0 !== options.disableOn ? options.disableOn : $.magnificPopup.defaults.disableOn;
                    if (disableOn)
                        if ($.isFunction(disableOn)) {
                            if (!disableOn.call(mfp)) return !0;
                        } else if (_window.width() < disableOn) return !0;
                    e.type && (e.preventDefault(), mfp.isOpen && e.stopPropagation()), (options.el = $(e.mfpEl)), options.delegate && (options.items = el.find(options.delegate)), mfp.open(options);
                }
            },
            updateStatus: function (status, text) {
                if (mfp.preloader) {
                    _prevStatus !== status && mfp.container.removeClass("mfp-s-" + _prevStatus), text || "loading" !== status || (text = mfp.st.tLoading);
                    var data = { status: status, text: text };
                    _mfpTrigger("UpdateStatus", data),
                        (status = data.status),
                        (text = data.text),
                        mfp.preloader.html(text),
                        mfp.preloader.find("a").on("click", function (e) {
                            e.stopImmediatePropagation();
                        }),
                        mfp.container.addClass("mfp-s-" + status),
                        (_prevStatus = status);
                }
            },
            _checkIfClose: function (target) {
                if (!$(target).hasClass("mfp-prevent-close")) {
                    var closeOnContent = mfp.st.closeOnContentClick,
                        closeOnBg = mfp.st.closeOnBgClick;
                    if (closeOnContent && closeOnBg) return !0;
                    if (!mfp.content || $(target).hasClass("mfp-close") || (mfp.preloader && target === mfp.preloader[0])) return !0;
                    if (target === mfp.content[0] || $.contains(mfp.content[0], target)) {
                        if (closeOnContent) return !0;
                    } else if (closeOnBg && $.contains(document, target)) return !0;
                    return !1;
                }
            },
            _addClassToMFP: function (cName) {
                mfp.bgOverlay.addClass(cName), mfp.wrap.addClass(cName);
            },
            _removeClassFromMFP: function (cName) {
                this.bgOverlay.removeClass(cName), mfp.wrap.removeClass(cName);
            },
            _hasScrollBar: function (winHeight) {
                return (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height());
            },
            _setFocus: function () {
                (mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
            },
            _onFocusIn: function (e) {
                if (e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target)) return mfp._setFocus(), !1;
            },
            _parseMarkup: function (template, values, item) {
                var arr;
                item.data && (values = $.extend(item.data, values)),
                    _mfpTrigger("MarkupParse", [template, values, item]),
                    $.each(values, function (key, value) {
                        if (void 0 === value || !1 === value) return !0;
                        if (1 < (arr = key.split("_")).length) {
                            var el = template.find(".mfp-" + arr[0]);
                            if (0 < el.length) {
                                var attr = arr[1];
                                "replaceWith" === attr
                                    ? el[0] !== value[0] && el.replaceWith(value)
                                    : "img" === attr
                                    ? el.is("img")
                                        ? el.attr("src", value)
                                        : el.replaceWith($("<img>").attr("src", value).attr("class", el.attr("class")))
                                    : el.attr(arr[1], value);
                            }
                        } else template.find(".mfp-" + key).html(value);
                    });
            },
            _getScrollbarSize: function () {
                if (void 0 === mfp.scrollbarSize) {
                    var scrollDiv = document.createElement("div");
                    (scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
                        document.body.appendChild(scrollDiv),
                        (mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth),
                        document.body.removeChild(scrollDiv);
                }
                return mfp.scrollbarSize;
            },
        }),
            ($.magnificPopup = {
                instance: null,
                proto: MagnificPopup.prototype,
                modules: [],
                open: function (options, index) {
                    return _checkInstance(), ((options = options ? $.extend(!0, {}, options) : {}).isObj = !0), (options.index = index || 0), this.instance.open(options);
                },
                close: function () {
                    return $.magnificPopup.instance && $.magnificPopup.instance.close();
                },
                registerModule: function (name, module) {
                    module.options && ($.magnificPopup.defaults[name] = module.options), $.extend(this.proto, module.proto), this.modules.push(name);
                },
                defaults: {
                    disableOn: 0,
                    key: null,
                    midClick: !1,
                    mainClass: "",
                    preloader: !0,
                    focus: "",
                    closeOnContentClick: !1,
                    closeOnBgClick: !0,
                    closeBtnInside: !0,
                    showCloseBtn: !0,
                    enableEscapeKey: !0,
                    modal: !1,
                    alignTop: !1,
                    removalDelay: 0,
                    prependTo: null,
                    fixedContentPos: "auto",
                    fixedBgPos: "auto",
                    overflowY: "auto",
                    closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                    tClose: "Close (Esc)",
                    tLoading: "Loading...",
                    autoFocusLast: !0,
                },
            }),
            ($.fn.magnificPopup = function (options) {
                _checkInstance();
                var jqEl = $(this);
                if ("string" == typeof options)
                    if ("open" === options) {
                        var items,
                            itemOpts = _isJQ ? jqEl.data("magnificPopup") : jqEl[0].magnificPopup,
                            index = parseInt(arguments[1], 10) || 0;
                        (items = itemOpts.items ? itemOpts.items[index] : ((items = jqEl), itemOpts.delegate && (items = items.find(itemOpts.delegate)), items.eq(index))), mfp._openClick({ mfpEl: items }, jqEl, itemOpts);
                    } else mfp.isOpen && mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
                else (options = $.extend(!0, {}, options)), _isJQ ? jqEl.data("magnificPopup", options) : (jqEl[0].magnificPopup = options), mfp.addGroup(jqEl, options);
                return jqEl;
            });
        function _putInlineElementsBack() {
            _lastInlineElement && (_inlinePlaceholder.after(_lastInlineElement.addClass(_hiddenClass)).detach(), (_lastInlineElement = null));
        }
        var _hiddenClass, _inlinePlaceholder, _lastInlineElement;
        $.magnificPopup.registerModule("inline", {
            options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" },
            proto: {
                initInline: function () {
                    mfp.types.push("inline"),
                        _mfpOn("Close.inline", function () {
                            _putInlineElementsBack();
                        });
                },
                getInline: function (item, template) {
                    if ((_putInlineElementsBack(), item.src)) {
                        var inlineSt = mfp.st.inline,
                            el = $(item.src);
                        if (el.length) {
                            var parent = el[0].parentNode;
                            parent &&
                                parent.tagName &&
                                (_inlinePlaceholder || ((_hiddenClass = inlineSt.hiddenClass), (_inlinePlaceholder = _getEl(_hiddenClass)), (_hiddenClass = "mfp-" + _hiddenClass)),
                                (_lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass))),
                                mfp.updateStatus("ready");
                        } else mfp.updateStatus("error", inlineSt.tNotFound), (el = $("<div>"));
                        return (item.inlineElement = el);
                    }
                    return mfp.updateStatus("ready"), mfp._parseMarkup(template, {}, item), template;
                },
            },
        });
        function _removeAjaxCursor() {
            _ajaxCur && $(document.body).removeClass(_ajaxCur);
        }
        function _destroyAjaxRequest() {
            _removeAjaxCursor(), mfp.req && mfp.req.abort();
        }
        var _ajaxCur;
        $.magnificPopup.registerModule("ajax", {
            options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' },
            proto: {
                initAjax: function () {
                    mfp.types.push("ajax"), (_ajaxCur = mfp.st.ajax.cursor), _mfpOn("Close.ajax", _destroyAjaxRequest), _mfpOn("BeforeChange.ajax", _destroyAjaxRequest);
                },
                getAjax: function (item) {
                    _ajaxCur && $(document.body).addClass(_ajaxCur), mfp.updateStatus("loading");
                    var opts = $.extend(
                        {
                            url: item.src,
                            success: function (data, textStatus, jqXHR) {
                                var temp = { data: data, xhr: jqXHR };
                                _mfpTrigger("ParseAjax", temp),
                                    mfp.appendContent($(temp.data), "ajax"),
                                    (item.finished = !0),
                                    _removeAjaxCursor(),
                                    mfp._setFocus(),
                                    setTimeout(function () {
                                        mfp.wrap.addClass("mfp-ready");
                                    }, 16),
                                    mfp.updateStatus("ready"),
                                    _mfpTrigger("AjaxContentAdded");
                            },
                            error: function () {
                                _removeAjaxCursor(), (item.finished = item.loadError = !0), mfp.updateStatus("error", mfp.st.ajax.tError.replace("%url%", item.src));
                            },
                        },
                        mfp.st.ajax.settings
                    );
                    return (mfp.req = $.ajax(opts)), "";
                },
            },
        });
        var _imgInterval;
        $.magnificPopup.registerModule("image", {
            options: {
                markup:
                    '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                cursor: "mfp-zoom-out-cur",
                titleSrc: "title",
                verticalFit: !0,
                tError: '<a href="%url%">The image</a> could not be loaded.',
            },
            proto: {
                initImage: function () {
                    var imgSt = mfp.st.image,
                        ns = ".image";
                    mfp.types.push("image"),
                        _mfpOn("Open" + ns, function () {
                            "image" === mfp.currItem.type && imgSt.cursor && $(document.body).addClass(imgSt.cursor);
                        }),
                        _mfpOn("Close" + ns, function () {
                            imgSt.cursor && $(document.body).removeClass(imgSt.cursor), _window.off("resize.mfp");
                        }),
                        _mfpOn("Resize" + ns, mfp.resizeImage),
                        mfp.isLowIE && _mfpOn("AfterChange", mfp.resizeImage);
                },
                resizeImage: function () {
                    var item = mfp.currItem;
                    if (item && item.img && mfp.st.image.verticalFit) {
                        var decr = 0;
                        mfp.isLowIE && (decr = parseInt(item.img.css("padding-top"), 10) + parseInt(item.img.css("padding-bottom"), 10)), item.img.css("max-height", mfp.wH - decr);
                    }
                },
                _onImageHasSize: function (item) {
                    item.img &&
                        ((item.hasSize = !0),
                        _imgInterval && clearInterval(_imgInterval),
                        (item.isCheckingImgSize = !1),
                        _mfpTrigger("ImageHasSize", item),
                        item.imgHidden && (mfp.content && mfp.content.removeClass("mfp-loading"), (item.imgHidden = !1)));
                },
                findImageSize: function (item) {
                    var counter = 0,
                        img = item.img[0],
                        mfpSetInterval = function (delay) {
                            _imgInterval && clearInterval(_imgInterval),
                                (_imgInterval = setInterval(function () {
                                    0 < img.naturalWidth
                                        ? mfp._onImageHasSize(item)
                                        : (200 < counter && clearInterval(_imgInterval), 3 === ++counter ? mfpSetInterval(10) : 40 === counter ? mfpSetInterval(50) : 100 === counter && mfpSetInterval(500));
                                }, delay));
                        };
                    mfpSetInterval(1);
                },
                getImage: function (item, template) {
                    var guard = 0,
                        onLoadComplete = function () {
                            item &&
                                (item.img[0].complete
                                    ? (item.img.off(".mfploader"), item === mfp.currItem && (mfp._onImageHasSize(item), mfp.updateStatus("ready")), (item.hasSize = !0), (item.loaded = !0), _mfpTrigger("ImageLoadComplete"))
                                    : ++guard < 200
                                    ? setTimeout(onLoadComplete, 100)
                                    : onLoadError());
                        },
                        onLoadError = function () {
                            item &&
                                (item.img.off(".mfploader"),
                                item === mfp.currItem && (mfp._onImageHasSize(item), mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src))),
                                (item.hasSize = !0),
                                (item.loaded = !0),
                                (item.loadError = !0));
                        },
                        imgSt = mfp.st.image,
                        el = template.find(".mfp-img");
                    if (el.length) {
                        var img = document.createElement("img");
                        (img.className = "mfp-img"),
                            item.el && item.el.find("img").length && (img.alt = item.el.find("img").attr("alt")),
                            (item.img = $(img).on("load.mfploader", onLoadComplete).on("error.mfploader", onLoadError)),
                            (img.src = item.src),
                            el.is("img") && (item.img = item.img.clone()),
                            0 < (img = item.img[0]).naturalWidth ? (item.hasSize = !0) : img.width || (item.hasSize = !1);
                    }
                    return (
                        mfp._parseMarkup(
                            template,
                            {
                                title: (function (item) {
                                    if (item.data && void 0 !== item.data.title) return item.data.title;
                                    var src = mfp.st.image.titleSrc;
                                    if (src) {
                                        if ($.isFunction(src)) return src.call(mfp, item);
                                        if (item.el) return item.el.attr(src) || "";
                                    }
                                    return "";
                                })(item),
                                img_replaceWith: item.img,
                            },
                            item
                        ),
                        mfp.resizeImage(),
                        item.hasSize
                            ? (_imgInterval && clearInterval(_imgInterval),
                              item.loadError ? (template.addClass("mfp-loading"), mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src))) : (template.removeClass("mfp-loading"), mfp.updateStatus("ready")))
                            : (mfp.updateStatus("loading"), (item.loading = !0), item.hasSize || ((item.imgHidden = !0), template.addClass("mfp-loading"), mfp.findImageSize(item))),
                        template
                    );
                },
            },
        });
        var hasMozTransform;
        $.magnificPopup.registerModule("zoom", {
            options: {
                enabled: !1,
                easing: "ease-in-out",
                duration: 300,
                opener: function (element) {
                    return element.is("img") ? element : element.find("img");
                },
            },
            proto: {
                initZoom: function () {
                    var image,
                        zoomSt = mfp.st.zoom,
                        ns = ".zoom";
                    if (zoomSt.enabled && mfp.supportsTransition) {
                        function getElToAnimate(image) {
                            var newImg = image.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                transition = "all " + zoomSt.duration / 1e3 + "s " + zoomSt.easing,
                                cssObj = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" },
                                t = "transition";
                            return (cssObj["-webkit-" + t] = cssObj["-moz-" + t] = cssObj["-o-" + t] = cssObj[t] = transition), newImg.css(cssObj), newImg;
                        }
                        function showMainContent() {
                            mfp.content.css("visibility", "visible");
                        }
                        var openTimeout,
                            animatedImg,
                            duration = zoomSt.duration;
                        _mfpOn("BuildControls" + ns, function () {
                            if (mfp._allowZoom()) {
                                if ((clearTimeout(openTimeout), mfp.content.css("visibility", "hidden"), !(image = mfp._getItemToZoom()))) return void showMainContent();
                                (animatedImg = getElToAnimate(image)).css(mfp._getOffset()),
                                    mfp.wrap.append(animatedImg),
                                    (openTimeout = setTimeout(function () {
                                        animatedImg.css(mfp._getOffset(!0)),
                                            (openTimeout = setTimeout(function () {
                                                showMainContent(),
                                                    setTimeout(function () {
                                                        animatedImg.remove(), (image = animatedImg = null), _mfpTrigger("ZoomAnimationEnded");
                                                    }, 16);
                                            }, duration));
                                    }, 16));
                            }
                        }),
                            _mfpOn("BeforeClose" + ns, function () {
                                if (mfp._allowZoom()) {
                                    if ((clearTimeout(openTimeout), (mfp.st.removalDelay = duration), !image)) {
                                        if (!(image = mfp._getItemToZoom())) return;
                                        animatedImg = getElToAnimate(image);
                                    }
                                    animatedImg.css(mfp._getOffset(!0)),
                                        mfp.wrap.append(animatedImg),
                                        mfp.content.css("visibility", "hidden"),
                                        setTimeout(function () {
                                            animatedImg.css(mfp._getOffset());
                                        }, 16);
                                }
                            }),
                            _mfpOn("Close" + ns, function () {
                                mfp._allowZoom() && (showMainContent(), animatedImg && animatedImg.remove(), (image = null));
                            });
                    }
                },
                _allowZoom: function () {
                    return "image" === mfp.currItem.type;
                },
                _getItemToZoom: function () {
                    return !!mfp.currItem.hasSize && mfp.currItem.img;
                },
                _getOffset: function (isLarge) {
                    var el,
                        offset = (el = isLarge ? mfp.currItem.img : mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem)).offset(),
                        paddingTop = parseInt(el.css("padding-top"), 10),
                        paddingBottom = parseInt(el.css("padding-bottom"), 10);
                    offset.top -= $(window).scrollTop() - paddingTop;
                    var obj = { width: el.width(), height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop };
                    return (
                        void 0 === hasMozTransform && (hasMozTransform = void 0 !== document.createElement("p").style.MozTransform),
                        hasMozTransform ? (obj["-moz-transform"] = obj.transform = "translate(" + offset.left + "px," + offset.top + "px)") : ((obj.left = offset.left), (obj.top = offset.top)),
                        obj
                    );
                },
            },
        });
        function _fixIframeBugs(isShowing) {
            if (mfp.currTemplate.iframe) {
                var el = mfp.currTemplate.iframe.find("iframe");
                el.length && (isShowing || (el[0].src = "//about:blank"), mfp.isIE8 && el.css("display", isShowing ? "block" : "none"));
            }
        }
        $.magnificPopup.registerModule("iframe", {
            options: {
                markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                srcAction: "iframe_src",
                patterns: {
                    youtube: { index: "youtube.com/embed", id: "/", src: "//www.youtube.com/embed/%id%?autoplay=1" },
                    youtu_be: { index: "youtu.be", id: "/", src: "//www.youtube.com/embed/%id%?autoplay=1" },
                    youtu_watch: { index: "youtube.com/watch", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" },
                    vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" },
                    gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
                },
            },
            proto: {
                initIframe: function () {
                    mfp.types.push("iframe"),
                        _mfpOn("BeforeChange", function (e, prevType, newType) {
                            prevType !== newType && ("iframe" === prevType ? _fixIframeBugs() : "iframe" === newType && _fixIframeBugs(!0));
                        }),
                        _mfpOn("Close.iframe", function () {
                            _fixIframeBugs();
                        });
                },
                getIframe: function (item, template) {
                    var embedSrc = item.src,
                        iframeSt = mfp.st.iframe;
                    $.each(iframeSt.patterns, function () {
                        if (-1 < embedSrc.indexOf(this.index))
                            return (
                                this.id && (embedSrc = "string" == typeof this.id ? embedSrc.substr(embedSrc.lastIndexOf(this.id) + this.id.length, embedSrc.length) : this.id.call(this, embedSrc)),
                                (embedSrc = this.src.replace("%id%", embedSrc)),
                                !1
                            );
                    });
                    var dataObj = {};
                    return iframeSt.srcAction && (dataObj[iframeSt.srcAction] = embedSrc), mfp._parseMarkup(template, dataObj, item), mfp.updateStatus("ready"), template;
                },
            },
        });
        function _getLoopedId(index) {
            var numSlides = mfp.items.length;
            return numSlides - 1 < index ? index - numSlides : index < 0 ? numSlides + index : index;
        }
        function _replaceCurrTotal(text, curr, total) {
            return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
        }
        $.magnificPopup.registerModule("gallery", {
            options: {
                enabled: !1,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                preload: [0, 2],
                navigateByImgClick: !0,
                arrows: !0,
                tPrev: "Previous (Left arrow key)",
                tNext: "Next (Right arrow key)",
                tCounter: "%curr% of %total%",
            },
            proto: {
                initGallery: function () {
                    var gSt = mfp.st.gallery,
                        ns = ".mfp-gallery";
                    if (((mfp.direction = !0), !gSt || !gSt.enabled)) return !1;
                    (_wrapClasses += " mfp-gallery"),
                        _mfpOn("Open" + ns, function () {
                            gSt.navigateByImgClick &&
                                mfp.wrap.on("click" + ns, ".mfp-img", function () {
                                    if (1 < mfp.items.length) return mfp.next(), !1;
                                }),
                                _document.on("keydown" + ns, function (e) {
                                    37 === e.keyCode ? mfp.prev() : 39 === e.keyCode && mfp.next();
                                });
                        }),
                        _mfpOn("UpdateStatus" + ns, function (e, data) {
                            data.text && (data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length));
                        }),
                        _mfpOn("MarkupParse" + ns, function (e, element, values, item) {
                            var l = mfp.items.length;
                            values.counter = 1 < l ? _replaceCurrTotal(gSt.tCounter, item.index, l) : "";
                        }),
                        _mfpOn("BuildControls" + ns, function () {
                            if (1 < mfp.items.length && gSt.arrows && !mfp.arrowLeft) {
                                var markup = gSt.arrowMarkup,
                                    arrowLeft = (mfp.arrowLeft = $(markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, "left")).addClass("mfp-prevent-close")),
                                    arrowRight = (mfp.arrowRight = $(markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, "right")).addClass("mfp-prevent-close"));
                                arrowLeft.click(function () {
                                    mfp.prev();
                                }),
                                    arrowRight.click(function () {
                                        mfp.next();
                                    }),
                                    mfp.container.append(arrowLeft.add(arrowRight));
                            }
                        }),
                        _mfpOn("Change" + ns, function () {
                            mfp._preloadTimeout && clearTimeout(mfp._preloadTimeout),
                                (mfp._preloadTimeout = setTimeout(function () {
                                    mfp.preloadNearbyImages(), (mfp._preloadTimeout = null);
                                }, 16));
                        }),
                        _mfpOn("Close" + ns, function () {
                            _document.off(ns), mfp.wrap.off("click" + ns), (mfp.arrowRight = mfp.arrowLeft = null);
                        });
                },
                next: function () {
                    (mfp.direction = !0), (mfp.index = _getLoopedId(mfp.index + 1)), mfp.updateItemHTML();
                },
                prev: function () {
                    (mfp.direction = !1), (mfp.index = _getLoopedId(mfp.index - 1)), mfp.updateItemHTML();
                },
                goTo: function (newIndex) {
                    (mfp.direction = newIndex >= mfp.index), (mfp.index = newIndex), mfp.updateItemHTML();
                },
                preloadNearbyImages: function () {
                    var i,
                        p = mfp.st.gallery.preload,
                        preloadBefore = Math.min(p[0], mfp.items.length),
                        preloadAfter = Math.min(p[1], mfp.items.length);
                    for (i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) mfp._preloadItem(mfp.index + i);
                    for (i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) mfp._preloadItem(mfp.index - i);
                },
                _preloadItem: function (index) {
                    if (((index = _getLoopedId(index)), !mfp.items[index].preloaded)) {
                        var item = mfp.items[index];
                        item.parsed || (item = mfp.parseEl(index)),
                            _mfpTrigger("LazyLoad", item),
                            "image" === item.type &&
                                (item.img = $('<img class="mfp-img" />')
                                    .on("load.mfploader", function () {
                                        item.hasSize = !0;
                                    })
                                    .on("error.mfploader", function () {
                                        (item.hasSize = !0), (item.loadError = !0), _mfpTrigger("LazyLoadError", item);
                                    })
                                    .attr("src", item.src)),
                            (item.preloaded = !0);
                    }
                },
            },
        });
        $.magnificPopup.registerModule("retina", {
            options: {
                replaceSrc: function (item) {
                    return item.src.replace(/\.\w+$/, function (m) {
                        return "@2x" + m;
                    });
                },
                ratio: 1,
            },
            proto: {
                initRetina: function () {
                    if (1 < window.devicePixelRatio) {
                        var st = mfp.st.retina,
                            ratio = st.ratio;
                        1 < (ratio = isNaN(ratio) ? ratio() : ratio) &&
                            (_mfpOn("ImageHasSize.retina", function (e, item) {
                                item.img.css({ "max-width": item.img[0].naturalWidth / ratio, width: "100%" });
                            }),
                            _mfpOn("ElementParse.retina", function (e, item) {
                                item.src = st.replaceSrc(item, ratio);
                            }));
                    }
                },
            },
        }),
            _checkInstance();
    }),
    (function ($, window, document) {
        function Owl(element, options) {
            (this.settings = null),
                (this.options = $.extend({}, Owl.Defaults, options)),
                (this.$element = $(element)),
                (this._handlers = {}),
                (this._plugins = {}),
                (this._supress = {}),
                (this._current = null),
                (this._speed = null),
                (this._coordinates = []),
                (this._breakpoint = null),
                (this._width = null),
                (this._items = []),
                (this._clones = []),
                (this._mergers = []),
                (this._widths = []),
                (this._invalidated = {}),
                (this._pipe = []),
                (this._drag = { time: null, target: null, pointer: null, stage: { start: null, current: null }, direction: null }),
                (this._states = { current: {}, tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] } }),
                $.each(
                    ["onResize", "onThrottledResize"],
                    $.proxy(function (i, handler) {
                        this._handlers[handler] = $.proxy(this[handler], this);
                    }, this)
                ),
                $.each(
                    Owl.Plugins,
                    $.proxy(function (key, plugin) {
                        this._plugins[key.charAt(0).toLowerCase() + key.slice(1)] = new plugin(this);
                    }, this)
                ),
                $.each(
                    Owl.Workers,
                    $.proxy(function (priority, worker) {
                        this._pipe.push({ filter: worker.filter, run: $.proxy(worker.run, this) });
                    }, this)
                ),
                this.setup(),
                this.initialize();
        }
        (Owl.Defaults = {
            items: 3,
            loop: !1,
            center: !1,
            rewind: !1,
            checkVisibility: !0,
            mouseDrag: !0,
            touchDrag: !0,
            pullDrag: !0,
            freeDrag: !1,
            margin: 0,
            stagePadding: 0,
            merge: !1,
            mergeFit: !0,
            autoWidth: !1,
            startPosition: 0,
            rtl: !1,
            smartSpeed: 250,
            fluidSpeed: !1,
            dragEndSpeed: !1,
            responsive: {},
            responsiveRefreshRate: 200,
            responsiveBaseElement: window,
            fallbackEasing: "swing",
            info: !1,
            nestedItemSelector: !1,
            itemElement: "div",
            stageElement: "div",
            refreshClass: "owl-refresh",
            loadedClass: "owl-loaded",
            loadingClass: "owl-loading",
            rtlClass: "owl-rtl",
            responsiveClass: "owl-responsive",
            dragClass: "owl-drag",
            itemClass: "owl-item",
            stageClass: "owl-stage",
            stageOuterClass: "owl-stage-outer",
            grabClass: "owl-grab",
        }),
            (Owl.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
            (Owl.Type = { Event: "event", State: "state" }),
            (Owl.Plugins = {}),
            (Owl.Workers = [
                {
                    filter: ["width", "settings"],
                    run: function () {
                        this._width = this.$element.width();
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (cache) {
                        cache.current = this._items && this._items[this.relative(this._current)];
                    },
                },
                {
                    filter: ["items", "settings"],
                    run: function () {
                        this.$stage.children(".cloned").remove();
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (cache) {
                        var margin = this.settings.margin || "",
                            grid = !this.settings.autoWidth,
                            rtl = this.settings.rtl,
                            css = { width: "auto", "margin-left": rtl ? margin : "", "margin-right": rtl ? "" : margin };
                        grid || this.$stage.children().css(css), (cache.css = css);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (cache) {
                        var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                            merge = null,
                            iterator = this._items.length,
                            grid = !this.settings.autoWidth,
                            widths = [];
                        for (cache.items = { merge: !1, width: width }; iterator--; )
                            (merge = this._mergers[iterator]),
                                (merge = (this.settings.mergeFit && Math.min(merge, this.settings.items)) || merge),
                                (cache.items.merge = 1 < merge || cache.items.merge),
                                (widths[iterator] = grid ? width * merge : this._items[iterator].width());
                        this._widths = widths;
                    },
                },
                {
                    filter: ["items", "settings"],
                    run: function () {
                        var clones = [],
                            items = this._items,
                            settings = this.settings,
                            view = Math.max(2 * settings.items, 4),
                            size = 2 * Math.ceil(items.length / 2),
                            repeat = settings.loop && items.length ? (settings.rewind ? view : Math.max(view, size)) : 0,
                            append = "",
                            prepend = "";
                        for (repeat /= 2; 0 < repeat; )
                            clones.push(this.normalize(clones.length / 2, !0)),
                                (append += items[clones[clones.length - 1]][0].outerHTML),
                                clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, !0)),
                                (prepend = items[clones[clones.length - 1]][0].outerHTML + prepend),
                                (repeat -= 1);
                        (this._clones = clones), $(append).addClass("cloned").appendTo(this.$stage), $(prepend).addClass("cloned").prependTo(this.$stage);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function () {
                        for (var rtl = this.settings.rtl ? 1 : -1, size = this._clones.length + this._items.length, iterator = -1, previous = 0, current = 0, coordinates = []; ++iterator < size; )
                            (previous = coordinates[iterator - 1] || 0), (current = this._widths[this.relative(iterator)] + this.settings.margin), coordinates.push(previous + current * rtl);
                        this._coordinates = coordinates;
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function () {
                        var padding = this.settings.stagePadding,
                            coordinates = this._coordinates,
                            css = { width: Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + 2 * padding, "padding-left": padding || "", "padding-right": padding || "" };
                        this.$stage.css(css);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (cache) {
                        var iterator = this._coordinates.length,
                            grid = !this.settings.autoWidth,
                            items = this.$stage.children();
                        if (grid && cache.items.merge) for (; iterator--; ) (cache.css.width = this._widths[this.relative(iterator)]), items.eq(iterator).css(cache.css);
                        else grid && ((cache.css.width = cache.items.width), items.css(cache.css));
                    },
                },
                {
                    filter: ["items"],
                    run: function () {
                        this._coordinates.length < 1 && this.$stage.removeAttr("style");
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function (cache) {
                        (cache.current = cache.current ? this.$stage.children().index(cache.current) : 0), (cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current))), this.reset(cache.current);
                    },
                },
                {
                    filter: ["position"],
                    run: function () {
                        this.animate(this.coordinates(this._current));
                    },
                },
                {
                    filter: ["width", "position", "items", "settings"],
                    run: function () {
                        var inner,
                            outer,
                            i,
                            n,
                            rtl = this.settings.rtl ? 1 : -1,
                            padding = 2 * this.settings.stagePadding,
                            begin = this.coordinates(this.current()) + padding,
                            end = begin + this.width() * rtl,
                            matches = [];
                        for (i = 0, n = this._coordinates.length; i < n; i++)
                            (inner = this._coordinates[i - 1] || 0),
                                (outer = Math.abs(this._coordinates[i]) + padding * rtl),
                                ((this.op(inner, "<=", begin) && this.op(inner, ">", end)) || (this.op(outer, "<", begin) && this.op(outer, ">", end))) && matches.push(i);
                        this.$stage.children(".active").removeClass("active"),
                            this.$stage.children(":eq(" + matches.join("), :eq(") + ")").addClass("active"),
                            this.$stage.children(".center").removeClass("center"),
                            this.settings.center && this.$stage.children().eq(this.current()).addClass("center");
                    },
                },
            ]),
            (Owl.prototype.initializeStage = function () {
                (this.$stage = this.$element.find("." + this.settings.stageClass)),
                    this.$stage.length ||
                        (this.$element.addClass(this.options.loadingClass),
                        (this.$stage = $("<" + this.settings.stageElement + ' class="' + this.settings.stageClass + '"/>').wrap('<div class="' + this.settings.stageOuterClass + '"/>')),
                        this.$element.append(this.$stage.parent()));
            }),
            (Owl.prototype.initializeItems = function () {
                var $items = this.$element.find(".owl-item");
                if ($items.length)
                    return (
                        (this._items = $items.get().map(function (item) {
                            return $(item);
                        })),
                        (this._mergers = this._items.map(function () {
                            return 1;
                        })),
                        void this.refresh()
                    );
                this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
            }),
            (Owl.prototype.initialize = function () {
                var imgs, nestedSelector, width;
                this.enter("initializing"),
                    this.trigger("initialize"),
                    this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
                    this.settings.autoWidth &&
                        !this.is("pre-loading") &&
                        ((imgs = this.$element.find("img")),
                        (nestedSelector = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : void 0),
                        (width = this.$element.children(nestedSelector).width()),
                        imgs.length && width <= 0 && this.preloadAutoWidthImages(imgs));
                this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized");
            }),
            (Owl.prototype.isVisible = function () {
                return !this.settings.checkVisibility || this.$element.is(":visible");
            }),
            (Owl.prototype.setup = function () {
                var viewport = this.viewport(),
                    overwrites = this.options.responsive,
                    match = -1,
                    settings = null;
                overwrites
                    ? ($.each(overwrites, function (breakpoint) {
                          breakpoint <= viewport && match < breakpoint && (match = Number(breakpoint));
                      }),
                      "function" == typeof (settings = $.extend({}, this.options, overwrites[match])).stagePadding && (settings.stagePadding = settings.stagePadding()),
                      delete settings.responsive,
                      settings.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + match)))
                    : (settings = $.extend({}, this.options)),
                    this.trigger("change", { property: { name: "settings", value: settings } }),
                    (this._breakpoint = match),
                    (this.settings = settings),
                    this.invalidate("settings"),
                    this.trigger("changed", { property: { name: "settings", value: this.settings } });
            }),
            (Owl.prototype.optionsLogic = function () {
                this.settings.autoWidth && ((this.settings.stagePadding = !1), (this.settings.merge = !1));
            }),
            (Owl.prototype.prepare = function (item) {
                var event = this.trigger("prepare", { content: item });
                return (
                    event.data ||
                        (event.data = $("<" + this.settings.itemElement + "/>")
                            .addClass(this.options.itemClass)
                            .append(item)),
                    this.trigger("prepared", { content: event.data }),
                    event.data
                );
            }),
            (Owl.prototype.update = function () {
                for (
                    var i = 0,
                        n = this._pipe.length,
                        filter = $.proxy(function (p) {
                            return this[p];
                        }, this._invalidated),
                        cache = {};
                    i < n;

                )
                    (this._invalidated.all || 0 < $.grep(this._pipe[i].filter, filter).length) && this._pipe[i].run(cache), i++;
                (this._invalidated = {}), this.is("valid") || this.enter("valid");
            }),
            (Owl.prototype.width = function (dimension) {
                switch ((dimension = dimension || Owl.Width.Default)) {
                    case Owl.Width.Inner:
                    case Owl.Width.Outer:
                        return this._width;
                    default:
                        return this._width - 2 * this.settings.stagePadding + this.settings.margin;
                }
            }),
            (Owl.prototype.refresh = function () {
                this.enter("refreshing"),
                    this.trigger("refresh"),
                    this.setup(),
                    this.optionsLogic(),
                    this.$element.addClass(this.options.refreshClass),
                    this.update(),
                    this.$element.removeClass(this.options.refreshClass),
                    this.leave("refreshing"),
                    this.trigger("refreshed");
            }),
            (Owl.prototype.onThrottledResize = function () {
                window.clearTimeout(this.resizeTimer), (this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate));
            }),
            (Owl.prototype.onResize = function () {
                return (
                    !!this._items.length &&
                    this._width !== this.$element.width() &&
                    !!this.isVisible() &&
                    (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))
                );
            }),
            (Owl.prototype.registerEventHandlers = function () {
                $.support.transition && this.$stage.on($.support.transition.end + ".owl.core", $.proxy(this.onTransitionEnd, this)),
                    !1 !== this.settings.responsive && this.on(window, "resize", this._handlers.onThrottledResize),
                    this.settings.mouseDrag &&
                        (this.$element.addClass(this.options.dragClass),
                        this.$stage.on("mousedown.owl.core", $.proxy(this.onDragStart, this)),
                        this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
                            return !1;
                        })),
                    this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", $.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", $.proxy(this.onDragEnd, this)));
            }),
            (Owl.prototype.onDragStart = function (event) {
                var stage = null;
                3 !== event.which &&
                    ((stage = $.support.transform
                        ? {
                              x: (stage = this.$stage
                                  .css("transform")
                                  .replace(/.*\(|\)| /g, "")
                                  .split(","))[16 === stage.length ? 12 : 4],
                              y: stage[16 === stage.length ? 13 : 5],
                          }
                        : ((stage = this.$stage.position()), { x: this.settings.rtl ? stage.left + this.$stage.width() - this.width() + this.settings.margin : stage.left, y: stage.top })),
                    this.is("animating") && ($.support.transform ? this.animate(stage.x) : this.$stage.stop(), this.invalidate("position")),
                    this.$element.toggleClass(this.options.grabClass, "mousedown" === event.type),
                    this.speed(0),
                    (this._drag.time = new Date().getTime()),
                    (this._drag.target = $(event.target)),
                    (this._drag.stage.start = stage),
                    (this._drag.stage.current = stage),
                    (this._drag.pointer = this.pointer(event)),
                    $(document).on("mouseup.owl.core touchend.owl.core", $.proxy(this.onDragEnd, this)),
                    $(document).one(
                        "mousemove.owl.core touchmove.owl.core",
                        $.proxy(function (event) {
                            var delta = this.difference(this._drag.pointer, this.pointer(event));
                            $(document).on("mousemove.owl.core touchmove.owl.core", $.proxy(this.onDragMove, this)),
                                (Math.abs(delta.x) < Math.abs(delta.y) && this.is("valid")) || (event.preventDefault(), this.enter("dragging"), this.trigger("drag"));
                        }, this)
                    ));
            }),
            (Owl.prototype.onDragMove = function (event) {
                var minimum = null,
                    maximum = null,
                    pull = null,
                    delta = this.difference(this._drag.pointer, this.pointer(event)),
                    stage = this.difference(this._drag.stage.start, delta);
                this.is("dragging") &&
                    (event.preventDefault(),
                    this.settings.loop
                        ? ((minimum = this.coordinates(this.minimum())), (maximum = this.coordinates(this.maximum() + 1) - minimum), (stage.x = ((((stage.x - minimum) % maximum) + maximum) % maximum) + minimum))
                        : ((minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum())),
                          (maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum())),
                          (pull = this.settings.pullDrag ? (-1 * delta.x) / 5 : 0),
                          (stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull))),
                    (this._drag.stage.current = stage),
                    this.animate(stage.x));
            }),
            (Owl.prototype.onDragEnd = function (event) {
                var delta = this.difference(this._drag.pointer, this.pointer(event)),
                    stage = this._drag.stage.current,
                    direction = (0 < delta.x) ^ this.settings.rtl ? "left" : "right";
                $(document).off(".owl.core"),
                    this.$element.removeClass(this.options.grabClass),
                    ((0 !== delta.x && this.is("dragging")) || !this.is("valid")) &&
                        (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
                        this.current(this.closest(stage.x, 0 !== delta.x ? direction : this._drag.direction)),
                        this.invalidate("position"),
                        this.update(),
                        (this._drag.direction = direction),
                        (3 < Math.abs(delta.x) || 300 < new Date().getTime() - this._drag.time) &&
                            this._drag.target.one("click.owl.core", function () {
                                return !1;
                            })),
                    this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
            }),
            (Owl.prototype.closest = function (coordinate, direction) {
                var position = -1,
                    width = this.width(),
                    coordinates = this.coordinates();
                return (
                    this.settings.freeDrag ||
                        $.each(
                            coordinates,
                            $.proxy(function (index, value) {
                                return (
                                    "left" === direction && value - 30 < coordinate && coordinate < value + 30
                                        ? (position = index)
                                        : "right" === direction && value - width - 30 < coordinate && coordinate < value - width + 30
                                        ? (position = index + 1)
                                        : this.op(coordinate, "<", value) && this.op(coordinate, ">", void 0 !== coordinates[index + 1] ? coordinates[index + 1] : value - width) && (position = "left" === direction ? index + 1 : index),
                                    -1 === position
                                );
                            }, this)
                        ),
                    this.settings.loop ||
                        (this.op(coordinate, ">", coordinates[this.minimum()]) ? (position = coordinate = this.minimum()) : this.op(coordinate, "<", coordinates[this.maximum()]) && (position = coordinate = this.maximum())),
                    position
                );
            }),
            (Owl.prototype.animate = function (coordinate) {
                var animate = 0 < this.speed();
                this.is("animating") && this.onTransitionEnd(),
                    animate && (this.enter("animating"), this.trigger("translate")),
                    $.support.transform3d && $.support.transition
                        ? this.$stage.css({ transform: "translate3d(" + coordinate + "px,0px,0px)", transition: this.speed() / 1e3 + "s" })
                        : animate
                        ? this.$stage.animate({ left: coordinate + "px" }, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this))
                        : this.$stage.css({ left: coordinate + "px" });
            }),
            (Owl.prototype.is = function (state) {
                return this._states.current[state] && 0 < this._states.current[state];
            }),
            (Owl.prototype.current = function (position) {
                if (void 0 === position) return this._current;
                if (0 !== this._items.length) {
                    if (((position = this.normalize(position)), this._current !== position)) {
                        var event = this.trigger("change", { property: { name: "position", value: position } });
                        void 0 !== event.data && (position = this.normalize(event.data)), (this._current = position), this.invalidate("position"), this.trigger("changed", { property: { name: "position", value: this._current } });
                    }
                    return this._current;
                }
            }),
            (Owl.prototype.invalidate = function (part) {
                return (
                    "string" === $.type(part) && ((this._invalidated[part] = !0), this.is("valid") && this.leave("valid")),
                    $.map(this._invalidated, function (v, i) {
                        return i;
                    })
                );
            }),
            (Owl.prototype.reset = function (position) {
                void 0 !== (position = this.normalize(position)) &&
                    ((this._speed = 0), (this._current = position), this.suppress(["translate", "translated"]), this.animate(this.coordinates(position)), this.release(["translate", "translated"]));
            }),
            (Owl.prototype.normalize = function (position, relative) {
                var n = this._items.length,
                    m = relative ? 0 : this._clones.length;
                return !this.isNumeric(position) || n < 1 ? (position = void 0) : (position < 0 || n + m <= position) && (position = ((((position - m / 2) % n) + n) % n) + m / 2), position;
            }),
            (Owl.prototype.relative = function (position) {
                return (position -= this._clones.length / 2), this.normalize(position, !0);
            }),
            (Owl.prototype.maximum = function (relative) {
                var iterator,
                    reciprocalItemsWidth,
                    elementWidth,
                    settings = this.settings,
                    maximum = this._coordinates.length;
                if (settings.loop) maximum = this._clones.length / 2 + this._items.length - 1;
                else if (settings.autoWidth || settings.merge) {
                    if ((iterator = this._items.length))
                        for (reciprocalItemsWidth = this._items[--iterator].width(), elementWidth = this.$element.width(); iterator-- && !(elementWidth < (reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin)); );
                    maximum = iterator + 1;
                } else maximum = settings.center ? this._items.length - 1 : this._items.length - settings.items;
                return relative && (maximum -= this._clones.length / 2), Math.max(maximum, 0);
            }),
            (Owl.prototype.minimum = function (relative) {
                return relative ? 0 : this._clones.length / 2;
            }),
            (Owl.prototype.items = function (position) {
                return void 0 === position ? this._items.slice() : ((position = this.normalize(position, !0)), this._items[position]);
            }),
            (Owl.prototype.mergers = function (position) {
                return void 0 === position ? this._mergers.slice() : ((position = this.normalize(position, !0)), this._mergers[position]);
            }),
            (Owl.prototype.clones = function (position) {
                function map(index) {
                    return index % 2 == 0 ? even + index / 2 : odd - (index + 1) / 2;
                }
                var odd = this._clones.length / 2,
                    even = odd + this._items.length;
                return void 0 === position
                    ? $.map(this._clones, function (v, i) {
                          return map(i);
                      })
                    : $.map(this._clones, function (v, i) {
                          return v === position ? map(i) : null;
                      });
            }),
            (Owl.prototype.speed = function (speed) {
                return void 0 !== speed && (this._speed = speed), this._speed;
            }),
            (Owl.prototype.coordinates = function (position) {
                var coordinate,
                    multiplier = 1,
                    newPosition = position - 1;
                return void 0 === position
                    ? $.map(
                          this._coordinates,
                          $.proxy(function (coordinate, index) {
                              return this.coordinates(index);
                          }, this)
                      )
                    : (this.settings.center
                          ? (this.settings.rtl && ((multiplier = -1), (newPosition = position + 1)),
                            (coordinate = this._coordinates[position]),
                            (coordinate += ((this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2) * multiplier))
                          : (coordinate = this._coordinates[newPosition] || 0),
                      (coordinate = Math.ceil(coordinate)));
            }),
            (Owl.prototype.duration = function (from, to, factor) {
                return 0 === factor ? 0 : Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs(factor || this.settings.smartSpeed);
            }),
            (Owl.prototype.to = function (position, speed) {
                var current = this.current(),
                    revert = null,
                    distance = position - this.relative(current),
                    direction = (0 < distance) - (distance < 0),
                    items = this._items.length,
                    minimum = this.minimum(),
                    maximum = this.maximum();
                this.settings.loop
                    ? (!this.settings.rewind && Math.abs(distance) > items / 2 && (distance += -1 * direction * items),
                      (revert = (((((position = current + distance) - minimum) % items) + items) % items) + minimum) !== position &&
                          revert - distance <= maximum &&
                          0 < revert - distance &&
                          ((current = revert - distance), (position = revert), this.reset(current)))
                    : (position = this.settings.rewind ? ((position % (maximum += 1)) + maximum) % maximum : Math.max(minimum, Math.min(maximum, position))),
                    this.speed(this.duration(current, position, speed)),
                    this.current(position),
                    this.isVisible() && this.update();
            }),
            (Owl.prototype.next = function (speed) {
                (speed = speed || !1), this.to(this.relative(this.current()) + 1, speed);
            }),
            (Owl.prototype.prev = function (speed) {
                (speed = speed || !1), this.to(this.relative(this.current()) - 1, speed);
            }),
            (Owl.prototype.onTransitionEnd = function (event) {
                if (void 0 !== event && (event.stopPropagation(), (event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0))) return !1;
                this.leave("animating"), this.trigger("translated");
            }),
            (Owl.prototype.viewport = function () {
                var width;
                return (
                    this.options.responsiveBaseElement !== window
                        ? (width = $(this.options.responsiveBaseElement).width())
                        : window.innerWidth
                        ? (width = window.innerWidth)
                        : document.documentElement && document.documentElement.clientWidth
                        ? (width = document.documentElement.clientWidth)
                        : console.warn("Can not detect viewport width."),
                    width
                );
            }),
            (Owl.prototype.replace = function (content) {
                this.$stage.empty(),
                    (this._items = []),
                    (content = content && (content instanceof jQuery ? content : $(content))),
                    this.settings.nestedItemSelector && (content = content.find("." + this.settings.nestedItemSelector)),
                    content
                        .filter(function () {
                            return 1 === this.nodeType;
                        })
                        .each(
                            $.proxy(function (index, item) {
                                (item = this.prepare(item)), this.$stage.append(item), this._items.push(item), this._mergers.push(1 * item.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
                            }, this)
                        ),
                    this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
                    this.invalidate("items");
            }),
            (Owl.prototype.add = function (content, position) {
                var current = this.relative(this._current);
                (position = void 0 === position ? this._items.length : this.normalize(position, !0)),
                    (content = content instanceof jQuery ? content : $(content)),
                    this.trigger("add", { content: content, position: position }),
                    (content = this.prepare(content)),
                    0 === this._items.length || position === this._items.length
                        ? (0 === this._items.length && this.$stage.append(content),
                          0 !== this._items.length && this._items[position - 1].after(content),
                          this._items.push(content),
                          this._mergers.push(1 * content.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1))
                        : (this._items[position].before(content), this._items.splice(position, 0, content), this._mergers.splice(position, 0, 1 * content.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)),
                    this._items[current] && this.reset(this._items[current].index()),
                    this.invalidate("items"),
                    this.trigger("added", { content: content, position: position });
            }),
            (Owl.prototype.remove = function (position) {
                void 0 !== (position = this.normalize(position, !0)) &&
                    (this.trigger("remove", { content: this._items[position], position: position }),
                    this._items[position].remove(),
                    this._items.splice(position, 1),
                    this._mergers.splice(position, 1),
                    this.invalidate("items"),
                    this.trigger("removed", { content: null, position: position }));
            }),
            (Owl.prototype.preloadAutoWidthImages = function (images) {
                images.each(
                    $.proxy(function (i, element) {
                        this.enter("pre-loading"),
                            (element = $(element)),
                            $(new Image())
                                .one(
                                    "load",
                                    $.proxy(function (e) {
                                        element.attr("src", e.target.src), element.css("opacity", 1), this.leave("pre-loading"), this.is("pre-loading") || this.is("initializing") || this.refresh();
                                    }, this)
                                )
                                .attr("src", element.attr("src") || element.attr("data-src") || element.attr("data-src-retina"));
                    }, this)
                );
            }),
            (Owl.prototype.destroy = function () {
                for (var i in (this.$element.off(".owl.core"),
                this.$stage.off(".owl.core"),
                $(document).off(".owl.core"),
                !1 !== this.settings.responsive && (window.clearTimeout(this.resizeTimer), this.off(window, "resize", this._handlers.onThrottledResize)),
                this._plugins))
                    this._plugins[i].destroy();
                this.$stage.children(".cloned").remove(),
                    this.$stage.unwrap(),
                    this.$stage.children().contents().unwrap(),
                    this.$stage.children().unwrap(),
                    this.$stage.remove(),
                    this.$element
                        .removeClass(this.options.refreshClass)
                        .removeClass(this.options.loadingClass)
                        .removeClass(this.options.loadedClass)
                        .removeClass(this.options.rtlClass)
                        .removeClass(this.options.dragClass)
                        .removeClass(this.options.grabClass)
                        .attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), ""))
                        .removeData("owl.carousel");
            }),
            (Owl.prototype.op = function (a, o, b) {
                var rtl = this.settings.rtl;
                switch (o) {
                    case "<":
                        return rtl ? b < a : a < b;
                    case ">":
                        return rtl ? a < b : b < a;
                    case ">=":
                        return rtl ? a <= b : b <= a;
                    case "<=":
                        return rtl ? b <= a : a <= b;
                }
            }),
            (Owl.prototype.on = function (element, event, listener, capture) {
                element.addEventListener ? element.addEventListener(event, listener, capture) : element.attachEvent && element.attachEvent("on" + event, listener);
            }),
            (Owl.prototype.off = function (element, event, listener, capture) {
                element.removeEventListener ? element.removeEventListener(event, listener, capture) : element.detachEvent && element.detachEvent("on" + event, listener);
            }),
            (Owl.prototype.trigger = function (name, data, namespace, state, enter) {
                var status = { item: { count: this._items.length, index: this.current() } },
                    handler = $.camelCase(
                        $.grep(["on", name, namespace], function (v) {
                            return v;
                        })
                            .join("-")
                            .toLowerCase()
                    ),
                    event = $.Event([name, "owl", namespace || "carousel"].join(".").toLowerCase(), $.extend({ relatedTarget: this }, status, data));
                return (
                    this._supress[name] ||
                        ($.each(this._plugins, function (name, plugin) {
                            plugin.onTrigger && plugin.onTrigger(event);
                        }),
                        this.register({ type: Owl.Type.Event, name: name }),
                        this.$element.trigger(event),
                        this.settings && "function" == typeof this.settings[handler] && this.settings[handler].call(this, event)),
                    event
                );
            }),
            (Owl.prototype.enter = function (name) {
                $.each(
                    [name].concat(this._states.tags[name] || []),
                    $.proxy(function (i, name) {
                        void 0 === this._states.current[name] && (this._states.current[name] = 0), this._states.current[name]++;
                    }, this)
                );
            }),
            (Owl.prototype.leave = function (name) {
                $.each(
                    [name].concat(this._states.tags[name] || []),
                    $.proxy(function (i, name) {
                        this._states.current[name]--;
                    }, this)
                );
            }),
            (Owl.prototype.register = function (object) {
                if (object.type === Owl.Type.Event) {
                    if (($.event.special[object.name] || ($.event.special[object.name] = {}), !$.event.special[object.name].owl)) {
                        var _default = $.event.special[object.name]._default;
                        ($.event.special[object.name]._default = function (e) {
                            return !_default || !_default.apply || (e.namespace && -1 !== e.namespace.indexOf("owl")) ? e.namespace && -1 < e.namespace.indexOf("owl") : _default.apply(this, arguments);
                        }),
                            ($.event.special[object.name].owl = !0);
                    }
                } else
                    object.type === Owl.Type.State &&
                        (this._states.tags[object.name] ? (this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags)) : (this._states.tags[object.name] = object.tags),
                        (this._states.tags[object.name] = $.grep(
                            this._states.tags[object.name],
                            $.proxy(function (tag, i) {
                                return $.inArray(tag, this._states.tags[object.name]) === i;
                            }, this)
                        )));
            }),
            (Owl.prototype.suppress = function (events) {
                $.each(
                    events,
                    $.proxy(function (index, event) {
                        this._supress[event] = !0;
                    }, this)
                );
            }),
            (Owl.prototype.release = function (events) {
                $.each(
                    events,
                    $.proxy(function (index, event) {
                        delete this._supress[event];
                    }, this)
                );
            }),
            (Owl.prototype.pointer = function (event) {
                var result = { x: null, y: null };
                return (
                    (event = (event = event.originalEvent || event || window.event).touches && event.touches.length ? event.touches[0] : event.changedTouches && event.changedTouches.length ? event.changedTouches[0] : event).pageX
                        ? ((result.x = event.pageX), (result.y = event.pageY))
                        : ((result.x = event.clientX), (result.y = event.clientY)),
                    result
                );
            }),
            (Owl.prototype.isNumeric = function (number) {
                return !isNaN(parseFloat(number));
            }),
            (Owl.prototype.difference = function (first, second) {
                return { x: first.x - second.x, y: first.y - second.y };
            }),
            ($.fn.owlCarousel = function (option) {
                var args = Array.prototype.slice.call(arguments, 1);
                return this.each(function () {
                    var $this = $(this),
                        data = $this.data("owl.carousel");
                    data ||
                        ((data = new Owl(this, "object" == typeof option && option)),
                        $this.data("owl.carousel", data),
                        $.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (i, event) {
                            data.register({ type: Owl.Type.Event, name: event }),
                                data.$element.on(
                                    event + ".owl.carousel.core",
                                    $.proxy(function (e) {
                                        e.namespace && e.relatedTarget !== this && (this.suppress([event]), data[event].apply(this, [].slice.call(arguments, 1)), this.release([event]));
                                    }, data)
                                );
                        })),
                        "string" == typeof option && "_" !== option.charAt(0) && data[option].apply(data, args);
                });
            }),
            ($.fn.owlCarousel.Constructor = Owl);
    })(window.Zepto || window.jQuery, window, document),
    (function ($, window) {
        var AutoRefresh = function (carousel) {
            (this._core = carousel),
                (this._interval = null),
                (this._visible = null),
                (this._handlers = {
                    "initialized.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.autoRefresh && this.watch();
                    }, this),
                }),
                (this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        };
        (AutoRefresh.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
            (AutoRefresh.prototype.watch = function () {
                this._interval || ((this._visible = this._core.isVisible()), (this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval)));
            }),
            (AutoRefresh.prototype.refresh = function () {
                this._core.isVisible() !== this._visible && ((this._visible = !this._visible), this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh());
            }),
            (AutoRefresh.prototype.destroy = function () {
                var handler, property;
                for (handler in (window.clearInterval(this._interval), this._handlers)) this._core.$element.off(handler, this._handlers[handler]);
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh);
    })(window.Zepto || window.jQuery, window, document),
    (function ($, window) {
        var Lazy = function (carousel) {
            (this._core = carousel),
                (this._loaded = []),
                (this._handlers = {
                    "initialized.owl.carousel change.owl.carousel resized.owl.carousel": $.proxy(function (e) {
                        if (e.namespace && this._core.settings && this._core.settings.lazyLoad && ((e.property && "position" == e.property.name) || "initialized" == e.type))
                            for (
                                var settings = this._core.settings,
                                    n = (settings.center && Math.ceil(settings.items / 2)) || settings.items,
                                    i = (settings.center && -1 * n) || 0,
                                    position = (e.property && void 0 !== e.property.value ? e.property.value : this._core.current()) + i,
                                    clones = this._core.clones().length,
                                    load = $.proxy(function (i, v) {
                                        this.load(v);
                                    }, this);
                                i++ < n;

                            )
                                this.load(clones / 2 + this._core.relative(position)), clones && $.each(this._core.clones(this._core.relative(position)), load), position++;
                    }, this),
                }),
                (this._core.options = $.extend({}, Lazy.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        };
        (Lazy.Defaults = { lazyLoad: !1 }),
            (Lazy.prototype.load = function (position) {
                var $item = this._core.$stage.children().eq(position),
                    $elements = $item && $item.find(".owl-lazy");
                !$elements ||
                    -1 < $.inArray($item.get(0), this._loaded) ||
                    ($elements.each(
                        $.proxy(function (index, element) {
                            var image,
                                $element = $(element),
                                url = (1 < window.devicePixelRatio && $element.attr("data-src-retina")) || $element.attr("data-src") || $element.attr("data-srcset");
                            this._core.trigger("load", { element: $element, url: url }, "lazy"),
                                $element.is("img")
                                    ? $element
                                          .one(
                                              "load.owl.lazy",
                                              $.proxy(function () {
                                                  $element.css("opacity", 1), this._core.trigger("loaded", { element: $element, url: url }, "lazy");
                                              }, this)
                                          )
                                          .attr("src", url)
                                    : $element.is("source")
                                    ? $element
                                          .one(
                                              "load.owl.lazy",
                                              $.proxy(function () {
                                                  this._core.trigger("loaded", { element: $element, url: url }, "lazy");
                                              }, this)
                                          )
                                          .attr("srcset", url)
                                    : (((image = new Image()).onload = $.proxy(function () {
                                          $element.css({ "background-image": 'url("' + url + '")', opacity: "1" }), this._core.trigger("loaded", { element: $element, url: url }, "lazy");
                                      }, this)),
                                      (image.src = url));
                        }, this)
                    ),
                    this._loaded.push($item.get(0)));
            }),
            (Lazy.prototype.destroy = function () {
                var handler, property;
                for (handler in this.handlers) this._core.$element.off(handler, this.handlers[handler]);
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy);
    })(window.Zepto || window.jQuery, window, document),
    (function ($, window) {
        var AutoHeight = function (carousel) {
            (this._core = carousel),
                (this._handlers = {
                    "initialized.owl.carousel refreshed.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.autoHeight && this.update();
                    }, this),
                    "changed.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.autoHeight && "position" === e.property.name && (console.log("update called"), this.update());
                    }, this),
                    "loaded.owl.lazy": $.proxy(function (e) {
                        e.namespace && this._core.settings.autoHeight && e.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
                    }, this),
                }),
                (this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                (this._intervalId = null);
            var refThis = this;
            $(window).on("load", function () {
                refThis._core.settings.autoHeight && refThis.update();
            }),
                $(window).resize(function () {
                    refThis._core.settings.autoHeight &&
                        (null != refThis._intervalId && clearTimeout(refThis._intervalId),
                        (refThis._intervalId = setTimeout(function () {
                            refThis.update();
                        }, 250)));
                });
        };
        (AutoHeight.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
            (AutoHeight.prototype.update = function () {
                var maxheight,
                    start = this._core._current,
                    end = start + this._core.settings.items,
                    visible = this._core.$stage.children().toArray().slice(start, end),
                    heights = [];
                $.each(visible, function (index, item) {
                    heights.push($(item).height());
                }),
                    (maxheight = Math.max.apply(null, heights)),
                    this._core.$stage.parent().height(maxheight).addClass(this._core.settings.autoHeightClass);
            }),
            (AutoHeight.prototype.destroy = function () {
                var handler, property;
                for (handler in this._handlers) this._core.$element.off(handler, this._handlers[handler]);
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight);
    })(window.Zepto || window.jQuery, window, document),
    (function ($, window, document) {
        var Video = function (carousel) {
            (this._core = carousel),
                (this._videos = {}),
                (this._playing = null),
                (this._handlers = {
                    "initialized.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.register({ type: "state", name: "playing", tags: ["interacting"] });
                    }, this),
                    "resize.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.video && this.isInFullScreen() && e.preventDefault();
                    }, this),
                    "refreshed.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
                    }, this),
                    "changed.owl.carousel": $.proxy(function (e) {
                        e.namespace && "position" === e.property.name && this._playing && this.stop();
                    }, this),
                    "prepared.owl.carousel": $.proxy(function (e) {
                        if (e.namespace) {
                            var $element = $(e.content).find(".owl-video");
                            $element.length && ($element.css("display", "none"), this.fetch($element, $(e.content)));
                        }
                    }, this),
                }),
                (this._core.options = $.extend({}, Video.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                this._core.$element.on(
                    "click.owl.video",
                    ".owl-video-play-icon",
                    $.proxy(function (e) {
                        this.play(e);
                    }, this)
                );
        };
        (Video.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
            (Video.prototype.fetch = function (target, item) {
                var type = target.attr("data-vimeo-id") ? "vimeo" : target.attr("data-vzaar-id") ? "vzaar" : "youtube",
                    id = target.attr("data-vimeo-id") || target.attr("data-youtube-id") || target.attr("data-vzaar-id"),
                    width = target.attr("data-width") || this._core.settings.videoWidth,
                    height = target.attr("data-height") || this._core.settings.videoHeight,
                    url = target.attr("href");
                if (!url) throw new Error("Missing video URL.");
                if (
                    -1 <
                    (id = url.match(
                        /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
                    ))[3].indexOf("youtu")
                )
                    type = "youtube";
                else if (-1 < id[3].indexOf("vimeo")) type = "vimeo";
                else {
                    if (!(-1 < id[3].indexOf("vzaar"))) throw new Error("Video URL not supported.");
                    type = "vzaar";
                }
                (id = id[6]), (this._videos[url] = { type: type, id: id, width: width, height: height }), item.attr("data-video", url), this.thumbnail(target, this._videos[url]);
            }),
            (Video.prototype.thumbnail = function (target, video) {
                function create(path) {
                    '<div class="owl-video-play-icon"></div>',
                        (tnLink = settings.lazyLoad ? '<div class="owl-video-tn ' + lazyClass + '" ' + srcType + '="' + path + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + path + ')"></div>'),
                        target.after(tnLink),
                        target.after('<div class="owl-video-play-icon"></div>');
                }
                var tnLink,
                    path,
                    dimensions = video.width && video.height ? 'style="width:' + video.width + "px;height:" + video.height + 'px;"' : "",
                    customTn = target.find("img"),
                    srcType = "src",
                    lazyClass = "",
                    settings = this._core.settings;
                if ((target.wrap('<div class="owl-video-wrapper"' + dimensions + "></div>"), this._core.settings.lazyLoad && ((srcType = "data-src"), (lazyClass = "owl-lazy")), customTn.length))
                    return create(customTn.attr(srcType)), customTn.remove(), !1;
                "youtube" === video.type
                    ? ((path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg"), create(path))
                    : "vimeo" === video.type
                    ? $.ajax({
                          type: "GET",
                          url: "//vimeo.com/api/v2/video/" + video.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (data) {
                              (path = data[0].thumbnail_large), create(path);
                          },
                      })
                    : "vzaar" === video.type &&
                      $.ajax({
                          type: "GET",
                          url: "//vzaar.com/api/videos/" + video.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (data) {
                              (path = data.framegrab_url), create(path);
                          },
                      });
            }),
            (Video.prototype.stop = function () {
                this._core.trigger("stop", null, "video"),
                    this._playing.find(".owl-video-frame").remove(),
                    this._playing.removeClass("owl-video-playing"),
                    (this._playing = null),
                    this._core.leave("playing"),
                    this._core.trigger("stopped", null, "video");
            }),
            (Video.prototype.play = function (event) {
                var html,
                    item = $(event.target).closest("." + this._core.settings.itemClass),
                    video = this._videos[item.attr("data-video")],
                    width = video.width || "100%",
                    height = video.height || this._core.$stage.height();
                this._playing ||
                    (this._core.enter("playing"),
                    this._core.trigger("play", null, "video"),
                    (item = this._core.items(this._core.relative(item.index()))),
                    this._core.reset(item.index()),
                    "youtube" === video.type
                        ? (html = '<iframe width="' + width + '" height="' + height + '" src="//www.youtube.com/embed/' + video.id + "?autoplay=1&rel=0&v=" + video.id + '" frameborder="0" allowfullscreen></iframe>')
                        : "vimeo" === video.type
                        ? (html = '<iframe src="//player.vimeo.com/video/' + video.id + '?autoplay=1" width="' + width + '" height="' + height + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>')
                        : "vzaar" === video.type &&
                          (html = '<iframe frameborder="0"height="' + height + '"width="' + width + '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' + video.id + '/player?autoplay=true"></iframe>'),
                    $('<div class="owl-video-frame">' + html + "</div>").insertAfter(item.find(".owl-video")),
                    (this._playing = item.addClass("owl-video-playing")));
            }),
            (Video.prototype.isInFullScreen = function () {
                var element = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
                return element && $(element).parent().hasClass("owl-video-frame");
            }),
            (Video.prototype.destroy = function () {
                var handler, property;
                for (handler in (this._core.$element.off("click.owl.video"), this._handlers)) this._core.$element.off(handler, this._handlers[handler]);
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.Video = Video);
    })(window.Zepto || window.jQuery, window, document),
    (function ($) {
        var Animate = function (scope) {
            (this.core = scope),
                (this.core.options = $.extend({}, Animate.Defaults, this.core.options)),
                (this.swapping = !0),
                (this.previous = void 0),
                (this.next = void 0),
                (this.handlers = {
                    "change.owl.carousel": $.proxy(function (e) {
                        e.namespace && "position" == e.property.name && ((this.previous = this.core.current()), (this.next = e.property.value));
                    }, this),
                    "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": $.proxy(function (e) {
                        e.namespace && (this.swapping = "translated" == e.type);
                    }, this),
                    "translate.owl.carousel": $.proxy(function (e) {
                        e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
                    }, this),
                }),
                this.core.$element.on(this.handlers);
        };
        (Animate.Defaults = { animateOut: !1, animateIn: !1 }),
            (Animate.prototype.swap = function () {
                if (1 === this.core.settings.items && $.support.animation && $.support.transition) {
                    this.core.speed(0);
                    var left,
                        clear = $.proxy(this.clear, this),
                        previous = this.core.$stage.children().eq(this.previous),
                        next = this.core.$stage.children().eq(this.next),
                        incoming = this.core.settings.animateIn,
                        outgoing = this.core.settings.animateOut;
                    this.core.current() !== this.previous &&
                        (outgoing &&
                            ((left = this.core.coordinates(this.previous) - this.core.coordinates(this.next)),
                            previous
                                .one($.support.animation.end, clear)
                                .css({ left: left + "px" })
                                .addClass("animated owl-animated-out")
                                .addClass(outgoing)),
                        incoming && next.one($.support.animation.end, clear).addClass("animated owl-animated-in").addClass(incoming));
                }
            }),
            (Animate.prototype.clear = function (e) {
                $(e.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd();
            }),
            (Animate.prototype.destroy = function () {
                var handler, property;
                for (handler in this.handlers) this.core.$element.off(handler, this.handlers[handler]);
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.Animate = Animate);
    })(window.Zepto || window.jQuery, window, document),
    (function ($, window, document) {
        var Autoplay = function (carousel) {
            (this._core = carousel),
                (this._call = null),
                (this._time = 0),
                (this._timeout = 0),
                (this._paused = !0),
                (this._handlers = {
                    "changed.owl.carousel": $.proxy(function (e) {
                        e.namespace && "settings" === e.property.name ? (this._core.settings.autoplay ? this.play() : this.stop()) : e.namespace && "position" === e.property.name && this._paused && (this._time = 0);
                    }, this),
                    "initialized.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.autoplay && this.play();
                    }, this),
                    "play.owl.autoplay": $.proxy(function (e, t, s) {
                        e.namespace && this.play(t, s);
                    }, this),
                    "stop.owl.autoplay": $.proxy(function (e) {
                        e.namespace && this.stop();
                    }, this),
                    "mouseover.owl.autoplay": $.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "mouseleave.owl.autoplay": $.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
                    }, this),
                    "touchstart.owl.core": $.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "touchend.owl.core": $.proxy(function () {
                        this._core.settings.autoplayHoverPause && this.play();
                    }, this),
                }),
                this._core.$element.on(this._handlers),
                (this._core.options = $.extend({}, Autoplay.Defaults, this._core.options));
        };
        (Autoplay.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }),
            (Autoplay.prototype._next = function (speed) {
                (this._call = window.setTimeout($.proxy(this._next, this, speed), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read())),
                    this._core.is("interacting") || document.hidden || this._core.next(speed || this._core.settings.autoplaySpeed);
            }),
            (Autoplay.prototype.read = function () {
                return new Date().getTime() - this._time;
            }),
            (Autoplay.prototype.play = function (timeout, speed) {
                var elapsed;
                this._core.is("rotating") || this._core.enter("rotating"),
                    (timeout = timeout || this._core.settings.autoplayTimeout),
                    (elapsed = Math.min(this._time % (this._timeout || timeout), timeout)),
                    this._paused ? ((this._time = this.read()), (this._paused = !1)) : window.clearTimeout(this._call),
                    (this._time += (this.read() % timeout) - elapsed),
                    (this._timeout = timeout),
                    (this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed));
            }),
            (Autoplay.prototype.stop = function () {
                this._core.is("rotating") && ((this._time = 0), (this._paused = !0), window.clearTimeout(this._call), this._core.leave("rotating"));
            }),
            (Autoplay.prototype.pause = function () {
                this._core.is("rotating") && !this._paused && ((this._time = this.read()), (this._paused = !0), window.clearTimeout(this._call));
            }),
            (Autoplay.prototype.destroy = function () {
                var handler, property;
                for (handler in (this.stop(), this._handlers)) this._core.$element.off(handler, this._handlers[handler]);
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay);
    })(window.Zepto || window.jQuery, window, document),
    (function ($) {
        "use strict";
        var Navigation = function (carousel) {
            (this._core = carousel),
                (this._initialized = !1),
                (this._pages = []),
                (this._controls = {}),
                (this._templates = []),
                (this.$element = this._core.$element),
                (this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }),
                (this._handlers = {
                    "prepared.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + $(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
                    }, this),
                    "added.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 0, this._templates.pop());
                    }, this),
                    "remove.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 1);
                    }, this),
                    "changed.owl.carousel": $.proxy(function (e) {
                        e.namespace && "position" == e.property.name && this.draw();
                    }, this),
                    "initialized.owl.carousel": $.proxy(function (e) {
                        e.namespace &&
                            !this._initialized &&
                            (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), (this._initialized = !0), this._core.trigger("initialized", null, "navigation"));
                    }, this),
                    "refreshed.owl.carousel": $.proxy(function (e) {
                        e.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
                    }, this),
                }),
                (this._core.options = $.extend({}, Navigation.Defaults, this._core.options)),
                this.$element.on(this._handlers);
        };
        (Navigation.Defaults = {
            nav: !1,
            navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
            navSpeed: !1,
            navElement: 'button type="button" role="presentation"',
            navContainer: !1,
            navContainerClass: "owl-nav",
            navClass: ["owl-prev", "owl-next"],
            slideBy: 1,
            dotClass: "owl-dot",
            dotsClass: "owl-dots",
            dots: !0,
            dotsEach: !1,
            dotsData: !1,
            dotsSpeed: !1,
            dotsContainer: !1,
        }),
            (Navigation.prototype.initialize = function () {
                var override,
                    settings = this._core.settings;
                for (override in ((this._controls.$relative = (settings.navContainer ? $(settings.navContainer) : $("<div>").addClass(settings.navContainerClass).appendTo(this.$element)).addClass("disabled")),
                (this._controls.$previous = $("<" + settings.navElement + ">")
                    .addClass(settings.navClass[0])
                    .html(settings.navText[0])
                    .prependTo(this._controls.$relative)
                    .on(
                        "click",
                        $.proxy(function (e) {
                            this.prev(settings.navSpeed);
                        }, this)
                    )),
                (this._controls.$next = $("<" + settings.navElement + ">")
                    .addClass(settings.navClass[1])
                    .html(settings.navText[1])
                    .appendTo(this._controls.$relative)
                    .on(
                        "click",
                        $.proxy(function (e) {
                            this.next(settings.navSpeed);
                        }, this)
                    )),
                settings.dotsData || (this._templates = [$('<button role="button">').addClass(settings.dotClass).append($("<span>")).prop("outerHTML")]),
                (this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer) : $("<div>").addClass(settings.dotsClass).appendTo(this.$element)).addClass("disabled")),
                this._controls.$absolute.on(
                    "click",
                    "button",
                    $.proxy(function (e) {
                        var index = $(e.target).parent().is(this._controls.$absolute) ? $(e.target).index() : $(e.target).parent().index();
                        e.preventDefault(), this.to(index, settings.dotsSpeed);
                    }, this)
                ),
                this._overrides))
                    this._core[override] = $.proxy(this[override], this);
            }),
            (Navigation.prototype.destroy = function () {
                var handler, control, property, override, settings;
                for (handler in ((settings = this._core.settings), this._handlers)) this.$element.off(handler, this._handlers[handler]);
                for (control in this._controls) "$relative" === control && settings.navContainer ? this._controls[control].html("") : this._controls[control].remove();
                for (override in this.overides) this._core[override] = this._overrides[override];
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            (Navigation.prototype.update = function () {
                var i,
                    j,
                    lower = this._core.clones().length / 2,
                    upper = lower + this._core.items().length,
                    maximum = this._core.maximum(!0),
                    settings = this._core.settings,
                    size = settings.center || settings.autoWidth || settings.dotsData ? 1 : settings.dotsEach || settings.items;
                if (("page" !== settings.slideBy && (settings.slideBy = Math.min(settings.slideBy, settings.items)), settings.dots || "page" == settings.slideBy))
                    for (this._pages = [], i = lower, j = 0; i < upper; i++) {
                        if (size <= j || 0 === j) {
                            if ((this._pages.push({ start: Math.min(maximum, i - lower), end: i - lower + size - 1 }), Math.min(maximum, i - lower) === maximum)) break;
                            (j = 0), 0;
                        }
                        j += this._core.mergers(this._core.relative(i));
                    }
            }),
            (Navigation.prototype.draw = function () {
                var difference,
                    settings = this._core.settings,
                    disabled = this._core.items().length <= settings.items,
                    index = this._core.relative(this._core.current()),
                    loop = settings.loop || settings.rewind;
                this._controls.$relative.toggleClass("disabled", !settings.nav || disabled),
                    settings.nav && (this._controls.$previous.toggleClass("disabled", !loop && index <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !loop && index >= this._core.maximum(!0))),
                    this._controls.$absolute.toggleClass("disabled", !settings.dots || disabled),
                    settings.dots &&
                        ((difference = this._pages.length - this._controls.$absolute.children().length),
                        settings.dotsData && 0 != difference
                            ? this._controls.$absolute.html(this._templates.join(""))
                            : 0 < difference
                            ? this._controls.$absolute.append(new Array(1 + difference).join(this._templates[0]))
                            : difference < 0 && this._controls.$absolute.children().slice(difference).remove(),
                        this._controls.$absolute.find(".active").removeClass("active"),
                        this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass("active"));
            }),
            (Navigation.prototype.onTrigger = function (event) {
                var settings = this._core.settings;
                event.page = { index: $.inArray(this.current(), this._pages), count: this._pages.length, size: settings && (settings.center || settings.autoWidth || settings.dotsData ? 1 : settings.dotsEach || settings.items) };
            }),
            (Navigation.prototype.current = function () {
                var current = this._core.relative(this._core.current());
                return $.grep(
                    this._pages,
                    $.proxy(function (page, index) {
                        return page.start <= current && page.end >= current;
                    }, this)
                ).pop();
            }),
            (Navigation.prototype.getPosition = function (successor) {
                var position,
                    length,
                    settings = this._core.settings;
                return (
                    "page" == settings.slideBy
                        ? ((position = $.inArray(this.current(), this._pages)), (length = this._pages.length), successor ? ++position : --position, (position = this._pages[((position % length) + length) % length].start))
                        : ((position = this._core.relative(this._core.current())), (length = this._core.items().length), successor ? (position += settings.slideBy) : (position -= settings.slideBy)),
                    position
                );
            }),
            (Navigation.prototype.next = function (speed) {
                $.proxy(this._overrides.to, this._core)(this.getPosition(!0), speed);
            }),
            (Navigation.prototype.prev = function (speed) {
                $.proxy(this._overrides.to, this._core)(this.getPosition(!1), speed);
            }),
            (Navigation.prototype.to = function (position, speed, standard) {
                var length;
                !standard && this._pages.length
                    ? ((length = this._pages.length), $.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed))
                    : $.proxy(this._overrides.to, this._core)(position, speed);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation);
    })(window.Zepto || window.jQuery, window, document),
    (function ($, window) {
        "use strict";
        var Hash = function (carousel) {
            (this._core = carousel),
                (this._hashes = {}),
                (this.$element = this._core.$element),
                (this._handlers = {
                    "initialized.owl.carousel": $.proxy(function (e) {
                        e.namespace && "URLHash" === this._core.settings.startPosition && $(window).trigger("hashchange.owl.navigation");
                    }, this),
                    "prepared.owl.carousel": $.proxy(function (e) {
                        if (e.namespace) {
                            var hash = $(e.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                            if (!hash) return;
                            this._hashes[hash] = e.content;
                        }
                    }, this),
                    "changed.owl.carousel": $.proxy(function (e) {
                        if (e.namespace && "position" === e.property.name) {
                            var current = this._core.items(this._core.relative(this._core.current())),
                                hash = $.map(this._hashes, function (item, hash) {
                                    return item === current ? hash : null;
                                }).join();
                            if (!hash || window.location.hash.slice(1) === hash) return;
                            window.location.hash = hash;
                        }
                    }, this),
                }),
                (this._core.options = $.extend({}, Hash.Defaults, this._core.options)),
                this.$element.on(this._handlers),
                $(window).on(
                    "hashchange.owl.navigation",
                    $.proxy(function (e) {
                        var hash = window.location.hash.substring(1),
                            items = this._core.$stage.children(),
                            position = this._hashes[hash] && items.index(this._hashes[hash]);
                        void 0 !== position && position !== this._core.current() && this._core.to(this._core.relative(position), !1, !0);
                    }, this)
                );
        };
        (Hash.Defaults = { URLhashListener: !1 }),
            (Hash.prototype.destroy = function () {
                var handler, property;
                for (handler in ($(window).off("hashchange.owl.navigation"), this._handlers)) this._core.$element.off(handler, this._handlers[handler]);
                for (property in Object.getOwnPropertyNames(this)) "function" != typeof this[property] && (this[property] = null);
            }),
            ($.fn.owlCarousel.Constructor.Plugins.Hash = Hash);
    })(window.Zepto || window.jQuery, window, document),
    (function ($, window, document, undefined) {
        var style = $("<support>").get(0).style,
            prefixes = "Webkit Moz O ms".split(" "),
            events = {
                transition: { end: { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" } },
                animation: { end: { WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend" } },
            },
            tests_csstransforms = function () {
                return !!test("transform");
            },
            tests_csstransforms3d = function () {
                return !!test("perspective");
            },
            tests_cssanimations = function () {
                return !!test("animation");
            };
        function test(property, prefixed) {
            var result = !1,
                upper = property.charAt(0).toUpperCase() + property.slice(1);
            return (
                $.each((property + " " + prefixes.join(upper + " ") + upper).split(" "), function (i, property) {
                    if (style[property] !== undefined) return (result = !prefixed || property), !1;
                }),
                result
            );
        }
        function prefixed(property) {
            return test(property, !0);
        }
        !(function () {
            return !!test("transition");
        })() || (($.support.transition = new String(prefixed("transition"))), ($.support.transition.end = events.transition.end[$.support.transition])),
            tests_cssanimations() && (($.support.animation = new String(prefixed("animation"))), ($.support.animation.end = events.animation.end[$.support.animation])),
            tests_csstransforms() && (($.support.transform = new String(prefixed("transform"))), ($.support.transform3d = tests_csstransforms3d()));
    })(window.Zepto || window.jQuery, window, document),
    (function ($) {
        var methods = {
            init: function (options) {
                var o = $.extend(
                        {
                            items: 1,
                            itemsOnPage: 1,
                            pages: 0,
                            displayedPages: 5,
                            edges: 2,
                            currentPage: 0,
                            useAnchors: !0,
                            hrefTextPrefix: "#page-",
                            hrefTextSuffix: "",
                            prevText: "Prev",
                            nextText: "Next",
                            ellipseText: "&hellip;",
                            ellipsePageSet: !0,
                            cssStyle: "light-theme",
                            listStyle: "",
                            labelMap: [],
                            selectOnClick: !0,
                            nextAtFront: !1,
                            invertPageOrder: !1,
                            useStartEdge: !0,
                            useEndEdge: !0,
                            onPageClick: function (pageNumber, event) {},
                            onInit: function () {},
                        },
                        options || {}
                    ),
                    self = this;
                return (
                    (o.pages = o.pages ? o.pages : Math.ceil(o.items / o.itemsOnPage) ? Math.ceil(o.items / o.itemsOnPage) : 1),
                    o.currentPage ? (o.currentPage = o.currentPage - 1) : (o.currentPage = o.invertPageOrder ? o.pages - 1 : 0),
                    (o.halfDisplayed = o.displayedPages / 2),
                    this.each(function () {
                        self.addClass(o.cssStyle + " simple-pagination").data("pagination", o), methods._draw.call(self);
                    }),
                    o.onInit(),
                    this
                );
            },
            selectPage: function (page) {
                return methods._selectPage.call(this, page - 1), this;
            },
            prevPage: function () {
                var o = this.data("pagination");
                return o.invertPageOrder ? o.currentPage < o.pages - 1 && methods._selectPage.call(this, o.currentPage + 1) : 0 < o.currentPage && methods._selectPage.call(this, o.currentPage - 1), this;
            },
            nextPage: function () {
                var o = this.data("pagination");
                return o.invertPageOrder ? 0 < o.currentPage && methods._selectPage.call(this, o.currentPage - 1) : o.currentPage < o.pages - 1 && methods._selectPage.call(this, o.currentPage + 1), this;
            },
            getPagesCount: function () {
                return this.data("pagination").pages;
            },
            setPagesCount: function (count) {
                this.data("pagination").pages = count;
            },
            getCurrentPage: function () {
                return this.data("pagination").currentPage + 1;
            },
            destroy: function () {
                return this.empty(), this;
            },
            drawPage: function (page) {
                var o = this.data("pagination");
                return (o.currentPage = page - 1), this.data("pagination", o), methods._draw.call(this), this;
            },
            redraw: function () {
                return methods._draw.call(this), this;
            },
            disable: function () {
                var o = this.data("pagination");
                return (o.disabled = !0), this.data("pagination", o), methods._draw.call(this), this;
            },
            enable: function () {
                var o = this.data("pagination");
                return (o.disabled = !1), this.data("pagination", o), methods._draw.call(this), this;
            },
            updateItems: function (newItems) {
                var o = this.data("pagination");
                (o.items = newItems), (o.pages = methods._getPages(o)), this.data("pagination", o), methods._draw.call(this);
            },
            updateItemsOnPage: function (itemsOnPage) {
                var o = this.data("pagination");
                return (o.itemsOnPage = itemsOnPage), (o.pages = methods._getPages(o)), this.data("pagination", o), methods._selectPage.call(this, 0), this;
            },
            getItemsOnPage: function () {
                return this.data("pagination").itemsOnPage;
            },
            _draw: function () {
                var i,
                    o = this.data("pagination"),
                    interval = methods._getInterval(o);
                methods.destroy.call(this);
                var $panel = "UL" === ("function" == typeof this.prop ? this.prop("tagName") : this.attr("tagName")) ? this : $("<ul" + (o.listStyle ? ' class="' + o.listStyle + '"' : "") + "></ul>").appendTo(this);
                if (
                    (o.prevText && methods._appendItem.call(this, o.invertPageOrder ? o.currentPage + 1 : o.currentPage - 1, { text: o.prevText, classes: "prev" }),
                    o.nextText && o.nextAtFront && methods._appendItem.call(this, o.invertPageOrder ? o.currentPage - 1 : o.currentPage + 1, { text: o.nextText, classes: "next" }),
                    o.invertPageOrder)
                ) {
                    if (interval.end < o.pages && 0 < o.edges) {
                        if (o.useStartEdge) {
                            var begin = Math.max(o.pages - o.edges, interval.end);
                            for (i = o.pages - 1; begin <= i; i--) methods._appendItem.call(this, i);
                        }
                        o.pages - o.edges > interval.end && o.pages - o.edges - interval.end != 1
                            ? $panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + "</span></li>")
                            : o.pages - o.edges - interval.end == 1 && methods._appendItem.call(this, interval.end);
                    }
                } else if (0 < interval.start && 0 < o.edges) {
                    if (o.useStartEdge) {
                        var end = Math.min(o.edges, interval.start);
                        for (i = 0; i < end; i++) methods._appendItem.call(this, i);
                    }
                    o.edges < interval.start && interval.start - o.edges != 1
                        ? $panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + "</span></li>")
                        : interval.start - o.edges == 1 && methods._appendItem.call(this, o.edges);
                }
                if (o.invertPageOrder) for (i = interval.end - 1; i >= interval.start; i--) methods._appendItem.call(this, i);
                else for (i = interval.start; i < interval.end; i++) methods._appendItem.call(this, i);
                if (o.invertPageOrder) {
                    if (
                        0 < interval.start &&
                        0 < o.edges &&
                        (o.edges < interval.start && interval.start - o.edges != 1
                            ? $panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + "</span></li>")
                            : interval.start - o.edges == 1 && methods._appendItem.call(this, o.edges),
                        o.useEndEdge)
                    )
                        for (i = (end = Math.min(o.edges, interval.start)) - 1; 0 <= i; i--) methods._appendItem.call(this, i);
                } else if (
                    interval.end < o.pages &&
                    0 < o.edges &&
                    (o.pages - o.edges > interval.end && o.pages - o.edges - interval.end != 1
                        ? $panel.append('<li class="disabled"><span class="ellipse">' + o.ellipseText + "</span></li>")
                        : o.pages - o.edges - interval.end == 1 && methods._appendItem.call(this, interval.end),
                    o.useEndEdge)
                )
                    for (i = begin = Math.max(o.pages - o.edges, interval.end); i < o.pages; i++) methods._appendItem.call(this, i);
                o.nextText && !o.nextAtFront && methods._appendItem.call(this, o.invertPageOrder ? o.currentPage - 1 : o.currentPage + 1, { text: o.nextText, classes: "next" }),
                    o.ellipsePageSet && !o.disabled && methods._ellipseClick.call(this, $panel);
            },
            _getPages: function (o) {
                return Math.ceil(o.items / o.itemsOnPage) || 1;
            },
            _getInterval: function (o) {
                return {
                    start: Math.ceil(o.currentPage > o.halfDisplayed ? Math.max(Math.min(o.currentPage - o.halfDisplayed, o.pages - o.displayedPages), 0) : 0),
                    end: Math.ceil(o.currentPage > o.halfDisplayed ? Math.min(o.currentPage + o.halfDisplayed, o.pages) : Math.min(o.displayedPages, o.pages)),
                };
            },
            _appendItem: function (pageIndex, opts) {
                var options,
                    $link,
                    self = this,
                    o = self.data("pagination"),
                    $linkWrapper = $("<li></li>"),
                    $ul = self.find("ul");
                (options = { text: (pageIndex = pageIndex < 0 ? 0 : pageIndex < o.pages ? pageIndex : o.pages - 1) + 1, classes: "" }),
                    o.labelMap.length && o.labelMap[pageIndex] && (options.text = o.labelMap[pageIndex]),
                    (options = $.extend(options, opts || {})),
                    pageIndex == o.currentPage || o.disabled
                        ? (o.disabled || "prev" === options.classes || "next" === options.classes ? $linkWrapper.addClass("disabled") : $linkWrapper.addClass("active"), ($link = $('<span class="current">' + options.text + "</span>")))
                        : ($link = o.useAnchors
                              ? $('<a href="javascript:void(0);" data-href="' + o.hrefTextPrefix + (pageIndex + 1) + o.hrefTextSuffix + '" class="page-link">' + options.text + "</a>")
                              : $("<span >" + options.text + "</span>")).click(function (event) {
                              return methods._selectPage.call(self, pageIndex, event);
                          }),
                    options.classes && $link.addClass(options.classes),
                    $linkWrapper.append($link),
                    $ul.length ? $ul.append($linkWrapper) : self.append($linkWrapper);
            },
            _selectPage: function (pageIndex, event) {
                var o = this.data("pagination");
                return (o.currentPage = pageIndex), o.selectOnClick && methods._draw.call(this), o.onPageClick(pageIndex + 1, event);
            },
            _ellipseClick: function ($panel) {
                var self = this,
                    o = this.data("pagination"),
                    $ellip = $panel.find(".ellipse");
                $ellip.addClass("clickable").parent().removeClass("disabled"),
                    $ellip.click(function (event) {
                        if (!o.disable) {
                            var $this = $(this),
                                val = (parseInt($this.parent().prev().text(), 10) || 0) + 1;
                            $this
                                .html('<input type="number" min="1" max="' + o.pages + '" step="1" value="' + val + '">')
                                .find("input")
                                .focus()
                                .click(function (event) {
                                    event.stopPropagation();
                                })
                                .keyup(function (event) {
                                    var val = $(this).val();
                                    13 === event.which && "" !== val ? 0 < val && val <= o.pages && methods._selectPage.call(self, val - 1) : 27 === event.which && $ellip.empty().html(o.ellipseText);
                                })
                                .bind("blur", function (event) {
                                    var val = $(this).val();
                                    return "" !== val && methods._selectPage.call(self, val - 1), $ellip.empty().html(o.ellipseText), !1;
                                });
                        }
                        return !1;
                    });
            },
        };
        $.fn.pagination = function (method) {
            return methods[method] && "_" != method.charAt(0)
                ? methods[method].apply(this, Array.prototype.slice.call(arguments, 1))
                : "object" != typeof method && method
                ? void $.error("Method " + method + " does not exist on jQuery.pagination")
                : methods.init.apply(this, arguments);
        };
    })(jQuery),
    (function (f) {
        function J(a, b, c) {
            if (!c[0] || "object" == typeof c[0]) return b.init.apply(a, c);
            if (b[c[0]]) return b[c[0]].apply(a, Array.prototype.slice.call(c, 1));
            throw q(c[0] + " is not a method or property");
        }
        function l(a, b, c, d) {
            return { css: { position: "absolute", top: a, left: b, overflow: d || "hidden", zIndex: c || "auto" } };
        }
        function S(a, b, c, d, e) {
            var h = 1 - e,
                f = h * h * h,
                g = e * e * e;
            return j(Math.round(f * a.x + 3 * e * h * h * b.x + 3 * e * e * h * c.x + g * d.x), Math.round(f * a.y + 3 * e * h * h * b.y + 3 * e * e * h * c.y + g * d.y));
        }
        function j(a, b) {
            return { x: a, y: b };
        }
        function F(a, b, c) {
            return z && c ? " translate3d(" + a + "px," + b + "px, 0px) " : " translate(" + a + "px, " + b + "px) ";
        }
        function G(a) {
            return " rotate(" + a + "deg) ";
        }
        function n(a, b) {
            return Object.prototype.hasOwnProperty.call(b, a);
        }
        function T() {
            for (var a = ["Moz", "Webkit", "Khtml", "O", "ms"], b = a.length, c = ""; b--; ) a[b] + "Transform" in document.body.style && (c = "-" + a[b].toLowerCase() + "-");
            return c;
        }
        function P(a, b, c, d, e) {
            var h,
                f = [];
            if ("-webkit-" == w) {
                for (h = 0; h < e; h++) f.push("color-stop(" + d[h][0] + ", " + d[h][1] + ")");
                a.css({ "background-image": "-webkit-gradient(linear, " + b.x + "% " + b.y + "%," + c.x + "% " + c.y + "%, " + f.join(",") + " )" });
            } else {
                b = { x: (b.x / 100) * a.width(), y: (b.y / 100) * a.height() };
                var g = (c = { x: (c.x / 100) * a.width(), y: (c.y / 100) * a.height() }).x - b.x;
                h = c.y - b.y;
                var i = Math.atan2(h, g),
                    x = i - Math.PI / 2,
                    k = ((x = Math.abs(a.width() * Math.sin(x)) + Math.abs(a.height() * Math.cos(x))), (g = Math.sqrt(h * h + g * g)), (c = j(c.x < b.x ? a.width() : 0, c.y < b.y ? a.height() : 0)), Math.tan(i));
                for (c = (h = -1 / k) * (k = (h * c.x - c.y - k * b.x + b.y) / (h - k)) - h * c.x + c.y, b = Math.sqrt(Math.pow(k - b.x, 2) + Math.pow(c - b.y, 2)), h = 0; h < e; h++)
                    f.push(" " + d[h][1] + " " + (100 * (b + g * d[h][0])) / x + "%");
                a.css({ "background-image": w + "linear-gradient(" + -i + "rad," + f.join(",") + ")" });
            }
        }
        function t(a, b, c) {
            return (a = f.Event(a)), b.trigger(a, c), a.isDefaultPrevented() ? "prevented" : a.isPropagationStopped() ? "stopped" : "";
        }
        function q(a) {
            function b(a) {
                (this.name = "TurnJsError"), (this.message = a);
            }
            return new ((b.prototype = Error()).constructor = b)(a);
        }
        function D(a) {
            for (var b = { top: 0, left: 0 }; (b.left += a.offsetLeft), (b.top += a.offsetTop), (a = a.offsetParent); );
            return b;
        }
        var z,
            U,
            w = "",
            K = Math.PI,
            L = K / 2,
            u = "ontouchstart" in window,
            r = u ? { down: "touchstart", move: "touchmove", up: "touchend", over: "touchstart", out: "touchend" } : { down: "mousedown", move: "mousemove", up: "mouseup", over: "mouseover", out: "mouseout" },
            p = { backward: ["bl", "tl"], forward: ["br", "tr"], all: "tl bl tr br l r".split(" ") },
            V = ["single", "double"],
            W = ["ltr", "rtl"],
            X = { acceleration: !0, display: "double", duration: 600, page: 1, gradients: !0, turnCorners: "bl,br", when: null },
            Y = { cornerSize: 100 },
            g = {
                init: function (a) {
                    var b, c;
                    (z = "WebKitCSSMatrix" in window || "MozPerspective" in document.body.style), (U = !(b = /AppleWebkit\/([0-9\.]+)/i.exec(navigator.userAgent)) || 534.3 < parseFloat(b[1])), (w = T()), (b = 0);
                    var d = this.data(),
                        e = this.children();
                    a = f.extend({ width: this.width(), height: this.height(), direction: this.attr("dir") || this.css("direction") || "ltr" }, X, a);
                    if (
                        ((d.opts = a),
                        (d.pageObjs = {}),
                        (d.pages = {}),
                        (d.pageWrap = {}),
                        (d.pageZoom = {}),
                        (d.pagePlace = {}),
                        (d.pageMv = []),
                        (d.zoom = 1),
                        (d.totalPages = a.pages || 0),
                        (d.eventHandlers = { touchStart: f.proxy(g._touchStart, this), touchMove: f.proxy(g._touchMove, this), touchEnd: f.proxy(g._touchEnd, this), start: f.proxy(g._eventStart, this) }),
                        a.when)
                    )
                        for (c in a.when) n(c, a.when) && this.bind(c, a.when[c]);
                    for (
                        this.css({ position: "relative", width: a.width, height: a.height }),
                            this.turn("display", a.display),
                            "" !== a.direction && this.turn("direction", a.direction),
                            z && !u && a.acceleration && this.transform(F(0, 0, !0)),
                            c = 0;
                        c < e.length;
                        c++
                    )
                        "1" != f(e[c]).attr("ignore") && this.turn("addPage", e[c], ++b);
                    return (
                        f(this).bind(r.down, d.eventHandlers.touchStart).bind("end", g._eventEnd).bind("pressed", g._eventPressed).bind("released", g._eventReleased).bind("flip", g._flip),
                        f(this).parent().bind("start", d.eventHandlers.start),
                        f(document).bind(r.move, d.eventHandlers.touchMove).bind(r.up, d.eventHandlers.touchEnd),
                        this.turn("page", a.page),
                        (d.done = !0),
                        this
                    );
                },
                addPage: function (a, b) {
                    var c,
                        d = !1,
                        e = this.data(),
                        h = e.totalPages + 1;
                    if (e.destroying) return !1;
                    if (((c = /\bp([0-9]+)\b/.exec(f(a).attr("class"))) && (b = parseInt(c[1], 10)), b)) {
                        if (b == h) d = !0;
                        else if (h < b) throw q('Page "' + b + '" cannot be inserted');
                    } else (b = h), (d = !0);
                    return (
                        1 <= b &&
                            b <= h &&
                            ((c = "double" == e.display ? (b % 2 ? " odd" : " even") : ""),
                            e.done && this.turn("stop"),
                            b in e.pageObjs && g._movePages.call(this, b, 1),
                            d && (e.totalPages = h),
                            (e.pageObjs[b] = f(a)
                                .css({ float: "left" })
                                .addClass("page p" + b + c)),
                            -1 != navigator.userAgent.indexOf("MSIE 9.0") && e.pageObjs[b].hasClass("hard") && e.pageObjs[b].removeClass("hard"),
                            g._addPage.call(this, b),
                            g._removeFromDOM.call(this)),
                        this
                    );
                },
                _addPage: function (a) {
                    var b = this.data(),
                        c = b.pageObjs[a];
                    if (c)
                        if (g._necessPage.call(this, a)) {
                            if (!b.pageWrap[a]) {
                                (b.pageWrap[a] = f("<div/>", { class: "page-wrapper", page: a, css: { position: "absolute", overflow: "hidden" } })),
                                    this.append(b.pageWrap[a]),
                                    b.pagePlace[a] || ((b.pagePlace[a] = a), b.pageObjs[a].appendTo(b.pageWrap[a]));
                                var d = g._pageSize.call(this, a, !0);
                                c.css({ width: d.width, height: d.height }), b.pageWrap[a].css(d);
                            }
                            b.pagePlace[a] == a && g._makeFlip.call(this, a);
                        } else (b.pagePlace[a] = 0), b.pageObjs[a] && b.pageObjs[a].remove();
                },
                hasPage: function (a) {
                    return n(a, this.data().pageObjs);
                },
                center: function (a) {
                    var b = this.data(),
                        c = f(this).turn("size"),
                        d = 0;
                    return (
                        b.noCenter ||
                            ("double" == b.display &&
                                ((a = this.turn("view", a || b.tpage || b.page)), "ltr" == b.direction ? (a[0] ? a[1] || (d += c.width / 4) : (d -= c.width / 4)) : a[0] ? a[1] || (d -= c.width / 4) : (d += c.width / 4)),
                            f(this).css({ marginLeft: d })),
                        this
                    );
                },
                destroy: function () {
                    var a = this,
                        b = this.data(),
                        c = "end first flip last pressed released start turning turned zooming missing".split(" ");
                    if ("prevented" != t("destroying", this)) {
                        for (
                            b.destroying = !0,
                                f.each(c, function (b, c) {
                                    a.unbind(c);
                                }),
                                this.parent().unbind("start", b.eventHandlers.start),
                                f(document).unbind(r.move, b.eventHandlers.touchMove).unbind(r.up, b.eventHandlers.touchEnd);
                            0 !== b.totalPages;

                        )
                            this.turn("removePage", b.totalPages);
                        return b.fparent && b.fparent.remove(), b.shadow && b.shadow.remove(), this.removeData(), (b = null), this;
                    }
                },
                is: function () {
                    return "object" == typeof this.data().pages;
                },
                zoom: function (a) {
                    var b = this.data();
                    if ("number" != typeof a) return b.zoom;
                    if (a < 0.001 || 100 < a) throw q(a + " is not a value for zoom");
                    if ("prevented" == t("zooming", this, [a, b.zoom])) return this;
                    var c = this.turn("size"),
                        d = this.turn("view"),
                        e = 1 / b.zoom,
                        h = Math.round(c.width * e * a);
                    c = Math.round(c.height * e * a);
                    for (b.zoom = a, f(this).turn("stop").turn("size", h, c), b.opts.autoCenter && this.turn("center"), g._updateShadow.call(this), a = 0; a < d.length; a++)
                        d[a] && b.pageZoom[d[a]] != b.zoom && (this.trigger("zoomed", [d[a], d, b.pageZoom[d[a]], b.zoom]), (b.pageZoom[d[a]] = b.zoom));
                    return this;
                },
                _pageSize: function (a, b) {
                    var c = this.data(),
                        d = {};
                    if ("single" == c.display) (d.width = this.width()), (d.height = this.height()), b && ((d.top = 0), (d.left = 0), (d.right = "auto"));
                    else {
                        var e = this.width() / 2,
                            h = this.height();
                        if ((c.pageObjs[a].hasClass("own-size") ? ((d.width = c.pageObjs[a].width()), (d.height = c.pageObjs[a].height())) : ((d.width = e), (d.height = h)), b)) {
                            var f = a % 2;
                            (d.top = (h - d.height) / 2), "ltr" == c.direction ? ((d[f ? "right" : "left"] = e - d.width), (d[f ? "left" : "right"] = "auto")) : ((d[f ? "left" : "right"] = e - d.width), (d[f ? "right" : "left"] = "auto"));
                        }
                    }
                    return d;
                },
                _makeFlip: function (a) {
                    var b = this.data();
                    if (!b.pages[a] && b.pagePlace[a] == a) {
                        var c = "single" == b.display,
                            d = a % 2;
                        (b.pages[a] = b.pageObjs[a]
                            .css(g._pageSize.call(this, a))
                            .flip({ page: a, next: d || c ? a + 1 : a - 1, turn: this })
                            .flip("disable", b.disabled)),
                            g._setPageLoc.call(this, a),
                            (b.pageZoom[a] = b.zoom);
                    }
                    return b.pages[a];
                },
                _makeRange: function () {
                    var a, b;
                    if (!(this.data().totalPages < 1)) for (a = (b = this.turn("range"))[0]; a <= b[1]; a++) g._addPage.call(this, a);
                },
                range: function (a) {
                    var b,
                        c,
                        d,
                        e = this.data();
                    a = a || e.tpage || e.page || 1;
                    if (((d = g._view.call(this, a)), a < 1 || a > e.totalPages)) throw q('"' + a + '" is not a valid page');
                    return (
                        (d[1] = d[1] || d[0]),
                        1 <= d[0] && d[1] <= e.totalPages ? ((a = Math.floor(2)), e.totalPages - d[1] > d[0] ? (c = 2 * a - (b = Math.min(d[0] - 1, a))) : (b = 2 * a - (c = Math.min(e.totalPages - d[1], a)))) : (c = b = 5),
                        [Math.max(1, d[0] - b), Math.min(e.totalPages, d[1] + c)]
                    );
                },
                _necessPage: function (a) {
                    if (0 === a) return !0;
                    var b = this.turn("range");
                    return this.data().pageObjs[a].hasClass("fixed") || (a >= b[0] && a <= b[1]);
                },
                _removeFromDOM: function () {
                    var a,
                        b = this.data();
                    for (a in b.pageWrap) n(a, b.pageWrap) && !g._necessPage.call(this, a) && g._removePageFromDOM.call(this, a);
                },
                _removePageFromDOM: function (a) {
                    var b = this.data();
                    if (b.pages[a]) {
                        var c = b.pages[a].data();
                        i._moveFoldingPage.call(b.pages[a], !1), c.f && c.f.fwrapper && c.f.fwrapper.remove(), b.pages[a].removeData(), b.pages[a].remove(), delete b.pages[a];
                    }
                    b.pageObjs[a] && b.pageObjs[a].remove(), b.pageWrap[a] && (b.pageWrap[a].remove(), delete b.pageWrap[a]), g._removeMv.call(this, a), delete b.pagePlace[a], delete b.pageZoom[a];
                },
                removePage: function (a) {
                    var b = this.data();
                    if ("*" == a) for (; 0 !== b.totalPages; ) this.turn("removePage", b.totalPages);
                    else {
                        if (a < 1 || a > b.totalPages) throw q("The page " + a + " doesn't exist");
                        b.pageObjs[a] && (this.turn("stop"), g._removePageFromDOM.call(this, a), delete b.pageObjs[a]),
                            g._movePages.call(this, a, -1),
                            (b.totalPages -= 1),
                            b.page > b.totalPages ? ((b.page = null), g._fitPage.call(this, b.totalPages)) : (g._makeRange.call(this), this.turn("update"));
                    }
                    return this;
                },
                _movePages: function (a, b) {
                    var c,
                        d = this,
                        e = this.data(),
                        h = "single" == e.display,
                        f = function (a) {
                            var c = a + b,
                                f = c % 2,
                                i = f ? " odd " : " even ";
                            e.pageObjs[a] && (e.pageObjs[c] = e.pageObjs[a].removeClass("p" + a + " odd even").addClass("p" + c + i)),
                                e.pagePlace[a] &&
                                    e.pageWrap[a] &&
                                    ((e.pagePlace[c] = c),
                                    (e.pageWrap[c] = e.pageObjs[c].hasClass("fixed") ? e.pageWrap[a].attr("page", c) : e.pageWrap[a].css(g._pageSize.call(d, c, !0)).attr("page", c)),
                                    e.pages[a] && (e.pages[c] = e.pages[a].flip("options", { page: c, next: h || f ? c + 1 : c - 1 })),
                                    b && (delete e.pages[a], delete e.pagePlace[a], delete e.pageZoom[a], delete e.pageObjs[a], delete e.pageWrap[a]));
                        };
                    if (0 < b) for (c = e.totalPages; a <= c; c--) f(c);
                    else for (c = a; c <= e.totalPages; c++) f(c);
                },
                display: function (a) {
                    var b = this.data(),
                        c = b.display;
                    if (void 0 === a) return c;
                    if (-1 == f.inArray(a, V)) throw q('"' + a + '" is not a value for display');
                    switch (a) {
                        case "single":
                            b.pageObjs[0] || (this.turn("stop").css({ overflow: "hidden" }), (b.pageObjs[0] = f("<div />", { class: "page p-temporal" }).css({ width: this.width(), height: this.height() }).appendTo(this))),
                                this.addClass("shadow");
                            break;
                        case "double":
                            b.pageObjs[0] && (this.turn("stop").css({ overflow: "" }), b.pageObjs[0].remove(), delete b.pageObjs[0]), this.removeClass("shadow");
                    }
                    return (b.display = a), c && ((a = this.turn("size")), g._movePages.call(this, 1, 0), this.turn("size", a.width, a.height).turn("update")), this;
                },
                direction: function (a) {
                    var b = this.data();
                    if (void 0 === a) return b.direction;
                    if (((a = a.toLowerCase()), -1 == f.inArray(a, W))) throw q('"' + a + '" is not a value for direction');
                    return "rtl" == a && f(this).attr("dir", "ltr").css({ direction: "ltr" }), (b.direction = a), b.done && this.turn("size", f(this).width(), f(this).height()), this;
                },
                animating: function () {
                    return 0 < this.data().pageMv.length;
                },
                corner: function () {
                    var a,
                        b,
                        c = this.data();
                    for (b in c.pages) if (n(b, c.pages) && (a = c.pages[b].flip("corner"))) return a;
                    return !1;
                },
                data: function () {
                    return this.data();
                },
                disable: function (a) {
                    var b,
                        c = this.data(),
                        d = this.turn("view");
                    for (b in ((c.disabled = void 0 === a || !0 === a), c.pages)) n(b, c.pages) && c.pages[b].flip("disable", !!c.disabled || -1 == f.inArray(parseInt(b, 10), d));
                    return this;
                },
                disabled: function (a) {
                    return void 0 === a ? !0 === this.data().disabled : this.turn("disable", a);
                },
                size: function (a, b) {
                    if (void 0 === a || void 0 === b) return { width: this.width(), height: this.height() };
                    this.turn("stop");
                    var c,
                        d,
                        e = this.data();
                    for (c in ((d = "double" == e.display ? a / 2 : a), this.css({ width: a, height: b }), e.pageObjs[0] && e.pageObjs[0].css({ width: d, height: b }), e.pageWrap))
                        n(c, e.pageWrap) && ((d = g._pageSize.call(this, c, !0)), e.pageObjs[c].css({ width: d.width, height: d.height }), e.pageWrap[c].css(d), e.pages[c] && e.pages[c].css({ width: d.width, height: d.height }));
                    return this.turn("resize"), this;
                },
                resize: function () {
                    var a,
                        b = this.data();
                    for (b.pages[0] && (b.pageWrap[0].css({ left: -this.width() }), b.pages[0].flip("resize", !0)), a = 1; a <= b.totalPages; a++) b.pages[a] && b.pages[a].flip("resize", !0);
                    g._updateShadow.call(this), b.opts.autoCenter && this.turn("center");
                },
                _removeMv: function (a) {
                    var b,
                        c = this.data();
                    for (b = 0; b < c.pageMv.length; b++) if (c.pageMv[b] == a) return c.pageMv.splice(b, 1), !0;
                    return !1;
                },
                _addMv: function (a) {
                    var b = this.data();
                    g._removeMv.call(this, a), b.pageMv.push(a);
                },
                _view: function (a) {
                    var b = this.data();
                    a = a || b.page;
                    return "double" == b.display ? (a % 2 ? [a - 1, a] : [a, a + 1]) : [a];
                },
                view: function (a) {
                    var b = this.data();
                    a = g._view.call(this, a);
                    return "double" == b.display ? [0 < a[0] ? a[0] : 0, a[1] <= b.totalPages ? a[1] : 0] : [0 < a[0] && a[0] <= b.totalPages ? a[0] : 0];
                },
                stop: function (a, b) {
                    if (this.turn("animating")) {
                        var c,
                            d,
                            e,
                            h = this.data();
                        for (h.tpage && ((h.page = h.tpage), delete h.tpage), c = 0; c < h.pageMv.length; c++)
                            h.pageMv[c] &&
                                h.pageMv[c] !== a &&
                                ((d = (e = h.pages[h.pageMv[c]]).data().f.opts), e.flip("hideFoldedPage", b), b || i._moveFoldingPage.call(e, !1), d.force && ((d.next = 0 == d.page % 2 ? d.page - 1 : d.page + 1), delete d.force));
                    }
                    return this.turn("update"), this;
                },
                pages: function (a) {
                    var b = this.data();
                    if (a) {
                        if (a < b.totalPages) for (var c = b.totalPages; a < c; c--) this.turn("removePage", c);
                        return (b.totalPages = a), g._fitPage.call(this, b.page), this;
                    }
                    return b.totalPages;
                },
                _missing: function (a) {
                    var b = this.data();
                    if (!(b.totalPages < 1)) {
                        var c = this.turn("range", a),
                            d = [];
                        for (a = c[0]; a <= c[1]; a++) b.pageObjs[a] || d.push(a);
                        0 < d.length && this.trigger("missing", [d]);
                    }
                },
                _fitPage: function (a) {
                    var b = this.data(),
                        c = this.turn("view", a);
                    if ((g._missing.call(this, a), b.pageObjs[a])) {
                        (b.page = a), this.turn("stop");
                        for (var d = 0; d < c.length; d++) c[d] && b.pageZoom[c[d]] != b.zoom && (this.trigger("zoomed", [c[d], c, b.pageZoom[c[d]], b.zoom]), (b.pageZoom[c[d]] = b.zoom));
                        g._removeFromDOM.call(this), g._makeRange.call(this), g._updateShadow.call(this), this.trigger("turned", [a, c]), this.turn("update"), b.opts.autoCenter && this.turn("center");
                    }
                },
                _turnPage: function (a) {
                    var b,
                        c,
                        d = this.data(),
                        e = d.pagePlace[a],
                        h = this.turn("view"),
                        i = this.turn("view", a);
                    if (d.page != a) {
                        var j = d.page;
                        if ("prevented" == t("turning", this, [a, i])) return void (j == d.page && -1 != f.inArray(e, d.pageMv) && d.pages[e].flip("hideFoldedPage", !0));
                        -1 != f.inArray(1, i) && this.trigger("first"), -1 != f.inArray(d.totalPages, i) && this.trigger("last");
                    }
                    "single" == d.display ? ((b = h[0]), (c = i[0])) : h[1] && a > h[1] ? ((b = h[1]), (c = i[0])) : h[0] && a < h[0] && ((b = h[0]), (c = i[1])),
                        (e = d.opts.turnCorners.split(",")),
                        (i = (h = d.pages[b].data().f).opts),
                        (j = h.point),
                        g._missing.call(this, a),
                        d.pageObjs[a] &&
                            (this.turn("stop"),
                            (d.page = a),
                            g._makeRange.call(this),
                            (d.tpage = c),
                            i.next != c && ((i.next = c), (i.force = !0)),
                            this.turn("update"),
                            (h.point = j),
                            "hard" == h.effect
                                ? "ltr" == d.direction
                                    ? d.pages[b].flip("turnPage", b < a ? "r" : "l")
                                    : d.pages[b].flip("turnPage", b < a ? "l" : "r")
                                : "ltr" == d.direction
                                ? d.pages[b].flip("turnPage", e[b < a ? 1 : 0])
                                : d.pages[b].flip("turnPage", e[b < a ? 0 : 1]));
                },
                page: function (a) {
                    var b = this.data();
                    if (void 0 === a) return b.page;
                    if (!b.disabled && !b.destroying) {
                        if (0 < (a = parseInt(a, 10)) && a <= b.totalPages) return a != b.page && (b.done && -1 == f.inArray(a, this.turn("view")) ? g._turnPage.call(this, a) : g._fitPage.call(this, a)), this;
                        throw q("The page " + a + " does not exist");
                    }
                },
                next: function () {
                    return this.turn("page", Math.min(this.data().totalPages, g._view.call(this, this.data().page).pop() + 1));
                },
                previous: function () {
                    return this.turn("page", Math.max(1, g._view.call(this, this.data().page).shift() - 1));
                },
                peel: function (a, b) {
                    var c = this.data(),
                        d = this.turn("view");
                    b = void 0 === b || !0 === b;
                    return (
                        !1 === a
                            ? this.turn("stop", null, b)
                            : "single" == c.display
                            ? c.pages[c.page].flip("peel", a, b)
                            : ((d = "ltr" == c.direction ? (-1 != a.indexOf("l") ? d[0] : d[1]) : -1 != a.indexOf("l") ? d[1] : d[0]), c.pages[d] && c.pages[d].flip("peel", a, b)),
                        this
                    );
                },
                _addMotionPage: function () {
                    var a = f(this).data().f.opts,
                        b = a.turn;
                    b.data(), g._addMv.call(b, a.page);
                },
                _eventStart: function (a, b, c) {
                    var d = b.turn.data(),
                        e = d.pageZoom[b.page];
                    a.isDefaultPrevented() ||
                        (e && e != d.zoom && (b.turn.trigger("zoomed", [b.page, b.turn.turn("view", b.page), e, d.zoom]), (d.pageZoom[b.page] = d.zoom)),
                        "single" == d.display &&
                            c &&
                            (("l" == c.charAt(1) && "ltr" == d.direction) || ("r" == c.charAt(1) && "rtl" == d.direction)
                                ? ((b.next = b.next < b.page ? b.next : b.page - 1), (b.force = !0))
                                : (b.next = b.next > b.page ? b.next : b.page + 1)),
                        g._addMotionPage.call(a.target)),
                        g._updateShadow.call(b.turn);
                },
                _eventEnd: function (a, b, c) {
                    f(a.target).data();
                    var d = (a = b.turn).data();
                    c ? ((c = d.tpage || d.page) != b.next && c != b.page) || (delete d.tpage, g._fitPage.call(a, c || b.next, !0)) : (g._removeMv.call(a, b.page), g._updateShadow.call(a), a.turn("update"));
                },
                _eventPressed: function (a) {
                    var b = (a = f(a.target).data().f).opts.turn;
                    return (b.data().mouseAction = !0), b.turn("update"), (a.time = new Date().getTime());
                },
                _eventReleased: function (a, b) {
                    var c,
                        d = (c = f(a.target)).data().f,
                        e = d.opts.turn,
                        h = e.data();
                    (c = "single" == h.display ? ("br" == b.corner || "tr" == b.corner ? b.x < c.width() / 2 : b.x > c.width() / 2) : b.x < 0 || b.x > c.width()),
                        (new Date().getTime() - d.time < 200 || c) && (a.preventDefault(), g._turnPage.call(e, d.opts.next)),
                        (h.mouseAction = !1);
                },
                _flip: function (a) {
                    a.stopPropagation(), (a = f(a.target).data().f.opts).turn.trigger("turn", [a.next]), a.turn.data().opts.autoCenter && a.turn.turn("center", a.next);
                },
                _touchStart: function () {
                    var b,
                        a = this.data();
                    for (b in a.pages) if (n(b, a.pages) && !1 === i._eventStart.apply(a.pages[b], arguments)) return !1;
                },
                _touchMove: function () {
                    var b,
                        a = this.data();
                    for (b in a.pages) n(b, a.pages) && i._eventMove.apply(a.pages[b], arguments);
                },
                _touchEnd: function () {
                    var b,
                        a = this.data();
                    for (b in a.pages) n(b, a.pages) && i._eventEnd.apply(a.pages[b], arguments);
                },
                calculateZ: function (a) {
                    function k(a) {
                        (a = h.turn("view", a))[0] && (j.pageV[a[0]] = !0), a[1] && (j.pageV[a[1]] = !0);
                    }
                    var b,
                        c,
                        d,
                        e,
                        h = this,
                        f = this.data(),
                        i = (b = this.turn("view"))[0] || b[1],
                        g = a.length - 1,
                        j = { pageZ: {}, partZ: {}, pageV: {} };
                    for (b = 0; b <= g; b++)
                        (c = a[b]), (d = f.pages[c].data().f.opts.next), (e = f.pagePlace[c]), k(c), k(d), (c = f.pagePlace[d] == d ? d : c), (j.pageZ[c] = f.totalPages - Math.abs(i - c)), (j.partZ[e] = 2 * f.totalPages - g + b);
                    return j;
                },
                update: function () {
                    var a,
                        b = this.data();
                    if (this.turn("animating") && 0 !== b.pageMv[0]) {
                        var c,
                            d = this.turn("calculateZ", b.pageMv),
                            e = this.turn("corner"),
                            h = this.turn("view"),
                            i = this.turn("view", b.tpage);
                        for (a in b.pageWrap)
                            n(a, b.pageWrap) &&
                                ((c = b.pageObjs[a].hasClass("fixed")), b.pageWrap[a].css({ display: d.pageV[a] || c ? "" : "none", zIndex: (b.pageObjs[a].hasClass("hard") ? d.partZ[a] : d.pageZ[a]) || (c ? -1 : 0) }), (c = b.pages[a])) &&
                                (c.flip("z", d.partZ[a] || null),
                                d.pageV[a] && c.flip("resize"),
                                b.tpage ? c.flip("hover", !1).flip("disable", -1 == f.inArray(parseInt(a, 10), b.pageMv) && a != i[0] && a != i[1]) : c.flip("hover", !1 === e).flip("disable", a != h[0] && a != h[1]));
                    } else
                        for (a in b.pageWrap)
                            n(a, b.pageWrap) &&
                                ((d = g._setPageLoc.call(this, a)),
                                b.pages[a] &&
                                    b.pages[a]
                                        .flip("disable", b.disabled || 1 != d)
                                        .flip("hover", !0)
                                        .flip("z", null));
                    return this;
                },
                _updateShadow: function () {
                    var a,
                        b,
                        c = this.data(),
                        d = this.width(),
                        e = this.height(),
                        h = "single" == c.display ? d : d / 2;
                    (a = this.turn("view")), c.shadow || (c.shadow = f("<div />", { class: "shadow", css: l(0, 0, 0).css }).appendTo(this));
                    for (var i = 0; i < c.pageMv.length && a[0] && a[1]; i++) (a = this.turn("view", c.pages[c.pageMv[i]].data().f.opts.next)), (b = this.turn("view", c.pageMv[i])), (a[0] = a[0] && b[0]), (a[1] = a[1] && b[1]);
                    switch (a[0] ? (a[1] ? 3 : "ltr" == c.direction ? 2 : 1) : "ltr" == c.direction ? 1 : 2) {
                        case 1:
                            c.shadow.css({ width: h, height: e, top: 0, left: h });
                            break;
                        case 2:
                            c.shadow.css({ width: h, height: e, top: 0, left: 0 });
                            break;
                        case 3:
                            c.shadow.css({ width: d, height: e, top: 0, left: 0 });
                    }
                },
                _setPageLoc: function (a) {
                    var b = this.data(),
                        c = this.turn("view"),
                        d = 0;
                    if ((a == c[0] || a == c[1] ? (d = 1) : (("single" == b.display && a == c[0] + 1) || ("double" == b.display && a == c[0] - 2) || a == c[1] + 2) && (d = 2), !this.turn("animating")))
                        switch (d) {
                            case 1:
                                b.pageWrap[a].css({ zIndex: b.totalPages, display: "" });
                                break;
                            case 2:
                                b.pageWrap[a].css({ zIndex: b.totalPages - 1, display: "" });
                                break;
                            case 0:
                                b.pageWrap[a].css({ zIndex: 0, display: b.pageObjs[a].hasClass("fixed") ? "" : "none" });
                        }
                    return d;
                },
                options: function (a) {
                    if (void 0 === a) return this.data().opts;
                    var b = this.data();
                    if (
                        (f.extend(b.opts, a),
                        a.pages && this.turn("pages", a.pages),
                        a.page && this.turn("page", a.page),
                        a.display && this.turn("display", a.display),
                        a.direction && this.turn("direction", a.direction),
                        a.width && a.height && this.turn("size", a.width, a.height),
                        a.when)
                    )
                        for (var c in a.when) n(c, a.when) && this.unbind(c).bind(c, a.when[c]);
                    return this;
                },
                version: function () {
                    return "4.1.0";
                },
            },
            i = {
                init: function (a) {
                    return this.data({ f: { disabled: !1, hover: !1, effect: this.hasClass("hard") ? "hard" : "sheet" } }), this.flip("options", a), i._addPageWrapper.call(this), this;
                },
                setData: function (a) {
                    var b = this.data();
                    return (b.f = f.extend(b.f, a)), this;
                },
                options: function (a) {
                    var b = this.data().f;
                    return a ? (i.setData.call(this, { opts: f.extend({}, b.opts || Y, a) }), this) : b.opts;
                },
                z: function (a) {
                    var b = this.data().f;
                    return (b.opts["z-index"] = a), b.fwrapper && b.fwrapper.css({ zIndex: a || parseInt(b.parent.css("z-index"), 10) || 0 }), this;
                },
                _cAllowed: function () {
                    var a = this.data().f,
                        b = a.opts.page,
                        c = a.opts.turn.data(),
                        d = b % 2;
                    return "hard" == a.effect
                        ? "ltr" == c.direction
                            ? [d ? "r" : "l"]
                            : [d ? "l" : "r"]
                        : "single" == c.display
                        ? 1 == b
                            ? "ltr" == c.direction
                                ? p.forward
                                : p.backward
                            : b == c.totalPages
                            ? "ltr" == c.direction
                                ? p.backward
                                : p.forward
                            : p.all
                        : "ltr" == c.direction
                        ? p[d ? "forward" : "backward"]
                        : p[d ? "backward" : "forward"];
                },
                _cornerActivated: function (a) {
                    var b = this.data().f,
                        c = this.width(),
                        d = this.height(),
                        e = ((a = { x: a.x, y: a.y, corner: "" }), b.opts.cornerSize);
                    if (a.x <= 0 || a.y <= 0 || a.x >= c || a.y >= d) return !1;
                    var h = i._cAllowed.call(this);
                    switch (b.effect) {
                        case "hard":
                            if (a.x > c - e) a.corner = "r";
                            else {
                                if (!(a.x < e)) return !1;
                                a.corner = "l";
                            }
                            break;
                        case "sheet":
                            if (a.y < e) a.corner += "t";
                            else {
                                if (!(a.y >= d - e)) return !1;
                                a.corner += "b";
                            }
                            if (a.x <= e) a.corner += "l";
                            else {
                                if (!(a.x >= c - e)) return !1;
                                a.corner += "r";
                            }
                    }
                    return !(!a.corner || -1 == f.inArray(a.corner, h)) && a;
                },
                _isIArea: function (a) {
                    var b = this.data().f.parent.offset();
                    a = u && a.originalEvent ? a.originalEvent.touches[0] : a;
                    return i._cornerActivated.call(this, { x: a.pageX - b.left, y: a.pageY - b.top });
                },
                _c: function (a, b) {
                    switch (((b = b || 0), a)) {
                        case "tl":
                            return j(b, b);
                        case "tr":
                            return j(this.width() - b, b);
                        case "bl":
                            return j(b, this.height() - b);
                        case "br":
                            return j(this.width() - b, this.height() - b);
                        case "l":
                            return j(b, 0);
                        case "r":
                            return j(this.width() - b, 0);
                    }
                },
                _c2: function (a) {
                    switch (a) {
                        case "tl":
                            return j(2 * this.width(), 0);
                        case "tr":
                            return j(-this.width(), 0);
                        case "bl":
                            return j(2 * this.width(), this.height());
                        case "br":
                            return j(-this.width(), this.height());
                        case "l":
                            return j(2 * this.width(), 0);
                        case "r":
                            return j(-this.width(), 0);
                    }
                },
                _foldingPage: function () {
                    var a = this.data().f;
                    if (a) {
                        var b = a.opts;
                        if (b.turn) return "single" == (a = b.turn.data()).display ? (1 < b.next || 1 < b.page ? a.pageObjs[0] : null) : a.pageObjs[b.next];
                    }
                },
                _backGradient: function () {
                    var a = this.data().f,
                        b = a.opts.turn.data();
                    return (
                        (b = b.opts.gradients && ("single" == b.display || (2 != a.opts.page && a.opts.page != b.totalPages - 1))) &&
                            !a.bshadow &&
                            (a.bshadow = f("<div/>", l(0, 0, 1)).css({ position: "", width: this.width(), height: this.height() }).appendTo(a.parent)),
                        b
                    );
                },
                type: function () {
                    return this.data().f.effect;
                },
                resize: function (a) {
                    var b = this.data().f,
                        c = b.opts.turn.data(),
                        d = this.width(),
                        e = this.height();
                    switch (b.effect) {
                        case "hard":
                            a && (b.wrapper.css({ width: d, height: e }), b.fpage.css({ width: d, height: e }), c.opts.gradients && (b.ashadow.css({ width: d, height: e }), b.bshadow.css({ width: d, height: e })));
                            break;
                        case "sheet":
                            a &&
                                ((a = Math.round(Math.sqrt(Math.pow(d, 2) + Math.pow(e, 2)))),
                                b.wrapper.css({ width: a, height: a }),
                                b.fwrapper.css({ width: a, height: a }).children(":first-child").css({ width: d, height: e }),
                                b.fpage.css({ width: d, height: e }),
                                c.opts.gradients && b.ashadow.css({ width: d, height: e }),
                                i._backGradient.call(this) && b.bshadow.css({ width: d, height: e })),
                                b.parent.is(":visible") && ((c = D(b.parent[0])), b.fwrapper.css({ top: c.top, left: c.left }), (c = D(b.opts.turn[0])), b.fparent.css({ top: -c.top, left: -c.left })),
                                this.flip("z", b.opts["z-index"]);
                    }
                },
                _addPageWrapper: function () {
                    var a = this.data().f,
                        b = a.opts.turn.data(),
                        c = this.parent();
                    if (((a.parent = c), !a.wrapper))
                        switch (a.effect) {
                            case "hard":
                                ((d = {})[w + "transform-style"] = "preserve-3d"),
                                    (d[w + "backface-visibility"] = "hidden"),
                                    (a.wrapper = f("<div/>", l(0, 0, 2)).css(d).appendTo(c).prepend(this)),
                                    (a.fpage = f("<div/>", l(0, 0, 1)).css(d).appendTo(c)),
                                    b.opts.gradients && ((a.ashadow = f("<div/>", l(0, 0, 0)).hide().appendTo(c)), (a.bshadow = f("<div/>", l(0, 0, 0))));
                                break;
                            case "sheet":
                                var d = this.width(),
                                    e = this.height();
                                Math.round(Math.sqrt(Math.pow(d, 2) + Math.pow(e, 2))),
                                    (a.fparent = a.opts.turn.data().fparent),
                                    a.fparent ||
                                        (((d = f("<div/>", { css: { "pointer-events": "none" } }).hide()).data().flips = 0), d.css(l(0, 0, "auto", "visible").css).appendTo(a.opts.turn), (a.opts.turn.data().fparent = d), (a.fparent = d)),
                                    this.css({ position: "absolute", top: 0, left: 0, bottom: "auto", right: "auto" }),
                                    (a.wrapper = f("<div/>", l(0, 0, this.css("z-index")))
                                        .appendTo(c)
                                        .prepend(this)),
                                    (a.fwrapper = f("<div/>", l(c.offset().top, c.offset().left)).hide().appendTo(a.fparent)),
                                    (a.fpage = f("<div/>", l(0, 0, 0, "visible")).css({ cursor: "default" }).appendTo(a.fwrapper)),
                                    b.opts.gradients && (a.ashadow = f("<div/>", l(0, 0, 1)).appendTo(a.fpage)),
                                    i.setData.call(this, a);
                        }
                    i.resize.call(this, !0);
                },
                _fold: function (a) {
                    var b = this.data().f,
                        c = b.opts.turn.data(),
                        d = i._c.call(this, a.corner),
                        e = this.width(),
                        h = this.height();
                    switch (b.effect) {
                        case "hard":
                            a.x = "l" == a.corner ? Math.min(Math.max(a.x, 0), 2 * e) : Math.max(Math.min(a.x, e), -e);
                            var f,
                                g,
                                s,
                                x,
                                k,
                                n = c.totalPages,
                                l = b.opts["z-index"] || n,
                                q = { overflow: "visible" },
                                p = d.x ? (d.x - a.x) / e : a.x / e,
                                r = 90 * p,
                                t = r < 90;
                            switch (a.corner) {
                                case "l":
                                    (x = "0% 50%"), (k = "100% 50%"), (s = t ? ((g = (f = 0) < b.opts.next - 1), 1) : ((f = "100%"), (g = b.opts.page + 1 < n), 0));
                                    break;
                                case "r":
                                    (x = "100% 50%"), (k = "0% 50%"), (r = -r), (e = -e), (s = t ? ((f = 0), (g = b.opts.next + 1 < n), 0) : ((f = "-100%"), (g = 1 != b.opts.page), 1));
                            }
                            (q[w + "perspective-origin"] = k),
                                b.wrapper.transform("rotateY(" + r + "deg)translate3d(0px, 0px, " + (this.attr("depth") || 0) + "px)", k),
                                b.fpage.transform("translateX(" + e + "px) rotateY(" + (180 + r) + "deg)", x),
                                b.parent.css(q),
                                t ? ((p = 1 - p), b.wrapper.css({ zIndex: l + 1 }), b.fpage.css({ zIndex: l })) : ((p -= 1), b.wrapper.css({ zIndex: l }), b.fpage.css({ zIndex: l + 1 })),
                                c.opts.gradients &&
                                    (g ? b.ashadow.css({ display: "", left: f, backgroundColor: "rgba(0,0,0," + 0.5 * p + ")" }).transform("rotateY(0deg)") : b.ashadow.hide(),
                                    b.bshadow.css({ opacity: 1 - p }),
                                    t ? b.bshadow.parent()[0] != b.wrapper[0] && b.bshadow.appendTo(b.wrapper) : b.bshadow.parent()[0] != b.fpage[0] && b.bshadow.appendTo(b.fpage),
                                    P(
                                        b.bshadow,
                                        j(100 * s, 0),
                                        j(100 * (1 - s), 0),
                                        [
                                            [0, "rgba(0,0,0,0.3)"],
                                            [1, "rgba(0,0,0,0)"],
                                        ],
                                        2
                                    ));
                            break;
                        case "sheet":
                            var z,
                                A,
                                B,
                                M,
                                y,
                                N,
                                D,
                                u = this,
                                H = 0,
                                v = j(0, 0),
                                Q = j(0, 0),
                                m = j(0, 0),
                                J = i._foldingPage.call(this);
                            Math.tan(0);
                            var O = c.opts.acceleration,
                                R = b.wrapper.height(),
                                E = "t" == a.corner.substr(0, 1),
                                C = "l" == a.corner.substr(1, 1),
                                I = function () {
                                    var b = j(0, 0),
                                        f = j(0, 0);
                                    (b.x = d.x ? d.x - a.x : a.x), (b.y = U ? (d.y ? d.y - a.y : a.y) : 0), (f.x = C ? e - b.x / 2 : a.x + b.x / 2), (f.y = b.y / 2);
                                    var g = L - Math.atan2(b.y, b.x),
                                        k = g - Math.atan2(f.y, f.x);
                                    k = Math.max(0, Math.sin(k) * Math.sqrt(Math.pow(f.x, 2) + Math.pow(f.y, 2)));
                                    return (
                                        (H = (g / K) * 180),
                                        (m = j(k * Math.sin(g), k * Math.cos(g))),
                                        L < g && ((m.x += Math.abs((m.y * b.y) / b.x)), (m.y = 0), Math.round(m.x * Math.tan(K - g)) < h)
                                            ? ((a.y = Math.sqrt(Math.pow(h, 2) + 2 * f.x * b.x)), E && (a.y = h - a.y), I())
                                            : (L < g && ((b = K - g), (f = R - h / Math.sin(b)), (v = j(Math.round(f * Math.cos(b)), Math.round(f * Math.sin(b)))), C && (v.x = -v.x), E && (v.y = -v.y)),
                                              (z = Math.round(m.y / Math.tan(g) + m.x)),
                                              (f = (b = e - z) * Math.cos(2 * g)),
                                              (k = b * Math.sin(2 * g)),
                                              (Q = j(Math.round(C ? b - f : z + f), Math.round(E ? k : h - k))),
                                              c.opts.gradients &&
                                                  ((y = b * Math.sin(g)),
                                                  (b = i._c2.call(u, a.corner)),
                                                  (b = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2)) / e),
                                                  (D = Math.sin(L * (1 < b ? 2 - b : b))),
                                                  (N = Math.min(b, 1)),
                                                  (M = 100 < y ? (y - 100) / y : 0),
                                                  (A = j(((y * Math.sin(g)) / e) * 100, ((y * Math.cos(g)) / h) * 100)),
                                                  i._backGradient.call(u) && ((B = j(((1.2 * y * Math.sin(g)) / e) * 100, ((1.2 * y * Math.cos(g)) / h) * 100)), C || (B.x = 100 - B.x), E || (B.y = 100 - B.y))),
                                              (m.x = Math.round(m.x)),
                                              (m.y = Math.round(m.y)),
                                              !0)
                                    );
                                };
                            switch (
                                ((f = function (a, d, f, g) {
                                    var k = ["0", "auto"],
                                        m = ((e - R) * f[0]) / 100,
                                        l = ((h - R) * f[1]) / 100,
                                        n = ((d = { left: k[d[0]], top: k[d[1]], right: k[d[2]], bottom: k[d[3]] }), (k = {}), 90 != g && -90 != g ? (C ? -1 : 1) : 0),
                                        s = f[0] + "% " + f[1] + "%";
                                    u.css(d).transform(G(g) + F(a.x + n, a.y, O), s),
                                        b.fpage.css(d).transform(G(g) + F(a.x + Q.x - v.x - (e * f[0]) / 100, a.y + Q.y - v.y - (h * f[1]) / 100, O) + G((180 / g - 2) * g), s),
                                        b.wrapper.transform(F(-a.x + m - n, -a.y + l, O) + G(-g), s),
                                        b.fwrapper.transform(F(-a.x + v.x + m, -a.y + v.y + l, O) + G(-g), s),
                                        c.opts.gradients &&
                                            (f[0] && (A.x = 100 - A.x),
                                            f[1] && (A.y = 100 - A.y),
                                            (k["box-shadow"] = "0 0 20px rgba(0,0,0," + 0.5 * D + ")"),
                                            J.css(k),
                                            P(
                                                b.ashadow,
                                                j(C ? 100 : 0, E ? 0 : 100),
                                                j(A.x, A.y),
                                                [
                                                    [M, "rgba(0,0,0,0)"],
                                                    [0.8 * (1 - M) + M, "rgba(0,0,0," + 0.2 * N + ")"],
                                                    [1, "rgba(255,255,255," + 0.2 * N + ")"],
                                                ],
                                                3
                                            ),
                                            i._backGradient.call(u) &&
                                                P(
                                                    b.bshadow,
                                                    j(C ? 0 : 100, E ? 0 : 100),
                                                    j(B.x, B.y),
                                                    [
                                                        [0.6, "rgba(0,0,0,0)"],
                                                        [0.8, "rgba(0,0,0," + 0.3 * N + ")"],
                                                        [1, "rgba(0,0,0,0)"],
                                                    ],
                                                    3
                                                ));
                                }),
                                a.corner)
                            ) {
                                case "tl":
                                    (a.x = Math.max(a.x, 1)), I(), f(m, [1, 0, 0, 1], [100, 0], H);
                                    break;
                                case "tr":
                                    (a.x = Math.min(a.x, e - 1)), I(), f(j(-m.x, m.y), [0, 0, 0, 1], [0, 0], -H);
                                    break;
                                case "bl":
                                    (a.x = Math.max(a.x, 1)), I(), f(j(m.x, -m.y), [1, 1, 0, 0], [100, 100], -H);
                                    break;
                                case "br":
                                    (a.x = Math.min(a.x, e - 1)), I(), f(j(-m.x, -m.y), [0, 1, 1, 0], [0, 100], H);
                            }
                    }
                    b.point = a;
                },
                _moveFoldingPage: function (a) {
                    var b = this.data().f;
                    if (b) {
                        var c = b.opts.turn,
                            d = c.data(),
                            e = d.pagePlace;
                        a
                            ? (e[(d = b.opts.next)] != b.opts.page && (b.folding && i._moveFoldingPage.call(this, !1), i._foldingPage.call(this).appendTo(b.fpage), (e[d] = b.opts.page), (b.folding = d)), c.turn("update"))
                            : b.folding &&
                              (d.pages[b.folding] ? ((c = d.pages[b.folding].data().f), d.pageObjs[b.folding].appendTo(c.wrapper)) : d.pageWrap[b.folding] && d.pageObjs[b.folding].appendTo(d.pageWrap[b.folding]),
                              b.folding in e && (e[b.folding] = b.folding),
                              delete b.folding);
                    }
                },
                _showFoldedPage: function (a, b) {
                    var c = i._foldingPage.call(this),
                        e = (d = this.data()).f,
                        f = e.visible;
                    if (c) {
                        if (!((f && e.point && e.point.corner == a.corner) || ((c = "hover" == e.status || "peel" == e.status || e.opts.turn.data().mouseAction ? a.corner : null), (f = !1), "prevented" != t("start", this, [e.opts, c]))))
                            return !1;
                        if (b) {
                            var g = this,
                                d = e.point && e.point.corner == a.corner ? e.point : i._c.call(this, a.corner, 1);
                            this.animatef({
                                from: [d.x, d.y],
                                to: [a.x, a.y],
                                duration: 500,
                                frame: function (b) {
                                    (a.x = Math.round(b[0])), (a.y = Math.round(b[1])), i._fold.call(g, a);
                                },
                            });
                        } else i._fold.call(this, a), d.effect && !d.effect.turning && this.animatef(!1);
                        if (!f)
                            switch (e.effect) {
                                case "hard":
                                    (e.visible = !0), i._moveFoldingPage.call(this, !0), e.fpage.show(), e.opts.shadows && e.bshadow.show();
                                    break;
                                case "sheet":
                                    (e.visible = !0), e.fparent.show().data().flips++, i._moveFoldingPage.call(this, !0), e.fwrapper.show(), e.bshadow && e.bshadow.show();
                            }
                        return !0;
                    }
                    return !1;
                },
                hide: function () {
                    var a = this.data().f,
                        b = a.opts.turn.data(),
                        c = i._foldingPage.call(this);
                    switch (a.effect) {
                        case "hard":
                            b.opts.gradients && ((a.bshadowLoc = 0), a.bshadow.remove(), a.ashadow.hide()), a.wrapper.transform(""), a.fpage.hide();
                            break;
                        case "sheet":
                            0 == --a.fparent.data().flips && a.fparent.hide(),
                                this.css({ left: 0, top: 0, right: "auto", bottom: "auto" }).transform(""),
                                a.wrapper.transform(""),
                                a.fwrapper.hide(),
                                a.bshadow && a.bshadow.hide(),
                                c.transform("");
                    }
                    return (a.visible = !1), this;
                },
                hideFoldedPage: function (a) {
                    var b = this.data().f;
                    if (b.point) {
                        function e() {
                            (b.point = null), (b.status = ""), c.flip("hide"), c.trigger("end", [b.opts, !1]);
                        }
                        var c = this,
                            d = b.point;
                        if (a) {
                            var f = i._c.call(this, d.corner),
                                g = ((a = "t" == d.corner.substr(0, 1) ? Math.min(0, d.y - f.y) / 2 : Math.max(0, d.y - f.y) / 2), j(d.x, d.y + a)),
                                l = j(f.x, f.y - a);
                            this.animatef({
                                from: 0,
                                to: 1,
                                frame: function (a) {
                                    (a = S(d, g, l, f, a)), (d.x = a.x), (d.y = a.y), i._fold.call(c, d);
                                },
                                complete: e,
                                duration: 800,
                                hiding: !0,
                            });
                        } else this.animatef(!1), e();
                    }
                },
                turnPage: function (a) {
                    var b = this,
                        c = this.data().f,
                        d = c.opts.turn.data(),
                        e = ((a = { corner: c.corner ? c.corner.corner : a || i._cAllowed.call(this)[0] }), c.point || i._c.call(this, a.corner, c.opts.turn ? d.opts.elevation : 0)),
                        f = i._c2.call(this, a.corner);
                    this.trigger("flip").animatef({
                        from: 0,
                        to: 1,
                        frame: function (c) {
                            (c = S(e, e, f, f, c)), (a.x = c.x), (a.y = c.y), i._showFoldedPage.call(b, a);
                        },
                        complete: function () {
                            b.trigger("end", [c.opts, !0]);
                        },
                        duration: d.opts.duration,
                        turning: !0,
                    }),
                        (c.corner = null);
                },
                moving: function () {
                    return "effect" in this.data();
                },
                isTurning: function () {
                    return this.flip("moving") && this.data().effect.turning;
                },
                corner: function () {
                    return this.data().f.corner;
                },
                _eventStart: function (a) {
                    var b = this.data().f,
                        c = b.opts.turn;
                    if (!b.corner && !b.disabled && !this.flip("isTurning") && b.opts.page == c.data().pagePlace[b.opts.page]) {
                        if (((b.corner = i._isIArea.call(this, a)), b.corner && i._foldingPage.call(this))) return this.trigger("pressed", [b.point]), i._showFoldedPage.call(this, b.corner), !1;
                        b.corner = null;
                    }
                },
                _eventMove: function (a) {
                    var b = this.data().f;
                    if (!b.disabled)
                        if (((a = u ? a.originalEvent.touches : [a]), b.corner)) {
                            var c = b.parent.offset();
                            (b.corner.x = a[0].pageX - c.left), (b.corner.y = a[0].pageY - c.top), i._showFoldedPage.call(this, b.corner);
                        } else
                            b.hover &&
                                !this.data().effect &&
                                this.is(":visible") &&
                                ((a = i._isIArea.call(this, a[0]))
                                    ? (("sheet" == b.effect && 2 == a.corner.length) || "hard" == b.effect) &&
                                      ((b.status = "hover"), (b = i._c.call(this, a.corner, b.opts.cornerSize / 2)), (a.x = b.x), (a.y = b.y), i._showFoldedPage.call(this, a, !0))
                                    : "hover" == b.status && ((b.status = ""), i.hideFoldedPage.call(this, !0)));
                },
                _eventEnd: function () {
                    var a = this.data().f,
                        b = a.corner;
                    !a.disabled && b && "prevented" != t("released", this, [a.point || b]) && i.hideFoldedPage.call(this, !0), (a.corner = null);
                },
                disable: function (a) {
                    return i.setData.call(this, { disabled: a }), this;
                },
                hover: function (a) {
                    return i.setData.call(this, { hover: a }), this;
                },
                peel: function (a, b) {
                    var c = this.data().f;
                    if (a) {
                        if (-1 == f.inArray(a, p.all)) throw q("Corner " + a + " is not permitted");
                        if (-1 != f.inArray(a, i._cAllowed.call(this))) {
                            var d = i._c.call(this, a, c.opts.cornerSize / 2);
                            (c.status = "peel"), i._showFoldedPage.call(this, { corner: a, x: d.x, y: d.y }, b);
                        }
                    } else (c.status = ""), i.hideFoldedPage.call(this, b);
                    return this;
                },
            };
        (window.requestAnim =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (a) {
                window.setTimeout(a, 1e3 / 60);
            }),
            f.extend(f.fn, {
                flip: function () {
                    return J(f(this[0]), i, arguments);
                },
                turn: function () {
                    return J(f(this[0]), g, arguments);
                },
                transform: function (a, b) {
                    var c = {};
                    return b && (c[w + "transform-origin"] = b), (c[w + "transform"] = a), this.css(c);
                },
                animatef: function (a) {
                    var b = this.data();
                    if ((b.effect && b.effect.stop(), a)) {
                        a.to.length || (a.to = [a.to]), a.from.length || (a.from = [a.from]);
                        for (
                            var c = [],
                                d = a.to.length,
                                e = !0,
                                g = this,
                                i = new Date().getTime(),
                                j = function () {
                                    if (b.effect && e) {
                                        for (var f = [], k = Math.min(a.duration, new Date().getTime() - i), l = 0; l < d; l++) f.push(b.effect.easing(1, k, a.from[l], c[l], a.duration));
                                        a.frame(1 == d ? f[0] : f), k == a.duration ? (delete b.effect, g.data(b), a.complete && a.complete()) : window.requestAnim(j);
                                    }
                                },
                                l = 0;
                            l < d;
                            l++
                        )
                            c.push(a.to[l] - a.from[l]);
                        (b.effect = f.extend(
                            {
                                stop: function () {
                                    e = !1;
                                },
                                easing: function (a, b, c, d, e) {
                                    return d * Math.sqrt(1 - (b = b / e - 1) * b) + c;
                                },
                            },
                            a
                        )),
                            this.data(b),
                            j();
                    } else delete b.effect;
                },
            }),
            (f.isTouch = u),
            (f.mouseEvents = r),
            (f.cssPrefix = T),
            (f.cssTransitionEnd = function () {
                var a,
                    b = document.createElement("fakeelement"),
                    c = { transition: "transitionend", OTransition: "oTransitionEnd", MSTransition: "transitionend", MozTransition: "transitionend", WebkitTransition: "webkitTransitionEnd" };
                for (a in c) if (void 0 !== b.style[a]) return c[a];
            }),
            (f.findPos = D);
    })(jQuery),
    "function" != typeof Object.create &&
        (Object.create = function (obj) {
            function F() {}
            return (F.prototype = obj), new F();
        }),
    (function ($) {
        var ElevateZoom = {
            init: function (options, elem) {
                var self = this;
                (self.elem = elem),
                    (self.$elem = $(elem)),
                    (self.imageSrc = self.$elem.data("zoom-image") ? self.$elem.data("zoom-image") : self.$elem.attr("src")),
                    (self.options = $.extend({}, $.fn.elevateZoom.options, options)),
                    self.options.tint && ((self.options.lensColour = "none"), (self.options.lensOpacity = "1")),
                    "inner" == self.options.zoomType && (self.options.showLens = !1),
                    self.$elem.parent().removeAttr("title").removeAttr("alt"),
                    (self.zoomImage = self.imageSrc),
                    self.refresh(1),
                    $("#" + self.options.gallery + " a").click(function (e) {
                        return (
                            self.options.galleryActiveClass && ($("#" + self.options.gallery + " a").removeClass(self.options.galleryActiveClass), $(this).addClass(self.options.galleryActiveClass)),
                            e.preventDefault(),
                            $(this).data("zoom-image") ? (self.zoomImagePre = $(this).data("zoom-image")) : (self.zoomImagePre = $(this).data("image")),
                            self.swaptheimage($(this).data("image"), self.zoomImagePre),
                            !1
                        );
                    });
            },
            refresh: function (length) {
                var self = this;
                setTimeout(function () {
                    self.fetch(self.imageSrc);
                }, length || self.options.refresh);
            },
            fetch: function (imgsrc) {
                var self = this,
                    newImg = new Image();
                (newImg.onload = function () {
                    (self.largeWidth = newImg.width), (self.largeHeight = newImg.height), self.startZoom(), (self.currentImage = self.imageSrc), self.options.onZoomedImageLoaded(self.$elem);
                }),
                    (newImg.src = imgsrc);
            },
            startZoom: function () {
                var self = this;
                if (
                    ((self.nzWidth = self.$elem.width()),
                    (self.nzHeight = self.$elem.height()),
                    (self.isWindowActive = !1),
                    (self.isLensActive = !1),
                    (self.isTintActive = !1),
                    (self.overWindow = !1),
                    self.options.imageCrossfade && ((self.zoomWrap = self.$elem.wrap('<div style="height:' + self.nzHeight + "px;width:" + self.nzWidth + 'px;" class="zoomWrapper" />')), self.$elem.css("position", "absolute")),
                    (self.zoomLock = 1),
                    (self.scrollingLock = !1),
                    (self.changeBgSize = !1),
                    (self.currentZoomLevel = self.options.zoomLevel),
                    (self.nzOffset = self.$elem.offset()),
                    (self.widthRatio = self.largeWidth / self.currentZoomLevel / self.nzWidth),
                    (self.heightRatio = self.largeHeight / self.currentZoomLevel / self.nzHeight),
                    "window" == self.options.zoomType &&
                        (self.zoomWindowStyle =
                            "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " +
                            String(self.options.zoomWindowBgColour) +
                            ";width: " +
                            String(self.options.zoomWindowWidth) +
                            "px;height: " +
                            String(self.options.zoomWindowHeight) +
                            "px;float: left;background-size: " +
                            self.largeWidth / self.currentZoomLevel +
                            "px " +
                            self.largeHeight / self.currentZoomLevel +
                            "px;display: none;z-index:100;border: " +
                            String(self.options.borderSize) +
                            "px solid " +
                            self.options.borderColour +
                            ";background-repeat: no-repeat;position: absolute;"),
                    "inner" == self.options.zoomType)
                ) {
                    var borderWidth = self.$elem.css("border-left-width");
                    self.zoomWindowStyle =
                        "overflow: hidden;margin-left: " +
                        String(borderWidth) +
                        ";margin-top: " +
                        String(borderWidth) +
                        ";background-position: 0px 0px;width: " +
                        String(self.nzWidth) +
                        "px;height: " +
                        String(self.nzHeight) +
                        "px;px;float: left;display: none;cursor:" +
                        self.options.cursor +
                        ";px solid " +
                        self.options.borderColour +
                        ";background-repeat: no-repeat;position: absolute;";
                }
                "window" == self.options.zoomType &&
                    (self.nzHeight < self.options.zoomWindowWidth / self.widthRatio ? (lensHeight = self.nzHeight) : (lensHeight = String(self.options.zoomWindowHeight / self.heightRatio)),
                    self.largeWidth < self.options.zoomWindowWidth ? (lensWidth = self.nzWidth) : (lensWidth = self.options.zoomWindowWidth / self.widthRatio),
                    (self.lensStyle =
                        "background-position: 0px 0px;width: " +
                        String(self.options.zoomWindowWidth / self.widthRatio) +
                        "px;height: " +
                        String(self.options.zoomWindowHeight / self.heightRatio) +
                        "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" +
                        self.options.lensOpacity +
                        ";filter: alpha(opacity = " +
                        100 * self.options.lensOpacity +
                        "); zoom:1;width:" +
                        lensWidth +
                        "px;height:" +
                        lensHeight +
                        "px;background-color:" +
                        self.options.lensColour +
                        ";cursor:" +
                        self.options.cursor +
                        ";border: " +
                        self.options.lensBorderSize +
                        "px solid " +
                        self.options.lensBorderColour +
                        ";background-repeat: no-repeat;position: absolute;")),
                    (self.tintStyle = "display: block;position: absolute;background-color: " + self.options.tintColour + ";filter:alpha(opacity=0);opacity: 0;width: " + self.nzWidth + "px;height: " + self.nzHeight + "px;"),
                    (self.lensRound = ""),
                    "lens" == self.options.zoomType &&
                        (self.lensStyle =
                            "background-position: 0px 0px;float: left;display: none;border: " +
                            String(self.options.borderSize) +
                            "px solid " +
                            self.options.borderColour +
                            ";width:" +
                            String(self.options.lensSize) +
                            "px;height:" +
                            String(self.options.lensSize) +
                            "px;background-repeat: no-repeat;position: absolute;"),
                    "round" == self.options.lensShape &&
                        (self.lensRound =
                            "border-top-left-radius: " +
                            String(self.options.lensSize / 2 + self.options.borderSize) +
                            "px;border-top-right-radius: " +
                            String(self.options.lensSize / 2 + self.options.borderSize) +
                            "px;border-bottom-left-radius: " +
                            String(self.options.lensSize / 2 + self.options.borderSize) +
                            "px;border-bottom-right-radius: " +
                            String(self.options.lensSize / 2 + self.options.borderSize) +
                            "px;"),
                    (self.zoomContainer = $(
                        '<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' +
                            self.nzOffset.left +
                            "px;top:" +
                            self.nzOffset.top +
                            "px;height:" +
                            self.nzHeight +
                            "px;width:" +
                            self.nzWidth +
                            'px;"></div>'
                    )),
                    $("body").append(self.zoomContainer),
                    self.options.containLensZoom && "lens" == self.options.zoomType && self.zoomContainer.css("overflow", "hidden"),
                    "inner" != self.options.zoomType &&
                        ((self.zoomLens = $("<div class='zoomLens' style='" + self.lensStyle + self.lensRound + "'>&nbsp;</div>")
                            .appendTo(self.zoomContainer)
                            .click(function () {
                                self.$elem.trigger("click");
                            })),
                        self.options.tint &&
                            ((self.tintContainer = $("<div/>").addClass("tintContainer")),
                            (self.zoomTint = $("<div class='zoomTint' style='" + self.tintStyle + "'></div>")),
                            self.zoomLens.wrap(self.tintContainer),
                            (self.zoomTintcss = self.zoomLens.after(self.zoomTint)),
                            (self.zoomTintImage = $('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' + self.nzWidth + "px; height: " + self.nzHeight + 'px;" src="' + self.imageSrc + '">')
                                .appendTo(self.zoomLens)
                                .click(function () {
                                    self.$elem.trigger("click");
                                })))),
                    isNaN(self.options.zoomWindowPosition)
                        ? (self.zoomWindow = $("<div style='z-index:999;left:" + self.windowOffsetLeft + "px;top:" + self.windowOffsetTop + "px;" + self.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>")
                              .appendTo("body")
                              .click(function () {
                                  self.$elem.trigger("click");
                              }))
                        : (self.zoomWindow = $("<div style='z-index:999;left:" + self.windowOffsetLeft + "px;top:" + self.windowOffsetTop + "px;" + self.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>")
                              .appendTo(self.zoomContainer)
                              .click(function () {
                                  self.$elem.trigger("click");
                              })),
                    (self.zoomWindowContainer = $("<div/>").addClass("zoomWindowContainer").css("width", self.options.zoomWindowWidth)),
                    self.zoomWindow.wrap(self.zoomWindowContainer),
                    "lens" == self.options.zoomType && self.zoomLens.css({ backgroundImage: "url('" + self.imageSrc + "')" }),
                    "window" == self.options.zoomType && self.zoomWindow.css({ backgroundImage: "url('" + self.imageSrc + "')" }),
                    "inner" == self.options.zoomType && self.zoomWindow.css({ backgroundImage: "url('" + self.imageSrc + "')" }),
                    self.$elem.bind("touchmove", function (e) {
                        e.preventDefault();
                        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                        self.setPosition(touch);
                    }),
                    self.zoomContainer.bind("touchmove", function (e) {
                        "inner" == self.options.zoomType && self.showHideWindow("show"), e.preventDefault();
                        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                        self.setPosition(touch);
                    }),
                    self.zoomContainer.bind("touchend", function (e) {
                        self.showHideWindow("hide"), self.options.showLens && self.showHideLens("hide"), self.options.tint && "inner" != self.options.zoomType && self.showHideTint("hide");
                    }),
                    self.$elem.bind("touchend", function (e) {
                        self.showHideWindow("hide"), self.options.showLens && self.showHideLens("hide"), self.options.tint && "inner" != self.options.zoomType && self.showHideTint("hide");
                    }),
                    self.options.showLens &&
                        (self.zoomLens.bind("touchmove", function (e) {
                            e.preventDefault();
                            var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                            self.setPosition(touch);
                        }),
                        self.zoomLens.bind("touchend", function (e) {
                            self.showHideWindow("hide"), self.options.showLens && self.showHideLens("hide"), self.options.tint && "inner" != self.options.zoomType && self.showHideTint("hide");
                        })),
                    self.$elem.bind("mousemove", function (e) {
                        0 == self.overWindow && self.setElements("show"), (self.lastX === e.clientX && self.lastY === e.clientY) || (self.setPosition(e), (self.currentLoc = e)), (self.lastX = e.clientX), (self.lastY = e.clientY);
                    }),
                    self.zoomContainer.bind("mousemove", function (e) {
                        0 == self.overWindow && self.setElements("show"), (self.lastX === e.clientX && self.lastY === e.clientY) || (self.setPosition(e), (self.currentLoc = e)), (self.lastX = e.clientX), (self.lastY = e.clientY);
                    }),
                    "inner" != self.options.zoomType &&
                        self.zoomLens.bind("mousemove", function (e) {
                            (self.lastX === e.clientX && self.lastY === e.clientY) || (self.setPosition(e), (self.currentLoc = e)), (self.lastX = e.clientX), (self.lastY = e.clientY);
                        }),
                    self.options.tint &&
                        "inner" != self.options.zoomType &&
                        self.zoomTint.bind("mousemove", function (e) {
                            (self.lastX === e.clientX && self.lastY === e.clientY) || (self.setPosition(e), (self.currentLoc = e)), (self.lastX = e.clientX), (self.lastY = e.clientY);
                        }),
                    "inner" == self.options.zoomType &&
                        self.zoomWindow.bind("mousemove", function (e) {
                            (self.lastX === e.clientX && self.lastY === e.clientY) || (self.setPosition(e), (self.currentLoc = e)), (self.lastX = e.clientX), (self.lastY = e.clientY);
                        }),
                    self.zoomContainer
                        .add(self.$elem)
                        .mouseenter(function () {
                            0 == self.overWindow && self.setElements("show");
                        })
                        .mouseleave(function () {
                            self.scrollLock || (self.setElements("hide"), self.options.onDestroy(self.$elem));
                        }),
                    "inner" != self.options.zoomType &&
                        self.zoomWindow
                            .mouseenter(function () {
                                (self.overWindow = !0), self.setElements("hide");
                            })
                            .mouseleave(function () {
                                self.overWindow = !1;
                            }),
                    self.options.zoomLevel,
                    self.options.minZoomLevel ? (self.minZoomLevel = self.options.minZoomLevel) : (self.minZoomLevel = 2 * self.options.scrollZoomIncrement),
                    self.options.scrollZoom &&
                        self.zoomContainer.add(self.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll", function (e) {
                            (self.scrollLock = !0),
                                clearTimeout($.data(this, "timer")),
                                $.data(
                                    this,
                                    "timer",
                                    setTimeout(function () {
                                        self.scrollLock = !1;
                                    }, 250)
                                );
                            var theEvent = e.originalEvent.wheelDelta || -1 * e.originalEvent.detail;
                            return (
                                e.stopImmediatePropagation(),
                                e.stopPropagation(),
                                e.preventDefault(),
                                0 < theEvent / 120
                                    ? self.currentZoomLevel >= self.minZoomLevel && self.changeZoomLevel(self.currentZoomLevel - self.options.scrollZoomIncrement)
                                    : self.options.maxZoomLevel
                                    ? self.currentZoomLevel <= self.options.maxZoomLevel && self.changeZoomLevel(parseFloat(self.currentZoomLevel) + self.options.scrollZoomIncrement)
                                    : self.changeZoomLevel(parseFloat(self.currentZoomLevel) + self.options.scrollZoomIncrement),
                                !1
                            );
                        });
            },
            setElements: function (type) {
                if (!this.options.zoomEnabled) return !1;
                "show" == type &&
                    this.isWindowSet &&
                    ("inner" == this.options.zoomType && this.showHideWindow("show"),
                    "window" == this.options.zoomType && this.showHideWindow("show"),
                    this.options.showLens && this.showHideLens("show"),
                    this.options.tint && "inner" != this.options.zoomType && this.showHideTint("show")),
                    "hide" == type &&
                        ("window" == this.options.zoomType && this.showHideWindow("hide"),
                        this.options.tint || this.showHideWindow("hide"),
                        this.options.showLens && this.showHideLens("hide"),
                        this.options.tint && this.showHideTint("hide"));
            },
            setPosition: function (e) {
                if (!this.options.zoomEnabled) return !1;
                (this.nzHeight = this.$elem.height()),
                    (this.nzWidth = this.$elem.width()),
                    (this.nzOffset = this.$elem.offset()),
                    this.options.tint && "inner" != this.options.zoomType && (this.zoomTint.css({ top: 0 }), this.zoomTint.css({ left: 0 })),
                    this.options.responsive &&
                        !this.options.scrollZoom &&
                        this.options.showLens &&
                        (this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? (lensHeight = this.nzHeight) : (lensHeight = String(this.options.zoomWindowHeight / this.heightRatio)),
                        this.largeWidth < this.options.zoomWindowWidth ? (lensWidth = this.nzWidth) : (lensWidth = this.options.zoomWindowWidth / this.widthRatio),
                        (this.widthRatio = this.largeWidth / this.nzWidth),
                        (this.heightRatio = this.largeHeight / this.nzHeight),
                        "lens" != this.options.zoomType &&
                            (this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? (lensHeight = this.nzHeight) : (lensHeight = String(this.options.zoomWindowHeight / this.heightRatio)),
                            this.nzWidth < this.options.zoomWindowHeight / this.heightRatio ? (lensWidth = this.nzWidth) : (lensWidth = String(this.options.zoomWindowWidth / this.widthRatio)),
                            this.zoomLens.css("width", lensWidth),
                            this.zoomLens.css("height", lensHeight),
                            this.options.tint && (this.zoomTintImage.css("width", this.nzWidth), this.zoomTintImage.css("height", this.nzHeight))),
                        "lens" == this.options.zoomType && this.zoomLens.css({ width: String(this.options.lensSize) + "px", height: String(this.options.lensSize) + "px" })),
                    this.zoomContainer.css({ top: this.nzOffset.top }),
                    this.zoomContainer.css({ left: this.nzOffset.left }),
                    (this.mouseLeft = parseInt(e.pageX - this.nzOffset.left)),
                    (this.mouseTop = parseInt(e.pageY - this.nzOffset.top)),
                    "window" == this.options.zoomType &&
                        ((this.Etoppos = this.mouseTop < this.zoomLens.height() / 2),
                        (this.Eboppos = this.mouseTop > this.nzHeight - this.zoomLens.height() / 2 - 2 * this.options.lensBorderSize),
                        (this.Eloppos = this.mouseLeft < 0 + this.zoomLens.width() / 2),
                        (this.Eroppos = this.mouseLeft > this.nzWidth - this.zoomLens.width() / 2 - 2 * this.options.lensBorderSize)),
                    "inner" == this.options.zoomType &&
                        ((this.Etoppos = this.mouseTop < this.nzHeight / 2 / this.heightRatio),
                        (this.Eboppos = this.mouseTop > this.nzHeight - this.nzHeight / 2 / this.heightRatio),
                        (this.Eloppos = this.mouseLeft < 0 + this.nzWidth / 2 / this.widthRatio),
                        (this.Eroppos = this.mouseLeft > this.nzWidth - this.nzWidth / 2 / this.widthRatio - 2 * this.options.lensBorderSize)),
                    this.mouseLeft < 0 || this.mouseTop < 0 || this.mouseLeft > this.nzWidth || this.mouseTop > this.nzHeight
                        ? this.setElements("hide")
                        : (this.options.showLens && ((this.lensLeftPos = String(Math.floor(this.mouseLeft - this.zoomLens.width() / 2))), (this.lensTopPos = String(Math.floor(this.mouseTop - this.zoomLens.height() / 2)))),
                          this.Etoppos && (this.lensTopPos = 0),
                          this.Eloppos && ((this.windowLeftPos = 0), (this.lensLeftPos = 0), (this.tintpos = 0)),
                          "window" == this.options.zoomType &&
                              (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize, 0)),
                              this.Eroppos && (this.lensLeftPos = this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)),
                          "inner" == this.options.zoomType &&
                              (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.nzWidth - 2 * this.options.lensBorderSize)),
                          "lens" == this.options.zoomType &&
                              ((this.windowLeftPos = String(-1 * ((e.pageX - this.nzOffset.left) * this.widthRatio - this.zoomLens.width() / 2))),
                              (this.windowTopPos = String(-1 * ((e.pageY - this.nzOffset.top) * this.heightRatio - this.zoomLens.height() / 2))),
                              this.zoomLens.css({ backgroundPosition: this.windowLeftPos + "px " + this.windowTopPos + "px" }),
                              this.changeBgSize &&
                                  (this.nzHeight > this.nzWidth
                                      ? ("lens" == this.options.zoomType && this.zoomLens.css({ "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px" }),
                                        this.zoomWindow.css({ "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px" }))
                                      : ("lens" == this.options.zoomType && this.zoomLens.css({ "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px" }),
                                        this.zoomWindow.css({ "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px" })),
                                  (this.changeBgSize = !1)),
                              this.setWindowPostition(e)),
                          this.options.tint && "inner" != this.options.zoomType && this.setTintPosition(e),
                          "window" == this.options.zoomType && this.setWindowPostition(e),
                          "inner" == this.options.zoomType && this.setWindowPostition(e),
                          this.options.showLens && (this.fullwidth && "lens" != this.options.zoomType && (this.lensLeftPos = 0), this.zoomLens.css({ left: this.lensLeftPos + "px", top: this.lensTopPos + "px" })));
            },
            showHideWindow: function (change) {
                var self = this;
                "show" == change && (self.isWindowActive || (self.options.zoomWindowFadeIn ? self.zoomWindow.stop(!0, !0, !1).fadeIn(self.options.zoomWindowFadeIn) : self.zoomWindow.show(), (self.isWindowActive = !0))),
                    "hide" == change &&
                        self.isWindowActive &&
                        (self.options.zoomWindowFadeOut
                            ? self.zoomWindow.stop(!0, !0).fadeOut(self.options.zoomWindowFadeOut, function () {
                                  self.loop && (clearInterval(self.loop), (self.loop = !1));
                              })
                            : self.zoomWindow.hide(),
                        (self.isWindowActive = !1));
            },
            showHideLens: function (change) {
                "show" == change && (this.isLensActive || (this.options.lensFadeIn ? this.zoomLens.stop(!0, !0, !1).fadeIn(this.options.lensFadeIn) : this.zoomLens.show(), (this.isLensActive = !0))),
                    "hide" == change && this.isLensActive && (this.options.lensFadeOut ? this.zoomLens.stop(!0, !0).fadeOut(this.options.lensFadeOut) : this.zoomLens.hide(), (this.isLensActive = !1));
            },
            showHideTint: function (change) {
                "show" == change &&
                    (this.isTintActive ||
                        (this.options.zoomTintFadeIn
                            ? this.zoomTint.css({ opacity: this.options.tintOpacity }).animate().stop(!0, !0).fadeIn("slow")
                            : (this.zoomTint.css({ opacity: this.options.tintOpacity }).animate(), this.zoomTint.show()),
                        (this.isTintActive = !0))),
                    "hide" == change && this.isTintActive && (this.options.zoomTintFadeOut ? this.zoomTint.stop(!0, !0).fadeOut(this.options.zoomTintFadeOut) : this.zoomTint.hide(), (this.isTintActive = !1));
            },
            setLensPostition: function (e) {},
            setWindowPostition: function (e) {
                var self = this;
                if (isNaN(self.options.zoomWindowPosition))
                    (self.externalContainer = $("#" + self.options.zoomWindowPosition)),
                        (self.externalContainerWidth = self.externalContainer.width()),
                        (self.externalContainerHeight = self.externalContainer.height()),
                        (self.externalContainerOffset = self.externalContainer.offset()),
                        (self.windowOffsetTop = self.externalContainerOffset.top),
                        (self.windowOffsetLeft = self.externalContainerOffset.left);
                else
                    switch (self.options.zoomWindowPosition) {
                        case 1:
                            (self.windowOffsetTop = self.options.zoomWindowOffety), (self.windowOffsetLeft = +self.nzWidth);
                            break;
                        case 2:
                            self.options.zoomWindowHeight > self.nzHeight && ((self.windowOffsetTop = -1 * (self.options.zoomWindowHeight / 2 - self.nzHeight / 2)), (self.windowOffsetLeft = self.nzWidth));
                            break;
                        case 3:
                            (self.windowOffsetTop = self.nzHeight - self.zoomWindow.height() - 2 * self.options.borderSize), (self.windowOffsetLeft = self.nzWidth);
                            break;
                        case 4:
                            (self.windowOffsetTop = self.nzHeight), (self.windowOffsetLeft = self.nzWidth);
                            break;
                        case 5:
                            (self.windowOffsetTop = self.nzHeight), (self.windowOffsetLeft = self.nzWidth - self.zoomWindow.width() - 2 * self.options.borderSize);
                            break;
                        case 6:
                            self.options.zoomWindowHeight > self.nzHeight && ((self.windowOffsetTop = self.nzHeight), (self.windowOffsetLeft = -1 * (self.options.zoomWindowWidth / 2 - self.nzWidth / 2 + 2 * self.options.borderSize)));
                            break;
                        case 7:
                            (self.windowOffsetTop = self.nzHeight), (self.windowOffsetLeft = 0);
                            break;
                        case 8:
                            (self.windowOffsetTop = self.nzHeight), (self.windowOffsetLeft = -1 * (self.zoomWindow.width() + 2 * self.options.borderSize));
                            break;
                        case 9:
                            (self.windowOffsetTop = self.nzHeight - self.zoomWindow.height() - 2 * self.options.borderSize), (self.windowOffsetLeft = -1 * (self.zoomWindow.width() + 2 * self.options.borderSize));
                            break;
                        case 10:
                            self.options.zoomWindowHeight > self.nzHeight &&
                                ((self.windowOffsetTop = -1 * (self.options.zoomWindowHeight / 2 - self.nzHeight / 2)), (self.windowOffsetLeft = -1 * (self.zoomWindow.width() + 2 * self.options.borderSize)));
                            break;
                        case 11:
                            (self.windowOffsetTop = self.options.zoomWindowOffety), (self.windowOffsetLeft = -1 * (self.zoomWindow.width() + 2 * self.options.borderSize));
                            break;
                        case 12:
                            (self.windowOffsetTop = -1 * (self.zoomWindow.height() + 2 * self.options.borderSize)), (self.windowOffsetLeft = -1 * (self.zoomWindow.width() + 2 * self.options.borderSize));
                            break;
                        case 13:
                            (self.windowOffsetTop = -1 * (self.zoomWindow.height() + 2 * self.options.borderSize)), (self.windowOffsetLeft = 0);
                            break;
                        case 14:
                            self.options.zoomWindowHeight > self.nzHeight &&
                                ((self.windowOffsetTop = -1 * (self.zoomWindow.height() + 2 * self.options.borderSize)), (self.windowOffsetLeft = -1 * (self.options.zoomWindowWidth / 2 - self.nzWidth / 2 + 2 * self.options.borderSize)));
                            break;
                        case 15:
                            (self.windowOffsetTop = -1 * (self.zoomWindow.height() + 2 * self.options.borderSize)), (self.windowOffsetLeft = self.nzWidth - self.zoomWindow.width() - 2 * self.options.borderSize);
                            break;
                        case 16:
                            (self.windowOffsetTop = -1 * (self.zoomWindow.height() + 2 * self.options.borderSize)), (self.windowOffsetLeft = self.nzWidth);
                            break;
                        default:
                            (self.windowOffsetTop = self.options.zoomWindowOffety), (self.windowOffsetLeft = self.nzWidth);
                    }
                (self.isWindowSet = !0),
                    (self.windowOffsetTop = self.windowOffsetTop + self.options.zoomWindowOffety),
                    (self.windowOffsetLeft = self.windowOffsetLeft + self.options.zoomWindowOffetx),
                    self.zoomWindow.css({ top: self.windowOffsetTop }),
                    self.zoomWindow.css({ left: self.windowOffsetLeft }),
                    "inner" == self.options.zoomType && (self.zoomWindow.css({ top: 0 }), self.zoomWindow.css({ left: 0 })),
                    (self.windowLeftPos = String(-1 * ((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2))),
                    (self.windowTopPos = String(-1 * ((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2))),
                    self.Etoppos && (self.windowTopPos = 0),
                    self.Eloppos && (self.windowLeftPos = 0),
                    self.Eboppos && (self.windowTopPos = -1 * (self.largeHeight / self.currentZoomLevel - self.zoomWindow.height())),
                    self.Eroppos && (self.windowLeftPos = -1 * (self.largeWidth / self.currentZoomLevel - self.zoomWindow.width())),
                    self.fullheight && (self.windowTopPos = 0),
                    self.fullwidth && (self.windowLeftPos = 0),
                    ("window" != self.options.zoomType && "inner" != self.options.zoomType) ||
                        (1 == self.zoomLock && (self.widthRatio <= 1 && (self.windowLeftPos = 0), self.heightRatio <= 1 && (self.windowTopPos = 0)),
                        "window" == self.options.zoomType && (self.largeHeight < self.options.zoomWindowHeight && (self.windowTopPos = 0), self.largeWidth < self.options.zoomWindowWidth && (self.windowLeftPos = 0)),
                        self.options.easing
                            ? (self.xp || (self.xp = 0),
                              self.yp || (self.yp = 0),
                              self.loop ||
                                  (self.loop = setInterval(function () {
                                      (self.xp += (self.windowLeftPos - self.xp) / self.options.easingAmount),
                                          (self.yp += (self.windowTopPos - self.yp) / self.options.easingAmount),
                                          self.scrollingLock
                                              ? (clearInterval(self.loop),
                                                (self.xp = self.windowLeftPos),
                                                (self.yp = self.windowTopPos),
                                                (self.xp = -1 * ((e.pageX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2)),
                                                (self.yp = -1 * ((e.pageY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2)),
                                                self.changeBgSize &&
                                                    (self.nzHeight > self.nzWidth
                                                        ? ("lens" == self.options.zoomType && self.zoomLens.css({ "background-size": self.largeWidth / self.newvalueheight + "px " + self.largeHeight / self.newvalueheight + "px" }),
                                                          self.zoomWindow.css({ "background-size": self.largeWidth / self.newvalueheight + "px " + self.largeHeight / self.newvalueheight + "px" }))
                                                        : ("lens" != self.options.zoomType && self.zoomLens.css({ "background-size": self.largeWidth / self.newvaluewidth + "px " + self.largeHeight / self.newvalueheight + "px" }),
                                                          self.zoomWindow.css({ "background-size": self.largeWidth / self.newvaluewidth + "px " + self.largeHeight / self.newvaluewidth + "px" })),
                                                    (self.changeBgSize = !1)),
                                                self.zoomWindow.css({ backgroundPosition: self.windowLeftPos + "px " + self.windowTopPos + "px" }),
                                                (self.scrollingLock = !1),
                                                (self.loop = !1))
                                              : Math.round(Math.abs(self.xp - self.windowLeftPos) + Math.abs(self.yp - self.windowTopPos)) < 1
                                              ? (clearInterval(self.loop), self.zoomWindow.css({ backgroundPosition: self.windowLeftPos + "px " + self.windowTopPos + "px" }), (self.loop = !1))
                                              : (self.changeBgSize &&
                                                    (self.nzHeight > self.nzWidth
                                                        ? ("lens" == self.options.zoomType && self.zoomLens.css({ "background-size": self.largeWidth / self.newvalueheight + "px " + self.largeHeight / self.newvalueheight + "px" }),
                                                          self.zoomWindow.css({ "background-size": self.largeWidth / self.newvalueheight + "px " + self.largeHeight / self.newvalueheight + "px" }))
                                                        : ("lens" != self.options.zoomType && self.zoomLens.css({ "background-size": self.largeWidth / self.newvaluewidth + "px " + self.largeHeight / self.newvaluewidth + "px" }),
                                                          self.zoomWindow.css({ "background-size": self.largeWidth / self.newvaluewidth + "px " + self.largeHeight / self.newvaluewidth + "px" })),
                                                    (self.changeBgSize = !1)),
                                                self.zoomWindow.css({ backgroundPosition: self.xp + "px " + self.yp + "px" }));
                                  }, 16)))
                            : (self.changeBgSize &&
                                  (self.nzHeight > self.nzWidth
                                      ? ("lens" == self.options.zoomType && self.zoomLens.css({ "background-size": self.largeWidth / self.newvalueheight + "px " + self.largeHeight / self.newvalueheight + "px" }),
                                        self.zoomWindow.css({ "background-size": self.largeWidth / self.newvalueheight + "px " + self.largeHeight / self.newvalueheight + "px" }))
                                      : ("lens" == self.options.zoomType && self.zoomLens.css({ "background-size": self.largeWidth / self.newvaluewidth + "px " + self.largeHeight / self.newvaluewidth + "px" }),
                                        self.largeHeight / self.newvaluewidth < self.options.zoomWindowHeight
                                            ? self.zoomWindow.css({ "background-size": self.largeWidth / self.newvaluewidth + "px " + self.largeHeight / self.newvaluewidth + "px" })
                                            : self.zoomWindow.css({ "background-size": self.largeWidth / self.newvalueheight + "px " + self.largeHeight / self.newvalueheight + "px" })),
                                  (self.changeBgSize = !1)),
                              self.zoomWindow.css({ backgroundPosition: self.windowLeftPos + "px " + self.windowTopPos + "px" })));
            },
            setTintPosition: function (e) {
                (this.nzOffset = this.$elem.offset()),
                    (this.tintpos = String(-1 * (e.pageX - this.nzOffset.left - this.zoomLens.width() / 2))),
                    (this.tintposy = String(-1 * (e.pageY - this.nzOffset.top - this.zoomLens.height() / 2))),
                    this.Etoppos && (this.tintposy = 0),
                    this.Eloppos && (this.tintpos = 0),
                    this.Eboppos && (this.tintposy = -1 * (this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize)),
                    this.Eroppos && (this.tintpos = -1 * (this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)),
                    this.options.tint && (this.fullheight && (this.tintposy = 0), this.fullwidth && (this.tintpos = 0), this.zoomTintImage.css({ left: this.tintpos + "px" }), this.zoomTintImage.css({ top: this.tintposy + "px" }));
            },
            swaptheimage: function (smallimage, largeimage) {
                var self = this,
                    newImg = new Image();
                self.options.loadingIcon &&
                    ((self.spinner = $(
                        "<div style=\"background: url('" +
                            self.options.loadingIcon +
                            "') no-repeat center;height:" +
                            self.nzHeight +
                            "px;width:" +
                            self.nzWidth +
                            'px;z-index: 2000;position: absolute; background-position: center center;"></div>'
                    )),
                    self.$elem.after(self.spinner)),
                    self.options.onImageSwap(self.$elem),
                    (newImg.onload = function () {
                        (self.largeWidth = newImg.width),
                            (self.largeHeight = newImg.height),
                            (self.zoomImage = largeimage),
                            self.zoomWindow.css({ "background-size": self.largeWidth + "px " + self.largeHeight + "px" }),
                            self.swapAction(smallimage, largeimage);
                    }),
                    (newImg.src = largeimage);
            },
            swapAction: function (smallimage, largeimage) {
                var self = this,
                    newImg2 = new Image();
                if (
                    ((newImg2.onload = function () {
                        (self.nzHeight = newImg2.height), (self.nzWidth = newImg2.width), self.options.onImageSwapComplete(self.$elem), self.doneCallback();
                    }),
                    (newImg2.src = smallimage),
                    (self.currentZoomLevel = self.options.zoomLevel),
                    (self.options.maxZoomLevel = !1),
                    "lens" == self.options.zoomType && self.zoomLens.css({ backgroundImage: "url('" + largeimage + "')" }),
                    "window" == self.options.zoomType && self.zoomWindow.css({ backgroundImage: "url('" + largeimage + "')" }),
                    "inner" == self.options.zoomType && self.zoomWindow.css({ backgroundImage: "url('" + largeimage + "')" }),
                    (self.currentImage = largeimage),
                    self.options.imageCrossfade)
                ) {
                    var oldImg = self.$elem,
                        newImg = oldImg.clone();
                    if (
                        (self.$elem.attr("src", smallimage),
                        self.$elem.after(newImg),
                        newImg.stop(!0).fadeOut(self.options.imageCrossfade, function () {
                            $(this).remove();
                        }),
                        self.$elem.width("auto").removeAttr("width"),
                        self.$elem.height("auto").removeAttr("height"),
                        oldImg.fadeIn(self.options.imageCrossfade),
                        self.options.tint && "inner" != self.options.zoomType)
                    ) {
                        var oldImgTint = self.zoomTintImage,
                            newImgTint = oldImgTint.clone();
                        self.zoomTintImage.attr("src", largeimage),
                            self.zoomTintImage.after(newImgTint),
                            newImgTint.stop(!0).fadeOut(self.options.imageCrossfade, function () {
                                $(this).remove();
                            }),
                            oldImgTint.fadeIn(self.options.imageCrossfade),
                            self.zoomTint.css({ height: self.$elem.height() }),
                            self.zoomTint.css({ width: self.$elem.width() });
                    }
                    self.zoomContainer.css("height", self.$elem.height()),
                        self.zoomContainer.css("width", self.$elem.width()),
                        "inner" == self.options.zoomType &&
                            (self.options.constrainType ||
                                (self.zoomWrap.parent().css("height", self.$elem.height()),
                                self.zoomWrap.parent().css("width", self.$elem.width()),
                                self.zoomWindow.css("height", self.$elem.height()),
                                self.zoomWindow.css("width", self.$elem.width()))),
                        self.options.imageCrossfade && (self.zoomWrap.css("height", self.$elem.height()), self.zoomWrap.css("width", self.$elem.width()));
                } else
                    self.$elem.attr("src", smallimage),
                        self.options.tint &&
                            (self.zoomTintImage.attr("src", largeimage), self.zoomTintImage.attr("height", self.$elem.height()), self.zoomTintImage.css({ height: self.$elem.height() }), self.zoomTint.css({ height: self.$elem.height() })),
                        self.zoomContainer.css("height", self.$elem.height()),
                        self.zoomContainer.css("width", self.$elem.width()),
                        self.options.imageCrossfade && (self.zoomWrap.css("height", self.$elem.height()), self.zoomWrap.css("width", self.$elem.width()));
                self.options.constrainType &&
                    ("height" == self.options.constrainType &&
                        (self.zoomContainer.css("height", self.options.constrainSize),
                        self.zoomContainer.css("width", "auto"),
                        self.options.imageCrossfade
                            ? (self.zoomWrap.css("height", self.options.constrainSize), self.zoomWrap.css("width", "auto"), (self.constwidth = self.zoomWrap.width()))
                            : (self.$elem.css("height", self.options.constrainSize), self.$elem.css("width", "auto"), (self.constwidth = self.$elem.width())),
                        "inner" == self.options.zoomType &&
                            (self.zoomWrap.parent().css("height", self.options.constrainSize),
                            self.zoomWrap.parent().css("width", self.constwidth),
                            self.zoomWindow.css("height", self.options.constrainSize),
                            self.zoomWindow.css("width", self.constwidth)),
                        self.options.tint &&
                            (self.tintContainer.css("height", self.options.constrainSize),
                            self.tintContainer.css("width", self.constwidth),
                            self.zoomTint.css("height", self.options.constrainSize),
                            self.zoomTint.css("width", self.constwidth),
                            self.zoomTintImage.css("height", self.options.constrainSize),
                            self.zoomTintImage.css("width", self.constwidth))),
                    "width" == self.options.constrainType &&
                        (self.zoomContainer.css("height", "auto"),
                        self.zoomContainer.css("width", self.options.constrainSize),
                        self.options.imageCrossfade
                            ? (self.zoomWrap.css("height", "auto"), self.zoomWrap.css("width", self.options.constrainSize), (self.constheight = self.zoomWrap.height()))
                            : (self.$elem.css("height", "auto"), self.$elem.css("width", self.options.constrainSize), (self.constheight = self.$elem.height())),
                        "inner" == self.options.zoomType &&
                            (self.zoomWrap.parent().css("height", self.constheight),
                            self.zoomWrap.parent().css("width", self.options.constrainSize),
                            self.zoomWindow.css("height", self.constheight),
                            self.zoomWindow.css("width", self.options.constrainSize)),
                        self.options.tint &&
                            (self.tintContainer.css("height", self.constheight),
                            self.tintContainer.css("width", self.options.constrainSize),
                            self.zoomTint.css("height", self.constheight),
                            self.zoomTint.css("width", self.options.constrainSize),
                            self.zoomTintImage.css("height", self.constheight),
                            self.zoomTintImage.css("width", self.options.constrainSize))));
            },
            doneCallback: function () {
                this.options.loadingIcon && this.spinner.hide(),
                    (this.nzOffset = this.$elem.offset()),
                    (this.nzWidth = this.$elem.width()),
                    (this.nzHeight = this.$elem.height()),
                    (this.currentZoomLevel = this.options.zoomLevel),
                    (this.widthRatio = this.largeWidth / this.nzWidth),
                    (this.heightRatio = this.largeHeight / this.nzHeight),
                    "window" == this.options.zoomType &&
                        (this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? (lensHeight = this.nzHeight) : (lensHeight = String(this.options.zoomWindowHeight / this.heightRatio)),
                        this.options.zoomWindowWidth < this.options.zoomWindowWidth ? (lensWidth = this.nzWidth) : (lensWidth = this.options.zoomWindowWidth / this.widthRatio),
                        this.zoomLens && (this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight)));
            },
            getCurrentImage: function () {
                return this.zoomImage;
            },
            getGalleryList: function () {
                var self = this;
                return (
                    (self.gallerylist = []),
                    self.options.gallery
                        ? $("#" + self.options.gallery + " a").each(function () {
                              var img_src = "";
                              $(this).data("zoom-image") ? (img_src = $(this).data("zoom-image")) : $(this).data("image") && (img_src = $(this).data("image")),
                                  img_src == self.zoomImage
                                      ? self.gallerylist.unshift({ href: "" + img_src, title: $(this).find("img").attr("title") })
                                      : self.gallerylist.push({ href: "" + img_src, title: $(this).find("img").attr("title") });
                          })
                        : self.gallerylist.push({ href: "" + self.zoomImage, title: $(this).find("img").attr("title") }),
                    self.gallerylist
                );
            },
            changeZoomLevel: function (value) {
                (this.scrollingLock = !0),
                    (this.newvalue = parseFloat(value).toFixed(2)),
                    (newvalue = parseFloat(value).toFixed(2)),
                    (maxheightnewvalue = this.largeHeight / ((this.options.zoomWindowHeight / this.nzHeight) * this.nzHeight)),
                    (maxwidthtnewvalue = this.largeWidth / ((this.options.zoomWindowWidth / this.nzWidth) * this.nzWidth)),
                    "inner" != this.options.zoomType &&
                        (maxheightnewvalue <= newvalue
                            ? ((this.heightRatio = this.largeHeight / maxheightnewvalue / this.nzHeight), (this.newvalueheight = maxheightnewvalue), (this.fullheight = !0))
                            : ((this.heightRatio = this.largeHeight / newvalue / this.nzHeight), (this.newvalueheight = newvalue), (this.fullheight = !1)),
                        maxwidthtnewvalue <= newvalue
                            ? ((this.widthRatio = this.largeWidth / maxwidthtnewvalue / this.nzWidth), (this.newvaluewidth = maxwidthtnewvalue), (this.fullwidth = !0))
                            : ((this.widthRatio = this.largeWidth / newvalue / this.nzWidth), (this.newvaluewidth = newvalue), (this.fullwidth = !1)),
                        "lens" == this.options.zoomType &&
                            (maxheightnewvalue <= newvalue
                                ? ((this.fullwidth = !0), (this.newvaluewidth = maxheightnewvalue))
                                : ((this.widthRatio = this.largeWidth / newvalue / this.nzWidth), (this.newvaluewidth = newvalue), (this.fullwidth = !1)))),
                    "inner" == this.options.zoomType &&
                        ((maxheightnewvalue = parseFloat(this.largeHeight / this.nzHeight).toFixed(2)),
                        (maxwidthtnewvalue = parseFloat(this.largeWidth / this.nzWidth).toFixed(2)),
                        newvalue > maxheightnewvalue && (newvalue = maxheightnewvalue),
                        newvalue > maxwidthtnewvalue && (newvalue = maxwidthtnewvalue),
                        maxheightnewvalue <= newvalue
                            ? ((this.heightRatio = this.largeHeight / newvalue / this.nzHeight), newvalue > maxheightnewvalue ? (this.newvalueheight = maxheightnewvalue) : (this.newvalueheight = newvalue), (this.fullheight = !0))
                            : ((this.heightRatio = this.largeHeight / newvalue / this.nzHeight), newvalue > maxheightnewvalue ? (this.newvalueheight = maxheightnewvalue) : (this.newvalueheight = newvalue), (this.fullheight = !1)),
                        maxwidthtnewvalue <= newvalue
                            ? ((this.widthRatio = this.largeWidth / newvalue / this.nzWidth), newvalue > maxwidthtnewvalue ? (this.newvaluewidth = maxwidthtnewvalue) : (this.newvaluewidth = newvalue), (this.fullwidth = !0))
                            : ((this.widthRatio = this.largeWidth / newvalue / this.nzWidth), (this.newvaluewidth = newvalue), (this.fullwidth = !1))),
                    (scrcontinue = !1),
                    "inner" == this.options.zoomType &&
                        (this.nzWidth >= this.nzHeight && (this.newvaluewidth <= maxwidthtnewvalue ? (scrcontinue = !0) : ((scrcontinue = !1), (this.fullheight = !0), (this.fullwidth = !0))),
                        this.nzHeight > this.nzWidth && (this.newvaluewidth <= maxwidthtnewvalue ? (scrcontinue = !0) : ((scrcontinue = !1), (this.fullheight = !0), (this.fullwidth = !0)))),
                    "inner" != this.options.zoomType && (scrcontinue = !0),
                    scrcontinue &&
                        ((this.zoomLock = 0),
                        (this.changeZoom = !0),
                        this.options.zoomWindowHeight / this.heightRatio <= this.nzHeight &&
                            ((this.currentZoomLevel = this.newvalueheight),
                            "lens" != this.options.zoomType && "inner" != this.options.zoomType && ((this.changeBgSize = !0), this.zoomLens.css({ height: String(this.options.zoomWindowHeight / this.heightRatio) + "px" })),
                            ("lens" != this.options.zoomType && "inner" != this.options.zoomType) || (this.changeBgSize = !0)),
                        this.options.zoomWindowWidth / this.widthRatio <= this.nzWidth &&
                            ("inner" != this.options.zoomType && this.newvaluewidth > this.newvalueheight && (this.currentZoomLevel = this.newvaluewidth),
                            "lens" != this.options.zoomType && "inner" != this.options.zoomType && ((this.changeBgSize = !0), this.zoomLens.css({ width: String(this.options.zoomWindowWidth / this.widthRatio) + "px" })),
                            ("lens" != this.options.zoomType && "inner" != this.options.zoomType) || (this.changeBgSize = !0)),
                        "inner" == this.options.zoomType &&
                            ((this.changeBgSize = !0), this.nzWidth > this.nzHeight && (this.currentZoomLevel = this.newvaluewidth), this.nzHeight > this.nzWidth && (this.currentZoomLevel = this.newvaluewidth))),
                    this.setPosition(this.currentLoc);
            },
            closeAll: function () {
                self.zoomWindow && self.zoomWindow.hide(), self.zoomLens && self.zoomLens.hide(), self.zoomTint && self.zoomTint.hide();
            },
            changeState: function (value) {
                "enable" == value && (this.options.zoomEnabled = !0), "disable" == value && (this.options.zoomEnabled = !1);
            },
        };
        ($.fn.elevateZoom = function (options) {
            return this.each(function () {
                var elevate = Object.create(ElevateZoom);
                elevate.init(options, this), $.data(this, "elevateZoom", elevate);
            });
        }),
            ($.fn.elevateZoom.options = {
                zoomActivation: "hover",
                zoomEnabled: !0,
                preloading: 1,
                zoomLevel: 1,
                scrollZoom: !1,
                scrollZoomIncrement: 0.1,
                minZoomLevel: !1,
                maxZoomLevel: !1,
                easing: !1,
                easingAmount: 12,
                lensSize: 200,
                zoomWindowWidth: 400,
                zoomWindowHeight: 400,
                zoomWindowOffetx: 0,
                zoomWindowOffety: 0,
                zoomWindowPosition: 1,
                zoomWindowBgColour: "#fff",
                lensFadeIn: !1,
                lensFadeOut: !1,
                debug: !1,
                zoomWindowFadeIn: !1,
                zoomWindowFadeOut: !1,
                zoomWindowAlwaysShow: !1,
                zoomTintFadeIn: !1,
                zoomTintFadeOut: !1,
                borderSize: 4,
                showLens: !0,
                borderColour: "#888",
                lensBorderSize: 1,
                lensBorderColour: "#000",
                lensShape: "square",
                zoomType: "window",
                containLensZoom: !1,
                lensColour: "white",
                lensOpacity: 0.4,
                lenszoom: !1,
                tint: !1,
                tintColour: "#333",
                tintOpacity: 0.4,
                gallery: !1,
                galleryActiveClass: "zoomGalleryActive",
                imageCrossfade: !1,
                constrainType: !1,
                constrainSize: !1,
                loadingIcon: !1,
                cursor: "default",
                responsive: !0,
                onComplete: $.noop,
                onDestroy: function () {},
                onZoomedImageLoaded: function () {},
                onImageSwap: $.noop,
                onImageSwapComplete: $.noop,
            });
    })(jQuery, window, document);
var App = {};
!(function ($) {
    var _init = [];
    (App = {
        core: {
            init: function (f) {
                f
                    ? _init.push(f)
                    : $.each(_init, function (idx, f) {
                          f();
                      });
            },
            isDesktop: function () {
                return 1140 <= window.innerWidth;
            },
            isMobile: function () {
                return window.innerWidth < 768;
            },
            browser: function () {
                var tem,
                    N = navigator.appName,
                    ua = navigator.userAgent,
                    M = ua.match(/(opera|chrome|safari|firefox|msie|trident)\/?\s*(\.?\d+(\.\d+)*)/i);
                M && null != (tem = ua.match(/version\/([\.\d]+)/i)) && (M[2] = tem[1]),
                    (M = M ? [M[1], M[2]] : [N, navigator.appVersion, "-?"]) && "safari" == M[0].toLowerCase() && ($("html").addClass("safari"), parseFloat(M[1]) < 12 && $("html").addClass("safari-lt-12"));
            },
            scrollTo: function ($element) {
                setTimeout(function () {
                    $("html, body").animate({ scrollTop: $element.offset().top }, 500);
                }, 100);
            },
            getQueryString: function (field, url) {
                var href = url || window.location.href,
                    string = new RegExp("[?&]" + field + "=([^&#]*)", "i").exec(href);
                return string ? string[1] : "";
            },
        },
        navigation: {
            toggle: function ($nav) {
                $nav.slideToggle(function () {
                    $(this).toggleClass("open", $(this).is(":visible")).removeAttr("style");
                });
            },
        },
        search: {
            toggle: function ($search) {
                $search.slideToggle(function () {
                    $(this).toggleClass("open", $(this).is(":visible")).removeAttr("style");
                });
            },
        },
        tabs: {
            scrollTo: function ($tabTitle) {
                App.core.scrollTo($tabTitle);
            },
        },
        carousel: {
            init: function (identifier) {
                0 < $(identifier).length &&
                    $(identifier).owlCarousel({
                        loop: !1,
                        margin: 10,
                        nav: !0,
                        scrollPerPage: !0,
                        rewind: !1,
                        responsive: {
                            0: { loop: !1, items: 1, rewind: !1, nav: !0, slideBy: 1 },
                            640: { loop: !1, items: 2, rewind: !1, nav: !0, slideBy: 2 },
                            840: { loop: !1, items: 3, rewind: !1, nav: !0, slideBy: 3 },
                            1100: { loop: !1, items: 4, nav: !0, rewind: !1, slideBy: 4 },
                        },
                    });
            },
        },
    }),
        $(document).ready(function () {
            App.core.browser();
            $.each([".new-items", ".related-items"], function (k, v) {
                App.carousel.init(v);
            }),
                $(".navbar-toggle").click(function () {
                    var $nav = $("#main-nav");
                    App.navigation.toggle($nav);
                }),
                $(".search-toggler").click(function () {
                    var $search = $("#header-serach");
                    $search.hasClass("open") ||
                        setTimeout(function () {
                            $search.find('input[type="search"]').focus();
                        }, 500),
                        App.search.toggle($search);
                }),
                $(".tabset .htab-title > label").click(function () {
                    App.tabs.scrollTo($(this));
                }),
                App.core.init();
        });
})(jQuery),
    (function ($) {
        $.extend(App, {
            page: {
                wrapIframe: function () {
                    $(".article-container .article-content iframe").each(function () {
                        $(this).wrap('<div class="video-sm-wrapper" />');
                    });
                },
            },
        }),
            App.core.init(function () {
                App.page.wrapIframe();
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            book: {
                el: null,
                container: "#book-container",
                initiated: !1,
                defaultWidth: null,
                defaultHeight: null,
                init: function () {
                    0 == App.book.initiated &&
                        ((App.book.initiated = !0),
                        App.book.setSize(),
                        setTimeout(function () {
                            (App.book.el = $(".flipbook").turn({
                                width: App.book.defaultWidth,
                                height: App.book.defaultHeight,
                                elevation: 50,
                                gradients: !0,
                                autoCenter: !0,
                                when: {
                                    first: function (event) {
                                        $(".flipbook-previous").addClass("first");
                                    },
                                    turning: function (event, page, view) {
                                        1 != page && $(".flipbook-previous").removeClass("first"), page != $(".flipbook").turn("pages") && ($(".flipbook-actions").removeClass("last"), $(".flipbook-next").removeClass("last"));
                                    },
                                    last: function (event) {
                                        $(".flipbook-next").addClass("last"), $(".flipbook-actions").addClass("last");
                                    },
                                },
                            })),
                                App.book.resize(),
                                App.book.shortcuts();
                        }, 20));
                },
                setSize: function () {
                    var img = $(App.book.container).find("img").first(),
                        image = new Image();
                    (image.src = img.attr("src")), (App.book.defaultWidth = 2 * image.naturalWidth), (App.book.defaultHeight = image.naturalHeight);
                },
                resize: function () {
                    if (App.book.initiated && $(App.book.container).is(":visible")) {
                        var options = App.book.el.turn("options"),
                            width = $(window).width(),
                            height = $(window).height();
                        $(".flipbook-viewport").css({ width: width, height: height });
                        var bound = App.book.bound({ width: options.width, height: options.height, boundWidth: Math.min(options.width, width), boundHeight: Math.min(options.height, height) });
                        bound.width % 2 != 0 && (bound.width -= 1),
                            (bound.width == App.book.el.width() && bound.height == App.book.el.height()) || App.book.el.turn("size", bound.width, bound.height),
                            App.book.el.css({ top: -bound.height / 2, left: -bound.width / 2 });
                    }
                },
                bound: function (d) {
                    var bound = { width: d.width, height: d.height };
                    if (bound.width > d.boundWidth || bound.height > d.boundHeight) {
                        var rel = bound.width / bound.height;
                        d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth
                            ? ((bound.width = Math.round(d.boundHeight * rel)), (bound.height = d.boundHeight))
                            : ((bound.width = d.boundWidth), (bound.height = Math.round(d.boundWidth / rel)));
                    }
                    return bound;
                },
                shortcuts: function () {
                    $(document).keydown(function (e) {
                        if ($(App.book.container).is(":visible"))
                            switch (e.keyCode) {
                                case 37:
                                    App.book.el.turn("previous"), e.preventDefault();
                                    break;
                                case 39:
                                    App.book.el.turn("next"), e.preventDefault();
                            }
                    });
                },
                close: function () {
                    App.book.el.turn("page", 1), $("#book-container").addClass("hide");
                },
            },
        }),
            App.core.init(function () {
                0 < $(".template-product").length &&
                    ($(".read").click(function () {
                        $("#book-container").removeClass("hide"), $("html, body").animate({ scrollTop: $("body,html").offset().top }, 500), App.book.init();
                    }),
                    $(".flipbook-previous .previous").click(function () {
                        App.book.el.turn("previous");
                    }),
                    $(".flipbook-previous .first-page").click(function () {
                        App.book.el.turn("page", 1);
                    }),
                    $(".flipbook-next .next").click(function () {
                        App.book.el.turn("next");
                    }),
                    $(".flipbook-next .last-page").click(function () {
                        App.book.el.turn("page", App.book.el.turn("pages"));
                    }),
                    $(".flipbook-quit").click(function () {
                        App.book.close();
                    }),
                    $(window).resize(function () {
                        App.book.resize();
                    }));
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            kb: {
                loader: {
                    add: function () {
                        $(".kb-content").addClass("loading");
                    },
                    remove: function () {
                        $(".kb-content").removeClass("loading");
                    },
                },
                algolia: {
                    index: function () {
                        if (window.algoliaShopify) {
                            var algolia = window.algoliaShopify,
                                client = algolia.client,
                                index = algolia.config.index_prefix + "pages";
                            return (index = client.initIndex(index));
                        }
                    },
                },
                get: function (page, q) {
                    var index = App.kb.algolia.index(),
                        algolia = window.algoliaShopify;
                    if (index) {
                        App.kb.loader.add();
                        var params = { query: q, distinct: !0, page: page, hitsPerPage: 6, filters: "meta.global.Type:kb" };
                        index.search(params, function (error, content) {
                            if (content.hits && 0 < content.hits.length) {
                                var template = algolia.compileTemplate("kb_pages"),
                                    output = algolia.render(template, { items: content.hits });
                                $("#kb-list .kb-items .row").html(output),
                                    content.nbPages && content.nbPages < 2 && pagination && $("#pagination").pagination("destroy"),
                                    content.nbPages && 1 < content.nbPages && pagination && App.kb.paginate.init(content.nbPages, page + 1);
                            } else $("#pagination").pagination("destroy"), $("#kb-list .kb-items .row").html("");
                            App.kb.loader.remove();
                        });
                    }
                },
                suggestions: function (q) {
                    var index = App.kb.algolia.index(),
                        algolia = window.algoliaShopify;
                    if (index) {
                        var params = { query: q, distinct: !0, page: 0, hitsPerPage: 10, filters: "meta.global.Type:kb" };
                        index.search(params, function (error, content) {
                            if (content.hits && 0 < content.hits.length) {
                                var template = algolia.compileTemplate("kb_pages"),
                                    output = algolia.render(template, { items: content.hits });
                                $("#kb-suggestions").removeClass("hide"), $("#kb-suggestions .suggestions-wrapper").html('<div class="kb-items"><div class="row">' + output + "</div></div>");
                            } else $("#kb-suggestions").addClass("hide"), $("#kb-suggestions .suggestions-wrapper").html("");
                        });
                    }
                },
                paginate: {
                    init: function (pages, current) {
                        $("#pagination").pagination("destroy"),
                            $("#pagination").pagination({
                                pages: pages,
                                prevText: "Previous",
                                nextText: "Next",
                                displayedPages: 3,
                                currentPage: current,
                                onPageClick: function (page) {
                                    App.kb.paginate.change(page);
                                },
                            });
                    },
                    change: function (page) {
                        (page = parseInt(page)) && 0 < page && App.kb.get(page - 1, "");
                    },
                },
            },
        }),
            App.core.init(function () {
                0 < $(".kb-template").length &&
                    (App.kb.get(0, ""),
                    $(".kb-form .search-form").submit(function (e) {
                        var q = $(this).find('[name="q"]').val();
                        return App.kb.get(0, q), e.preventDefault(), !1;
                    }),
                    $('.kb-form .search-form input[name="q"]').keyup(function (e) {
                        if (e.keyCode < 36 || 41 < e.keyCode) {
                            var val = $.trim($(this).val());
                            3 < val.length ? App.kb.suggestions(val) : $("#kb-suggestions").addClass("hide"), 0 === val.length && ($("#kb-list").removeClass("hide"), $("#kb-search").html(""));
                        }
                    }));
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            list: {
                query: {
                    params: {},
                    fetch: function (callback) {
                        var params = {},
                            query = decodeURIComponent(window.location.search);
                        if ((query = query.substr(1))) {
                            var parts = query.split("&");
                            $.each(parts, function (idx, part) {
                                if (part) {
                                    var option = part.split("=");
                                    2 == option.length && (params[option[0]] = option[1]);
                                }
                            });
                        }
                        (App.list.query.params = params), callback();
                    },
                    sortBy: function () {
                        var params = App.list.query.params;
                        return !!params.sort_by && params.sort_by;
                    },
                    pageNumber: function () {
                        var params = App.list.query.params;
                        return !!params.page && params.page;
                    },
                },
                open: function ($group) {
                    $group.find(".group-title").addClass("open");
                },
                toggle: function ($group) {
                    var $title = $group.find(".group-title");
                    $title.hasClass("selected") && $title.hasClass("closed")
                        ? $title.removeClass("closed").addClass("open")
                        : $title.hasClass("selected") && !$title.hasClass("open")
                        ? $title.addClass("closed")
                        : $title.hasClass("selected") && $title.hasClass("open")
                        ? $title.addClass("closed").removeClass("open")
                        : $title.removeClass("closed").toggleClass("open");
                },
                sort: {
                    el: "#sortBy",
                    init: function () {
                        if (window.algoliaShopify) {
                            var sortOrders = window.algoliaShopify.config.sort_orders,
                                options = [];
                            if (
                                ($.each(sortOrders, function (idx, sortOrder) {
                                    sortOrder.desc && !0 === sortOrder.desc.active && options.push({ value: sortOrder.key + "_desc", title: sortOrder.desc.title }),
                                        sortOrder.asc && !0 === sortOrder.asc.active && options.push({ value: sortOrder.key + "_asc", title: sortOrder.asc.title });
                                }),
                                0 < $(".template-product-list").length &&
                                    (options.push({ value: "word_count_asc", title: window.theme.strings.sorting.wordCountAsc }),
                                    options.push({ value: "word_count_desc", title: window.theme.strings.sorting.wordCountDesc })
                                    //,
                                    //options.push({ value: "level_asc", title: window.theme.strings.sorting.levelAsc }),
                                    //options.push({ value: "level_desc", title: window.theme.strings.sorting.levelDesc })
                                    ),
                                0 < options.length)
                            ) {
                                var $select = $("<select />").attr("id", App.list.sort.el.substr(1)).attr("name", "sort_by");
                                $select.append('<option value="">' + theme.strings.sort + "</option>"),
                                    $.each(options, function (key, option) {
                                        var selected = "";
                                        App.list.query.sortBy() && App.list.query.sortBy() == option.value && (selected = ' selected="selected"'),
                                            $select.append('<option value="' + option.value + '"' + selected + ">" + option.title + "</option>");
                                    }),
                                    $("#sort-select").append($select).removeClass("hide");
                            }
                        }
                    },
                    selectedValue: function () {
                        return $(App.list.sort.el).val();
                    },
                    onChange: function ($select) {
                        var sort = App.list.sort.getValue($select);
                        sort.length ? (window.location.search = sort) : (window.location.href = window.location.href.replace(window.location.search, ""));
                    },
                    getValue: function ($select) {
                        var sort = $select.val(),
                            query = "";
                        return "" !== sort && (query = "sort_by=" + sort), query;
                    },
                },
                hide: function ($group) {
                    $group.find(".show-more a").text("show more"), $group.find(".group-items").find("li:gt(2)").addClass("hide");
                },
                show: function ($group) {
                    $group.find(".show-more a").text("show less"), $group.find(".group-items").find("li:gt(2)").removeClass("hide");
                },
                items: {
                    get: function (page, pagination, infinite, template, callback) {
                        if (window.algoliaShopify) {
                            infinite || $("#list-section").addClass("loading"), (callback = callback || function () {});
                            var q = decodeURIComponent(App.core.getQueryString("q")),
                                algolia = window.algoliaShopify,
                                client = algolia.client,
                                index = algolia.config.index_prefix + "products";
                            App.list.sort.selectedValue() && (index += "_" + App.list.sort.selectedValue()), (index = client.initIndex(index));

							// PVB updates for filters on PLP's
							var pvb_hitsPerPage = 15;
							if (window.location.pathname.match(/\/collections\/([^/]+)/i)) {
								pvb_hitsPerPage = 16;
								template = "collection_items_wide";
							}
							
                            var params = { query: q, distinct: !0, page: page, hitsPerPage: pvb_hitsPerPage },
                                facetFilters = [];
                            $(".filter-group").each(function () {
                                var $selectedTags = $(this).find(".tag-item.checked");
                                if (0 < $selectedTags.length) {
                                    var innerTags = [];
                                    $selectedTags.each(function () {
                                        innerTags.push("tags:" + $(this).attr("data-option"));
                                    }),
                                        facetFilters.push(innerTags);
                                }
                            }),
                                0 < facetFilters.length && (params.facetFilters = facetFilters);
                            var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
                            if (matches && 2 === matches.length) {
                                "all" != matches[1].toLowerCase() && (params.filters = "collections:" + matches[1].toLowerCase());
                                var parts = window.location.pathname.split("/");
                                (parts = parts.slice(1)) && parts.length;
                            }
                            var $algoliaFilters = $(".algolia-filters");
                            if (0 < $algoliaFilters.length) {
                                var algoliaFilters = $algoliaFilters.attr("data-filters");
                                algoliaFilters && (algoliaFilters = $.parseJSON(algoliaFilters)).filters && (params.filters ? (params.filters = params.filters + "AND " + algoliaFilters.filters) : (params.filters = algoliaFilters.filters));
                            }
                            index.search(params, function (error, content) {
                                if (($("#list-section").removeClass("loading"), content.hits && 0 < content.hits.length)) {
									
                                    (template = template || "collection_items"), (template = algolia.compileTemplate(template));
									
                                    var output = algolia.render(template, { items: content.hits });
                                    content.nbHits && 1 < content.nbHits ? $(".list-count").html(theme.strings.other.replace("{{ count }}", content.nbHits)) : $(".list-count").text(theme.strings.one),
                                        infinite ? $("#list-items").append(output) : ($("#list-empty").addClass("hide"), $("#list-items").html(output)),
                                        content.nbPages && content.nbPages < 2 && pagination && $("#pagination").pagination("destroy"),
                                        content.nbPages && 1 < content.nbPages && pagination && App.list.items.paginate.init(content.nbPages, page + 1),
                                        App.list.items.levels();
                                } else $("#pagination").pagination("destroy"), $(".list-count").html(theme.strings.other.replace("{{ count }}", 0)), infinite || ($("#list-items").html(""), $("#list-empty").removeClass("hide"));
                                callback(content);
                            });
                        }
                    },
                    paginate: {
                        init: function (pages, current) {
                            $("#pagination").pagination("destroy"),
                                $("#pagination").pagination({
                                    pages: pages,
                                    prevText: "Previous",
                                    nextText: "Next",
                                    displayedPages: 3,
                                    currentPage: current,
                                    onPageClick: function (page) {
                                        App.list.items.paginate.change(page);
                                    },
                                });
                        },
                        change: function (page) {
                            if ((page = parseInt(page)) && 0 < page) {
                                if (App.list.items.filter.allowChangeUrl()) {
                                    var url = window.location.pathname + "?page=" + (page - 1);
                                    window.history.replaceState({ path: url }, "", url);
                                }
                                App.list.items.get(page - 1, !1), App.core.scrollTo($("#list-section"));
                            }
                        },
                    },
                    filter: {
                        allowChangeUrl: function () {
                            return !(0 < $(".template-search").length || 0 < $(".template-product-list").length);
                        },
                        changeUrl: function () {
                            var collection = $(".collection-item.checked").attr("data-option");
                            collection = collection || "all";
                            var tags = "";
                            if (
                                ($(".filter-group").each(function () {
                                    var $selectedTags = $(this).find(".tag-item.checked");
                                    if (0 < $selectedTags.length) {
                                        var innerTags = [];
                                        $selectedTags.each(function () {
                                            innerTags.push($(this).attr("data-option"));
                                        }),
                                            tags && (tags += "::"),
                                            (tags += innerTags.join("+"));
                                    }
                                }),
                                App.list.items.filter.allowChangeUrl())
                            ) {
                                var url = "/collections/" + collection + "/";
                                tags && (url += tags), window.history.replaceState({ path: url }, "", url);
                            }
                            0 < $(".template-product-list").length
                                ? ((App.page.product.listing._processing = !0),
                                  App.list.items.get(0, !0, !1, "collection_items_list", function (response) {
                                      App.page.product.listing.format(response), (App.page.product.listing._processing = !1);
                                  }))
                                : App.list.items.get(0, !0);
                        },
                    },
                    levels: function () {
                        var handles = [];
                        $(".bundle-item").each(function () {
                            handles.push($(this).attr("data-handle"));
                        }),
                            0 < handles.length &&
                                $.each(handles, function (key, handle) {
                                    $.ajax({ cache: !1, url: "/products/" + handle + "?view=level&cache=false", method: "GET" }).done(function (response) {
                                        if ((response = $.parseJSON(response)).handle && response.level) {
                                            var $itemLevel = $('.bundle-item[data-handle="' + response.handle + '"]').find(".item-level");
                                            $itemLevel.html(response.level), $itemLevel.removeClass("hide");
                                        }
                                    });
                                });
                    },
                },
            },
        }),
            App.core.init(function () {

              // PVB - Only init if id found
              if (0 < $("#list-container").length) {
              
                window.location.pathname.match(/\/collections\/([^/]+)/i) &&
                    (App.list.query.fetch(function () {
                        App.list.sort.init();
                    }),
                    setTimeout(function () {
                        var page = 0;
                        App.list.query.pageNumber() && (page = parseInt(App.list.query.pageNumber())), App.list.items.get(page, !0);
                    }, 50)),
                    $(document).on("change", App.list.sort.el, function () {
                        if (App.list.items.filter.allowChangeUrl()) {
                            var url = window.location.pathname;
                            $(this).val() && (url += "?sort_by=" + $(this).val()), window.history.replaceState({ path: url }, "", url);
                        }
                        0 < $(".template-product-list").length
                            ? ((App.page.product.listing._processing = !0),
                              App.list.items.get(0, !0, !1, "collection_items_list", function (response) {
                                  App.page.product.listing.format(response), (App.page.product.listing._processing = !1);
                              }))
                            : App.list.items.get(0, !0);
                    }),
                    $("#SortBy").change(function () {
                        App.list.sort.onChange($(this));
                    }),
                    App.core.isMobile() ||
                        $(".filter-group").each(function (key, group) {
                            var $items = $(this).find(".group-items");
                            3 < $items.find("li").length &&
                                (0 < $items.find(".checked").length
                                    ? $(this).append('<div class="show-more less"><a href="javascript:void(0);">show less</a></div>')
                                    : ($(this).append('<div class="show-more"><a href="javascript:void(0);">show more</a></div>'), $items.find("li:gt(2)").addClass("hide")));
                        }),
                    $(document).on("click", ".show-more", function () {
                        var $group = $(this).parent(".filter-group");
                        $(this).hasClass("less") ? (App.list.hide($group), $(this).removeClass("less")) : (App.list.show($group), $(this).addClass("less"));
                    }),
                    $(".tag-item").click(function () {
                        $(this).toggleClass("checked");
                        var $filterGroup = $(this).parents(".filter-group");
                        0 < $filterGroup.find(".tag-item.checked").length ? $filterGroup.find(".group-title").addClass("selected") : $filterGroup.find(".group-title").removeClass("selected"), App.list.items.filter.changeUrl();
                    }),
                    $(".collection-item").click(function () {
                        $(this).hasClass("checked")
                            ? ($(".collection-item").removeClass("checked"), $(this).parents(".filter-group").find(".group-title").removeClass("selected"))
                            : ($(".collection-item").removeClass("checked"), $(this).addClass("checked"), $(this).parents(".filter-group").find(".group-title").addClass("selected")),
                            App.list.items.filter.changeUrl();
                    }),
                    $(".filter-group .clear").click(function () {
                        $(this).parents(".filter-group").find(".group-item").removeClass("checked"), App.list.items.filter.changeUrl();
                    }),
                    $(document).on("click", ".level-chart", function () {
                        $(".level-chart-modal").click();
                    }),
                    0 < $(".level-chart-modal").length && $(".level-chart-modal").magnificPopup({ type: "inline", closeBtnInside: !0 }),
                    $(".group-title").click(function (e) {
                        App.list.toggle($(this).parent(".filter-group"));
                    });

              } else {


        $('#SortBy').change(
        function() {
          App.list.sort.onChange($(this));
        }
      );

        $(document).on(
        'click',
        '.level-chart',
        function() {
          $('.level-chart-modal').click();
        }
      );

      if ($('.level-chart-modal').length > 0) {
        $('.level-chart-modal').magnificPopup({
          type:'inline',
          closeBtnInside: true
        });
      }
     // App.list.items.levels();          
              }
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            page: {
                wrapIframe: function () {
                    $(".page-container .page-content iframe").each(function () {
                        $(this).wrap('<div class="video-sm-wrapper" />');
                    });
                },
                product: {
                    listing: {
                        _processing: !1,
                        handles: {},
                        format: function (response) {
                            response.hits &&
                                0 < response.hits.length &&
                                $.each(response.hits, function (key, hit) {
                                    App.page.product.listing.handles[hit.handle] && null != App.page.product.listing.handles[hit.handle]
                                        ? App.page.product.listing.append(App.page.product.listing.handles[hit.handle])
                                        : App.page.product.get(hit.handle);
                                });
                        },
                        append: function (content) {
                            if (content.handle && content.output) {
                                var $row = $('div[data-handle="' + content.handle + '"]');
                                0 < $row.length && ($row.find(".item-buy").html(content.output), content.sku && "" != content.sku && $row.find(".sku .item-value").html(content.sku));
                            }
                        },
                    },
                    get: function (handle) {
                        $.ajax({ cache: !1, url: "/products/" + handle + "?view=complete-list-options&cache=false", method: "GET" }).done(function (response) {
                            (response = $.parseJSON(response)), App.page.product.listing.append(response);
                        });
                    },
                },
            },
            quote: {
                el: ".show-shipping",
                init: function () {
                    0 < $(".rfq_form_page").length &&
                        (setTimeout(function () {
                            App.quote.shipping.hide();
                        }, 2e3),
                        setInterval(function () {
                            $(".show-shipping").hasClass("same") && App.quote.shipping.fillFields();
                        }, 1e3),
                        $(document).on("click", App.quote.el, function () {
                            $(this).hasClass("same") ? App.quote.shipping.show() : App.quote.shipping.hide();
                        }));
                },
                shipping: {
                    fillFields: function () {
                        $.each(["address_line_1", "address_line_2", "city", "state", "zip_code"], function (key, field) {
                            $("#shipping_" + field).val($("#billing_" + field).val());
                        });
                    },
                    hide: function () {
                        $(App.quote.el).addClass("same"), $(App.quote.el).nextAll(".form-group").not(".action-group").addClass("hide"), App.quote.shipping.fillFields();
                    },
                    show: function () {
                        $(App.quote.el).removeClass("same"), $(App.quote.el).nextAll(".form-group").not(".action-group").removeClass("hide");
                    },
                },
            },
        }),
            App.core.init(function () {
                if (0 < $(".template-product-list").length) {
                    App.list.sort.init();
                    var q = decodeURIComponent(App.core.getQueryString("q"));
                    (q = q.replace(/\+/g, " ")) && $('.sr-form input[name="q"]').val(q),
                        setTimeout(function () {
                            (App.page.product.listing._processing = !0),
                                App.list.items.get(0, !0, !1, "collection_items_list", function (response) {
                                    App.page.product.listing.format(response), (App.page.product.listing._processing = !1);
                                });
                        }, 100),
                        $(window).scroll(function () {
                            if ($(window).scrollTop() >= $(document).height() - $(window).height() - $("#footer").height() - 200 && !1 === App.page.product.listing._processing) {
                                var $pagination = $("#pagination");
                                if (0 < $pagination.children().length) {
                                    var totalPages = $pagination.pagination("getPagesCount"),
                                        currentPage = $pagination.pagination("getCurrentPage");
                                    currentPage < totalPages &&
                                        ((App.page.product.listing._processing = !0),
                                        App.list.items.get(currentPage, !0, !0, "collection_items_list", function (response) {
                                            (App.page.product.listing._processing = !1), App.page.product.listing.format(response);
                                        }));
                                }
                            }
                        }),
                        $(document).on("submit", ".complete-list-product-form", function () {
                            var $form = $(this);
                            return (
                                $form.parents(".item-variants").css("visibility", "hidden"),
                                $.ajax({ cache: !1, url: "/cart/add.js", method: "POST", dataType: "json", data: $form.serialize() })
                                    .done(function (response) {
                                        $(".site-notifications")
                                            .html("<p>" + theme.strings.cartSuccessMessage + "</p>")
                                            .fadeIn(),
                                            $form.parents(".item-variants").css("visibility", "visible"),
                                            App.cart.get(),
                                            setTimeout(function () {
                                                $(".site-notifications").fadeOut();
                                            }, 5e3);
                                    })
                                    .fail(function (response) {
                                        $(".site-notifications")
                                            .html("<p>" + theme.strings.cartErrorMessage + "</p>")
                                            .fadeIn(),
                                            $form.parents(".item-variants").css("visibility", "visible"),
                                            setTimeout(function () {
                                                $(".site-notifications").fadeOut();
                                            }, 5e3);
                                    }),
                                !1
                            );
                        }),
                        $(document).on("submit", ".sr-form .search-form", function () {
                            var url = window.location.pathname;
                            return (
                                (url += "?q=" + $(this).find('[name="q"]').val()),
                                window.history.replaceState({ path: url }, "", url),
                                setTimeout(function () {
                                    (App.page.product.listing._processing = !0),
                                        App.list.items.get(0, !0, !1, "collection_items_list", function (response) {
                                            App.page.product.listing.format(response), (App.page.product.listing._processing = !1);
                                        });
                                }, 50),
                                !1
                            );
                        });
                }
                App.page.wrapIframe(), App.quote.init();
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            product: {
                productJSON: null,
                getProductJSON: function () {
                    var html = $("#ProductJson-product-template").html();
                    App.product.productJSON = $.parseJSON(html);
                },
                getCurrentOptions: function () {
                    var options = [];
                    return (
                        $(".single-option-selector").each(function () {
                            options.push({ index: $(this).attr("data-index"), value: $(this).val() });
                        }),
                        options
                    );
                },
                getVariantFromOptions: function () {
                    var selectedOptions = App.product.getCurrentOptions(),
                        variants = App.product.productJSON.variants,
                        currentVariant = !1;
                    return (
                        $.each(variants, function (key, variant) {
                            var matches = [];
                            if (
                                ($.each(selectedOptions, function (key, selectedOption) {
                                    variant[selectedOption.index] == selectedOption.value && matches.push(!0);
                                }),
                                selectedOptions.length == matches.length)
                            )
                                return (currentVariant = variant), !1;
                        }),
                        currentVariant
                    );
                },
                getCurrentVariant: function () {
                    return App.product.getVariantFromOptions();
                },
                updateMainVariant: function (variant) {
                    $(".main-variants").val(variant.id);
                },
                updatePrice: function (variant) {
                    $(".product-price .sale-price").html(theme.Currency.formatMoney(variant.price, theme.moneyFormat)),
                        variant.compare_at_price > variant.price
                            ? ($(".product-price .regular-price").html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass("hide"), $(".product-price .sale-price").addClass("discount-price"))
                            : ($(".product-price .regular-price").addClass("hide"), $(".product-price .sale-price").removeClass("discount-price"));
                },
                updateAddToCart: function (variant) {
                    var $addToCart = $("#add-to-cart"),
                        $productPrice = $(".product-price");
                    variant
                        ? ($productPrice.removeClass("hide"), variant.available ? $addToCart.prop("disabled", !1).text(theme.strings.addToCart) : $addToCart.prop("disabled", !0).text(theme.strings.soldOut))
                        : ($addToCart.prop("disabled", !0).text(theme.strings.unavailable), $productPrice.addClass("hide"));
                },
                updateImages: function (variant) {
                    if (variant && variant.id) {
                        var featuredImage = variant.featured_image;
                        featuredImage &&
                            featuredImage.id &&
                            ($(".product-image, .indicator-image").removeClass("active"),
                            $('.product-image[data-image-id="' + featuredImage.id + '"]').addClass("active"),
                            $('.indicator-image[data-image-id="' + featuredImage.id + '"]').addClass("active"));
                    }
                },
                updateIncludes: function (variant) {
                    variant && variant.id && ($(".product-details .includes").addClass("hide"), $('.product-details .includes[data-variant-id="' + variant.id + '"]').removeClass("hide"));
                },
                updateSKU: function (variant) {
                    variant && variant.id && $(".product-sku .sku").html(variant.sku);
                },
                popup: function () {
                    0 < $(".product-image").length && $(".product-image a").magnificPopup({ type: "image", gallery: { enabled: !0, navigateByImgClick: !1 } });
                },
                zoom: {
                    active: !1,
                    init: function () {
                        App.core.isDesktop() && 0 == App.product.zoom.active
                            ? ((App.product.zoom.active = !0), $('.product-image a[data-zoom="true"]').elevateZoom({ easing: !0, borderSize: 2, borderColour: "#d6d6d6" }))
                            : 1 == App.product.zoom.active && ($.removeData($('.product-image a[data-zoom="true"]'), "elevateZoom"), $(".zoomContainer").remove(), (App.product.zoom.active = !1));
                    },
                },
                belongsTo: {
                    init: function (handle) {
                        if (window.algoliaShopify) {
                            var algolia = window.algoliaShopify;
                            algolia.client.initIndex(algolia.config.index_prefix + "products_includes").search({ query: handle, distinct: !0, attributesToRetrieve: ["handle", "meta"], typoTolerance: !1 }, function (error, content) {
                                if (content.hits && 0 < content.hits.length) {
                                    var hits = content.hits,
                                        handles = [];
                                    $.each(hits, function (index, hit) {
                                        if (hit.meta && hit.meta.global && hit.meta.global.Includes) {
                                            var includes = hit.meta.global.Includes;
                                            $.each(includes, function (index, include) {
                                                var parts = include.split("_");
                                                0 < parts.length && (1 == parts.length && handle == parts[0] ? handles.push(hit.handle) : 1 < parts.length && handle == parts[1] && handles.push(hit.handle));
                                            });
                                        }
                                    }),
                                        App.product.belongsTo.get(handles);
                                }
                            });
                        }
                    },
                    get: function (handles) {
                        0 < handles.length &&
                            $.each(handles, function (key, handle) {
                                $.ajax({ cache: !1, url: "/products/" + handle + "?view=belongs&cache=false", method: "GET" }).done(function (response) {
                                    if ((response = $.parseJSON(response)).handle && response.level && response.title) {
                                        var content = '<p><a href="/products/' + response.handle + '"><strong>' + response.title + "</strong></a>" + response.level + "</p>";
                                        $(".belongs-portion .extra-content").append(content), $(".belongs-portion").removeClass("hide");
                                    }
                                });
                            });
                    },
                },
            },
        }),
            App.core.init(function () {
                0 < $(".template-product").length &&
                    (App.product.getProductJSON(),
                    App.product.popup(),
                    App.product.zoom.init(),
                    setTimeout(function () {
                        App.product.belongsTo.init(App.product.productJSON.handle);
                    }, 50),
                    $(window).resize(function () {
                        App.product.zoom.init();
                    })),
                    $(document).on("change", ".single-option-selector", function () {
                        var variant = App.product.getCurrentVariant();
                        variant && (App.product.updatePrice(variant), App.product.updateMainVariant(variant), App.product.updateImages(variant), App.product.updateIncludes(variant), App.product.updateSKU(variant)),
                            App.product.updateAddToCart(variant);
                    });
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            quickView: {
                get: function (handle) {
                    $.ajax({ url: "/products/" + handle + "?view=quick-view&cache=false", method: "GET" }).done(function (response) {
                        (response = $.parseJSON(response)), $("#quick-view-modal .modal-wrapper").html(""), $("#quick-view-modal .modal-wrapper").html(response.content), $(".open-quick-view-modal").click();
                    });
                },
            },
            cart: {
                add: function ($this) {
                    $this.serialize();
                    $.ajax({ cache: !1, url: "/cart/add.js", dataType: "json", method: "POST", data: $this.serialize() })
                        .done(function (response) {
                            $this.find('[type="submit"]').attr("disabled", !1),
                                $("#messages").html('<div class="alert alert-success"><a href="#" class="close" data-dismiss="alert" aria-label="Close">&times;</a>' + theme.strings.cartSuccessMessage + "</div>"),
                                App.cart.get();
                        })
                        .fail(function (response) {
                            response.description &&
                                ($this.find('[type="submit"]').attr("disabled", !1),
                                $("#messages").html('<div class="alert alert-danger"><a href="#" class="close" data-dismiss="alert" aria-label="Close">&times;</a>' + response.description + "</div>"));
                        });
                },
                get: function () {
                    $.ajax({ cache: !1, url: "/cart.js", method: "GET", dataType: "json" }).done(function (response) {
                        response &&
                            ($(".cart-figures .cart-amount").removeClass("hide"),
                            $(".cart-figures .cart-amount").html(theme.Currency.formatMoney(response.total_price, theme.moneyFormat)),
                            $(".cart-figures .cart-count").html(response.item_count));
                    });
                },
            },
        }),
            App.core.init(function () {
                $(document).on("submit", "#product-form", function () {
                    var $form = $(this);
                    return $form.find('[type="submit"]').attr("disabled", !0), App.cart.add($form), !1;
                }),
                    $(".open-quick-view-modal").magnificPopup({ type: "inline", midClick: !0 }),
                    $(document).on("click", ".quick-view", function () {
                        var $this = $(this);
                        if (!$this.attr("disabled")) {
                            var handle = $this.attr("data-handle");
                            App.quickView.get(handle),
                                $this.attr("disabled", !0),
                                setTimeout(function () {
                                    $this.attr("disabled", !1);
                                }, 1500);
                        }
                        return !1;
                    });
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            search: {
                el: "#auto-suggestions",
                counter: 0,
                results: function (q) {
                    var counter = ++App.search.counter;
                    $.ajax({ url: "/search?view=json&q=" + q, method: "GET" }).done(function (response) {
                        counter == App.search.counter && (response = $.parseJSON(response)) && $(App.search.el).html(response.content);
                    });
                },
                page: {
                    _processing: !1,
                    init: function () {
                        var url = "/search?" + $(".page-results .search-form").serialize();
                        App.search.page.fetch(url, !1);
                    },
                    fetch: function (url, scroll) {
                        !1 === App.search.page._processing &&
                            ((App.search.page._processing = !0),
                            $.ajax({ method: "GET", url: url }).done(function (response) {
                                (App.search.page._processing = !1),
                                    (response = $.parseJSON(response)) &&
                                        response.content &&
                                        ($(".page-results .search-results").html(response.content), !0 === scroll && $("html, body").animate({ scrollTop: $(".page-results .search-results").offset().top }, 100));
                            }));
                    },
                },
            },
        }),
            App.core.init(function () {
                0 < $(".template-search").length &&
                    (App.core.getQueryString("view") || App.search.page.init(),
                    App.list.items.get(0, !0),
                    $(document).on("click", ".page-results .pagination a", function () {
                        var url = $(this).attr("href");
                        return "" != url && null != url && App.search.page.fetch(url, !0), !1;
                    }));
            });
    })(jQuery),
    (function ($) {
        $.extend(App, {
            table: {
                init: function () {
                    $(".main-container table").each(function (i, element) {
                        $(element).wrap('<div class="table-wrapper" />'), $(element).tableHeadFixer({ head: !1, left: 1 });
                    }),
                        0 < $(".chart-table").length && $(".chart-table").tableHeadFixer({ head: !1, left: 1, cellBackground: "#e5f3fc" });
                },
            },
        }),
            App.core.init(function () {
                App.table.init(),
                    $(".chart-scroll").scroll(function () {
                        $(".chart-content").scrollLeft($(".chart-scroll").scrollLeft());
                    }),
                    $(".chart-content").scroll(function () {
                        $(".chart-scroll").scrollLeft($(".chart-content").scrollLeft());
                    });
            });
    })(jQuery),
    (window.theme = window.theme || {}),
    (theme.Currency = {
        formatMoney: function (cents, format) {
            "string" == typeof cents && (cents = cents.replace(".", ""));
            var value = "",
                placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = format || "${{amount}}";
            function formatWithDelimiters(number, precision, thousands, decimal) {
                if (((thousands = thousands || ","), (decimal = decimal || "."), isNaN(number) || null === number)) return 0;
                var parts = (number = (number / 100).toFixed(precision)).split(".");
                return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands) + (parts[1] ? decimal + parts[1] : "");
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case "amount":
                    value = formatWithDelimiters(cents, 2);
                    break;
                case "amount_no_decimals":
                    value = formatWithDelimiters(cents, 0);
                    break;
                case "amount_with_comma_separator":
                    value = formatWithDelimiters(cents, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    value = formatWithDelimiters(cents, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    value = formatWithDelimiters(cents, 0, " ");
            }
            return formatString.replace(placeholderRegex, value);
        },
    }),
    (window.theme = theme || {}),
    (theme.customerTemplates = (function () {
        function toggleRecoverPasswordForm() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
        }
        return {
            init: function () {
                "#recover" === window.location.hash && toggleRecoverPasswordForm(),
                    $("#RecoverPassword").on("click", function (evt) {
                        evt.preventDefault(), toggleRecoverPasswordForm();
                    }),
                    $("#HideRecoverPasswordLink").on("click", function (evt) {
                        evt.preventDefault(), toggleRecoverPasswordForm();
                    }),
                    $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"),
                    (function () {
                        var $newAddressForm = $("#AddressNewForm");
                        $newAddressForm.length &&
                            (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                            $(".address-country-option").each(function () {
                                var formId = $(this).data("form-id"),
                                    countrySelector = "AddressCountry_" + formId,
                                    provinceSelector = "AddressProvince_" + formId,
                                    containerSelector = "AddressProvinceContainer_" + formId;
                                new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, { hideElement: containerSelector });
                            }),
                            $(".address-new-toggle").on("click", function () {
                                $newAddressForm.toggleClass("hide");
                            }),
                            $(".address-edit-toggle").on("click", function () {
                                var formId = $(this).data("form-id");
                                $("#EditAddress_" + formId).toggleClass("hide");
                            }),
                            $(".address-delete").on("click", function () {
                                var $el = $(this),
                                    formId = $el.data("form-id"),
                                    confirmMessage = $el.data("confirm-message");
                                confirm(confirmMessage || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + formId, { parameters: { _method: "delete" } });
                            }));
                    })();
            },
        };
    })()),
    (theme.init = function () {
        theme.customerTemplates.init(),
            $('a[href="#"]').on("click", function (evt) {
                evt.preventDefault();
            });
    }),
    $(theme.init);
